export default {
  glyphs: {
    0: {
      ha: 797,
      x_min: 64,
      x_max: 732,
      o: 'm 732 408 q 647 95 732 203 q 399 -14 562 -14 q 152 93 237 -14 q 64 398 66 199 l 64 580 q 150 894 64 787 q 397 1001 236 1001 q 644 895 559 1001 q 732 590 730 789 l 732 408 m 536 608 q 502 786 536 730 q 397 842 469 842 q 295 789 328 842 q 260 623 262 736 l 260 382 q 293 203 260 262 q 399 144 326 144 q 503 201 471 144 q 536 373 534 257 l 536 608 z '
    },
    1: {
      ha: 797,
      x_min: 113,
      x_max: 543,
      o: 'm 543 0 l 347 0 l 347 755 l 113 683 l 113 842 l 522 989 l 543 989 l 543 0 z '
    },
    2: {
      ha: 797,
      x_min: 47,
      x_max: 744,
      o: 'm 744 0 l 67 0 l 67 134 l 387 475 q 484 600 452 547 q 515 702 515 654 q 482 805 515 768 q 387 843 449 843 q 282 797 321 843 q 244 677 244 751 l 47 677 q 91 842 47 767 q 212 959 134 916 q 391 1001 291 1001 q 628 928 543 1001 q 712 721 712 854 q 674 572 712 648 q 544 395 636 496 l 319 158 l 744 158 l 744 0 z '
    },
    3: {
      ha: 797,
      x_min: 43,
      x_max: 729,
      o: 'm 267 581 l 371 581 q 481 618 446 581 q 517 717 517 655 q 482 810 517 777 q 384 843 446 843 q 290 812 328 843 q 252 732 252 781 l 56 732 q 97 870 56 809 q 214 966 139 932 q 379 1001 289 1001 q 625 926 536 1001 q 713 720 713 851 q 672 595 713 652 q 564 507 631 538 q 688 418 647 477 q 729 277 729 358 q 633 66 729 145 q 379 -14 537 -14 q 137 64 231 -14 q 43 271 43 142 l 239 271 q 281 180 239 215 q 384 144 323 144 q 493 181 454 144 q 533 279 533 218 q 370 427 533 427 l 267 427 l 267 581 z '
    },
    4: {
      ha: 797,
      x_min: 37,
      x_max: 759,
      o: 'm 647 372 l 759 372 l 759 214 l 647 214 l 647 0 l 451 0 l 451 214 l 46 214 l 37 337 l 449 987 l 647 987 l 647 372 m 233 372 l 451 372 l 451 720 l 438 698 l 233 372 z '
    },
    5: {
      ha: 797,
      x_min: 71,
      x_max: 739,
      o: 'm 96 486 l 153 987 l 707 987 l 707 824 l 314 824 l 290 612 q 438 649 359 649 q 659 562 579 649 q 739 317 739 474 q 699 145 739 221 q 583 28 659 70 q 406 -14 508 -14 q 239 23 316 -14 q 118 125 163 59 q 71 275 74 191 l 265 275 q 308 179 271 213 q 405 144 345 144 q 507 192 471 144 q 543 328 543 240 q 502 456 543 412 q 385 501 460 501 q 271 465 315 501 l 252 447 l 96 486 z '
    },
    6: {
      ha: 797,
      x_min: 68,
      x_max: 748,
      o: 'm 599 998 l 599 836 l 580 836 q 366 767 447 834 q 269 581 285 700 q 467 661 347 661 q 672 568 596 661 q 748 326 748 476 q 706 151 748 229 q 588 30 665 73 q 416 -14 512 -14 q 164 95 260 -14 q 68 385 68 203 l 68 455 q 129 739 68 616 q 303 929 189 862 q 566 998 416 997 l 599 998 m 408 503 q 321 478 360 503 q 264 413 283 454 l 264 353 q 303 200 264 255 q 412 144 342 144 q 514 194 475 144 q 553 323 553 244 q 513 454 553 404 q 408 503 474 503 z '
    },
    7: {
      ha: 797,
      x_min: 41,
      x_max: 739,
      o: 'm 739 878 l 357 0 l 150 0 l 532 829 l 41 829 l 41 987 l 739 987 l 739 878 z '
    },
    8: {
      ha: 797,
      x_min: 64,
      x_max: 732,
      o: 'm 711 725 q 675 597 711 653 q 576 509 639 542 q 690 413 648 474 q 732 271 732 353 q 642 63 732 139 q 399 -14 553 -14 q 155 63 245 -14 q 64 271 64 140 q 106 414 64 353 q 220 509 149 475 q 121 597 157 542 q 85 725 85 653 q 170 926 85 851 q 398 1001 254 1001 q 626 927 542 1001 q 711 725 711 852 m 535 285 q 498 388 535 349 q 397 427 460 427 q 298 388 335 427 q 260 285 260 350 q 297 183 260 222 q 399 144 334 144 q 499 182 463 144 q 535 285 535 219 m 515 715 q 484 808 515 773 q 398 843 454 843 q 313 809 343 843 q 282 715 282 775 q 313 621 282 656 q 399 585 343 585 q 485 621 454 585 q 515 715 515 656 z '
    },
    9: {
      ha: 797,
      x_min: 58,
      x_max: 724,
      o: 'm 526 395 q 347 319 449 319 q 137 409 216 319 q 58 652 58 499 q 101 830 58 749 q 219 956 143 911 q 390 1001 295 1001 q 564 952 488 1001 q 682 812 640 903 q 724 602 724 720 l 724 530 q 602 142 724 283 q 254 -9 479 1 l 205 -9 l 205 154 l 249 155 q 526 395 505 166 m 395 469 q 476 494 442 469 q 528 553 511 518 l 528 633 q 490 788 528 733 q 389 843 452 843 q 292 789 330 843 q 254 654 254 735 q 291 521 254 573 q 395 469 328 469 z '
    },
    '\u0000': { ha: 0, x_min: 0, x_max: 0, o: '' },
    '\u0002': { ha: 0, x_min: 0, x_max: 0, o: '' },
    '\r': { ha: 346, x_min: 0, x_max: 0, o: '' },
    ' ': { ha: 346, x_min: 0, x_max: 0, o: '' },
    '!': {
      ha: 378,
      x_min: 84,
      x_max: 303,
      o: 'm 275 303 l 112 303 l 89 987 l 298 987 l 275 303 m 193 196 q 273 167 243 196 q 303 92 303 138 q 273 18 303 47 q 193 -11 243 -11 q 114 18 144 -11 q 84 92 84 47 q 114 166 84 137 q 193 196 144 196 z '
    },
    '"': {
      ha: 446,
      x_min: 43,
      x_max: 401,
      o: 'm 180 948 l 153 669 l 43 669 l 43 1042 l 180 1042 l 180 948 m 401 948 l 374 669 l 264 669 l 264 1042 l 401 1042 l 401 948 z '
    },
    '#': {
      ha: 827,
      x_min: 43,
      x_max: 800,
      o: 'm 452 278 l 321 278 l 273 0 l 149 0 l 197 278 l 43 278 l 43 395 l 218 395 l 252 587 l 94 587 l 94 705 l 273 705 l 322 987 l 446 987 l 396 705 l 528 705 l 577 987 l 701 987 l 652 705 l 800 705 l 800 587 l 631 587 l 597 395 l 749 395 l 749 278 l 576 278 l 528 0 l 404 0 l 452 278 m 342 395 l 473 395 l 507 587 l 375 587 l 342 395 z '
    },
    $: {
      ha: 797,
      x_min: 62,
      x_max: 732,
      o: 'm 536 260 q 505 348 536 315 q 400 409 474 381 q 273 464 326 437 q 181 527 219 492 q 121 611 142 563 q 100 726 100 659 q 173 913 100 840 q 368 999 246 987 l 368 1144 l 476 1144 l 476 997 q 664 897 596 980 q 732 682 732 814 l 536 682 q 502 803 536 763 q 412 844 469 844 q 326 812 357 844 q 296 725 296 781 q 326 642 296 673 q 436 578 355 611 q 570 517 517 546 q 658 452 622 488 q 713 369 694 416 q 732 261 732 323 q 660 74 732 146 q 462 -11 588 2 l 462 -146 l 354 -146 l 354 -12 q 139 87 215 3 q 62 310 62 171 l 258 310 q 297 186 258 229 q 407 143 335 143 q 501 175 467 143 q 536 260 536 206 z '
    },
    '%': {
      ha: 1025,
      x_min: 64,
      x_max: 966,
      o: 'm 64 798 q 123 945 64 888 q 278 1002 182 1002 q 434 946 375 1002 q 493 794 493 890 l 493 745 q 434 598 493 654 q 279 543 375 543 q 124 598 183 543 q 64 749 64 654 l 64 798 m 195 745 q 218 680 195 705 q 279 655 241 655 q 340 680 317 655 q 362 747 362 705 l 362 798 q 340 863 362 838 q 278 888 317 888 q 218 864 241 888 q 195 795 195 839 l 195 745 m 536 242 q 596 390 536 334 q 751 446 656 446 q 906 390 847 446 q 966 238 966 335 l 966 189 q 907 42 966 98 q 752 -14 849 -14 q 595 43 654 -14 q 536 192 536 99 l 536 242 m 667 189 q 691 125 667 152 q 752 99 715 99 q 835 191 835 99 l 835 242 q 812 308 835 283 q 751 332 789 332 q 690 308 713 332 q 667 240 667 283 l 667 189 m 318 74 l 222 125 l 705 897 l 800 846 l 318 74 z '
    },
    '&': {
      ha: 911,
      x_min: 48,
      x_max: 895,
      o: 'm 48 266 q 86 393 48 334 q 227 522 125 451 q 158 633 183 581 q 133 741 133 685 q 206 929 133 857 q 402 1001 279 1001 q 584 935 513 1001 q 654 771 654 869 q 535 563 654 653 l 459 508 l 629 310 q 669 484 669 389 l 836 484 q 747 172 836 291 l 895 0 l 673 0 l 622 58 q 371 -14 513 -14 q 136 63 224 -14 q 48 266 48 140 m 380 144 q 514 183 451 144 l 319 408 l 305 398 q 245 277 245 347 q 282 181 245 218 q 380 144 320 144 m 309 744 q 368 616 309 693 l 420 650 q 476 701 460 676 q 491 759 491 725 q 466 818 491 793 q 401 843 441 843 q 334 816 359 843 q 309 744 309 789 z '
    },
    "'": {
      ha: 224,
      x_min: 43,
      x_max: 186,
      o: 'm 186 942 l 167 668 l 43 668 l 43 1042 l 186 1042 l 186 942 z '
    },
    '(': {
      ha: 488,
      x_min: 84,
      x_max: 460,
      o: 'm 84 401 q 125 697 84 557 q 248 946 167 838 q 422 1096 328 1054 l 460 990 q 306 764 361 917 q 250 406 250 610 l 250 385 q 305 25 250 179 q 460 -205 360 -129 l 422 -309 q 251 -162 330 -267 q 129 79 171 -58 q 84 366 87 216 l 84 401 z '
    },
    ')': {
      ha: 490,
      x_min: 27,
      x_max: 413,
      o: 'm 413 386 q 369 91 413 233 q 242 -159 325 -51 q 65 -309 159 -268 l 27 -205 q 179 19 123 -132 q 237 367 235 170 l 237 403 q 181 760 237 606 q 27 992 126 915 l 65 1096 q 239 951 157 1056 q 366 706 321 846 q 413 416 411 566 l 413 386 z '
    },
    '*': {
      ha: 629,
      x_min: 18,
      x_max: 621,
      o: 'm 231 652 l 18 713 l 58 836 l 269 751 l 256 987 l 389 987 l 375 746 l 581 829 l 621 705 l 404 645 l 546 465 l 438 388 l 315 586 l 193 395 l 85 468 l 231 652 z '
    },
    '+': {
      ha: 758,
      x_min: 39,
      x_max: 715,
      o: 'm 471 553 l 715 553 l 715 376 l 471 376 l 471 99 l 284 99 l 284 376 l 39 376 l 39 553 l 284 553 l 284 818 l 471 818 l 471 553 z '
    },
    ',': {
      ha: 339,
      x_min: 24,
      x_max: 260,
      o: 'm 126 -248 l 24 -194 l 48 -150 q 95 15 94 -67 l 95 167 l 260 167 l 260 31 q 222 -121 259 -44 q 126 -248 184 -197 z '
    },
    '-': {
      ha: 538,
      x_min: 75,
      x_max: 456,
      o: 'm 456 344 l 75 344 l 75 502 l 456 502 l 456 344 z '
    },
    '.': {
      ha: 404,
      x_min: 85,
      x_max: 307,
      o: 'm 85 96 q 117 172 85 143 q 196 201 149 201 q 276 172 244 201 q 307 96 307 143 q 276 21 307 50 q 196 -7 245 -7 q 117 21 148 -7 q 85 96 85 50 z '
    },
    '/': {
      ha: 519,
      x_min: -9,
      x_max: 500,
      o: 'm 137 -85 l -9 -85 l 355 987 l 500 987 l 137 -85 z '
    },
    ':': {
      ha: 392,
      x_min: 85,
      x_max: 307,
      o: 'm 85 96 q 116 172 85 143 q 195 201 148 201 q 275 172 243 201 q 307 96 307 143 q 275 21 307 50 q 195 -7 244 -7 q 116 21 147 -7 q 85 96 85 50 m 85 652 q 116 728 85 699 q 195 757 148 757 q 275 728 243 757 q 307 652 307 699 q 275 577 307 606 q 195 548 244 548 q 116 577 147 548 q 85 652 85 606 z '
    },
    ';': {
      ha: 364,
      x_min: 39,
      x_max: 295,
      o: 'm 73 652 q 105 728 73 699 q 184 757 136 757 q 263 728 232 757 q 295 652 295 699 q 264 577 295 606 q 184 548 233 548 q 104 577 136 548 q 73 652 73 606 m 141 -248 l 39 -194 l 63 -150 q 110 15 109 -67 l 110 167 l 275 167 l 275 31 q 237 -121 274 -44 q 141 -248 199 -197 z '
    },
    '<': {
      ha: 707,
      x_min: 37,
      x_max: 621,
      o: 'm 234 419 l 621 283 l 621 93 l 37 340 l 37 500 l 621 748 l 621 558 l 234 419 z '
    },
    '=': {
      ha: 795,
      x_min: 92,
      x_max: 699,
      o: 'm 699 506 l 92 506 l 92 666 l 699 666 l 699 506 m 699 212 l 92 212 l 92 372 l 699 372 l 699 212 z '
    },
    '>': {
      ha: 718,
      x_min: 81,
      x_max: 672,
      o: 'm 475 421 l 81 559 l 81 747 l 672 500 l 672 340 l 81 92 l 81 281 l 475 421 z '
    },
    '?': {
      ha: 691,
      x_min: 31,
      x_max: 642,
      o: 'm 235 303 q 258 454 235 398 q 343 565 281 511 q 425 654 404 620 q 445 726 445 688 q 339 841 445 841 q 259 810 289 841 q 227 725 229 779 l 31 725 q 114 928 32 854 q 339 1001 197 1001 q 562 931 483 1001 q 642 735 642 862 q 616 626 642 677 q 526 513 590 575 l 471 460 q 412 345 419 411 l 409 303 l 235 303 m 216 95 q 247 170 216 140 q 326 199 277 199 q 405 170 374 199 q 435 95 435 140 q 405 21 435 50 q 326 -8 375 -8 q 246 21 276 -8 q 216 95 216 50 z '
    },
    '@': {
      ha: 1243,
      x_min: 51,
      x_max: 1194,
      o: 'm 1186 363 q 1100 88 1179 190 q 890 -14 1022 -14 q 789 11 831 -14 q 725 83 747 36 q 548 -12 657 -12 q 395 71 449 -12 q 354 292 340 155 q 411 491 366 404 q 523 625 455 578 q 669 671 591 671 q 835 627 766 671 l 878 597 l 843 205 q 855 123 836 152 q 914 95 873 95 q 1019 168 977 95 q 1065 359 1061 241 q 969 723 1076 595 q 653 850 863 850 q 420 783 522 850 q 258 594 317 717 q 192 314 199 472 q 288 -57 181 74 q 609 -189 395 -189 q 727 -176 665 -189 q 833 -142 789 -163 l 859 -247 q 748 -291 818 -274 q 606 -307 677 -307 q 301 -235 427 -307 q 113 -22 175 -163 q 59 314 51 119 q 144 650 67 501 q 355 879 222 798 q 656 960 488 960 q 949 887 826 960 q 1133 679 1072 814 q 1186 363 1194 543 m 505 292 q 520 156 497 202 q 595 109 543 109 q 658 138 628 109 q 707 222 688 168 l 736 543 q 682 552 709 552 q 561 486 604 552 q 505 292 517 419 z '
    },
    A: {
      ha: 935,
      x_min: 5,
      x_max: 930,
      o: 'm 646 203 l 289 203 l 221 0 l 5 0 l 372 987 l 561 987 l 930 0 l 714 0 l 646 203 m 344 368 l 591 368 l 467 738 l 344 368 z '
    },
    B: {
      ha: 886,
      x_min: 88,
      x_max: 822,
      o: 'm 88 0 l 88 987 l 434 987 q 707 919 614 987 q 800 717 800 850 q 762 589 800 644 q 659 508 725 534 q 778 431 734 489 q 822 290 822 374 q 731 75 822 148 q 472 0 640 1 l 88 0 m 292 430 l 292 163 l 466 163 q 578 198 538 163 q 618 292 618 232 q 478 430 618 428 l 292 430 m 292 574 l 442 574 q 596 696 596 576 q 557 793 596 764 q 434 823 518 823 l 292 823 l 292 574 z '
    },
    C: {
      ha: 909,
      x_min: 58,
      x_max: 865,
      o: 'm 863 329 q 746 78 852 170 q 466 -14 640 -14 q 167 114 276 -14 q 58 465 58 242 l 58 526 q 109 777 58 668 q 252 943 159 885 q 469 1001 345 1001 q 744 909 640 1001 q 865 652 848 818 l 661 652 q 608 791 654 748 q 469 834 562 834 q 316 761 367 834 q 264 535 266 688 l 264 460 q 313 227 264 300 q 466 153 361 153 q 607 196 560 153 q 660 329 653 239 l 863 329 z '
    },
    D: {
      ha: 903,
      x_min: 88,
      x_max: 843,
      o: 'm 88 0 l 88 987 l 392 987 q 625 929 522 987 q 785 762 728 870 q 843 516 843 654 l 843 471 q 786 226 843 333 q 627 60 730 119 q 394 0 524 1 l 88 0 m 292 823 l 292 163 l 390 163 q 572 241 509 163 q 637 465 635 319 l 637 517 q 574 745 637 667 q 392 823 512 823 l 292 823 z '
    },
    E: {
      ha: 781,
      x_min: 88,
      x_max: 750,
      o: 'm 682 428 l 292 428 l 292 163 l 750 163 l 750 0 l 88 0 l 88 987 l 749 987 l 749 823 l 292 823 l 292 587 l 682 587 l 682 428 z '
    },
    F: {
      ha: 761,
      x_min: 88,
      x_max: 731,
      o: 'm 682 404 l 292 404 l 292 0 l 88 0 l 88 987 l 731 987 l 731 823 l 292 823 l 292 568 l 682 568 l 682 404 z '
    },
    G: {
      ha: 946,
      x_min: 64,
      x_max: 869,
      o: 'm 869 125 q 714 23 814 59 q 492 -14 614 -14 q 267 42 363 -14 q 118 205 170 98 q 64 455 65 311 l 64 522 q 114 778 64 670 q 257 944 163 886 q 477 1001 351 1001 q 752 917 653 1001 q 869 673 851 833 l 671 673 q 611 798 658 758 q 484 837 565 837 q 326 759 380 837 q 271 527 271 681 l 271 464 q 330 229 271 309 q 503 150 389 150 q 666 199 617 150 l 666 369 l 481 369 l 481 519 l 869 519 l 869 125 z '
    },
    H: {
      ha: 981,
      x_min: 88,
      x_max: 892,
      o: 'm 892 0 l 688 0 l 688 423 l 292 423 l 292 0 l 88 0 l 88 987 l 292 987 l 292 587 l 688 587 l 688 987 l 892 987 l 892 0 z '
    },
    I: {
      ha: 405,
      x_min: 101,
      x_max: 304,
      o: 'm 304 0 l 101 0 l 101 987 l 304 987 l 304 0 z '
    },
    J: {
      ha: 776,
      x_min: 27,
      x_max: 690,
      o: 'm 486 987 l 690 987 l 690 304 q 648 137 690 210 q 530 26 606 65 q 359 -14 454 -14 q 115 66 202 -14 q 27 292 27 146 l 232 292 q 262 184 232 219 q 359 150 293 150 q 452 190 417 150 q 486 304 486 230 l 486 987 z '
    },
    K: {
      ha: 882,
      x_min: 88,
      x_max: 893,
      o: 'm 397 396 l 292 282 l 292 0 l 88 0 l 88 987 l 292 987 l 292 540 l 381 663 l 633 987 l 883 987 l 532 549 l 893 0 l 651 0 l 397 396 z '
    },
    L: {
      ha: 752,
      x_min: 88,
      x_max: 724,
      o: 'm 292 163 l 724 163 l 724 0 l 88 0 l 88 987 l 292 987 l 292 163 z '
    },
    M: {
      ha: 1217,
      x_min: 88,
      x_max: 1127,
      o: 'm 354 987 l 608 271 l 860 987 l 1127 987 l 1127 0 l 923 0 l 923 270 l 943 736 l 677 0 l 537 0 l 271 735 l 292 270 l 292 0 l 88 0 l 88 987 l 354 987 z '
    },
    N: {
      ha: 981,
      x_min: 88,
      x_max: 891,
      o: 'm 891 0 l 688 0 l 292 650 l 292 0 l 88 0 l 88 987 l 292 987 l 688 336 l 688 987 l 891 987 l 891 0 z '
    },
    O: {
      ha: 959,
      x_min: 58,
      x_max: 899,
      o: 'm 899 471 q 848 216 899 326 q 700 46 796 106 q 480 -14 604 -14 q 261 45 357 -14 q 112 214 165 104 q 58 466 59 323 l 58 515 q 111 771 58 661 q 259 942 163 882 q 479 1001 355 1001 q 698 942 602 1001 q 847 771 794 882 q 899 515 899 661 l 899 471 m 693 516 q 637 752 693 671 q 479 833 582 833 q 321 753 376 833 q 264 519 265 673 l 264 471 q 320 237 264 320 q 480 153 376 153 q 637 234 583 153 q 693 468 692 314 l 693 516 z '
    },
    P: {
      ha: 896,
      x_min: 88,
      x_max: 844,
      o: 'm 292 348 l 292 0 l 88 0 l 88 987 l 473 987 q 669 947 585 987 q 799 831 753 906 q 844 661 844 756 q 745 432 844 515 q 470 348 646 348 l 292 348 m 292 513 l 473 513 q 596 551 554 513 q 639 659 639 589 q 596 777 639 732 q 478 823 553 821 l 292 823 l 292 513 z '
    },
    Q: {
      ha: 959,
      x_min: 57,
      x_max: 898,
      o: 'm 898 471 q 853 231 898 333 q 729 67 808 129 l 893 -62 l 764 -176 l 553 -7 q 479 -14 517 -14 q 260 45 356 -14 q 111 214 163 104 q 57 466 58 323 l 57 515 q 110 771 57 661 q 258 942 162 882 q 477 1001 354 1001 q 697 942 601 1001 q 845 771 793 882 q 898 515 898 661 l 898 471 m 692 516 q 636 752 692 671 q 477 833 581 833 q 319 753 375 833 q 263 519 264 673 l 263 471 q 319 237 263 320 q 479 153 374 153 q 636 234 581 153 q 692 468 691 314 l 692 516 z '
    },
    R: {
      ha: 886,
      x_min: 88,
      x_max: 857,
      o: 'm 454 361 l 292 361 l 292 0 l 88 0 l 88 987 l 455 987 q 725 909 630 987 q 820 689 820 831 q 776 520 820 588 q 644 413 732 453 l 857 9 l 857 0 l 639 0 l 454 361 m 292 526 l 456 526 q 574 565 532 526 q 616 673 616 604 q 577 783 616 743 q 455 823 537 823 l 292 823 l 292 526 z '
    },
    S: {
      ha: 854,
      x_min: 47,
      x_max: 804,
      o: 'm 600 259 q 559 348 600 317 q 413 413 519 378 q 245 480 307 447 q 77 725 77 571 q 122 868 77 805 q 252 966 168 930 q 441 1001 336 1001 q 630 963 547 1001 q 759 854 713 924 q 804 696 804 785 l 601 696 q 558 801 601 764 q 438 839 515 839 q 322 807 363 839 q 281 724 281 776 q 329 644 281 676 q 472 583 378 611 q 725 453 646 530 q 804 260 804 376 q 707 59 804 132 q 446 -14 610 -14 q 239 28 332 -14 q 96 142 145 70 q 47 311 47 215 l 251 311 q 446 147 251 147 q 559 177 519 147 q 600 259 600 206 z '
    },
    T: {
      ha: 859,
      x_min: 27,
      x_max: 831,
      o: 'm 831 823 l 529 823 l 529 0 l 326 0 l 326 823 l 27 823 l 27 987 l 831 987 l 831 823 z '
    },
    U: {
      ha: 914,
      x_min: 79,
      x_max: 836,
      o: 'm 836 987 l 836 337 q 734 81 836 175 q 457 -14 633 -14 q 182 78 284 -14 q 79 330 81 170 l 79 987 l 282 987 l 282 336 q 329 194 282 239 q 457 150 375 150 q 631 330 629 150 l 631 987 l 836 987 z '
    },
    V: {
      ha: 908,
      x_min: 5,
      x_max: 903,
      o: 'm 453 245 l 677 987 l 903 987 l 559 0 l 347 0 l 5 987 l 231 987 l 453 245 z '
    },
    W: {
      ha: 1215,
      x_min: 24,
      x_max: 1193,
      o: 'm 857 285 l 990 987 l 1193 987 l 974 0 l 769 0 l 608 661 l 448 0 l 243 0 l 24 987 l 227 987 l 360 286 l 523 987 l 695 987 l 857 285 z '
    },
    X: {
      ha: 882,
      x_min: 15,
      x_max: 868,
      o: 'm 441 647 l 627 987 l 861 987 l 573 498 l 868 0 l 631 0 l 441 346 l 252 0 l 15 0 l 310 498 l 22 987 l 256 987 l 441 647 z '
    },
    Y: {
      ha: 859,
      x_min: 1,
      x_max: 857,
      o: 'm 429 543 l 634 987 l 857 987 l 532 358 l 532 0 l 326 0 l 326 358 l 1 987 l 224 987 l 429 543 z '
    },
    Z: {
      ha: 842,
      x_min: 50,
      x_max: 802,
      o: 'm 304 163 l 802 163 l 802 0 l 50 0 l 50 119 l 538 823 l 50 823 l 50 987 l 791 987 l 791 871 l 304 163 z '
    },
    '[': {
      ha: 386,
      x_min: 81,
      x_max: 374,
      o: 'm 374 998 l 278 998 l 278 -79 l 374 -79 l 374 -230 l 81 -230 l 81 1149 l 374 1149 l 374 998 z '
    },
    '\\': {
      ha: 586,
      x_min: 0,
      x_max: 612,
      o: 'm 0 987 l 200 987 l 612 -85 l 412 -85 l 0 987 z '
    },
    ']': {
      ha: 386,
      x_min: 9,
      x_max: 302,
      o: 'm 9 1149 l 302 1149 l 302 -230 l 9 -230 l 9 -79 l 106 -79 l 106 998 l 9 998 l 9 1149 z '
    },
    '^': {
      ha: 607,
      x_min: 30,
      x_max: 578,
      o: 'm 304 804 l 186 494 l 30 494 l 233 987 l 375 987 l 578 494 l 422 494 l 304 804 z '
    },
    _: {
      ha: 620,
      x_min: 1,
      x_max: 618,
      o: 'm 618 -153 l 1 -153 l 1 0 l 618 0 l 618 -153 z '
    },
    '`': {
      ha: 459,
      x_min: 35,
      x_max: 383,
      o: 'm 383 831 l 222 831 l 35 1042 l 249 1042 l 383 831 z '
    },
    a: {
      ha: 745,
      x_min: 46,
      x_max: 699,
      o: 'm 500 0 q 481 66 487 26 q 296 -14 410 -14 q 117 49 188 -14 q 46 206 46 111 q 133 385 46 323 q 382 448 219 448 l 473 448 l 473 490 q 447 572 473 541 q 364 602 420 602 q 287 578 315 602 q 258 513 258 555 l 62 513 q 102 631 62 577 q 213 716 141 686 q 374 747 285 747 q 590 679 510 747 q 669 488 669 611 l 669 170 q 699 12 670 65 l 699 0 l 500 0 m 338 136 q 418 156 382 136 q 473 208 455 175 l 473 334 l 399 334 q 243 232 252 334 l 242 220 q 268 160 242 184 q 338 136 294 136 z '
    },
    b: {
      ha: 782,
      x_min: 75,
      x_max: 736,
      o: 'm 736 360 q 661 85 736 184 q 451 -14 586 -14 q 260 78 332 -14 l 252 0 l 75 0 l 75 1042 l 271 1042 l 271 668 q 450 747 339 747 q 660 649 584 747 q 736 371 736 550 l 736 360 m 541 374 q 505 537 541 486 q 400 588 470 588 q 271 511 307 588 l 271 222 q 401 144 307 144 q 526 238 496 144 q 541 374 541 283 z '
    },
    c: {
      ha: 724,
      x_min: 45,
      x_max: 688,
      o: 'm 380 144 q 469 174 435 144 q 504 254 503 204 l 688 254 q 647 117 687 179 q 537 21 607 55 q 384 -14 468 -14 q 136 86 227 -14 q 45 363 45 186 l 45 376 q 135 646 45 545 q 382 747 225 747 q 603 669 520 747 q 688 460 686 591 l 504 460 q 469 553 503 517 q 379 589 435 589 q 276 539 311 589 q 241 377 241 489 l 241 357 q 275 194 241 243 q 380 144 310 144 z '
    },
    d: {
      ha: 783,
      x_min: 45,
      x_max: 706,
      o: 'm 45 372 q 122 646 45 544 q 332 747 199 747 q 509 667 439 747 l 509 1042 l 706 1042 l 706 0 l 529 0 l 519 78 q 331 -14 446 -14 q 123 89 201 -14 q 45 372 45 191 m 241 358 q 277 200 241 255 q 381 145 313 145 q 509 222 472 145 l 509 511 q 382 588 473 588 q 241 358 241 588 z '
    },
    e: {
      ha: 751,
      x_min: 49,
      x_max: 715,
      o: 'm 413 -14 q 150 85 252 -14 q 49 349 49 184 l 49 368 q 92 566 49 479 q 213 700 134 653 q 391 747 291 747 q 628 652 542 747 q 715 383 715 557 l 715 303 l 248 303 q 305 188 257 231 q 426 144 353 144 q 603 227 539 144 l 699 119 q 580 21 655 56 q 413 -14 505 -14 m 391 589 q 296 549 332 589 q 250 437 260 510 l 522 437 l 522 452 q 487 553 521 517 q 391 589 453 589 z '
    },
    f: {
      ha: 498,
      x_min: 20,
      x_max: 498,
      o: 'm 129 0 l 129 590 l 20 590 l 20 734 l 129 734 l 129 796 q 200 988 129 920 q 398 1056 271 1056 q 498 1042 439 1056 l 496 890 q 436 897 471 897 q 326 793 326 897 l 326 734 l 471 734 l 471 590 l 326 590 l 326 0 l 129 0 z '
    },
    g: {
      ha: 793,
      x_min: 47,
      x_max: 718,
      o: 'm 47 372 q 127 644 47 541 q 344 747 208 747 q 532 665 465 747 l 540 734 l 718 734 l 718 24 q 674 -143 718 -72 q 551 -252 630 -214 q 365 -289 471 -289 q 208 -257 284 -289 q 92 -174 131 -224 l 178 -54 q 356 -136 252 -136 q 477 -95 434 -136 q 521 24 521 -53 l 521 63 q 342 -14 453 -14 q 129 90 210 -14 q 47 364 47 193 l 47 372 m 243 358 q 283 202 243 258 q 393 145 323 145 q 521 212 482 145 l 521 521 q 394 588 481 588 q 283 530 323 588 q 243 358 243 473 z '
    },
    h: {
      ha: 777,
      x_min: 71,
      x_max: 705,
      o: 'm 267 654 q 463 747 345 747 q 705 470 701 747 l 705 0 l 509 0 l 509 465 q 481 558 509 528 q 391 588 454 588 q 267 522 305 588 l 267 0 l 71 0 l 71 1042 l 267 1042 l 267 654 z '
    },
    i: {
      ha: 368,
      x_min: 74,
      x_max: 294,
      o: 'm 282 0 l 85 0 l 85 734 l 282 734 l 282 0 m 74 924 q 103 996 74 968 q 184 1025 133 1025 q 264 996 234 1025 q 294 924 294 968 q 263 850 294 879 q 184 822 233 822 q 104 850 134 822 q 74 924 74 879 z '
    },
    j: {
      ha: 361,
      x_min: -64,
      x_max: 290,
      o: 'm 283 734 l 283 -40 q 218 -229 283 -161 q 33 -296 154 -296 q -64 -285 -18 -296 l -64 -130 q -3 -136 -29 -136 q 86 -41 86 -136 l 86 734 l 283 734 m 71 924 q 100 996 71 968 q 180 1025 130 1025 q 261 996 231 1025 q 290 924 290 968 q 260 850 290 879 q 180 822 230 822 q 101 850 131 822 q 71 924 71 879 z '
    },
    k: {
      ha: 742,
      x_min: 75,
      x_max: 755,
      o: 'm 342 294 l 271 224 l 271 0 l 75 0 l 75 1042 l 271 1042 l 271 465 l 309 513 l 497 734 l 732 734 l 467 428 l 755 0 l 530 0 l 342 294 z '
    },
    l: {
      ha: 368,
      x_min: 85,
      x_max: 282,
      o: 'm 282 0 l 85 0 l 85 1042 l 282 1042 l 282 0 z '
    },
    m: {
      ha: 1202,
      x_min: 75,
      x_max: 1127,
      o: 'm 259 734 l 265 652 q 476 747 343 747 q 671 635 618 747 q 891 747 748 747 q 1069 678 1010 747 q 1127 469 1127 608 l 1127 0 l 930 0 l 930 468 q 906 559 930 530 q 820 588 882 588 q 698 504 732 588 l 699 0 l 503 0 l 503 467 q 477 559 503 531 q 392 588 452 588 q 271 519 309 588 l 271 0 l 75 0 l 75 734 l 259 734 z '
    },
    n: {
      ha: 778,
      x_min: 71,
      x_max: 705,
      o: 'm 256 734 l 262 649 q 473 747 340 747 q 646 679 589 747 q 705 474 703 610 l 705 0 l 509 0 l 509 469 q 481 560 509 532 q 391 588 454 588 q 267 517 309 588 l 267 0 l 71 0 l 71 734 l 256 734 z '
    },
    o: {
      ha: 785,
      x_min: 45,
      x_max: 740,
      o: 'm 45 374 q 87 568 45 483 q 208 701 129 654 q 391 747 287 747 q 634 656 540 747 q 739 410 728 566 l 740 359 q 646 89 740 191 q 393 -14 551 -14 q 139 88 234 -14 q 45 365 45 190 l 45 374 m 241 359 q 280 200 241 255 q 393 144 319 144 q 504 199 464 144 q 544 374 544 254 q 504 532 544 476 q 391 589 464 589 q 280 533 319 589 q 241 359 241 477 z '
    },
    p: {
      ha: 782,
      x_min: 75,
      x_max: 736,
      o: 'm 736 360 q 659 89 736 191 q 451 -14 582 -14 q 271 64 340 -14 l 271 -282 l 75 -282 l 75 734 l 257 734 l 264 662 q 450 747 335 747 q 661 647 585 747 q 736 370 736 547 l 736 360 m 540 374 q 504 532 540 477 q 398 588 467 588 q 271 517 306 588 l 271 217 q 399 144 307 144 q 540 374 540 144 z '
    },
    q: {
      ha: 785,
      x_min: 45,
      x_max: 706,
      o: 'm 45 374 q 122 647 45 547 q 333 747 199 747 q 521 657 451 747 l 534 734 l 706 734 l 706 -282 l 509 -282 l 509 63 q 332 -14 441 -14 q 123 88 201 -14 q 45 374 45 190 m 241 359 q 278 199 241 254 q 382 144 315 144 q 509 216 472 144 l 509 519 q 383 589 473 589 q 278 534 315 589 q 241 359 241 479 z '
    },
    r: {
      ha: 507,
      x_min: 75,
      x_max: 490,
      o: 'm 488 550 q 417 555 448 555 q 271 480 306 555 l 271 0 l 75 0 l 75 734 l 260 734 l 266 646 q 429 747 325 747 q 490 739 462 747 l 488 550 z '
    },
    s: {
      ha: 714,
      x_min: 38,
      x_max: 663,
      o: 'm 473 203 q 437 259 473 239 q 323 296 401 280 q 61 519 61 351 q 142 682 61 616 q 354 747 223 747 q 577 682 494 747 q 661 511 661 616 l 465 511 q 438 580 465 553 q 353 608 411 608 q 277 585 304 608 q 250 528 250 563 q 280 476 250 496 q 385 441 311 456 q 508 408 458 427 q 663 211 663 351 q 577 48 663 111 q 355 -14 491 -14 q 191 19 262 -14 q 79 110 119 52 q 38 233 38 167 l 224 233 q 262 153 227 181 q 359 125 298 125 q 444 147 415 125 q 473 203 473 168 z '
    },
    t: {
      ha: 469,
      x_min: 7,
      x_max: 443,
      o: 'm 310 914 l 310 734 l 435 734 l 435 590 l 310 590 l 310 224 q 326 165 310 183 q 385 148 341 148 q 443 153 418 148 l 443 4 q 324 -14 385 -14 q 114 195 118 -14 l 114 590 l 7 590 l 7 734 l 114 734 l 114 914 l 310 914 z '
    },
    u: {
      ha: 777,
      x_min: 71,
      x_max: 705,
      o: 'm 515 75 q 314 -14 442 -14 q 134 54 196 -14 q 71 253 72 122 l 71 734 l 267 734 l 267 260 q 371 145 267 145 q 508 214 471 145 l 508 734 l 705 734 l 705 0 l 520 0 l 515 75 z '
    },
    v: {
      ha: 702,
      x_min: 9,
      x_max: 691,
      o: 'm 350 239 l 486 734 l 691 734 l 444 0 l 256 0 l 9 734 l 214 734 l 350 239 z '
    },
    w: {
      ha: 1021,
      x_min: 19,
      x_max: 999,
      o: 'm 713 267 l 810 734 l 999 734 l 812 0 l 648 0 l 509 462 l 370 0 l 206 0 l 19 734 l 208 734 l 304 267 l 438 734 l 580 734 l 713 267 z '
    },
    x: {
      ha: 707,
      x_min: 14,
      x_max: 696,
      o: 'm 355 515 l 478 734 l 688 734 l 479 374 l 696 0 l 486 0 l 355 231 l 225 0 l 14 0 l 232 374 l 24 734 l 234 734 l 355 515 z '
    },
    y: {
      ha: 697,
      x_min: 2,
      x_max: 695,
      o: 'm 349 277 l 485 734 l 695 734 l 400 -114 l 384 -153 q 167 -296 318 -296 q 80 -283 124 -296 l 80 -135 l 110 -136 q 193 -119 165 -136 q 236 -62 220 -102 l 259 -2 l 2 734 l 213 734 l 349 277 z '
    },
    z: {
      ha: 707,
      x_min: 50,
      x_max: 659,
      o: 'm 300 158 l 659 158 l 659 0 l 50 0 l 50 119 l 395 575 l 60 575 l 60 734 l 648 734 l 648 618 l 300 158 z '
    },
    '{': {
      ha: 458,
      x_min: 33,
      x_max: 435,
      o: 'm 397 -244 q 153 71 153 -176 l 153 206 q 33 349 153 349 l 33 490 q 153 625 151 490 l 153 768 q 214 971 153 894 q 397 1083 275 1048 l 435 974 q 357 908 384 955 q 330 777 331 861 l 330 635 q 208 420 330 481 q 330 203 330 357 l 330 60 q 435 -134 333 -99 l 397 -244 z '
    },
    '|': {
      ha: 351,
      x_min: 117,
      x_max: 236,
      o: 'm 236 -183 l 117 -183 l 117 987 l 236 987 l 236 -183 z '
    },
    '}': {
      ha: 458,
      x_min: 23,
      x_max: 426,
      o: 'm 23 -134 q 129 62 126 -98 l 129 206 q 253 419 129 359 q 129 635 129 479 l 129 777 q 23 974 126 935 l 61 1083 q 243 972 182 1049 q 305 770 304 895 l 305 625 q 426 490 308 490 l 426 349 q 305 208 305 349 l 305 60 q 61 -244 300 -177 l 23 -134 z '
    },
    '~': {
      ha: 901,
      x_min: 72,
      x_max: 828,
      o: 'm 828 538 q 765 333 828 412 q 602 254 702 254 q 509 274 552 254 q 410 347 466 293 q 306 401 353 401 q 242 367 267 401 q 218 280 218 333 l 72 281 q 133 484 72 408 q 296 561 195 561 q 393 541 349 561 q 491 468 436 520 q 592 415 547 415 q 657 451 632 415 q 683 538 683 487 l 828 538 z '
    },
    '¡': {
      ha: 392,
      x_min: 87,
      x_max: 307,
      o: 'm 115 433 l 279 433 l 301 -250 l 93 -250 l 115 433 m 307 643 q 275 568 307 597 q 197 539 244 539 q 118 568 149 539 q 87 643 87 597 q 117 718 87 688 q 197 747 147 747 q 276 718 246 747 q 307 643 307 688 z '
    },
    '¢': {
      ha: 799,
      x_min: 67,
      x_max: 711,
      o: 'm 403 144 q 491 174 457 144 q 526 254 525 204 l 711 254 q 644 84 709 155 q 473 -7 578 12 l 473 -166 l 338 -166 l 338 -8 q 139 110 211 12 q 67 361 67 208 l 67 376 q 138 622 67 524 q 338 742 210 720 l 338 894 l 473 894 l 473 741 q 647 646 584 722 q 711 460 709 571 l 526 460 q 491 554 525 519 q 402 589 457 589 q 298 538 333 589 q 263 379 264 488 l 263 357 q 298 194 263 243 q 403 144 333 144 z '
    },
    '£': {
      ha: 825,
      x_min: 67,
      x_max: 787,
      o: 'm 382 391 l 387 296 q 345 163 387 213 l 787 163 l 787 0 l 69 0 l 69 163 l 132 163 q 180 285 180 176 l 177 391 l 67 391 l 67 551 l 172 551 l 167 705 q 251 921 167 842 q 475 1000 334 1000 q 701 924 618 1000 q 783 718 783 848 l 588 718 q 558 806 588 775 q 474 836 529 836 q 400 803 429 836 q 370 705 370 770 l 376 551 l 586 551 l 586 391 l 382 391 z '
    },
    '¤': {
      ha: 962,
      x_min: 55,
      x_max: 913,
      o: 'm 728 73 q 483 -14 620 -14 q 238 72 345 -14 l 151 -18 l 55 80 l 146 173 q 79 412 79 279 q 153 660 79 551 l 55 760 l 151 857 l 247 759 q 483 837 352 837 q 720 758 614 837 l 817 858 l 913 760 l 813 657 q 886 412 886 549 q 819 176 886 281 l 913 80 l 817 -18 l 728 73 m 205 412 q 241 263 205 332 q 343 155 278 195 q 483 115 408 115 q 622 155 557 115 q 724 263 687 195 q 760 412 760 332 q 724 561 760 493 q 623 669 687 629 q 483 708 558 708 q 342 669 407 708 q 241 561 278 629 q 205 412 205 493 z '
    },
    '¥': {
      ha: 745,
      x_min: 7,
      x_max: 737,
      o: 'm 373 605 l 525 987 l 737 987 l 519 503 l 667 503 l 667 385 l 471 385 l 471 307 l 667 307 l 667 189 l 471 189 l 471 0 l 268 0 l 268 189 l 60 189 l 60 307 l 268 307 l 268 385 l 60 385 l 60 503 l 226 503 l 7 987 l 220 987 l 373 605 z '
    },
    '¦': {
      ha: 350,
      x_min: 87,
      x_max: 263,
      o: 'm 87 -183 l 87 356 l 263 356 l 263 -183 l 87 -183 m 263 473 l 87 473 l 87 987 l 263 987 l 263 473 z '
    },
    '§': {
      ha: 873,
      x_min: 62,
      x_max: 800,
      o: 'm 800 326 q 690 142 800 203 q 782 -53 782 73 q 689 -239 782 -172 q 431 -307 595 -307 q 160 -234 257 -307 q 62 -24 62 -161 l 258 -23 q 302 -116 258 -83 q 431 -148 345 -148 q 547 -122 507 -148 q 586 -54 586 -97 q 542 18 586 -10 q 375 80 498 45 q 188 151 251 114 q 95 239 125 189 q 64 362 64 290 q 174 547 64 484 q 81 743 81 617 q 177 930 81 859 q 434 1001 272 1001 q 694 924 602 1001 q 786 711 786 848 l 590 711 q 548 807 590 770 q 434 843 507 843 q 319 817 359 843 q 278 744 278 790 q 316 669 278 694 q 479 611 353 644 q 670 541 604 578 q 768 451 736 503 q 800 326 800 399 m 311 477 q 260 382 260 449 q 288 310 260 335 q 400 257 316 284 l 551 212 q 606 307 606 243 q 575 375 606 349 q 465 429 545 402 l 311 477 z '
    },
    '¨': {
      ha: 648,
      x_min: 64,
      x_max: 582,
      o: 'm 252 926 q 225 865 252 890 q 157 840 199 840 q 90 865 115 840 q 64 926 64 890 q 90 986 64 961 q 157 1012 115 1012 q 225 986 199 1012 q 252 926 252 961 m 394 926 q 421 987 394 962 q 488 1012 449 1012 q 555 987 528 1012 q 582 926 582 962 q 556 865 582 890 q 488 840 530 840 q 420 865 446 840 q 394 926 394 890 z '
    },
    '©': {
      ha: 1089,
      x_min: 58,
      x_max: 1021,
      o: 'm 758 404 q 698 246 758 301 q 530 191 639 191 q 358 263 422 191 q 294 458 294 336 l 294 534 q 358 725 294 652 q 530 797 423 797 q 700 741 641 797 q 758 584 758 685 l 652 584 q 621 677 652 649 q 530 705 590 705 q 434 660 468 705 q 399 537 399 614 l 399 454 q 433 329 399 374 q 530 283 468 283 q 621 310 591 283 q 652 404 652 338 l 758 404 m 938 494 q 887 704 938 607 q 743 858 836 800 q 540 916 650 916 q 339 861 432 916 q 194 707 247 805 q 141 494 141 610 q 194 281 141 379 q 339 127 246 184 q 540 71 431 71 q 742 128 648 71 q 886 283 835 186 q 938 494 938 381 m 58 494 q 122 749 58 631 q 297 933 185 866 q 540 1001 410 1001 q 782 933 670 1001 q 958 749 895 866 q 1021 494 1021 631 q 957 238 1021 356 q 781 54 892 121 q 540 -14 669 -14 q 297 54 409 -14 q 122 239 186 122 q 58 494 58 357 z '
    },
    ª: {
      ha: 616,
      x_min: 93,
      x_max: 530,
      o: 'm 410 478 q 398 524 403 496 q 262 469 346 469 q 137 510 182 469 q 93 623 93 552 q 150 739 93 698 q 324 780 207 780 l 393 780 l 393 814 q 315 901 393 901 q 246 883 271 901 q 221 833 221 866 l 104 843 q 163 957 104 913 q 315 1001 222 1001 q 459 952 406 1001 q 512 813 512 903 l 512 599 q 530 478 512 533 l 410 478 m 291 566 q 347 579 318 566 q 393 608 375 591 l 393 701 l 321 701 q 241 680 270 700 q 212 626 212 659 q 291 566 212 566 z '
    },
    '«': {
      ha: 694,
      x_min: 52,
      x_max: 629,
      o: 'm 205 355 l 368 85 l 242 85 l 52 349 l 52 362 l 242 627 l 368 627 l 205 355 m 467 355 l 629 85 l 503 85 l 313 349 l 313 362 l 503 627 l 629 627 l 467 355 z '
    },
    '¬': {
      ha: 766,
      x_min: 85,
      x_max: 652,
      o: 'm 652 254 l 516 254 l 516 430 l 85 430 l 85 546 l 652 546 l 652 254 z '
    },
    '®': {
      ha: 1089,
      x_min: 58,
      x_max: 1021,
      o: 'm 58 494 q 122 749 58 631 q 297 933 185 866 q 540 1001 410 1001 q 782 933 670 1001 q 958 749 895 866 q 1021 494 1021 631 q 957 238 1021 356 q 781 54 892 121 q 540 -14 669 -14 q 297 54 409 -14 q 122 239 186 122 q 58 494 58 357 m 938 494 q 887 704 938 607 q 743 858 836 800 q 540 916 650 916 q 339 861 432 916 q 194 707 247 805 q 141 494 141 610 q 194 281 141 379 q 339 127 246 184 q 540 71 431 71 q 742 128 648 71 q 886 283 835 186 q 938 494 938 381 m 442 443 l 442 214 l 340 214 l 340 791 l 530 791 q 692 744 633 791 q 751 612 751 698 q 674 494 751 536 q 732 436 715 473 q 749 342 749 398 q 751 264 749 287 q 760 225 753 241 l 760 214 l 655 214 q 646 346 646 237 q 624 420 646 397 q 549 443 602 443 l 442 443 m 442 534 l 534 534 q 617 555 585 534 q 649 612 649 577 q 625 680 649 660 q 538 701 601 700 l 442 701 l 442 534 z '
    },
    '¯': {
      ha: 696,
      x_min: 114,
      x_max: 582,
      o: 'm 582 873 l 114 873 l 114 986 l 582 986 l 582 873 z '
    },
    '°': {
      ha: 539,
      x_min: 85,
      x_max: 452,
      o: 'm 85 814 q 140 946 85 891 q 270 1001 195 1001 q 398 946 344 1001 q 452 814 452 892 q 398 683 452 736 q 270 629 344 629 q 141 683 197 629 q 85 814 85 736 m 270 730 q 329 754 306 730 q 353 814 353 778 q 329 875 353 849 q 270 901 306 901 q 210 875 234 901 q 185 814 185 849 q 210 754 185 779 q 270 730 235 730 z '
    },
    '±': {
      ha: 746,
      x_min: 60,
      x_max: 682,
      o: 'm 459 639 l 682 639 l 682 475 l 459 475 l 459 229 l 288 229 l 288 475 l 60 475 l 60 639 l 288 639 l 288 871 l 459 871 l 459 639 m 663 1 l 77 1 l 77 160 l 663 160 l 663 1 z '
    },
    '²': {
      ha: 517,
      x_min: 37,
      x_max: 470,
      o: 'm 470 452 l 50 452 l 50 546 l 244 720 q 299 782 282 753 q 315 826 315 810 q 251 883 315 883 q 197 862 217 883 q 177 809 177 841 l 37 809 q 95 941 37 888 q 245 995 153 995 q 400 951 345 995 q 454 827 454 907 q 430 740 454 779 q 332 642 406 701 l 232 564 l 470 564 l 470 452 z '
    },
    '³': {
      ha: 517,
      x_min: 33,
      x_max: 470,
      o: 'm 185 771 l 241 771 q 321 831 321 771 q 302 869 321 854 q 250 883 283 883 q 201 872 221 883 q 181 842 181 862 l 42 842 q 99 953 42 911 q 245 995 157 995 q 402 955 344 995 q 460 842 460 914 q 368 727 460 761 q 470 602 470 699 q 408 488 470 531 q 245 445 346 445 q 91 490 149 445 q 33 612 33 535 l 172 612 q 195 573 172 589 q 254 556 218 556 q 312 574 294 556 q 330 616 330 592 q 248 679 330 678 l 185 679 l 185 771 z '
    },
    '´': {
      ha: 460,
      x_min: 68,
      x_max: 416,
      o: 'm 202 1042 l 416 1042 l 228 831 l 68 831 l 202 1042 z '
    },
    µ: {
      ha: 855,
      x_min: 94,
      x_max: 747,
      o: 'm 290 734 l 290 311 q 318 185 290 226 q 412 145 345 145 q 551 216 513 145 l 551 734 l 747 734 l 747 0 l 565 0 l 561 46 q 408 -14 500 -14 q 290 16 339 -14 l 290 -282 l 94 -282 l 94 734 l 290 734 z '
    },
    '¶': {
      ha: 680,
      x_min: 51,
      x_max: 589,
      o: 'm 441 0 l 441 353 l 387 353 q 141 439 231 353 q 51 670 51 525 q 141 901 51 814 q 387 987 231 987 l 589 987 l 589 0 l 441 0 z '
    },
    '·': {
      ha: 418,
      x_min: 95,
      x_max: 317,
      o: 'm 95 473 q 126 549 95 519 q 205 578 157 578 q 285 549 254 578 q 317 473 317 519 q 285 397 317 426 q 205 368 253 368 q 126 398 157 368 q 95 473 95 427 z '
    },
    '¸': {
      ha: 372,
      x_min: 66,
      x_max: 328,
      o: 'm 234 5 l 227 -35 q 328 -152 328 -53 q 266 -270 328 -227 q 92 -313 204 -313 l 87 -200 q 163 -145 163 -200 q 140 -106 163 -117 q 66 -92 117 -96 l 87 5 l 234 5 z '
    },
    '¹': {
      ha: 517,
      x_min: 92,
      x_max: 358,
      o: 'm 358 452 l 220 452 l 220 824 l 92 796 l 92 903 l 345 985 l 358 985 l 358 452 z '
    },
    º: {
      ha: 635,
      x_min: 80,
      x_max: 550,
      o: 'm 80 760 q 145 935 80 869 q 315 1001 210 1001 q 485 935 420 1001 q 550 757 550 869 l 550 708 q 486 534 550 600 q 316 468 422 468 q 144 534 209 468 q 80 711 80 601 l 80 760 m 199 708 q 230 604 199 642 q 316 567 262 567 q 400 604 369 567 q 431 706 431 640 l 431 760 q 400 863 431 826 q 315 901 368 901 q 230 864 262 901 q 199 758 199 827 l 199 708 z '
    },
    '»': {
      ha: 694,
      x_min: 58,
      x_max: 641,
      o: 'm 184 626 l 374 361 l 374 349 l 184 84 l 58 84 l 220 355 l 58 626 l 184 626 m 451 626 l 641 361 l 641 349 l 451 84 l 324 84 l 487 355 l 324 626 l 451 626 z '
    },
    '¼': {
      ha: 997,
      x_min: 68,
      x_max: 943,
      o: 'm 335 450 l 197 450 l 197 822 l 68 794 l 68 901 l 322 983 l 335 983 l 335 450 m 311 79 l 215 131 l 697 903 l 793 851 l 311 79 m 883 221 l 943 221 l 943 108 l 883 108 l 883 0 l 744 0 l 744 108 l 509 108 l 501 199 l 743 535 l 883 535 l 883 221 m 634 221 l 744 221 l 744 365 l 734 350 l 634 221 z '
    },
    '½': {
      ha: 1057,
      x_min: 57,
      x_max: 1002,
      o: 'm 282 79 l 186 131 l 669 903 l 764 851 l 282 79 m 323 454 l 185 454 l 185 826 l 57 798 l 57 905 l 311 987 l 323 987 l 323 454 m 1002 0 l 581 0 l 581 94 l 776 268 q 830 330 814 301 q 847 374 847 358 q 783 431 847 431 q 729 410 749 431 q 709 357 709 389 l 569 357 q 627 489 569 435 q 777 543 685 543 q 931 499 877 543 q 986 374 986 455 q 962 288 986 327 q 864 189 937 248 l 764 111 l 1002 111 l 1002 0 z '
    },
    '¾': {
      ha: 1122,
      x_min: 64,
      x_max: 1050,
      o: 'm 420 79 l 324 131 l 806 903 l 902 851 l 420 79 m 990 221 l 1050 221 l 1050 108 l 990 108 l 990 0 l 851 0 l 851 108 l 616 108 l 608 199 l 850 535 l 990 535 l 990 221 m 741 221 l 851 221 l 851 365 l 842 350 l 741 221 m 216 771 l 272 771 q 353 831 353 771 q 333 869 353 854 q 281 883 314 883 q 232 872 252 883 q 212 842 212 862 l 73 842 q 131 953 73 911 q 277 995 188 995 q 433 955 375 995 q 491 842 491 914 q 399 727 491 761 q 501 602 501 699 q 439 488 501 531 q 277 445 377 445 q 122 490 180 445 q 64 612 64 535 l 203 612 q 227 573 203 589 q 285 556 250 556 q 343 574 326 556 q 361 616 361 592 q 279 679 361 678 l 216 679 l 216 771 z '
    },
    '¿': {
      ha: 691,
      x_min: 47,
      x_max: 659,
      o: 'm 452 436 q 431 290 452 346 q 356 184 410 235 q 282 110 302 134 q 253 60 263 85 q 243 5 243 35 q 348 -101 243 -101 q 431 -71 400 -101 q 463 15 462 -40 l 659 15 q 576 -188 658 -115 q 351 -261 494 -261 q 127 -192 207 -261 q 47 4 47 -123 q 151 216 47 112 l 216 279 q 263 342 250 309 q 278 436 277 376 l 452 436 m 476 644 q 445 569 476 598 q 366 540 414 540 q 288 569 319 540 q 256 644 256 598 q 287 718 256 689 q 366 747 317 747 q 446 718 416 747 q 476 644 476 689 z '
    },
    Æ: {
      ha: 1305,
      x_min: 1,
      x_max: 1265,
      o: 'm 1265 0 l 656 0 l 647 226 l 345 226 l 231 0 l 1 0 l 534 987 l 1223 987 l 1223 827 l 818 827 l 828 587 l 1168 587 l 1168 427 l 835 427 l 846 159 l 1265 159 l 1265 0 m 429 393 l 640 393 l 624 780 l 429 393 z '
    },
    '×': {
      ha: 738,
      x_min: 44,
      x_max: 688,
      o: 'm 44 253 l 252 465 l 44 677 l 159 791 l 366 581 l 572 791 l 688 677 l 479 465 l 688 253 l 572 139 l 366 349 l 159 139 l 44 253 z '
    },
    Ø: {
      ha: 957,
      x_min: 63,
      x_max: 904,
      o: 'm 904 471 q 852 216 904 326 q 705 46 801 106 q 485 -14 609 -14 q 285 34 374 -14 l 227 -64 l 100 -64 l 197 100 q 63 476 63 232 l 63 515 q 116 771 63 661 q 264 942 168 882 q 484 1001 360 1001 q 696 945 602 1001 l 747 1029 l 873 1029 l 783 876 q 904 511 904 741 l 904 471 m 269 471 q 302 278 269 355 l 606 791 q 484 833 556 833 q 326 753 381 833 q 269 519 270 673 l 269 471 m 699 516 q 673 690 699 618 l 374 185 q 485 153 422 153 q 643 234 587 153 q 699 468 698 314 l 699 516 z '
    },
    Þ: {
      ha: 845,
      x_min: 90,
      x_max: 801,
      o: 'm 286 987 l 286 806 l 442 806 q 633 768 552 806 q 758 661 714 730 q 801 500 801 591 q 707 281 801 363 q 450 195 613 198 l 286 195 l 286 0 l 90 0 l 90 987 l 286 987 m 286 648 l 286 353 l 437 353 q 561 393 517 353 q 605 499 605 433 q 562 606 605 566 q 443 648 519 647 l 286 648 z '
    },
    ß: {
      ha: 876,
      x_min: 92,
      x_max: 830,
      o: 'm 288 0 l 92 0 l 92 747 q 176 977 92 896 q 413 1057 260 1057 q 621 990 543 1057 q 699 806 699 922 q 663 674 699 733 q 627 563 627 615 q 647 511 627 538 q 728 431 668 484 q 830 240 830 340 q 752 53 830 120 q 528 -14 674 -14 q 420 -3 473 -14 q 339 24 366 8 l 376 180 q 524 144 442 144 q 606 169 578 144 q 635 237 635 194 q 611 297 635 268 q 532 372 588 327 q 431 555 431 453 q 468 681 431 620 q 505 796 505 743 q 475 872 505 844 q 399 900 445 900 q 288 755 291 900 l 288 0 z '
    },
    æ: {
      ha: 1173,
      x_min: 45,
      x_max: 1137,
      o: 'm 845 -14 q 583 86 677 -14 q 470 13 540 39 q 316 -14 401 -14 q 117 47 190 -14 q 45 216 45 107 q 129 381 45 323 q 378 440 213 439 l 492 440 l 492 479 q 464 559 492 530 q 385 589 437 589 q 297 565 329 589 q 264 505 264 541 l 68 518 q 157 683 68 619 q 387 747 245 747 q 608 673 530 747 q 829 747 694 749 q 1055 658 973 747 q 1137 412 1137 569 l 1137 305 l 684 305 q 739 185 692 227 q 865 144 786 144 q 962 155 918 144 q 1065 196 1006 165 l 1118 68 q 995 8 1068 30 q 845 -14 922 -14 m 353 130 q 426 145 387 130 q 492 184 465 161 l 492 313 l 380 313 q 278 283 316 312 q 241 214 241 255 q 268 153 241 176 q 353 130 296 130 m 829 589 q 731 550 768 589 q 686 437 694 511 l 945 437 l 945 456 q 915 554 945 519 q 829 589 886 589 z '
    },
    ð: {
      ha: 799,
      x_min: 57,
      x_max: 749,
      o: 'm 576 885 q 749 441 749 707 l 749 391 q 704 182 749 275 q 578 38 659 89 q 398 -14 498 -14 q 222 30 300 -14 q 101 149 144 73 q 57 317 57 225 q 140 565 57 474 q 363 655 224 655 q 529 604 456 655 q 416 783 496 707 l 287 701 l 234 778 l 337 844 q 158 919 258 892 l 220 1071 q 502 949 381 1038 l 618 1023 l 670 945 l 576 885 m 553 450 q 408 506 507 506 q 292 455 331 506 q 253 317 253 405 q 294 193 253 241 q 401 144 334 144 q 512 206 471 144 q 553 374 553 267 l 553 450 z '
    },
    '÷': {
      ha: 792,
      x_min: 43,
      x_max: 740,
      o: 'm 740 387 l 43 387 l 43 543 l 740 543 l 740 387 m 281 739 q 312 813 281 785 q 392 842 343 842 q 472 813 440 842 q 503 739 503 785 q 473 665 503 693 q 392 637 442 637 q 311 665 341 637 q 281 739 281 694 m 281 188 q 312 262 281 234 q 392 291 343 291 q 472 263 440 291 q 503 188 503 235 q 473 114 503 142 q 392 86 442 86 q 311 115 341 86 q 281 188 281 143 z '
    },
    ø: {
      ha: 784,
      x_min: 45,
      x_max: 740,
      o: 'm 45 374 q 87 568 45 483 q 208 701 129 654 q 391 747 287 747 q 517 728 460 747 l 565 825 l 674 825 l 604 682 q 740 359 740 581 q 646 89 740 191 q 393 -14 551 -14 q 273 4 328 -14 l 224 -96 l 115 -96 l 185 47 q 45 374 45 146 m 241 359 q 269 218 241 271 l 445 579 q 391 589 420 589 q 280 533 319 589 q 241 359 241 477 m 544 374 q 519 507 544 451 l 345 151 q 393 144 366 144 q 504 199 464 144 q 544 374 544 254 z '
    },
    þ: {
      ha: 788,
      x_min: 77,
      x_max: 737,
      o: 'm 737 360 q 660 89 737 191 q 452 -14 583 -14 q 273 63 341 -14 l 273 -282 l 77 -282 l 77 1042 l 273 1042 l 273 671 q 451 747 341 747 q 661 648 585 747 q 737 370 737 548 l 737 360 m 541 374 q 505 532 541 477 q 399 588 469 588 q 273 519 310 588 l 273 216 q 401 144 310 144 q 541 374 541 144 z '
    },
    đ: {
      ha: 876,
      x_min: 45,
      x_max: 813,
      o: 'm 813 826 l 706 826 l 706 0 l 529 0 l 519 78 q 331 -14 446 -14 q 123 89 201 -14 q 45 372 45 191 q 122 646 45 544 q 332 747 199 747 q 509 667 439 747 l 509 826 l 338 826 l 338 950 l 509 950 l 509 1042 l 706 1042 l 706 950 l 813 950 l 813 826 m 241 358 q 277 200 241 255 q 381 145 313 145 q 509 222 472 145 l 509 511 q 382 588 473 588 q 241 358 241 588 z '
    },
    Ħ: {
      ha: 1000,
      x_min: 22,
      x_max: 985,
      o: 'm 903 830 l 985 830 l 985 712 l 903 712 l 903 0 l 699 0 l 699 423 l 302 423 l 302 0 l 98 0 l 98 712 l 22 712 l 22 830 l 98 830 l 98 987 l 302 987 l 302 830 l 699 830 l 699 987 l 903 987 l 903 830 m 302 587 l 699 587 l 699 712 l 302 712 l 302 587 z '
    },
    ı: {
      ha: 380,
      x_min: 91,
      x_max: 287,
      o: 'm 287 0 l 91 0 l 91 734 l 287 734 l 287 0 z '
    },
    ĸ: {
      ha: 819,
      x_min: 88,
      x_max: 793,
      o: 'm 364 271 l 284 271 l 284 0 l 88 0 l 88 734 l 284 734 l 284 458 l 343 458 l 534 734 l 782 734 l 524 380 l 793 0 l 542 0 l 364 271 z '
    },
    Ł: {
      ha: 774,
      x_min: 20,
      x_max: 746,
      o: 'm 314 607 l 460 649 l 460 536 l 314 494 l 314 163 l 746 163 l 746 0 l 111 0 l 111 435 l 20 410 l 20 522 l 111 548 l 111 987 l 314 987 l 314 607 z '
    },
    ł: {
      ha: 425,
      x_min: 20,
      x_max: 402,
      o: 'm 306 617 l 402 649 l 402 536 l 306 505 l 306 0 l 110 0 l 110 439 l 20 410 l 20 522 l 110 552 l 110 1042 l 306 1042 l 306 617 z '
    },
    Ŋ: {
      ha: 977,
      x_min: 87,
      x_max: 890,
      o: 'm 890 987 l 890 -18 q 821 -223 890 -151 q 627 -296 751 -296 q 528 -285 572 -296 l 537 -123 q 604 -132 568 -132 q 686 -14 686 -132 l 686 0 l 291 665 l 291 0 l 87 0 l 87 987 l 291 987 l 686 323 l 686 987 l 890 987 z '
    },
    ŋ: {
      ha: 784,
      x_min: 73,
      x_max: 710,
      o: 'm 256 734 l 264 631 q 474 747 341 747 q 650 673 591 747 q 710 452 709 598 l 710 -23 q 642 -225 710 -155 q 452 -296 573 -296 q 355 -285 399 -296 l 364 -128 q 431 -136 395 -136 q 513 -19 513 -136 l 513 448 q 487 554 513 521 q 402 588 460 588 q 269 529 315 588 l 269 0 l 73 0 l 73 734 l 256 734 z '
    },
    Œ: {
      ha: 1345,
      x_min: 65,
      x_max: 1272,
      o: 'm 1272 0 l 671 0 q 476 -14 558 -14 q 264 36 358 -14 q 119 177 171 86 q 65 382 67 267 l 65 597 q 116 807 65 714 q 261 950 168 899 q 475 1001 355 1001 q 671 987 558 1001 l 1271 987 l 1271 823 l 814 823 l 814 587 l 1204 587 l 1204 428 l 814 428 l 814 163 l 1272 163 l 1272 0 m 476 144 q 610 153 540 144 l 610 833 q 475 843 534 843 q 317 780 373 843 q 261 600 262 718 l 261 391 q 318 208 261 271 q 476 144 374 144 z '
    },
    œ: {
      ha: 1253,
      x_min: 56,
      x_max: 1201,
      o: 'm 56 374 q 98 568 56 483 q 218 700 139 653 q 401 747 296 747 q 652 646 557 747 q 889 747 743 749 q 1118 660 1034 747 q 1201 412 1201 572 l 1201 305 l 758 305 q 813 186 768 229 q 927 144 857 144 q 1030 155 985 144 q 1131 197 1076 166 l 1185 70 q 1061 8 1135 31 q 907 -14 987 -14 q 654 87 749 -14 q 402 -14 560 -14 q 150 88 244 -14 q 56 365 56 189 l 56 374 m 252 359 q 291 199 252 254 q 402 144 329 144 q 513 198 474 144 q 551 374 551 253 q 512 533 551 477 q 401 589 473 589 q 291 533 330 589 q 252 359 252 477 m 889 589 q 804 550 837 589 q 760 439 770 511 l 1008 439 l 1008 456 q 977 555 1008 522 q 889 589 945 589 z '
    },
    ſ: {
      ha: 360,
      x_min: 79,
      x_max: 458,
      o: 'm 79 0 l 79 796 q 150 988 79 920 q 349 1056 220 1056 q 458 1042 393 1056 l 441 890 q 376 897 412 897 q 275 793 275 897 l 275 0 l 79 0 z '
    },
    Ə: {
      ha: 965,
      x_min: 51,
      x_max: 899,
      o: 'm 475 -14 q 162 108 274 -14 q 51 455 51 229 l 51 560 l 695 560 q 621 755 690 688 q 420 823 551 823 q 158 780 282 823 l 125 947 q 260 984 168 968 q 431 1001 351 1001 q 774 878 649 1001 q 899 535 899 754 l 899 441 q 844 208 899 312 q 692 45 789 104 q 475 -14 594 -14 m 475 163 q 623 224 566 163 q 693 395 681 286 l 254 395 l 254 374 q 311 217 254 271 q 475 163 368 163 z '
    },
    ƒ: {
      ha: 501,
      x_min: -24,
      x_max: 503,
      o: 'm 462 590 l 321 590 l 321 -32 q 255 -228 321 -159 q 73 -296 190 -296 q -24 -285 20 -296 l -14 -130 q 48 -138 5 -138 q 108 -111 91 -138 q 125 -33 125 -84 l 125 590 l 16 590 l 16 734 l 125 734 l 125 802 q 197 989 126 923 q 395 1056 268 1056 q 503 1042 438 1056 l 487 890 q 420 897 458 897 q 321 795 321 897 l 321 734 l 462 734 l 462 590 z '
    },
    Ơ: {
      ha: 974,
      x_min: 54,
      x_max: 995,
      o: 'm 895 471 q 844 216 895 326 q 696 46 792 106 q 476 -14 600 -14 q 257 45 353 -14 q 108 214 161 104 q 54 466 55 323 l 54 515 q 107 771 54 661 q 255 942 159 882 q 475 1001 351 1001 q 644 968 568 1001 q 776 873 720 935 q 844 935 825 886 q 862 1062 862 983 l 995 1062 q 840 777 995 829 q 895 522 894 665 l 895 471 m 689 516 q 633 752 689 671 q 475 833 578 833 q 317 753 372 833 q 260 519 261 673 l 260 471 q 316 237 260 320 q 476 153 372 153 q 633 234 578 153 q 689 468 688 314 l 689 516 z '
    },
    ơ: {
      ha: 807,
      x_min: 43,
      x_max: 819,
      o: 'm 43 374 q 86 569 43 484 q 208 701 128 654 q 391 747 287 747 q 646 642 551 747 q 688 703 677 662 q 699 802 699 744 l 819 802 q 699 564 819 618 q 739 374 739 480 l 739 359 q 696 164 739 250 q 575 33 654 79 q 392 -14 497 -14 q 146 81 240 -14 q 44 335 52 175 l 43 374 m 240 359 q 279 200 240 255 q 392 144 319 144 q 503 199 464 144 q 543 374 543 254 q 503 532 543 475 q 391 589 464 589 q 279 533 319 589 q 240 359 240 477 z '
    },
    Ư: {
      ha: 989,
      x_min: 79,
      x_max: 1099,
      o: 'm 836 987 l 836 833 q 915 858 886 837 q 955 916 943 878 q 968 1042 968 954 l 1099 1042 q 1035 806 1099 880 q 836 726 972 732 l 836 337 q 734 81 836 175 q 457 -14 633 -14 q 182 78 284 -14 q 79 330 81 170 l 79 987 l 282 987 l 282 336 q 329 194 282 239 q 457 150 375 150 q 631 330 629 150 l 631 987 l 836 987 z '
    },
    ư: {
      ha: 847,
      x_min: 71,
      x_max: 905,
      o: 'm 905 798 q 857 615 905 675 q 705 545 808 556 l 705 0 l 520 0 l 515 75 q 314 -14 442 -14 q 134 54 196 -14 q 71 253 72 122 l 71 734 l 267 734 l 267 260 q 371 145 267 145 q 508 214 471 145 l 508 734 l 705 734 l 705 640 q 769 682 751 650 q 788 798 788 713 l 905 798 z '
    },
    ȷ: {
      ha: 391,
      x_min: -56,
      x_max: 298,
      o: 'm 298 734 l 298 -24 q 230 -225 297 -155 q 40 -296 162 -296 q -56 -285 -12 -296 l -47 -130 q 20 -138 -17 -138 q 102 -18 102 -138 l 102 734 l 298 734 z '
    },
    ə: {
      ha: 735,
      x_min: 53,
      x_max: 695,
      o: 'm 347 748 q 598 648 501 748 q 695 382 695 548 l 695 362 q 654 168 695 254 q 537 34 613 81 q 365 -13 462 -14 q 136 75 218 -13 q 53 321 53 163 l 53 429 l 496 429 q 441 547 486 505 q 327 590 397 590 q 163 557 232 590 l 123 537 l 69 664 q 192 726 119 703 q 347 748 265 748 m 365 145 q 450 184 417 145 q 494 295 484 222 l 245 295 l 245 277 q 277 179 245 212 q 365 145 308 145 z '
    },
    ˆ: {
      ha: 688,
      x_min: 83,
      x_max: 602,
      o: 'm 602 852 l 602 844 l 446 844 l 341 942 l 237 844 l 83 844 l 83 854 l 284 1042 l 398 1042 l 602 852 z '
    },
    ˇ: {
      ha: 654,
      x_min: 58,
      x_max: 591,
      o: 'm 325 945 l 424 1042 l 591 1042 l 591 1035 l 387 844 l 262 844 l 58 1036 l 58 1042 l 225 1042 l 325 945 z '
    },
    ˉ: {
      ha: 696,
      x_min: 114,
      x_max: 582,
      o: 'm 582 873 l 114 873 l 114 986 l 582 986 l 582 873 z '
    },
    '˘': {
      ha: 616,
      x_min: 72,
      x_max: 541,
      o: 'm 541 1035 q 476 889 541 945 q 307 833 412 833 q 137 888 201 833 q 72 1035 72 943 l 211 1035 q 236 969 211 992 q 307 945 262 945 q 376 969 351 945 q 401 1035 401 992 l 541 1035 z '
    },
    '˙': {
      ha: 368,
      x_min: 80,
      x_max: 281,
      o: 'm 180 1025 q 254 999 227 1025 q 281 932 281 972 q 254 865 281 891 q 180 840 227 840 q 107 865 134 840 q 80 932 80 891 q 107 999 80 972 q 180 1025 135 1025 z '
    },
    '˚': {
      ha: 463,
      x_min: 81,
      x_max: 383,
      o: 'm 81 899 q 125 997 81 957 q 232 1038 169 1038 q 339 998 294 1038 q 383 899 383 958 q 340 802 383 841 q 232 762 296 762 q 123 802 166 762 q 81 899 81 842 m 159 899 q 178 847 159 869 q 232 826 198 826 q 286 847 266 826 q 305 899 305 869 q 285 951 305 930 q 232 972 265 972 q 179 951 199 972 q 159 899 159 930 z '
    },
    '˛': {
      ha: 418,
      x_min: 22,
      x_max: 288,
      o: 'm 274 0 q 197 -56 224 -28 q 170 -119 170 -83 q 214 -163 170 -163 q 269 -150 237 -163 l 288 -256 q 176 -286 239 -286 q 65 -249 109 -286 q 22 -144 22 -211 q 174 41 22 -28 l 274 0 z '
    },
    '˜': {
      ha: 668,
      x_min: 79,
      x_max: 590,
      o: 'm 590 1034 q 545 905 590 957 q 436 853 500 853 q 390 859 410 853 q 335 884 370 865 q 284 907 300 903 q 250 911 269 911 q 210 895 227 911 q 193 846 193 878 l 79 853 q 124 981 79 928 q 233 1034 168 1034 q 271 1029 253 1034 q 330 1004 289 1024 q 386 981 370 985 q 418 977 401 977 q 459 993 442 977 q 477 1041 477 1010 l 590 1034 z '
    },
    '˝': {
      ha: 570,
      x_min: 39,
      x_max: 606,
      o: 'm 430 1041 l 606 1041 l 425 837 l 277 837 l 430 1041 m 165 1041 l 338 1041 l 182 837 l 39 837 l 165 1041 z '
    },
    '˳': {
      ha: 436,
      x_min: 96,
      x_max: 349,
      o: 'm 224 -39 q 314 -73 279 -39 q 349 -156 349 -108 q 314 -237 349 -204 q 224 -271 279 -271 q 133 -238 170 -271 q 96 -156 96 -205 q 133 -73 96 -106 q 224 -39 170 -39 m 173 -156 q 188 -192 173 -178 q 224 -206 202 -206 q 259 -192 245 -206 q 273 -156 273 -178 q 259 -118 273 -133 q 224 -104 245 -104 q 188 -118 202 -104 q 173 -156 173 -133 z '
    },
    '̀': {
      ha: 0,
      x_min: -608,
      x_max: -260,
      o: 'm -260 831 l -420 831 l -608 1042 l -393 1042 l -260 831 z '
    },
    '́': {
      ha: 0,
      x_min: -463,
      x_max: -115,
      o: 'm -330 1042 l -115 1042 l -304 831 l -463 831 l -330 1042 z '
    },
    '̃': {
      ha: 0,
      x_min: -629,
      x_max: -118,
      o: 'm -118 1034 q -163 905 -118 957 q -272 853 -208 853 q -318 859 -298 853 q -373 884 -338 865 q -424 907 -408 903 q -458 911 -439 911 q -498 895 -481 911 q -515 846 -515 878 l -629 853 q -584 981 -629 928 q -475 1034 -540 1034 q -437 1029 -455 1034 q -378 1004 -419 1024 q -322 981 -338 985 q -290 977 -307 977 q -249 993 -266 977 q -231 1041 -231 1010 l -118 1034 z '
    },
    '̉': {
      ha: 0,
      x_min: -500,
      x_max: -238,
      o: 'm -487 859 l -497 950 q -426 963 -448 953 q -404 994 -404 972 q -500 1041 -404 1041 l -495 1133 q -303 1097 -368 1133 q -238 1000 -238 1062 q -266 935 -238 960 q -340 903 -294 909 l -340 859 l -487 859 z '
    },
    '̏': {
      ha: 0,
      x_min: -705,
      x_max: -115,
      o: 'm -345 849 l -507 849 l -705 1029 l -511 1029 l -345 849 m -115 849 l -273 849 l -439 1029 l -250 1029 l -115 849 z '
    },
    '̣': {
      ha: 0,
      x_min: -516,
      x_max: -297,
      o: 'm -516 -159 q -486 -92 -516 -118 q -407 -65 -455 -65 q -328 -92 -358 -65 q -297 -159 -297 -118 q -327 -226 -297 -199 q -407 -253 -357 -253 q -486 -226 -456 -253 q -516 -159 -516 -199 z '
    },
    '΄': {
      ha: 468,
      x_min: 148,
      x_max: 375,
      o: 'm 197 1086 l 375 1086 l 264 852 l 148 852 l 197 1086 z '
    },
    '΅': {
      ha: 762,
      x_min: 69,
      x_max: 675,
      o: 'm 344 1187 l 519 1187 l 415 962 l 315 962 l 344 1187 m 69 926 q 95 986 69 961 q 163 1012 121 1012 q 231 986 205 1012 q 257 926 257 961 q 231 865 257 890 q 163 840 205 840 q 96 865 122 840 q 69 926 69 890 m 488 926 q 514 987 488 962 q 581 1012 541 1012 q 648 987 621 1012 q 675 926 675 962 q 649 865 675 890 q 581 840 623 840 q 513 865 539 840 q 488 926 488 890 z '
    },
    '·': {
      ha: 418,
      x_min: 95,
      x_max: 317,
      o: 'm 95 473 q 126 549 95 519 q 205 578 157 578 q 285 549 254 578 q 317 473 317 519 q 285 397 317 426 q 205 368 253 368 q 126 398 157 368 q 95 473 95 427 z '
    },
    Γ: {
      ha: 774,
      x_min: 90,
      x_max: 736,
      o: 'm 736 823 l 293 823 l 293 0 l 90 0 l 90 987 l 736 987 l 736 823 z '
    },
    Δ: {
      ha: 1015,
      x_min: 14,
      x_max: 1007,
      o: 'm 408 987 l 618 987 l 1007 0 l 14 0 l 408 987 m 290 163 l 732 163 l 512 752 l 290 163 z '
    },
    '∆': {
      ha: 1015,
      x_min: 14,
      x_max: 1007,
      o: 'm 408 987 l 618 987 l 1007 0 l 14 0 l 408 987 m 290 163 l 732 163 l 512 752 l 290 163 z '
    },
    Θ: {
      ha: 956,
      x_min: 56,
      x_max: 897,
      o: 'm 611 412 l 351 412 l 351 569 l 611 569 l 611 412 m 897 471 q 845 216 897 326 q 697 46 793 106 q 477 -14 602 -14 q 258 45 355 -14 q 109 214 162 104 q 56 466 56 323 l 56 515 q 108 771 56 661 q 257 942 161 882 q 476 1001 353 1001 q 695 942 600 1001 q 844 771 791 882 q 897 515 897 661 l 897 471 m 690 516 q 635 752 690 671 q 476 833 579 833 q 318 753 374 833 q 262 519 262 673 l 262 471 q 317 237 262 320 q 477 153 373 153 q 635 234 580 153 q 690 468 690 314 l 690 516 z '
    },
    Λ: {
      ha: 899,
      x_min: 11,
      x_max: 886,
      o: 'm 448 707 l 231 0 l 11 0 l 342 987 l 554 987 l 886 0 l 666 0 l 448 707 z '
    },
    Ξ: {
      ha: 787,
      x_min: 64,
      x_max: 732,
      o: 'm 64 163 l 732 163 l 732 0 l 64 0 l 64 163 m 142 578 l 654 578 l 654 420 l 142 420 l 142 578 m 81 987 l 703 987 l 703 823 l 81 823 l 81 987 z '
    },
    Π: {
      ha: 983,
      x_min: 90,
      x_max: 892,
      o: 'm 892 0 l 688 0 l 688 823 l 293 823 l 293 0 l 90 0 l 90 987 l 892 987 l 892 0 z '
    },
    Σ: {
      ha: 787,
      x_min: 49,
      x_max: 749,
      o: 'm 562 493 l 325 163 l 749 163 l 749 0 l 49 0 l 49 102 l 347 498 l 49 885 l 49 987 l 733 987 l 733 823 l 328 823 l 562 503 l 562 493 z '
    },
    Φ: {
      ha: 1069,
      x_min: 50,
      x_max: 1027,
      o: 'm 641 873 q 844 819 757 868 q 979 684 932 770 q 1027 488 1027 597 q 979 296 1027 380 q 843 164 932 212 q 641 111 755 116 l 641 0 l 437 0 l 437 111 q 233 162 322 115 q 97 294 144 210 q 50 486 50 378 q 98 684 50 597 q 234 820 146 771 q 437 873 323 869 l 437 987 l 641 987 l 641 873 m 250 486 q 300 343 250 393 q 437 288 350 293 l 437 696 q 299 637 349 690 q 250 486 250 583 m 827 488 q 778 636 827 582 q 641 696 730 690 l 641 289 q 778 345 729 294 q 827 488 827 395 z '
    },
    Ψ: {
      ha: 1009,
      x_min: 35,
      x_max: 971,
      o: 'm 608 430 q 727 505 688 445 q 766 673 766 564 l 766 987 l 971 987 l 971 667 q 864 378 969 486 q 608 264 769 282 l 608 0 l 405 0 l 405 264 q 135 385 235 277 q 35 671 36 492 l 35 987 l 239 987 l 239 673 q 282 507 239 567 q 405 431 326 447 l 405 987 l 608 987 l 608 430 z '
    },
    Ω: {
      ha: 933,
      x_min: 69,
      x_max: 852,
      o: 'm 498 168 q 625 486 616 219 l 625 585 q 582 771 625 709 q 460 834 538 834 q 340 771 384 834 q 296 585 296 709 l 296 526 q 330 283 296 373 q 428 168 363 193 l 428 0 l 81 0 l 81 165 l 228 165 q 112 327 154 232 q 69 523 70 421 l 69 583 q 119 799 69 703 q 258 947 168 895 q 460 1000 347 1000 q 662 948 572 1000 q 801 803 751 897 q 852 593 850 710 l 852 526 q 810 326 852 420 q 694 165 767 231 l 840 165 l 840 0 l 498 0 l 498 168 z '
    },
    Ω: {
      ha: 933,
      x_min: 69,
      x_max: 852,
      o: 'm 498 168 q 625 486 616 219 l 625 585 q 582 771 625 709 q 460 834 538 834 q 340 771 384 834 q 296 585 296 709 l 296 526 q 330 283 296 373 q 428 168 363 193 l 428 0 l 81 0 l 81 165 l 228 165 q 112 327 154 232 q 69 523 70 421 l 69 583 q 119 799 69 703 q 258 947 168 895 q 460 1000 347 1000 q 662 948 572 1000 q 801 803 751 897 q 852 593 850 710 l 852 526 q 810 326 852 420 q 694 165 767 231 l 840 165 l 840 0 l 498 0 l 498 168 z '
    },
    α: {
      ha: 783,
      x_min: 50,
      x_max: 779,
      o: 'm 699 734 l 699 227 q 747 147 701 147 q 762 150 757 147 l 779 3 q 694 -14 745 -14 q 525 99 571 -14 q 336 -14 458 -14 q 134 76 210 -14 q 50 320 57 165 l 50 361 q 127 644 50 540 q 337 747 204 747 q 515 646 449 747 l 529 734 l 699 734 m 246 347 q 385 144 246 144 q 503 209 466 144 l 503 517 q 387 589 466 589 q 283 530 319 589 q 246 347 246 472 z '
    },
    β: {
      ha: 836,
      x_min: 96,
      x_max: 785,
      o: 'm 425 1001 q 657 930 571 1001 q 743 734 743 860 q 709 611 743 666 q 613 523 675 556 q 741 432 696 494 q 785 281 785 370 q 705 64 785 142 q 483 -14 624 -14 q 292 38 376 -14 l 292 -275 l 96 -275 l 96 701 q 139 855 96 786 q 258 962 182 924 q 425 1001 334 1001 m 547 719 q 513 808 547 774 q 425 842 479 842 q 330 804 367 842 q 292 699 292 766 l 292 184 q 439 144 348 144 q 549 183 508 144 q 589 283 589 222 q 552 398 589 357 q 444 439 515 439 l 378 439 l 378 582 l 431 582 q 547 719 547 586 z '
    },
    γ: {
      ha: 709,
      x_min: 12,
      x_max: 699,
      o: 'm 357 231 l 494 734 l 699 734 l 452 9 l 452 -283 l 256 -283 l 256 16 l 12 734 l 216 734 l 357 231 z '
    },
    δ: {
      ha: 784,
      x_min: 46,
      x_max: 743,
      o: 'm 130 847 q 205 1008 130 951 q 409 1066 280 1066 q 540 1049 477 1066 l 586 1036 l 586 885 q 426 917 485 917 q 346 900 375 917 q 317 852 317 882 q 425 760 317 798 q 604 665 532 722 q 709 535 675 608 q 743 355 743 463 q 648 89 743 191 q 396 -14 553 -14 q 142 85 238 -14 q 46 352 46 184 l 46 359 q 107 552 46 467 q 260 661 168 637 l 258 665 q 130 847 130 731 m 242 364 q 283 202 242 260 q 396 144 325 144 q 507 202 466 144 q 547 378 547 260 q 505 515 547 453 q 396 592 462 578 q 284 534 326 592 q 242 364 242 476 z '
    },
    ε: {
      ha: 772,
      x_min: 64,
      x_max: 726,
      o: 'm 64 208 q 203 378 64 332 q 111 443 144 402 q 77 533 77 484 q 165 690 77 633 q 405 747 253 747 q 628 684 541 747 q 715 522 715 621 l 519 522 q 485 578 519 557 q 395 599 450 599 q 307 576 340 599 q 273 517 273 554 q 304 461 273 482 q 395 440 334 440 l 522 440 l 522 309 l 393 309 q 260 222 260 309 q 297 159 260 184 q 394 134 334 134 q 493 157 456 134 q 530 217 530 181 l 726 217 q 636 50 726 113 q 405 -14 546 -14 q 159 47 254 -14 q 64 208 64 108 z '
    },
    ζ: {
      ha: 696,
      x_min: 52,
      x_max: 656,
      o: 'm 656 987 l 656 876 l 413 585 q 304 430 334 494 q 275 289 275 366 q 300 204 275 233 q 398 153 324 174 q 508 119 472 132 q 607 59 578 95 q 635 -34 635 22 q 590 -151 635 -85 q 478 -264 545 -217 l 378 -188 q 441 -74 444 -119 q 380 -12 444 -31 l 319 3 q 137 96 194 35 q 81 259 81 157 q 123 456 81 363 q 265 667 165 549 l 403 830 l 52 830 l 52 987 l 656 987 z '
    },
    η: {
      ha: 784,
      x_min: 73,
      x_max: 710,
      o: 'm 256 734 l 263 644 q 474 747 344 747 q 710 484 705 747 l 710 -281 l 513 -281 l 513 475 q 402 589 511 589 q 269 526 316 589 l 269 0 l 73 0 l 73 734 l 256 734 z '
    },
    θ: {
      ha: 819,
      x_min: 76,
      x_max: 743,
      o: 'm 743 412 q 656 97 743 208 q 410 -14 570 -14 q 165 94 252 -14 q 76 401 79 202 l 76 576 q 162 891 76 781 q 409 1001 249 1001 q 653 895 566 1001 q 743 589 740 789 l 743 412 m 547 420 l 272 420 l 272 386 q 410 144 272 144 q 546 351 537 144 l 547 420 m 272 572 l 547 572 l 547 604 q 512 784 547 725 q 409 842 478 842 q 273 638 281 842 l 272 572 z '
    },
    ι: {
      ha: 468,
      x_min: 94,
      x_max: 422,
      o: 'm 290 734 l 290 229 q 306 171 290 189 q 366 153 321 153 q 422 159 395 153 l 422 10 q 304 -7 370 -7 q 94 202 97 -7 l 94 734 l 290 734 z '
    },
    λ: {
      ha: 762,
      x_min: 5,
      x_max: 756,
      o: 'm 194 1048 q 375 938 328 1048 l 661 220 l 672 196 q 730 146 695 147 l 744 146 l 755 147 l 756 -7 q 682 -12 728 -12 q 558 21 606 -12 q 482 132 511 55 l 366 450 l 216 0 l 5 0 l 264 717 l 216 829 q 181 876 202 863 q 128 890 160 890 l 89 888 l 85 1034 q 194 1048 132 1048 z '
    },
    ξ: {
      ha: 736,
      x_min: 70,
      x_max: 695,
      o: 'm 625 814 q 535 834 564 830 q 473 839 507 839 q 359 813 395 839 q 323 744 323 787 q 484 644 323 644 l 581 644 l 581 480 l 486 480 q 266 311 266 480 q 430 153 266 192 l 530 129 l 582 112 q 693 -37 695 68 q 647 -156 693 -90 q 536 -267 600 -222 l 435 -191 q 499 -76 499 -123 q 420 -9 499 -31 l 380 1 q 249 45 307 24 q 152 99 191 66 q 91 179 112 131 q 70 304 70 228 q 122 465 70 400 q 273 561 175 529 q 127 741 127 614 q 215 931 127 862 q 451 1001 303 1001 q 557 994 513 1001 q 656 967 600 987 l 625 814 z '
    },
    π: {
      ha: 894,
      x_min: 35,
      x_max: 867,
      o: 'm 850 584 l 734 584 l 734 229 q 750 171 734 189 q 810 153 765 153 q 867 159 840 153 l 867 10 q 749 -7 814 -7 q 538 201 543 -7 l 538 584 l 351 584 l 351 0 l 155 0 l 155 584 l 35 584 l 35 734 l 850 734 l 850 584 z '
    },
    ρ: {
      ha: 784,
      x_min: 77,
      x_max: 736,
      o: 'm 411 747 q 650 644 563 747 q 736 356 736 540 l 736 347 q 660 83 736 179 q 452 -14 583 -14 q 273 68 342 -14 l 273 -282 l 77 -282 l 77 385 q 168 649 77 551 q 411 747 260 747 m 273 206 q 401 144 311 144 q 505 195 469 144 q 541 361 541 246 q 504 530 541 471 q 401 589 468 589 q 307 533 341 589 q 273 370 273 477 l 273 206 z '
    },
    ς: {
      ha: 715,
      x_min: 43,
      x_max: 682,
      o: 'm 382 747 q 601 669 519 747 q 682 460 682 591 l 498 460 q 467 554 498 519 q 382 589 436 589 q 277 536 314 589 q 239 378 240 483 l 239 357 q 278 227 239 273 q 410 155 317 181 q 541 108 503 129 q 597 56 578 87 q 618 -23 616 25 q 571 -144 618 -77 q 464 -254 525 -211 l 361 -176 q 424 -62 425 -110 q 352 3 424 -14 q 118 127 191 45 q 43 348 45 210 l 43 376 q 84 570 43 485 q 202 701 125 655 q 382 747 279 747 z '
    },
    σ: {
      ha: 795,
      x_min: 45,
      x_max: 780,
      o: 'm 780 575 l 608 575 q 726 332 726 479 q 635 82 726 177 q 391 -14 543 -14 q 139 87 234 -14 q 45 365 45 189 l 45 374 q 138 635 45 536 q 393 734 231 734 l 780 734 l 780 575 m 241 359 q 280 199 241 254 q 391 144 319 144 q 494 199 458 144 q 530 374 530 254 q 494 523 530 470 q 390 575 457 575 q 280 524 319 575 q 241 359 241 472 z '
    },
    τ: {
      ha: 723,
      x_min: 30,
      x_max: 692,
      o: 'm 692 576 l 451 576 l 451 222 q 465 164 451 182 q 513 146 479 146 q 579 157 545 146 l 600 8 q 473 -14 542 -14 q 313 44 371 -14 q 255 222 256 101 l 255 576 l 30 576 l 30 734 l 692 734 l 692 576 z '
    },
    υ: {
      ha: 758,
      x_min: 77,
      x_max: 705,
      o: 'm 273 734 l 273 285 q 359 144 273 144 q 467 213 424 144 q 510 384 510 283 q 441 734 507 544 l 628 734 q 705 384 705 579 q 617 92 705 198 q 366 -14 529 -14 q 151 61 224 -14 q 77 277 78 137 l 77 734 l 273 734 z '
    },
    φ: {
      ha: 1036,
      x_min: 37,
      x_max: 990,
      o: 'm 414 -8 q 134 121 232 14 q 37 404 37 228 q 77 597 37 508 q 189 743 118 686 l 323 639 q 257 530 281 592 q 233 404 234 469 q 414 154 233 195 l 414 542 q 473 687 414 629 q 621 744 532 744 q 808 700 726 744 q 941 569 891 655 q 990 379 990 482 q 891 112 990 213 q 610 -9 791 10 l 610 -324 l 414 -324 l 414 -8 m 610 152 q 746 226 698 169 q 794 379 794 283 q 753 530 793 473 q 644 586 713 586 q 610 551 610 586 l 610 152 z '
    },
    ψ: {
      ha: 1034,
      x_min: 46,
      x_max: 988,
      o: 'm 608 734 l 608 153 q 792 404 792 192 q 719 734 790 548 l 901 734 q 988 404 988 586 q 889 117 988 223 q 608 -9 791 11 l 608 -324 l 412 -324 l 412 -8 q 141 114 235 14 q 46 391 48 215 l 46 734 l 243 734 l 243 399 q 412 155 243 195 l 412 734 l 608 734 z '
    },
    ω: {
      ha: 1140,
      x_min: 56,
      x_max: 1086,
      o: 'm 345 734 q 253 384 258 551 q 281 205 253 267 q 359 144 309 144 q 468 340 468 144 l 468 572 l 675 572 l 675 340 q 783 144 675 144 q 862 207 835 144 q 890 384 890 271 q 798 734 885 552 l 985 734 q 1086 384 1086 579 q 1010 86 1086 186 q 790 -14 935 -14 q 660 23 715 -14 q 571 130 604 60 q 482 23 538 60 q 353 -14 427 -14 q 132 86 207 -14 q 56 384 56 186 q 157 734 56 579 l 345 734 z '
    },
    ϑ: {
      ha: 827,
      x_min: 79,
      x_max: 820,
      o: 'm 820 391 q 743 372 787 380 l 743 315 q 651 75 743 163 q 409 -14 559 -14 q 171 78 262 -14 q 79 316 79 169 l 79 477 l 266 477 l 266 313 q 307 195 266 239 q 418 151 349 151 q 506 193 475 151 q 537 311 537 235 l 537 371 q 316 491 399 400 q 231 707 233 583 l 231 730 q 303 928 231 854 q 492 1001 376 1001 q 675 926 609 1001 q 743 721 742 851 l 743 543 l 812 557 l 820 391 m 417 723 q 448 618 417 664 q 537 551 478 573 l 537 743 q 482 827 536 827 q 417 735 417 827 l 417 723 z '
    },
    ϒ: {
      ha: 821,
      x_min: -17,
      x_max: 840,
      o: 'm 411 520 l 534 840 q 618 966 568 928 q 741 1005 668 1005 q 840 988 790 1005 l 814 831 l 775 835 q 708 787 729 835 l 512 331 l 512 0 l 307 0 l 307 331 l 113 787 q 45 835 93 835 l 7 831 l -17 988 q 81 1005 34 1005 q 205 969 157 1005 q 285 854 254 932 l 411 520 z '
    },
    ϖ: {
      ha: 1149,
      x_min: 14,
      x_max: 1143,
      o: 'm 1143 594 l 1057 594 q 1091 384 1091 494 q 1018 86 1091 185 q 804 -14 945 -14 q 668 24 726 -14 q 575 134 609 61 q 482 24 541 61 q 346 -14 424 -14 q 131 87 204 -14 q 58 384 58 187 q 92 594 58 494 l 14 594 l 14 734 l 1143 734 l 1143 594 m 896 384 q 859 594 893 483 l 291 594 q 254 384 257 485 q 280 205 254 267 q 353 144 306 144 q 472 340 472 144 l 472 470 l 678 470 l 678 340 q 797 144 678 144 q 870 205 844 144 q 896 384 896 267 z '
    },
    Ђ: {
      ha: 1038,
      x_min: 20,
      x_max: 1000,
      o: 'm 790 823 l 469 823 l 469 586 q 634 607 559 607 q 905 527 810 607 q 1000 300 1000 446 q 976 174 1000 234 q 901 72 952 115 q 623 -12 801 -12 l 623 142 q 797 288 797 142 q 752 399 797 357 q 624 441 707 441 q 469 426 545 441 l 469 0 l 265 0 l 265 823 l 20 823 l 20 987 l 790 987 l 790 823 z '
    },
    Є: {
      ha: 916,
      x_min: 59,
      x_max: 865,
      o: 'm 865 328 q 748 79 853 172 q 467 -14 642 -14 q 170 112 279 -14 q 59 454 61 237 l 59 524 q 109 777 59 669 q 253 943 159 885 q 469 1001 346 1001 q 745 909 641 1001 q 865 652 849 817 l 662 652 q 609 792 654 747 q 469 836 563 836 q 323 772 374 836 q 264 576 272 709 l 567 576 l 567 412 l 264 412 q 318 216 271 283 q 467 149 366 149 q 606 193 559 149 q 661 328 654 237 l 865 328 z '
    },
    Љ: {
      ha: 1469,
      x_min: 27,
      x_max: 1428,
      o: 'm 891 652 l 1055 652 q 1250 611 1164 652 q 1382 495 1335 570 q 1428 326 1428 420 q 1325 91 1428 181 q 1048 0 1223 0 l 687 0 l 687 823 l 424 823 l 408 474 q 363 196 397 298 q 262 48 328 95 q 80 0 195 1 l 27 0 l 27 163 l 61 167 q 171 255 138 177 q 212 534 203 334 l 229 987 l 891 987 l 891 652 m 891 488 l 891 163 l 1053 163 q 1178 209 1131 163 q 1224 328 1224 255 q 1180 441 1224 396 q 1060 488 1135 486 l 891 488 z '
    },
    Њ: {
      ha: 1470,
      x_min: 90,
      x_max: 1428,
      o: 'm 293 571 l 688 571 l 688 987 l 892 987 l 892 646 l 1056 646 q 1251 605 1166 646 q 1382 491 1335 565 q 1428 323 1428 418 q 1328 91 1428 180 q 1061 0 1227 2 l 688 0 l 688 408 l 293 408 l 293 0 l 90 0 l 90 987 l 293 987 l 293 571 m 892 481 l 892 165 l 1055 165 q 1179 209 1132 165 q 1225 325 1225 254 q 1179 438 1225 394 q 1054 481 1133 481 l 892 481 z '
    },
    Ћ: {
      ha: 1072,
      x_min: 22,
      x_max: 992,
      o: 'm 777 823 l 460 823 l 460 620 q 607 632 547 632 q 892 550 795 632 q 992 313 989 468 l 992 0 l 789 0 l 789 306 q 747 431 789 393 q 607 468 706 468 q 460 456 547 468 l 460 0 l 256 0 l 256 823 l 22 823 l 22 987 l 777 987 l 777 823 z '
    },
    Џ: {
      ha: 972,
      x_min: 79,
      x_max: 882,
      o: 'm 79 987 l 283 987 l 283 163 l 678 163 l 678 987 l 882 987 l 882 0 l 592 0 l 592 -244 l 387 -244 l 387 0 l 79 0 l 79 987 z '
    },
    Б: {
      ha: 870,
      x_min: 86,
      x_max: 829,
      o: 'm 732 823 l 292 823 l 292 631 l 450 631 q 727 547 625 631 q 829 319 829 463 q 727 89 829 176 q 458 0 626 1 l 86 0 l 86 987 l 732 987 l 732 823 m 292 467 l 292 163 l 454 163 q 578 206 532 163 q 625 321 625 249 q 580 427 625 388 q 458 467 536 466 l 292 467 z '
    },
    Д: {
      ha: 1038,
      x_min: 17,
      x_max: 1020,
      o: 'm 1004 -243 l 816 -243 l 816 0 l 220 0 l 220 -242 l 28 -242 l 17 163 l 92 163 q 185 311 152 214 q 229 552 218 408 l 258 987 l 905 987 l 905 163 l 1020 163 l 1004 -243 m 325 163 l 701 163 l 701 823 l 451 823 l 434 563 q 325 163 414 302 z '
    },
    Ж: {
      ha: 1385,
      x_min: 12,
      x_max: 1385,
      o: 'm 921 402 l 804 402 l 804 0 l 600 0 l 600 402 l 480 402 l 265 0 l 12 0 l 319 530 l 26 987 l 279 987 l 499 589 l 600 589 l 600 987 l 804 987 l 804 589 l 903 589 l 1117 987 l 1369 987 l 1082 530 l 1385 0 l 1131 0 l 921 402 z '
    },
    З: {
      ha: 857,
      x_min: 45,
      x_max: 795,
      o: 'm 575 715 q 531 804 575 772 q 414 836 487 836 q 306 804 349 836 q 263 720 263 772 l 60 720 q 105 864 60 800 q 233 964 150 928 q 414 1000 316 1000 q 682 927 585 1000 q 779 720 779 854 q 740 597 779 654 q 627 507 700 541 q 751 421 708 479 q 795 277 795 363 q 691 65 795 144 q 414 -13 587 -13 q 220 24 307 -13 q 90 125 134 61 q 45 274 45 189 l 250 274 q 296 185 250 221 q 414 150 342 150 q 543 186 496 150 q 590 279 590 223 q 548 390 590 357 q 425 424 506 424 l 304 424 l 304 583 l 429 583 q 575 715 575 585 z '
    },
    И: {
      ha: 972,
      x_min: 81,
      x_max: 884,
      o: 'm 680 987 l 884 987 l 884 0 l 680 0 l 680 656 l 285 0 l 81 0 l 81 987 l 285 987 l 285 330 l 680 987 z '
    },
    Л: {
      ha: 981,
      x_min: 27,
      x_max: 891,
      o: 'm 891 987 l 891 0 l 687 0 l 687 823 l 424 823 l 408 474 q 363 196 397 298 q 262 48 328 95 q 80 0 195 1 l 27 0 l 27 163 l 61 167 q 171 255 138 177 q 212 534 203 334 l 229 987 l 891 987 z '
    },
    У: {
      ha: 877,
      x_min: 21,
      x_max: 858,
      o: 'm 458 521 l 638 987 l 858 987 l 513 173 l 485 119 q 250 -14 408 -14 l 179 -12 l 177 152 q 230 149 193 149 q 299 164 273 149 q 342 219 325 179 l 368 283 l 21 987 l 240 987 l 458 521 z '
    },
    Ф: {
      ha: 1134,
      x_min: 50,
      x_max: 1088,
      o: 'm 668 899 l 680 899 q 890 848 796 899 q 1036 703 984 797 q 1088 488 1088 608 q 975 198 1088 311 q 668 85 861 85 l 668 -41 l 472 -41 l 472 85 l 459 85 q 248 136 342 85 q 101 278 153 186 q 50 487 50 370 q 101 699 50 606 q 245 845 153 793 q 453 899 338 898 l 472 899 l 472 1028 l 668 1028 l 668 899 m 459 730 q 300 667 358 730 q 242 487 242 603 q 300 316 242 378 q 462 254 357 254 l 472 254 l 472 730 l 459 730 m 668 730 l 668 254 l 682 254 q 839 317 781 254 q 896 488 896 380 q 840 666 896 602 q 678 730 783 730 l 668 730 z '
    },
    Ц: {
      ha: 1054,
      x_min: 79,
      x_max: 1017,
      o: 'm 79 987 l 283 987 l 283 163 l 678 163 l 678 987 l 882 987 l 882 163 l 1017 163 l 1004 -238 l 814 -238 l 814 0 l 79 0 l 79 987 z '
    },
    Ч: {
      ha: 966,
      x_min: 93,
      x_max: 876,
      o: 'm 876 987 l 876 0 l 672 0 l 672 374 q 478 355 579 355 q 193 437 290 355 q 93 674 96 519 l 93 987 l 297 987 l 297 678 q 338 556 298 593 q 478 519 378 519 q 672 538 579 519 l 672 987 l 876 987 z '
    },
    Ш: {
      ha: 1331,
      x_min: 87,
      x_max: 1244,
      o: 'm 291 987 l 291 163 l 565 163 l 565 987 l 769 987 l 769 163 l 1040 163 l 1040 987 l 1244 987 l 1244 0 l 87 0 l 87 987 l 291 987 z '
    },
    Щ: {
      ha: 1418,
      x_min: 87,
      x_max: 1374,
      o: 'm 291 987 l 291 163 l 565 163 l 565 987 l 769 987 l 769 163 l 1040 163 l 1040 987 l 1244 987 l 1244 157 l 1374 157 l 1360 -237 l 1179 -237 l 1179 0 l 87 0 l 87 987 l 291 987 z '
    },
    Ъ: {
      ha: 1070,
      x_min: 17,
      x_max: 1029,
      o: 'm 17 987 l 492 987 l 492 631 l 650 631 q 927 547 825 631 q 1029 319 1029 463 q 927 89 1029 176 q 658 0 826 1 l 287 0 l 287 829 l 17 829 l 17 987 m 492 467 l 492 163 l 654 163 q 778 206 732 163 q 825 321 825 249 q 780 427 825 388 q 659 467 736 466 l 492 467 z '
    },
    Ы: {
      ha: 1211,
      x_min: 90,
      x_max: 1120,
      o: 'm 295 631 l 454 631 q 730 547 628 631 q 832 319 832 463 q 731 89 832 176 q 461 0 629 1 l 90 0 l 90 987 l 295 987 l 295 631 m 1120 0 l 917 0 l 917 987 l 1120 987 l 1120 0 m 295 467 l 295 163 l 457 163 q 582 206 535 163 q 628 321 628 249 q 584 427 628 388 q 462 467 539 466 l 295 467 z '
    },
    Ь: {
      ha: 869,
      x_min: 87,
      x_max: 829,
      o: 'm 292 631 l 450 631 q 727 547 625 631 q 829 319 829 463 q 727 89 829 176 q 458 0 626 1 l 87 0 l 87 987 l 292 987 l 292 631 m 292 467 l 292 163 l 454 163 q 578 206 532 163 q 625 321 625 249 q 580 427 625 388 q 458 467 536 466 l 292 467 z '
    },
    Э: {
      ha: 903,
      x_min: 42,
      x_max: 848,
      o: 'm 246 328 q 302 191 255 233 q 440 149 350 149 q 588 215 540 149 q 644 411 636 281 l 332 411 l 332 576 l 643 576 q 584 772 635 708 q 437 836 532 836 q 299 792 345 836 q 245 652 253 749 l 42 652 q 160 907 57 814 q 437 1001 264 1001 q 654 943 561 1001 q 798 777 747 885 q 848 525 848 669 l 848 460 q 739 114 848 242 q 440 -14 630 -14 q 160 79 265 -14 q 43 328 54 172 l 246 328 z '
    },
    Ю: {
      ha: 1310,
      x_min: 96,
      x_max: 1250,
      o: 'm 1250 471 q 1198 216 1250 326 q 1051 46 1147 106 q 831 -14 955 -14 q 628 36 718 -14 q 482 177 538 85 q 413 393 426 269 l 300 393 l 300 0 l 96 0 l 96 987 l 300 987 l 300 551 l 410 551 q 469 787 416 684 q 616 945 522 889 q 829 1001 710 1001 q 1049 942 953 1001 q 1197 771 1145 882 q 1250 515 1250 661 l 1250 471 m 1044 516 q 988 752 1044 671 q 829 833 932 833 q 671 753 727 833 q 615 519 616 673 l 615 471 q 671 237 615 320 q 831 153 726 153 q 988 234 933 153 q 1044 468 1043 314 l 1044 516 z '
    },
    Я: {
      ha: 829,
      x_min: -19,
      x_max: 749,
      o: 'm 545 0 l 545 356 l 379 356 l 201 0 l -19 0 l 192 421 q 39 682 39 505 q 134 907 39 827 q 399 987 229 986 l 749 987 l 749 0 l 545 0 m 243 667 q 283 547 243 585 q 404 510 323 510 l 545 510 l 545 823 l 404 823 q 243 667 243 823 z '
    },
    б: {
      ha: 791,
      x_min: 57,
      x_max: 749,
      o: 'm 439 693 q 665 600 581 693 q 749 345 749 506 l 749 336 q 655 81 749 177 q 404 -14 562 -14 q 151 89 245 -14 q 57 370 57 193 l 57 403 q 141 790 58 650 q 389 967 223 930 q 500 1005 475 986 q 526 1057 526 1023 l 684 1057 q 627 897 684 950 q 423 814 570 843 q 286 745 336 796 q 218 602 236 694 q 439 693 312 693 m 402 534 q 293 488 332 534 q 253 336 253 441 q 292 193 253 242 q 404 144 330 144 q 513 192 475 144 q 553 334 552 240 l 553 350 q 513 487 553 440 q 402 534 473 534 z '
    },
    в: {
      ha: 786,
      x_min: 88,
      x_max: 742,
      o: 'm 88 0 l 88 734 l 395 734 q 625 681 545 734 q 705 529 705 628 q 671 438 705 478 q 573 376 637 397 q 697 317 652 361 q 742 210 742 273 q 665 54 742 107 q 441 0 588 0 l 88 0 m 284 304 l 284 157 l 442 157 q 546 229 546 157 q 447 304 546 303 l 284 304 m 284 436 l 406 436 q 509 503 509 437 q 480 559 509 543 q 395 576 452 576 l 284 576 l 284 436 z '
    },
    г: {
      ha: 582,
      x_min: 75,
      x_max: 575,
      o: 'm 575 575 l 271 575 l 271 0 l 75 0 l 75 734 l 575 734 l 575 575 z '
    },
    д: {
      ha: 877,
      x_min: 22,
      x_max: 853,
      o: 'm 85 158 q 176 298 152 229 q 202 494 199 367 l 208 734 l 747 734 l 747 158 l 853 158 l 853 -220 l 657 -220 l 657 0 l 222 0 l 222 -220 l 22 -220 l 22 158 l 85 158 m 317 158 l 552 158 l 552 572 l 399 572 l 398 484 q 317 158 392 281 z '
    },
    ж: {
      ha: 1186,
      x_min: 26,
      x_max: 1168,
      o: 'm 781 272 l 692 272 l 692 0 l 496 0 l 496 272 l 409 272 l 263 0 l 26 0 l 258 384 l 29 734 l 272 734 l 425 460 l 496 460 l 496 734 l 692 734 l 692 460 l 766 460 l 919 734 l 1162 734 l 935 389 l 1168 0 l 927 0 l 781 272 z '
    },
    з: {
      ha: 713,
      x_min: 47,
      x_max: 669,
      o: 'm 460 517 q 435 577 460 556 q 363 599 410 599 q 284 579 315 599 q 254 522 254 559 l 58 522 q 141 684 58 622 q 353 747 224 747 q 575 691 494 747 q 656 533 656 635 q 627 443 656 484 q 544 378 597 402 q 669 208 669 334 q 583 46 669 106 q 353 -14 496 -14 q 133 49 219 -14 q 47 217 47 111 l 243 217 q 276 157 243 180 q 363 134 309 134 q 444 158 415 134 q 473 222 473 182 q 446 291 473 270 q 362 311 418 311 l 256 311 l 256 439 l 369 439 q 460 517 460 441 z '
    },
    и: {
      ha: 788,
      x_min: 75,
      x_max: 713,
      o: 'm 517 734 l 713 734 l 713 0 l 517 0 l 517 453 l 272 0 l 75 0 l 75 734 l 272 734 l 272 281 l 517 734 z '
    },
    к: {
      ha: 783,
      x_min: 88,
      x_max: 784,
      o: 'm 363 271 l 284 271 l 284 0 l 88 0 l 88 734 l 284 734 l 284 458 l 354 458 l 514 734 l 762 734 l 522 385 l 784 0 l 523 0 l 363 271 z '
    },
    л: {
      ha: 789,
      x_min: 15,
      x_max: 713,
      o: 'm 713 734 l 713 0 l 517 0 l 517 575 l 345 575 l 332 349 q 261 85 321 168 q 83 0 201 2 l 17 0 l 15 159 l 39 161 q 117 224 92 165 q 147 422 141 282 l 161 734 l 713 734 z '
    },
    м: {
      ha: 1055,
      x_min: 88,
      x_max: 960,
      o: 'm 522 231 l 714 734 l 960 734 l 960 0 l 764 0 l 764 450 l 588 0 l 456 0 l 284 443 l 284 0 l 88 0 l 88 734 l 332 734 l 522 231 z '
    },
    н: {
      ha: 788,
      x_min: 75,
      x_max: 711,
      o: 'm 711 0 l 515 0 l 515 282 l 271 282 l 271 0 l 75 0 l 75 734 l 271 734 l 271 439 l 515 439 l 515 734 l 711 734 l 711 0 z '
    },
    п: {
      ha: 788,
      x_min: 75,
      x_max: 713,
      o: 'm 713 0 l 517 0 l 517 575 l 271 575 l 271 0 l 75 0 l 75 734 l 713 734 l 713 0 z '
    },
    т: {
      ha: 707,
      x_min: 21,
      x_max: 684,
      o: 'm 684 576 l 449 576 l 449 0 l 252 0 l 252 576 l 21 576 l 21 734 l 684 734 l 684 576 z '
    },
    ф: {
      ha: 1015,
      x_min: 46,
      x_max: 968,
      o: 'm 46 361 q 118 643 46 538 q 317 747 191 747 q 408 728 367 747 l 408 1042 l 604 1042 l 604 727 q 696 747 646 747 q 896 643 824 747 q 968 347 968 539 q 896 84 968 181 q 698 -14 823 -14 q 604 5 646 -14 l 604 -282 l 408 -282 l 408 5 q 316 -14 367 -14 q 125 75 197 -14 q 47 319 54 164 l 46 361 m 772 361 q 739 530 772 471 q 645 589 705 589 q 604 584 626 589 l 604 148 q 646 144 623 144 q 771 319 762 144 l 772 361 m 242 347 q 366 144 242 144 q 408 148 392 144 l 408 584 q 368 589 385 589 q 275 531 307 589 q 242 347 242 474 z '
    },
    ц: {
      ha: 846,
      x_min: 75,
      x_max: 823,
      o: 'm 75 734 l 271 734 l 271 158 l 517 158 l 517 734 l 713 734 l 713 157 l 823 157 l 810 -218 l 627 -218 l 627 0 l 75 0 l 75 734 z '
    },
    ч: {
      ha: 769,
      x_min: 60,
      x_max: 694,
      o: 'm 694 0 l 498 0 l 498 231 q 395 220 443 220 q 145 291 229 220 q 60 497 61 361 l 60 734 l 256 734 l 256 497 q 287 406 256 433 q 395 378 317 378 q 498 390 444 378 l 498 734 l 694 734 l 694 0 z '
    },
    ш: {
      ha: 1149,
      x_min: 75,
      x_max: 1067,
      o: 'm 271 734 l 271 158 l 473 158 l 473 734 l 669 734 l 669 158 l 871 158 l 871 734 l 1067 734 l 1067 0 l 75 0 l 75 734 l 271 734 z '
    },
    щ: {
      ha: 1250,
      x_min: 73,
      x_max: 1211,
      o: 'm 269 734 l 269 158 l 471 158 l 471 734 l 667 734 l 667 158 l 868 158 l 868 734 l 1065 734 l 1065 157 l 1211 157 l 1197 -218 l 1015 -218 l 1015 0 l 73 0 l 73 734 l 269 734 z '
    },
    ъ: {
      ha: 911,
      x_min: 22,
      x_max: 884,
      o: 'm 22 734 l 428 734 l 428 519 l 568 519 q 735 487 663 519 q 845 396 807 455 q 884 258 884 336 q 798 71 884 142 q 564 0 712 0 l 232 0 l 232 575 l 22 575 l 22 734 m 428 361 l 428 157 l 567 157 q 656 184 625 157 q 688 258 688 211 q 657 333 688 305 q 567 361 627 361 l 428 361 z '
    },
    ы: {
      ha: 1149,
      x_min: 88,
      x_max: 1053,
      o: 'm 285 519 l 425 519 q 592 487 520 519 q 702 396 664 455 q 741 258 741 336 q 655 71 741 142 q 421 0 569 0 l 88 0 l 88 734 l 285 734 l 285 519 m 1053 0 l 857 0 l 857 734 l 1053 734 l 1053 0 m 285 361 l 285 157 l 424 157 q 513 184 482 157 q 545 258 545 211 q 514 333 545 305 q 424 361 484 361 l 285 361 z '
    },
    ь: {
      ha: 775,
      x_min: 88,
      x_max: 741,
      o: 'm 285 519 l 425 519 q 592 487 520 519 q 702 396 664 455 q 741 258 741 336 q 655 71 741 142 q 421 0 569 0 l 88 0 l 88 734 l 285 734 l 285 519 m 285 361 l 285 157 l 424 157 q 513 184 482 157 q 545 258 545 211 q 514 333 545 305 q 424 361 484 361 l 285 361 z '
    },
    э: {
      ha: 722,
      x_min: 43,
      x_max: 682,
      o: 'm 342 589 q 258 559 290 589 q 227 480 227 530 l 43 480 q 82 616 43 555 q 191 713 122 678 q 342 747 260 747 q 590 646 498 747 q 682 370 682 545 l 682 357 q 642 164 682 248 q 524 33 601 79 q 344 -14 447 -14 q 125 64 208 -14 q 43 273 43 142 l 227 273 q 259 180 227 216 q 344 144 290 144 q 439 185 403 144 q 483 309 475 227 l 286 309 l 286 429 l 483 429 q 342 589 463 589 z '
    },
    ю: {
      ha: 1127,
      x_min: 91,
      x_max: 1082,
      o: 'm 288 452 l 393 452 q 506 668 415 589 q 734 747 596 747 q 976 656 882 747 q 1081 410 1070 566 l 1082 359 q 988 89 1082 191 q 735 -14 894 -14 q 501 69 592 -14 q 391 294 410 152 l 288 294 l 288 0 l 91 0 l 91 734 l 288 734 l 288 452 m 583 359 q 623 200 583 255 q 735 144 662 144 q 847 199 808 144 q 886 374 886 254 q 846 532 886 476 q 734 589 806 589 q 623 533 662 589 q 583 359 583 477 z '
    },
    я: {
      ha: 777,
      x_min: 28,
      x_max: 687,
      o: 'm 687 734 l 687 0 l 492 0 l 492 254 l 368 254 l 227 0 l 28 0 l 188 287 q 86 370 122 317 q 51 488 51 422 q 133 663 51 595 q 354 734 216 731 l 687 734 m 357 391 l 492 391 l 492 576 l 364 576 q 279 549 312 576 q 247 482 247 522 q 278 417 247 443 q 357 391 309 391 z '
    },
    ђ: {
      ha: 777,
      x_min: -35,
      x_max: 705,
      o: 'm 439 806 l 267 806 l 267 654 q 463 747 345 747 q 705 470 701 747 l 705 -23 q 637 -225 705 -154 q 447 -296 569 -296 q 350 -285 394 -296 l 359 -130 q 427 -138 389 -138 q 509 -18 509 -138 l 509 464 q 481 558 509 528 q 391 588 454 588 q 267 522 305 588 l 267 0 l 71 0 l 71 806 l -35 806 l -35 930 l 71 930 l 71 1042 l 267 1042 l 267 930 l 439 930 l 439 806 z '
    },
    є: {
      ha: 722,
      x_min: 43,
      x_max: 687,
      o: 'm 379 144 q 467 174 433 144 q 503 254 501 204 l 687 254 q 646 117 686 178 q 536 21 606 55 q 382 -14 467 -14 q 135 86 227 -14 q 43 362 43 186 l 43 376 q 134 646 43 545 q 382 747 224 747 q 602 669 519 747 q 687 460 686 591 l 503 460 q 467 554 501 519 q 378 589 433 589 q 241 418 251 589 l 448 418 l 448 298 l 242 298 q 284 182 250 219 q 379 144 317 144 z '
    },
    љ: {
      ha: 1192,
      x_min: 14,
      x_max: 1162,
      o: 'm 707 502 l 841 502 q 1078 433 994 502 q 1162 252 1162 365 q 1077 69 1162 138 q 843 0 991 0 l 510 0 l 510 575 l 344 575 l 332 349 q 261 86 320 169 q 86 0 203 3 l 16 0 l 14 159 l 39 161 q 116 224 92 165 q 146 422 140 282 l 160 734 l 707 734 l 707 502 m 707 345 l 707 157 l 846 157 q 935 183 904 157 q 966 253 966 209 q 935 320 966 295 q 846 345 904 345 l 707 345 z '
    },
    њ: {
      ha: 1196,
      x_min: 75,
      x_max: 1167,
      o: 'm 271 450 l 515 450 l 515 734 l 711 734 l 711 502 l 846 502 q 1083 433 998 502 q 1167 252 1167 365 q 1082 69 1167 138 q 848 0 996 0 l 515 0 l 515 293 l 271 293 l 271 0 l 75 0 l 75 734 l 271 734 l 271 450 m 711 345 l 711 157 l 850 157 q 940 183 909 157 q 971 253 971 209 q 940 320 971 295 q 850 345 909 345 l 711 345 z '
    },
    ћ: {
      ha: 784,
      x_min: -26,
      x_max: 705,
      o: 'm 448 814 l 267 814 l 267 654 q 463 747 345 747 q 705 470 701 747 l 705 0 l 509 0 l 509 465 q 481 558 509 528 q 391 588 454 588 q 267 522 305 588 l 267 0 l 71 0 l 71 814 l -26 814 l -26 939 l 71 939 l 71 1042 l 267 1042 l 267 939 l 448 939 l 448 814 z '
    },
    џ: {
      ha: 788,
      x_min: 75,
      x_max: 713,
      o: 'm 271 734 l 271 158 l 517 158 l 517 734 l 713 734 l 713 0 l 492 0 l 492 -243 l 296 -243 l 296 0 l 75 0 l 75 734 l 271 734 z '
    },
    Ѡ: {
      ha: 1315,
      x_min: 81,
      x_max: 1228,
      o: 'm 1228 987 l 1228 317 q 1138 75 1228 164 q 891 -14 1048 -14 q 654 96 736 -14 q 417 -14 573 -14 q 171 75 262 -14 q 81 317 81 163 l 81 987 l 285 987 l 285 323 q 417 149 285 149 q 516 189 479 149 q 552 315 552 229 l 552 987 l 757 987 l 757 321 q 891 149 757 149 q 988 189 953 149 q 1024 315 1024 229 l 1024 987 l 1228 987 z '
    },
    ѡ: {
      ha: 1139,
      x_min: 68,
      x_max: 1085,
      o: 'm 1085 734 l 1085 298 q 1004 70 1084 153 q 787 -14 924 -14 l 786 -14 q 578 83 650 -14 q 364 -14 503 -14 q 150 68 229 -14 q 68 296 70 151 l 68 734 l 264 734 l 264 293 q 364 144 267 144 q 481 296 479 144 l 481 734 l 677 734 l 677 291 q 786 144 681 144 q 888 292 886 144 l 888 734 l 1085 734 z '
    },
    ѣ: {
      ha: 774,
      x_min: -18,
      x_max: 740,
      o: 'm 458 734 l 285 734 l 285 536 l 428 536 q 656 462 572 534 q 740 269 740 389 q 656 76 740 149 q 431 0 573 2 l 88 0 l 88 734 l -18 734 l -18 858 l 88 858 l 88 1059 l 285 1059 l 285 858 l 458 858 l 458 734 m 285 378 l 285 157 l 424 157 q 514 186 483 157 q 545 269 545 216 q 515 347 545 317 q 429 378 486 377 l 285 378 z '
    },
    Ѥ: {
      ha: 1240,
      x_min: 85,
      x_max: 1211,
      o: 'm 288 583 l 407 583 q 470 806 416 711 q 612 951 523 901 q 815 1002 701 1002 q 1090 910 986 1002 q 1211 653 1195 819 l 1008 653 q 955 792 1000 749 q 815 835 909 835 q 671 773 722 835 q 612 583 621 711 l 903 583 l 903 425 l 612 425 q 666 218 617 283 q 813 153 715 153 q 953 196 907 153 q 1006 330 1000 238 l 1210 330 q 1092 79 1198 170 q 813 -13 986 -13 q 523 104 631 -13 q 406 425 415 222 l 288 425 l 288 0 l 85 0 l 85 987 l 288 987 l 288 583 z '
    },
    ѥ: {
      ha: 1048,
      x_min: 79,
      x_max: 1008,
      o: 'm 276 430 l 368 430 q 471 663 382 578 q 703 747 559 747 q 923 669 840 747 q 1008 460 1006 591 l 824 460 q 789 553 823 517 q 699 589 755 589 q 563 430 579 589 l 783 430 l 783 306 l 562 306 q 700 144 575 144 q 788 175 754 144 q 824 254 823 205 l 1008 254 q 920 63 1006 139 q 704 -14 833 -14 q 470 72 559 -14 q 367 306 380 157 l 276 306 l 276 0 l 79 0 l 79 734 l 276 734 l 276 430 z '
    },
    Ѧ: {
      ha: 918,
      x_min: 10,
      x_max: 916,
      o: 'm 609 284 l 544 284 l 544 0 l 374 0 l 374 284 l 317 284 l 224 0 l 10 0 l 358 987 l 570 987 l 916 0 l 703 0 l 609 284 m 363 425 l 563 425 l 463 730 l 363 425 z '
    },
    ѧ: {
      ha: 777,
      x_min: 5,
      x_max: 761,
      o: 'm 496 182 l 444 182 l 444 0 l 315 0 l 315 182 l 268 182 l 205 0 l 5 0 l 282 734 l 484 734 l 761 0 l 561 0 l 496 182 m 312 310 l 452 310 l 402 452 l 382 539 l 361 452 l 312 310 z '
    },
    Ѩ: {
      ha: 1299,
      x_min: 100,
      x_max: 1286,
      o: 'm 303 425 l 529 425 l 728 987 l 939 987 l 1286 0 l 1072 0 l 979 284 l 913 284 l 913 0 l 744 0 l 744 284 l 687 284 l 593 0 l 380 0 l 479 284 l 303 284 l 303 0 l 100 0 l 100 987 l 303 987 l 303 425 m 733 425 l 932 425 l 833 728 l 733 425 z '
    },
    ѩ: {
      ha: 1109,
      x_min: 85,
      x_max: 1093,
      o: 'm 282 309 l 453 309 l 614 734 l 814 734 l 1093 0 l 892 0 l 828 182 l 776 182 l 776 0 l 646 0 l 646 182 l 600 182 l 536 0 l 336 0 l 405 182 l 282 182 l 282 0 l 85 0 l 85 734 l 282 734 l 282 309 m 644 310 l 783 310 l 734 452 l 713 539 l 693 452 l 644 310 z '
    },
    Ѫ: {
      ha: 1211,
      x_min: 74,
      x_max: 1136,
      o: 'm 801 542 q 1051 461 969 536 q 1136 241 1133 387 l 1136 0 l 932 0 l 932 233 q 896 342 932 309 q 778 376 861 375 l 716 376 l 716 0 l 513 0 l 513 376 l 440 376 q 315 343 352 376 q 277 233 278 309 l 277 0 l 74 0 l 74 231 q 162 464 75 387 q 432 543 249 541 l 180 987 l 1055 987 l 801 542 m 617 574 l 745 821 l 490 821 l 617 574 z '
    },
    ѫ: {
      ha: 1019,
      x_min: 75,
      x_max: 943,
      o: 'm 689 412 q 882 325 820 397 q 943 123 943 252 l 943 0 l 747 0 l 747 128 q 717 235 747 203 q 610 266 687 266 l 610 0 l 414 0 l 414 266 l 399 266 q 301 234 330 266 q 271 127 272 202 l 271 0 l 75 0 l 75 129 q 141 331 77 261 q 339 414 206 401 l 154 734 l 874 734 l 689 412 m 514 427 l 600 604 l 429 604 l 514 427 z '
    },
    Ѭ: {
      ha: 1615,
      x_min: 101,
      x_max: 1541,
      o: 'm 479 0 l 479 229 q 508 385 479 319 l 304 385 l 304 0 l 101 0 l 101 987 l 304 987 l 304 545 l 836 545 l 585 987 l 1459 987 l 1206 542 q 1456 461 1374 536 q 1541 241 1537 387 l 1541 0 l 1337 0 l 1337 233 q 1301 342 1337 309 q 1183 376 1265 375 l 1121 376 l 1121 0 l 918 0 l 918 376 l 845 376 q 720 343 757 376 q 682 233 683 309 l 682 0 l 479 0 m 1022 574 l 1149 821 l 895 821 l 1022 574 z '
    },
    ѭ: {
      ha: 1397,
      x_min: 91,
      x_max: 1322,
      o: 'm 453 0 l 453 123 q 480 271 453 210 l 287 271 l 287 0 l 91 0 l 91 734 l 287 734 l 287 416 l 716 416 l 532 734 l 1253 734 l 1067 412 q 1260 325 1198 397 q 1322 123 1322 252 l 1322 0 l 1125 0 l 1125 124 q 1096 233 1125 201 q 989 266 1067 266 l 989 0 l 793 0 l 793 266 l 778 266 q 679 234 707 266 q 649 127 650 202 l 649 0 l 453 0 m 892 427 l 977 604 l 808 604 l 892 427 z '
    },
    Ѯ: {
      ha: 713,
      x_min: 5,
      x_max: 642,
      o: 'm 415 711 q 377 793 415 762 q 259 824 340 824 l 82 824 l 82 987 l 257 987 q 521 920 431 987 q 612 730 612 853 q 457 506 612 569 q 594 419 547 477 q 642 277 642 361 q 550 64 642 142 q 295 -14 458 -14 l 257 -14 q 183 -78 183 -16 q 281 -184 183 -144 l 226 -304 q 64 -215 121 -280 q 5 -51 6 -150 q 66 96 5 44 q 241 149 127 148 l 292 149 q 404 184 362 150 q 445 274 445 218 q 256 423 445 423 l 161 423 l 161 587 l 269 587 q 377 620 339 588 q 415 711 415 652 m 333 1211 l 432 1308 l 600 1308 l 600 1300 l 395 1109 l 271 1109 l 66 1301 l 66 1308 l 233 1308 l 333 1211 z '
    },
    ѯ: {
      ha: 699,
      x_min: 19,
      x_max: 624,
      o: 'm 397 513 q 254 591 397 591 l 82 591 l 82 734 l 266 734 q 510 680 427 732 q 593 532 593 627 q 474 366 593 417 q 624 206 624 321 q 540 46 624 105 q 315 -14 456 -13 l 273 -14 q 189 -78 189 -16 q 276 -184 189 -145 l 221 -293 q 75 -198 129 -263 q 19 -51 20 -132 q 76 81 19 34 q 243 128 133 128 l 279 128 q 386 151 345 128 q 428 213 428 174 q 265 303 428 303 l 161 303 l 161 425 l 268 425 q 397 513 397 425 m 319 948 l 419 1045 l 586 1045 l 586 1038 l 381 847 l 258 847 l 52 1038 l 52 1045 l 220 1045 l 319 948 z '
    },
    Ѳ: {
      ha: 956,
      x_min: 61,
      x_max: 902,
      o: 'm 902 471 q 850 216 902 326 q 703 46 799 106 q 483 -14 607 -14 q 264 45 360 -14 q 115 214 168 104 q 61 466 62 323 l 61 515 q 114 771 61 661 q 262 942 166 882 q 481 1001 358 1001 q 701 942 605 1001 q 849 771 797 882 q 902 515 902 661 l 902 471 m 483 153 q 634 225 579 153 q 695 434 688 297 l 268 434 q 331 225 275 297 q 483 153 386 153 m 481 833 q 331 763 385 833 q 269 557 276 692 l 695 557 q 632 763 688 692 q 481 833 577 833 z '
    },
    ѳ: {
      ha: 784,
      x_min: 43,
      x_max: 739,
      o: 'm 43 374 q 86 569 43 484 q 208 701 128 654 q 391 747 287 747 q 644 645 549 747 q 739 367 739 543 l 739 359 q 696 164 739 250 q 575 33 654 79 q 392 -14 497 -14 q 146 81 240 -14 q 44 335 52 175 l 43 374 m 391 589 q 290 546 329 589 q 243 427 252 503 l 539 427 q 491 547 530 506 q 391 589 453 589 m 392 144 q 491 185 454 144 q 539 302 528 225 l 243 302 q 290 186 252 227 q 392 144 328 144 z '
    },
    Ѵ: {
      ha: 892,
      x_min: 7,
      x_max: 873,
      o: 'm 429 268 l 442 206 l 455 265 l 595 761 q 694 943 634 886 q 847 1000 755 1000 l 873 999 l 872 828 l 854 828 q 772 748 795 828 l 548 0 l 337 0 l 7 987 l 223 987 l 429 268 z '
    },
    ѵ: {
      ha: 709,
      x_min: 12,
      x_max: 719,
      o: 'm 327 280 l 340 208 l 353 280 l 416 521 q 505 689 449 630 q 649 747 562 747 q 719 735 693 747 l 703 580 l 669 583 q 623 562 643 583 q 593 512 602 542 l 435 0 l 248 0 l 12 734 l 216 734 l 327 280 z '
    },
    Ѻ: {
      ha: 956,
      x_min: 61,
      x_max: 902,
      o: 'm 902 471 q 859 235 902 339 q 734 68 815 131 q 545 -9 654 5 l 545 -92 l 412 -92 l 412 -8 q 156 144 251 16 q 61 475 61 273 l 61 515 q 155 842 61 713 q 411 996 250 970 l 411 1068 l 543 1068 l 543 997 q 805 846 707 975 q 902 511 902 718 l 902 471 m 696 516 q 657 724 696 646 q 543 824 617 802 l 543 755 l 411 755 l 411 821 q 267 510 267 770 l 267 471 q 304 268 267 345 q 412 165 342 190 l 412 228 l 545 228 l 545 162 q 657 263 618 185 q 696 471 696 342 l 696 516 z '
    },
    ѻ: {
      ha: 784,
      x_min: 45,
      x_max: 740,
      o: 'm 45 374 q 123 625 45 525 q 337 744 201 726 l 337 816 l 450 816 l 450 743 q 662 626 583 725 q 740 370 740 526 l 740 359 q 661 106 740 206 q 446 -10 582 7 l 446 -83 l 334 -83 l 334 -9 q 122 108 199 9 q 45 363 45 208 l 45 374 m 446 154 q 544 364 544 193 l 544 374 q 520 505 544 452 q 450 577 496 557 l 450 511 l 337 511 l 337 578 q 241 359 241 541 q 334 155 241 195 l 334 230 l 446 230 l 446 154 z '
    },
    Ѽ: {
      ha: 1314,
      x_min: 81,
      x_max: 1217,
      o: 'm 880 987 q 1125 897 1034 987 q 1217 649 1217 807 l 1217 320 q 1126 76 1217 166 q 880 -14 1036 -14 q 648 88 730 -14 q 417 -14 566 -14 q 171 76 262 -14 q 81 321 81 166 l 81 652 q 172 897 81 807 q 417 987 263 987 l 417 823 q 321 782 357 823 q 285 652 285 741 l 285 320 q 321 190 285 231 q 417 149 357 149 q 516 189 479 149 q 552 315 552 229 l 552 553 l 745 553 l 745 315 q 782 189 745 229 q 880 149 818 149 q 976 190 940 149 q 1013 320 1013 231 l 1013 652 q 976 782 1013 741 q 880 823 940 823 l 880 987 m 956 1159 l 956 1068 l 942 1068 q 840 1080 886 1068 q 725 1117 793 1091 q 642 1146 656 1143 q 612 1149 627 1149 q 543 1078 543 1149 l 543 1068 l 452 1068 l 452 1091 q 610 1240 452 1240 q 685 1228 648 1240 q 763 1199 722 1215 q 845 1172 804 1183 q 937 1159 886 1160 l 956 1159 m 562 906 q 608 1002 606 962 l 608 1073 l 723 1073 l 723 1003 q 690 929 723 970 q 618 867 658 888 l 562 906 z '
    },
    ѽ: {
      ha: 1122,
      x_min: 73,
      x_max: 1046,
      o: 'm 734 745 q 961 662 877 745 q 1046 433 1045 578 l 1046 300 q 967 70 1046 154 q 754 -14 888 -14 q 559 86 627 -14 q 365 -14 490 -14 q 153 68 231 -14 q 73 293 75 151 l 73 431 q 157 661 73 577 q 385 745 241 745 l 385 587 q 301 550 332 587 q 270 431 270 512 l 270 300 q 296 181 270 218 q 365 144 322 144 q 466 307 466 144 l 466 411 l 653 411 l 653 302 q 681 182 653 220 q 754 144 708 144 q 823 181 797 144 q 849 300 849 218 l 849 431 q 818 550 849 512 q 734 587 786 587 l 734 745 m 873 930 l 873 839 l 857 839 q 745 853 797 839 q 591 907 694 867 q 528 920 557 920 q 458 850 458 920 l 458 839 l 368 839 l 368 864 q 410 976 368 940 q 526 1011 452 1011 q 678 971 582 1011 q 854 930 774 930 l 873 930 m 484 681 q 530 777 528 736 l 530 848 l 644 848 l 644 778 q 612 704 644 745 q 539 642 579 663 l 484 681 z '
    },
    Ѿ: {
      ha: 1315,
      x_min: 81,
      x_max: 1228,
      o: 'm 1228 987 l 1228 317 q 1138 75 1228 164 q 891 -14 1048 -14 q 654 96 736 -14 q 417 -14 573 -14 q 171 75 262 -14 q 81 317 81 163 l 81 987 l 285 987 l 285 323 q 417 149 285 149 q 516 189 479 149 q 552 315 552 229 l 552 987 l 757 987 l 757 321 q 891 149 757 149 q 988 189 953 149 q 1024 315 1024 229 l 1024 987 l 1228 987 m 356 1144 l 356 1234 l 956 1234 l 957 1144 l 711 1144 l 711 1058 l 589 1058 l 589 1144 l 356 1144 z '
    },
    ѿ: {
      ha: 1139,
      x_min: 68,
      x_max: 1085,
      o: 'm 1085 734 l 1085 298 q 1004 70 1084 153 q 787 -14 924 -14 l 786 -14 q 578 83 650 -14 q 364 -14 503 -14 q 150 68 229 -14 q 68 296 70 151 l 68 734 l 264 734 l 264 293 q 364 144 267 144 q 481 296 479 144 l 481 734 l 677 734 l 677 291 q 786 144 681 144 q 888 292 886 144 l 888 734 l 1085 734 m 298 897 l 298 988 l 857 988 l 861 897 l 633 897 l 633 811 l 511 811 l 511 897 l 298 897 z '
    },
    Ҁ: {
      ha: 863,
      x_min: 60,
      x_max: 810,
      o: 'm 574 -245 l 370 -245 l 370 -9 q 144 122 228 14 q 60 395 60 230 l 60 594 q 107 806 60 713 q 242 950 155 899 q 441 1002 330 1002 q 714 913 618 1002 q 810 658 810 825 l 607 658 q 568 794 607 751 q 441 837 530 837 q 311 772 359 837 q 264 591 264 708 l 264 392 q 311 215 264 281 q 440 149 358 150 l 574 149 l 574 -245 z '
    },
    ҁ: {
      ha: 743,
      x_min: 58,
      x_max: 697,
      o: 'm 524 -248 l 328 -248 l 328 -8 q 131 111 203 12 q 58 361 58 209 l 58 376 q 150 646 58 544 q 397 747 241 747 q 615 669 533 747 q 697 460 697 591 l 513 460 q 481 553 513 517 q 397 589 449 589 q 292 536 329 589 q 254 378 255 483 l 254 357 q 400 144 254 144 l 524 144 l 524 -248 z '
    },
    '҂': {
      ha: 865,
      x_min: 73,
      x_max: 793,
      o: 'm 408 304 l 604 188 l 555 101 l 357 216 l 235 0 l 116 0 l 269 270 l 73 386 l 121 473 l 319 357 l 456 601 l 260 717 l 309 805 l 507 689 l 632 910 l 749 910 l 594 635 l 793 519 l 741 433 l 546 549 l 408 304 z '
    },
    '҃': {
      ha: 0,
      x_min: -616,
      x_max: -126,
      o: 'm -496 890 l -496 804 l -616 805 l -616 966 l -245 966 l -246 1040 l -126 1039 l -126 890 l -496 890 z '
    },
    '҄': {
      ha: 0,
      x_min: -613,
      x_max: -96,
      o: 'm -258 1056 q -96 907 -96 1056 l -96 884 l -189 884 l -189 895 q -260 965 -189 965 q -323 952 -290 965 l -397 924 q -585 884 -501 885 l -613 884 l -613 975 q -513 983 -551 975 q -404 1019 -474 992 q -309 1050 -334 1045 q -258 1056 -283 1056 z '
    },
    '҅': {
      ha: 0,
      x_min: -419,
      x_max: -252,
      o: 'm -419 1017 l -419 1114 l -291 1114 l -292 1005 l -252 932 l -307 886 l -419 1017 z '
    },
    '҆': {
      ha: 0,
      x_min: -408,
      x_max: -240,
      o: 'm -352 886 l -408 932 l -368 1005 l -368 1114 l -240 1114 l -240 1017 l -352 886 z '
    },
    '҈': {
      ha: 0,
      x_min: -1009,
      x_max: 311,
      o: 'm -501 859 q -462 951 -501 916 q -359 987 -423 987 q -255 951 -294 987 q -216 859 -216 916 l -292 859 q -309 909 -292 890 q -359 928 -326 928 q -407 910 -390 928 q -425 859 -425 892 l -501 859 m -100 671 q -61 764 -100 728 q 41 799 -22 799 q 145 764 106 799 q 185 671 185 729 l 109 671 q 91 722 109 705 q 41 740 73 740 q -6 722 12 740 q -23 671 -23 704 l -100 671 m 26 330 q 65 423 26 388 q 168 458 105 458 q 272 422 233 458 q 311 330 311 387 l 235 330 q 217 381 235 363 q 168 399 199 399 q 120 380 137 399 q 102 330 102 361 l 26 330 m -107 -22 q -68 71 -107 35 q 35 106 -28 106 q 138 71 99 106 q 178 -22 178 35 l 102 -22 q 84 29 102 12 q 35 47 66 47 q -13 28 4 47 q -31 -22 -31 9 l -107 -22 m -498 -214 q -459 -122 -498 -157 q -355 -87 -420 -87 q -252 -122 -291 -87 q -212 -214 -212 -157 l -288 -214 q -306 -164 -288 -183 q -355 -146 -323 -146 q -404 -164 -387 -146 q -421 -214 -421 -183 l -498 -214 m -890 671 q -850 764 -890 728 q -747 799 -811 799 q -643 764 -682 799 q -604 671 -604 728 l -680 671 q -697 721 -680 703 q -747 740 -714 740 q -795 722 -778 740 q -812 671 -812 704 l -890 671 m -1009 330 q -969 423 -1009 388 q -867 458 -930 458 q -763 422 -802 458 q -724 330 -724 387 l -800 330 q -818 381 -800 363 q -867 399 -836 399 q -915 380 -898 399 q -932 330 -932 361 l -1009 330 m -897 -22 q -857 71 -897 36 q -754 106 -817 106 q -650 71 -690 106 q -610 -22 -610 36 l -687 -22 q -705 29 -687 12 q -754 47 -723 47 q -802 29 -785 47 q -819 -22 -819 11 l -897 -22 z '
    },
    '҉': {
      ha: 0,
      x_min: -966,
      x_max: 292,
      o: 'm -269 -41 l -262 -50 l -345 -280 l -410 -280 l -362 -41 l -269 -41 m -401 764 l -410 773 l -327 1002 l -262 1002 l -309 764 l -401 764 m 58 428 l 66 436 l 292 352 l 292 286 l 58 334 l 58 428 m -731 294 l -740 286 l -966 370 l -966 436 l -731 388 l -731 294 m -104 680 l -103 690 l 114 794 l 160 748 l -39 612 l -104 680 m -568 14 l -570 3 l -787 -101 l -833 -54 l -634 81 l -568 14 m -663 583 l -675 585 l -775 806 l -731 852 l -597 650 l -663 583 m -11 109 l 0 108 l 101 -113 l 56 -161 l -77 42 l -11 109 z '
    },
    Ҋ: {
      ha: 1080,
      x_min: 81,
      x_max: 1036,
      o: 'm 680 987 l 884 987 l 884 0 l 680 0 l 680 656 l 285 0 l 81 0 l 81 987 l 285 987 l 285 330 l 680 987 m 720 1247 q 655 1101 720 1157 q 485 1046 590 1046 q 315 1101 380 1046 q 250 1247 250 1156 l 389 1247 q 415 1181 389 1204 q 485 1158 440 1158 q 554 1181 529 1158 q 579 1247 579 1204 l 720 1247 m 901 -277 l 799 -224 l 823 -180 q 870 -15 869 -97 l 870 137 l 1036 137 l 1035 1 q 997 -151 1034 -74 q 901 -277 960 -227 z '
    },
    ҋ: {
      ha: 906,
      x_min: 75,
      x_max: 866,
      o: 'm 517 734 l 713 734 l 713 0 l 517 0 l 517 453 l 272 0 l 75 0 l 75 734 l 272 734 l 272 281 l 517 734 m 633 1031 q 568 886 633 941 q 398 830 503 830 q 228 885 293 830 q 163 1031 163 940 l 302 1031 q 328 965 302 989 q 398 942 353 942 q 467 965 442 942 q 492 1031 492 989 l 633 1031 m 732 -277 l 629 -224 l 654 -180 q 701 -15 699 -97 l 701 137 l 866 137 l 865 1 q 827 -151 865 -74 q 732 -277 790 -227 z '
    },
    ҍ: {
      ha: 774,
      x_min: -18,
      x_max: 740,
      o: 'm 458 863 l 285 863 l 285 536 l 428 536 q 656 462 572 534 q 740 269 740 389 q 656 76 740 149 q 431 0 573 2 l 88 0 l 88 863 l -18 863 l -18 987 l 88 987 l 88 1095 l 285 1095 l 285 987 l 458 987 l 458 863 m 285 378 l 285 157 l 424 157 q 514 186 483 157 q 545 269 545 216 q 515 347 545 317 q 429 378 486 377 l 285 378 z '
    },
    Ҏ: {
      ha: 873,
      x_min: 88,
      x_max: 844,
      o: 'm 292 348 l 292 0 l 88 0 l 88 987 l 473 987 q 669 947 585 987 q 799 831 753 906 q 844 661 844 756 q 751 437 844 521 l 831 347 l 762 286 l 672 386 q 473 348 589 348 l 292 348 m 621 583 q 639 659 639 614 q 596 777 639 732 q 478 823 553 821 l 292 823 l 292 513 l 473 513 q 549 524 518 513 l 466 618 l 535 680 l 621 583 z '
    },
    ҏ: {
      ha: 783,
      x_min: 75,
      x_max: 736,
      o: 'm 736 360 q 655 83 736 186 l 724 2 l 652 -58 l 586 22 q 451 -14 527 -14 q 271 64 340 -14 l 271 -282 l 75 -282 l 75 734 l 257 734 l 264 662 q 450 747 335 747 q 661 647 585 747 q 736 370 736 547 l 736 360 m 540 374 q 504 532 540 477 q 398 588 467 588 q 271 517 306 588 l 271 217 q 399 144 307 144 q 468 163 439 144 l 392 255 l 463 315 l 523 242 q 540 374 540 292 z '
    },
    Ґ: {
      ha: 771,
      x_min: 86,
      x_max: 741,
      o: 'm 741 829 l 733 829 l 733 823 l 290 823 l 290 0 l 86 0 l 86 987 l 545 987 l 545 1240 l 741 1240 l 741 829 z '
    },
    ґ: {
      ha: 641,
      x_min: 73,
      x_max: 600,
      o: 'm 600 575 l 269 575 l 269 0 l 73 0 l 73 734 l 404 734 l 404 947 l 600 947 l 600 575 z '
    },
    Ҕ: {
      ha: 865,
      x_min: 90,
      x_max: 817,
      o: 'm 736 823 l 293 823 l 293 567 l 404 567 q 709 463 602 567 q 817 169 817 359 q 792 7 817 83 q 719 -123 768 -69 q 448 -231 621 -231 l 448 -81 q 577 -20 533 -81 q 621 159 621 40 q 405 407 622 407 l 293 407 l 293 0 l 90 0 l 90 987 l 736 987 l 736 823 z '
    },
    ҕ: {
      ha: 734,
      x_min: 73,
      x_max: 688,
      o: 'm 573 575 l 269 575 l 269 451 l 301 451 q 586 364 484 451 q 687 121 687 277 q 618 -67 688 21 q 435 -194 549 -156 l 353 -63 q 455 10 419 -33 q 491 121 490 54 q 441 249 491 206 q 304 291 391 291 l 269 291 l 269 0 l 73 0 l 73 734 l 573 734 l 573 575 z '
    },
    Җ: {
      ha: 1485,
      x_min: 12,
      x_max: 1474,
      o: 'm 921 402 l 804 402 l 804 0 l 600 0 l 600 402 l 480 402 l 265 0 l 12 0 l 319 530 l 26 987 l 279 987 l 499 589 l 600 589 l 600 987 l 804 987 l 804 589 l 903 589 l 1117 987 l 1369 987 l 1082 530 l 1385 0 l 1131 0 l 921 402 m 1474 -242 l 1278 -242 l 1278 139 l 1474 139 l 1474 -242 z '
    },
    җ: {
      ha: 1262,
      x_min: 26,
      x_max: 1246,
      o: 'm 781 272 l 692 272 l 692 0 l 496 0 l 496 272 l 409 272 l 263 0 l 26 0 l 258 384 l 29 734 l 272 734 l 425 460 l 496 460 l 496 734 l 692 734 l 692 460 l 766 460 l 919 734 l 1162 734 l 935 389 l 1168 0 l 927 0 l 781 272 m 1246 -242 l 1050 -242 l 1050 139 l 1246 139 l 1246 -242 z '
    },
    Қ: {
      ha: 1032,
      x_min: 90,
      x_max: 988,
      o: 'm 410 404 l 293 404 l 293 0 l 90 0 l 90 987 l 293 987 l 293 592 l 386 592 l 627 987 l 876 987 l 571 520 l 907 0 l 665 0 l 410 404 m 988 -242 l 792 -242 l 792 139 l 988 139 l 988 -242 z '
    },
    қ: {
      ha: 903,
      x_min: 88,
      x_max: 863,
      o: 'm 363 271 l 284 271 l 284 0 l 88 0 l 88 734 l 284 734 l 284 458 l 354 458 l 514 734 l 762 734 l 522 385 l 784 0 l 523 0 l 363 271 m 863 -242 l 667 -242 l 667 139 l 863 139 l 863 -242 z '
    },
    Ҝ: {
      ha: 919,
      x_min: 87,
      x_max: 938,
      o: 'm 911 987 l 653 536 l 938 0 l 677 0 l 496 401 l 460 401 l 460 246 l 347 246 l 347 401 l 292 401 l 292 0 l 87 0 l 87 987 l 292 987 l 292 588 l 347 588 l 347 763 l 460 763 l 460 588 l 485 588 l 658 987 l 911 987 z '
    },
    ҝ: {
      ha: 836,
      x_min: 88,
      x_max: 836,
      o: 'm 825 734 l 626 385 l 836 0 l 585 0 l 473 271 l 441 271 l 441 155 l 338 155 l 338 271 l 284 271 l 284 0 l 88 0 l 88 734 l 284 734 l 284 458 l 338 458 l 338 587 l 441 587 l 441 458 l 471 458 l 577 734 l 825 734 z '
    },
    Ҡ: {
      ha: 1147,
      x_min: 25,
      x_max: 1165,
      o: 'm 667 404 l 551 404 l 551 0 l 347 0 l 347 829 l 25 829 l 25 987 l 551 987 l 551 592 l 644 592 l 885 987 l 1133 987 l 829 520 l 1165 0 l 922 0 l 667 404 z '
    },
    ҡ: {
      ha: 994,
      x_min: 39,
      x_max: 1003,
      o: 'm 582 271 l 504 271 l 504 0 l 308 0 l 308 574 l 39 574 l 39 734 l 504 734 l 504 458 l 573 458 l 734 734 l 981 734 l 741 385 l 1003 0 l 742 0 l 582 271 z '
    },
    Ң: {
      ha: 1085,
      x_min: 88,
      x_max: 1040,
      o: 'm 892 0 l 688 0 l 688 423 l 292 423 l 292 0 l 88 0 l 88 987 l 292 987 l 292 587 l 688 587 l 688 987 l 892 987 l 892 0 m 1040 -242 l 844 -242 l 844 139 l 1040 139 l 1040 -242 z '
    },
    ң: {
      ha: 901,
      x_min: 75,
      x_max: 861,
      o: 'm 711 0 l 515 0 l 515 282 l 271 282 l 271 0 l 75 0 l 75 734 l 271 734 l 271 439 l 515 439 l 515 734 l 711 734 l 711 0 m 861 -242 l 665 -242 l 665 139 l 861 139 l 861 -242 z '
    },
    Ҥ: {
      ha: 1368,
      x_min: 88,
      x_max: 1314,
      o: 'm 292 587 l 688 587 l 688 987 l 1314 987 l 1314 829 l 892 829 l 892 0 l 688 0 l 688 423 l 292 423 l 292 0 l 88 0 l 88 987 l 292 987 l 292 587 z '
    },
    ҥ: {
      ha: 981,
      x_min: 73,
      x_max: 939,
      o: 'm 269 439 l 513 439 l 513 734 l 939 734 l 939 575 l 709 575 l 709 0 l 513 0 l 513 282 l 269 282 l 269 0 l 73 0 l 73 734 l 269 734 l 269 439 z '
    },
    Ҧ: {
      ha: 1451,
      x_min: 90,
      x_max: 1402,
      o: 'm 892 566 l 989 566 q 1294 461 1187 566 q 1402 168 1402 357 q 1378 6 1402 82 q 1304 -125 1354 -71 q 1034 -232 1206 -232 l 1033 -82 q 1162 -22 1118 -82 q 1206 157 1206 39 q 990 406 1207 406 l 892 406 l 892 0 l 688 0 l 688 823 l 293 823 l 293 0 l 90 0 l 90 987 l 892 987 l 892 566 z '
    },
    ҧ: {
      ha: 1202,
      x_min: 73,
      x_max: 1171,
      o: 'm 711 456 l 769 456 q 1063 370 957 456 q 1169 125 1169 283 q 1101 -62 1171 26 q 917 -189 1032 -150 l 836 -58 q 937 15 901 -28 q 973 125 973 58 q 922 251 973 207 q 778 296 871 295 l 711 296 l 711 0 l 515 0 l 515 575 l 269 575 l 269 0 l 73 0 l 73 734 l 711 734 l 711 456 z '
    },
    Ҩ: {
      ha: 1116,
      x_min: 64,
      x_max: 1051,
      o: 'm 1051 -9 q 775 37 901 -9 q 538 -14 669 -14 q 294 45 402 -14 q 125 210 186 104 q 64 447 64 317 l 64 591 q 109 801 64 706 q 235 948 153 895 q 418 1002 316 1002 l 418 830 q 317 764 355 830 q 279 595 280 698 l 279 447 q 351 236 279 315 q 538 156 422 156 l 579 158 q 440 500 440 294 l 440 629 q 478 821 440 734 q 582 954 515 907 q 731 1001 648 1001 q 893 950 822 1001 q 1005 806 965 899 q 1044 595 1044 712 l 1044 481 q 932 159 1044 294 q 1051 148 987 148 l 1051 -9 m 633 496 q 663 352 633 418 q 750 240 692 287 q 840 487 840 331 l 840 618 q 814 781 840 731 q 731 830 788 830 q 633 647 636 830 l 633 496 z '
    },
    ҩ: {
      ha: 897,
      x_min: 58,
      x_max: 859,
      o: 'm 859 -18 q 623 18 724 -18 q 443 -14 539 -14 q 165 92 273 -14 q 58 364 58 197 l 58 425 q 95 592 58 517 q 199 707 133 667 q 348 747 265 747 l 348 584 q 286 536 309 578 q 264 427 264 494 l 264 359 q 311 210 264 268 q 436 150 359 153 q 371 361 371 237 l 371 465 q 436 667 371 587 q 603 747 500 747 q 777 658 709 747 q 844 429 844 570 l 844 334 q 753 104 844 198 q 859 94 802 94 l 859 -18 m 516 351 q 578 192 516 258 q 648 348 648 247 l 648 446 q 629 546 648 509 q 583 584 610 584 q 535 550 554 584 q 516 457 516 516 l 516 351 z '
    },
    Ҳ: {
      ha: 926,
      x_min: 15,
      x_max: 915,
      o: 'm 441 647 l 627 987 l 861 987 l 573 498 l 868 0 l 631 0 l 441 346 l 252 0 l 15 0 l 310 498 l 22 987 l 256 987 l 441 647 m 915 -242 l 719 -242 l 719 139 l 915 139 l 915 -242 z '
    },
    ҳ: {
      ha: 753,
      x_min: 14,
      x_max: 738,
      o: 'm 355 515 l 478 734 l 688 734 l 479 374 l 696 0 l 486 0 l 355 231 l 225 0 l 14 0 l 232 374 l 24 734 l 234 734 l 355 515 m 738 -242 l 542 -242 l 542 139 l 738 139 l 738 -242 z '
    },
    Ҵ: {
      ha: 1243,
      x_min: 23,
      x_max: 1187,
      o: 'm 248 829 l 23 829 l 23 987 l 675 987 l 675 829 l 452 829 l 452 163 l 848 163 l 848 987 l 1052 987 l 1052 163 l 1187 163 l 1173 -238 l 983 -238 l 983 0 l 248 0 l 248 829 z '
    },
    ҵ: {
      ha: 954,
      x_min: 31,
      x_max: 928,
      o: 'm 180 575 l 31 575 l 31 734 l 510 734 l 510 575 l 376 575 l 376 158 l 621 158 l 621 734 l 818 734 l 818 157 l 928 157 l 914 -218 l 732 -218 l 732 0 l 180 0 l 180 575 z '
    },
    Ҷ: {
      ha: 1066,
      x_min: 93,
      x_max: 1022,
      o: 'm 876 987 l 876 0 l 672 0 l 672 374 q 478 355 579 355 q 193 437 290 355 q 93 674 96 519 l 93 987 l 297 987 l 297 678 q 338 556 298 593 q 478 519 378 519 q 672 538 579 519 l 672 987 l 876 987 m 1022 -242 l 826 -242 l 826 139 l 1022 139 l 1022 -242 z '
    },
    ҷ: {
      ha: 884,
      x_min: 60,
      x_max: 844,
      o: 'm 694 0 l 498 0 l 498 231 q 395 220 443 220 q 145 291 229 220 q 60 497 61 361 l 60 734 l 256 734 l 256 497 q 287 406 256 433 q 395 378 317 378 q 498 390 444 378 l 498 734 l 694 734 l 694 0 m 844 -242 l 648 -242 l 648 139 l 844 139 l 844 -242 z '
    },
    Ҹ: {
      ha: 945,
      x_min: 75,
      x_max: 857,
      o: 'm 278 987 l 278 682 q 310 566 278 604 q 414 521 341 528 l 414 718 l 526 718 l 526 522 q 654 538 596 528 l 654 987 l 857 987 l 857 0 l 654 0 l 654 374 q 526 357 606 364 l 526 200 l 414 200 l 414 356 q 160 449 245 366 q 75 678 76 532 l 75 987 l 278 987 z '
    },
    ҹ: {
      ha: 778,
      x_min: 71,
      x_max: 705,
      o: 'm 705 0 l 509 0 l 509 231 q 446 222 483 225 l 446 121 l 334 121 l 334 224 q 139 307 205 239 q 71 492 73 374 l 71 734 l 267 734 l 267 492 q 334 387 269 405 l 334 562 l 446 562 l 446 380 q 509 389 477 382 l 509 734 l 705 734 l 705 0 z '
    },
    Һ: {
      ha: 970,
      x_min: 91,
      x_max: 874,
      o: 'm 91 0 l 91 987 l 295 987 l 295 612 q 386 626 327 619 q 489 632 444 632 q 774 550 677 632 q 874 313 871 468 l 874 0 l 670 0 l 670 309 q 629 431 669 393 q 489 468 589 468 q 295 448 391 468 l 295 0 l 91 0 z '
    },
    Ҽ: {
      ha: 1051,
      x_min: -18,
      x_max: 987,
      o: 'm 650 -16 q 318 99 437 -16 q 199 416 199 214 l 199 442 q 38 536 95 460 q -18 734 -18 612 l 117 734 q 199 590 117 621 q 252 800 199 705 q 398 947 304 894 q 604 1000 492 1001 q 886 878 785 1000 q 987 530 987 756 l 987 426 l 402 426 l 402 412 q 466 225 402 289 q 650 162 530 162 q 899 204 785 162 l 932 37 q 809 -1 886 14 q 650 -16 732 -16 m 604 821 q 458 758 512 821 q 402 590 404 694 l 784 590 l 784 611 q 738 767 784 713 q 604 821 692 821 z '
    },
    ҽ: {
      ha: 830,
      x_min: -46,
      x_max: 815,
      o: 'm 514 -14 q 258 78 357 -14 q 151 315 159 170 q 4 406 54 336 q -46 585 -46 477 l 77 585 q 156 447 77 478 q 267 666 177 585 q 492 747 357 747 q 729 652 644 747 q 815 383 815 557 l 815 303 l 349 303 q 406 188 358 231 q 526 144 453 144 q 703 227 640 144 l 800 119 q 681 21 755 56 q 514 -14 606 -14 m 491 589 q 397 549 433 589 q 351 437 361 510 l 623 437 l 623 452 q 587 553 621 517 q 491 589 553 589 z '
    },
    Ӄ: {
      ha: 902,
      x_min: 87,
      x_max: 878,
      o: 'm 558 559 q 794 434 711 536 q 878 166 878 333 q 830 -50 878 44 q 700 -190 783 -143 q 503 -237 617 -237 l 503 -81 q 630 -22 586 -81 q 673 155 673 37 q 463 400 675 400 l 292 400 l 292 0 l 87 0 l 87 987 l 292 987 l 292 591 l 359 591 l 602 987 l 854 987 l 558 559 z '
    },
    ӄ: {
      ha: 793,
      x_min: 88,
      x_max: 762,
      o: 'm 530 408 q 698 297 641 374 q 755 106 755 220 q 688 -79 757 8 q 503 -205 618 -166 l 422 -74 q 524 -2 488 -45 q 559 106 559 40 q 353 271 559 271 l 284 271 l 284 0 l 88 0 l 88 734 l 284 734 l 284 458 l 343 458 l 514 734 l 762 734 l 530 408 z '
    },
    Ӆ: {
      ha: 1085,
      x_min: 27,
      x_max: 1041,
      o: 'm 891 987 l 891 0 l 687 0 l 687 823 l 424 823 l 408 474 q 363 196 397 298 q 262 48 328 95 q 80 0 195 1 l 27 0 l 27 163 l 61 167 q 171 255 138 177 q 212 534 203 334 l 229 987 l 891 987 m 907 -277 l 804 -224 l 829 -180 q 876 -15 874 -97 l 876 137 l 1041 137 l 1040 1 q 1002 -151 1040 -74 q 907 -277 965 -227 z '
    },
    ӆ: {
      ha: 906,
      x_min: 15,
      x_max: 867,
      o: 'm 713 734 l 713 0 l 517 0 l 517 575 l 345 575 l 332 349 q 261 85 321 168 q 83 0 201 2 l 17 0 l 15 159 l 39 161 q 117 224 92 165 q 147 422 141 282 l 161 734 l 713 734 m 732 -277 l 630 -224 l 654 -180 q 701 -15 700 -97 l 701 137 l 867 137 l 866 1 q 828 -151 865 -74 q 732 -277 791 -227 z '
    },
    Ӈ: {
      ha: 982,
      x_min: 90,
      x_max: 892,
      o: 'm 293 987 l 293 568 l 688 568 l 688 987 l 892 987 l 892 -16 q 823 -224 892 -152 q 629 -296 753 -296 q 530 -285 576 -296 l 539 -123 q 607 -132 570 -132 q 688 -14 688 -132 l 688 404 l 293 404 l 293 0 l 90 0 l 90 987 l 293 987 z '
    },
    ӈ: {
      ha: 784,
      x_min: 73,
      x_max: 709,
      o: 'm 269 734 l 269 439 l 513 439 l 513 734 l 709 734 l 709 -24 q 641 -225 709 -155 q 452 -296 574 -296 q 354 -285 398 -296 l 364 -130 q 431 -138 393 -138 q 513 -19 513 -138 l 513 282 l 269 282 l 269 0 l 73 0 l 73 734 l 269 734 z '
    },
    Ӊ: {
      ha: 1088,
      x_min: 88,
      x_max: 1044,
      o: 'm 892 0 l 688 0 l 688 423 l 292 423 l 292 0 l 88 0 l 88 987 l 292 987 l 292 587 l 688 587 l 688 987 l 892 987 l 892 0 m 909 -277 l 807 -224 l 831 -180 q 878 -15 877 -97 l 878 137 l 1044 137 l 1043 1 q 1005 -151 1042 -74 q 909 -277 968 -227 z '
    },
    ӊ: {
      ha: 904,
      x_min: 75,
      x_max: 865,
      o: 'm 711 0 l 515 0 l 515 282 l 271 282 l 271 0 l 75 0 l 75 734 l 271 734 l 271 439 l 515 439 l 515 734 l 711 734 l 711 0 m 730 -277 l 628 -224 l 652 -180 q 699 -15 698 -97 l 699 137 l 865 137 l 864 1 q 826 -151 863 -74 q 730 -277 789 -227 z '
    },
    Ӎ: {
      ha: 1320,
      x_min: 88,
      x_max: 1276,
      o: 'm 354 987 l 608 271 l 860 987 l 1127 987 l 1127 0 l 923 0 l 923 270 l 943 736 l 677 0 l 537 0 l 271 735 l 292 270 l 292 0 l 88 0 l 88 987 l 354 987 m 1141 -277 l 1039 -224 l 1063 -180 q 1110 -15 1109 -97 l 1110 137 l 1276 137 l 1275 1 q 1237 -151 1274 -74 q 1141 -277 1200 -227 z '
    },
    ӎ: {
      ha: 1152,
      x_min: 88,
      x_max: 1112,
      o: 'm 522 231 l 714 734 l 960 734 l 960 0 l 764 0 l 764 450 l 588 0 l 456 0 l 284 443 l 284 0 l 88 0 l 88 734 l 332 734 l 522 231 m 978 -277 l 876 -224 l 900 -180 q 947 -15 945 -97 l 947 137 l 1112 137 l 1112 1 q 1074 -151 1111 -74 q 978 -277 1036 -227 z '
    },
    Ә: {
      ha: 965,
      x_min: 51,
      x_max: 899,
      o: 'm 420 1001 q 772 878 646 1001 q 899 536 899 754 l 899 441 q 844 207 899 312 q 691 44 789 102 q 475 -14 593 -14 q 162 108 274 -14 q 51 455 51 229 l 51 560 l 695 560 q 621 755 690 688 q 420 823 551 823 q 158 780 282 823 l 125 947 q 258 987 178 972 q 420 1001 338 1001 m 475 163 q 623 224 566 163 q 693 395 681 286 l 254 395 l 254 374 q 311 217 254 271 q 475 163 368 163 z '
    },
    Ӡ: {
      ha: 803,
      x_min: 54,
      x_max: 763,
      o: 'm 510 823 l 97 823 l 97 987 l 743 987 l 744 852 l 502 589 q 695 487 627 567 q 763 277 763 408 q 665 65 763 144 q 399 -14 566 -14 q 221 21 301 -14 q 98 121 142 56 q 54 274 54 186 l 258 274 q 298 184 258 218 q 399 149 338 149 q 515 185 471 149 q 559 279 559 221 q 514 417 559 372 q 371 463 469 463 l 281 463 l 281 590 l 510 823 z '
    },
    ӡ: {
      ha: 804,
      x_min: 56,
      x_max: 759,
      o: 'm 509 575 l 93 575 l 93 734 l 738 734 l 739 604 l 496 334 q 690 233 622 313 q 759 22 759 154 q 661 -189 759 -110 q 399 -268 564 -268 q 222 -233 301 -268 q 99 -133 142 -197 q 56 20 56 -68 l 252 20 q 294 -73 252 -37 q 399 -109 336 -109 q 517 -72 472 -109 q 563 25 563 -35 q 517 164 563 119 q 373 210 471 210 l 280 210 l 280 334 l 509 575 z '
    },
    Ӻ: {
      ha: 834,
      x_min: 25,
      x_max: 795,
      o: 'm 795 823 l 353 823 l 353 0 l 149 0 l 149 987 l 795 987 l 795 823 m 499 452 l 25 452 l 25 576 l 499 576 l 499 452 m 532 175 l 532 -27 q 464 -226 531 -156 q 275 -296 396 -296 q 178 -285 222 -296 l 188 -128 q 254 -136 217 -136 q 336 -20 336 -136 l 336 175 l 532 175 z '
    },
    ӻ: {
      ha: 637,
      x_min: 15,
      x_max: 630,
      o: 'm 630 575 l 326 575 l 326 0 l 130 0 l 130 734 l 630 734 l 630 575 m 489 332 l 15 332 l 15 456 l 489 456 l 489 332 m 486 171 l 486 -31 q 417 -230 484 -160 q 228 -300 349 -300 q 132 -289 176 -300 l 141 -132 q 208 -140 170 -140 q 289 -24 289 -140 l 289 171 l 486 171 z '
    },
    Ӽ: {
      ha: 972,
      x_min: 15,
      x_max: 962,
      o: 'm 441 647 l 627 987 l 861 987 l 573 498 l 868 0 l 631 0 l 441 346 l 252 0 l 15 0 l 310 498 l 22 987 l 256 987 l 441 647 m 962 175 l 962 -27 q 893 -226 960 -156 q 704 -296 825 -296 q 608 -285 652 -296 l 617 -128 q 684 -136 646 -136 q 765 -20 765 -136 l 765 175 l 962 175 z '
    },
    ӽ: {
      ha: 800,
      x_min: 14,
      x_max: 785,
      o: 'm 355 515 l 478 734 l 688 734 l 479 374 l 696 0 l 486 0 l 355 231 l 225 0 l 14 0 l 232 374 l 24 734 l 234 734 l 355 515 m 785 175 l 785 -27 q 716 -226 783 -156 q 527 -296 648 -296 q 431 -285 475 -296 l 440 -128 q 507 -136 469 -136 q 588 -20 588 -136 l 588 175 l 785 175 z '
    },
    Ԁ: {
      ha: 869,
      x_min: 50,
      x_max: 791,
      o: 'm 587 651 l 587 987 l 791 987 l 791 0 l 425 0 q 228 41 313 0 q 96 157 142 82 q 50 326 50 231 q 95 494 50 420 q 227 610 141 568 q 423 651 313 651 l 587 651 m 587 163 l 587 486 l 425 486 q 300 442 347 486 q 254 328 254 397 q 299 211 254 256 q 420 163 344 165 l 587 163 z '
    },
    Ԃ: {
      ha: 1260,
      x_min: 79,
      x_max: 1200,
      o: 'm 452 0 q 256 41 341 0 q 125 156 171 82 q 79 326 79 231 q 182 562 79 473 q 455 651 286 651 l 616 651 l 616 987 l 820 987 l 820 164 l 865 164 q 957 212 923 165 q 995 343 991 258 l 994 395 q 954 622 984 543 l 1153 622 q 1185 480 1171 567 q 1198 343 1200 394 q 1111 95 1196 187 q 876 0 1025 3 l 452 0 m 616 163 l 616 486 l 452 486 q 329 442 375 486 q 283 328 283 397 q 328 211 283 256 q 448 163 372 165 l 616 163 z '
    },
    ԃ: {
      ha: 1185,
      x_min: 61,
      x_max: 1133,
      o: 'm 61 361 q 138 643 61 539 q 348 747 214 747 q 514 668 449 747 l 514 1058 l 710 1058 l 710 256 q 733 174 710 203 q 792 145 756 145 q 897 203 861 146 q 935 359 932 260 q 894 632 938 486 l 1086 632 q 1119 495 1105 563 q 1131 359 1133 428 q 1087 161 1130 245 q 967 31 1044 77 q 792 -14 890 -14 q 548 109 612 -17 q 347 -14 477 -14 q 138 84 214 -14 q 61 351 61 182 l 61 361 m 514 531 q 397 588 473 588 q 293 530 330 588 q 257 347 257 471 q 396 144 257 144 q 519 204 477 144 l 514 254 l 514 531 z '
    },
    Ԅ: {
      ha: 1094,
      x_min: 44,
      x_max: 1031,
      o: 'm 138 403 l 138 570 l 269 570 q 399 604 358 570 q 441 707 441 637 q 275 821 441 821 l 44 821 l 44 987 l 283 987 q 551 914 458 986 q 644 705 644 842 q 452 479 644 545 q 642 272 637 439 l 642 217 q 655 170 641 189 q 694 151 669 151 q 790 208 758 153 q 827 359 823 263 q 785 632 829 486 l 985 632 q 1017 497 1002 566 q 1030 359 1031 429 q 985 160 1029 244 q 862 31 941 76 q 683 -14 783 -14 q 437 217 450 -20 l 437 260 q 401 363 437 324 q 299 403 366 403 l 138 403 z '
    },
    ԅ: {
      ha: 892,
      x_min: 31,
      x_max: 881,
      o: 'm 536 175 q 582 111 534 111 q 655 158 629 112 q 684 284 682 203 q 643 500 686 388 l 834 500 q 873 366 865 410 q 880 284 881 323 q 799 64 878 146 q 592 -18 720 -18 q 408 18 469 -20 q 339 145 346 56 l 339 194 q 261 264 339 264 l 90 264 l 88 414 l 217 414 q 319 489 319 415 q 208 575 319 575 l 35 575 l 31 734 l 221 734 q 437 675 359 732 q 515 515 515 618 q 404 360 515 410 q 536 214 532 330 l 536 175 z '
    },
    Ԇ: {
      ha: 813,
      x_min: 44,
      x_max: 776,
      o: 'm 88 391 l 87 549 l 260 549 q 417 684 417 553 q 374 791 417 754 q 254 829 331 829 l 48 829 l 44 987 l 264 987 q 521 908 429 985 q 612 694 612 831 q 454 474 612 544 q 619 239 619 426 l 619 170 l 776 170 l 775 35 q 737 -117 774 -41 q 642 -244 700 -194 l 539 -191 l 569 -135 q 609 0 605 -65 l 466 0 q 422 161 425 33 l 422 233 q 264 391 422 391 l 88 391 z '
    },
    ԇ: {
      ha: 777,
      x_min: 74,
      x_max: 751,
      o: 'm 111 260 l 111 397 l 281 397 q 371 420 341 397 q 401 482 401 444 q 370 549 401 523 q 283 576 338 576 l 79 576 l 74 734 l 279 734 q 512 670 425 734 q 599 498 599 607 q 491 333 599 391 q 608 161 605 290 l 751 161 l 751 26 q 713 -126 750 -50 q 617 -253 675 -203 l 515 -199 l 543 -148 q 585 0 583 -73 l 431 0 q 412 104 412 16 l 412 159 q 292 260 410 258 l 111 260 z '
    },
    Ԉ: {
      ha: 1340,
      x_min: 43,
      x_max: 1308,
      o: 'm 684 821 l 440 821 l 423 476 q 379 199 414 301 q 280 50 345 98 q 103 0 216 2 l 43 0 l 43 163 l 77 167 q 186 254 153 177 q 228 523 218 332 l 245 987 l 887 987 l 887 258 q 908 181 887 210 q 966 151 930 151 q 1063 205 1027 151 q 1102 359 1099 259 q 1061 632 1105 486 l 1261 632 q 1293 497 1278 566 q 1306 359 1308 429 q 1262 161 1305 245 q 1141 32 1219 77 q 966 -14 1063 -14 q 755 54 827 -14 q 684 256 684 122 l 684 821 z '
    },
    ԉ: {
      ha: 1177,
      x_min: 43,
      x_max: 1119,
      o: 'm 521 573 l 372 573 l 360 349 q 289 85 349 168 q 111 0 229 2 l 45 0 l 43 159 l 67 161 q 144 224 120 165 q 175 422 169 282 l 189 734 l 717 734 l 717 256 q 742 176 717 206 q 809 145 767 145 q 890 195 862 146 q 920 331 919 245 q 880 589 923 454 l 1071 589 l 1086 533 q 1117 331 1119 413 q 1077 149 1116 226 q 968 28 1038 71 q 809 -14 898 -14 q 594 54 667 -14 q 521 252 522 121 l 521 573 z '
    },
    Ԋ: {
      ha: 1381,
      x_min: 87,
      x_max: 1309,
      o: 'm 888 987 l 888 258 q 910 180 888 208 q 966 151 931 151 q 1066 208 1031 153 q 1103 359 1101 263 q 1062 632 1106 486 l 1261 632 q 1294 497 1280 566 q 1308 359 1309 429 q 1263 161 1306 245 q 1142 32 1219 77 q 966 -14 1064 -14 q 684 257 700 -20 l 684 404 l 292 404 l 292 0 l 87 0 l 87 987 l 292 987 l 292 568 l 684 568 l 684 987 l 888 987 z '
    },
    ԋ: {
      ha: 1146,
      x_min: 63,
      x_max: 1109,
      o: 'm 511 289 l 260 289 l 260 0 l 63 0 l 63 734 l 260 734 l 260 448 l 511 448 l 511 734 l 707 734 l 707 256 q 732 175 707 205 q 799 145 757 145 q 880 196 852 146 q 911 331 909 245 q 870 589 913 450 l 1061 589 l 1076 533 q 1107 331 1109 413 q 1067 149 1105 226 q 958 28 1028 71 q 799 -14 888 -14 q 591 49 663 -17 q 511 254 519 115 l 511 289 z '
    },
    Ԍ: {
      ha: 880,
      x_min: 47,
      x_max: 839,
      o: 'm 475 -14 q 255 39 353 -14 q 103 188 157 92 q 47 401 48 283 l 47 583 q 101 798 47 701 q 254 948 155 894 q 475 1002 352 1002 q 718 941 626 1002 l 676 789 q 475 835 584 835 q 314 764 376 835 q 252 579 252 693 l 252 405 q 314 223 252 294 q 475 151 376 151 q 592 192 551 153 q 634 300 632 231 q 600 533 636 399 l 799 533 l 825 419 q 838 300 839 359 q 735 70 835 155 q 475 -14 636 -14 z '
    },
    ԍ: {
      ha: 735,
      x_min: 47,
      x_max: 699,
      o: 'm 414 145 q 480 165 460 146 q 501 224 500 184 q 488 364 501 300 l 680 364 q 698 224 699 275 q 619 48 695 110 q 414 -14 543 -14 q 150 89 252 -14 q 47 361 47 192 l 47 381 q 92 568 47 484 q 216 700 136 652 q 401 747 297 747 q 592 703 527 747 l 561 548 q 401 587 494 587 q 287 529 330 587 q 244 376 244 471 l 244 353 q 290 203 244 261 q 414 145 336 145 z '
    },
    Ԏ: {
      ha: 979,
      x_min: 21,
      x_max: 936,
      o: 'm 313 821 l 21 821 l 21 987 l 802 987 l 802 821 l 516 821 l 516 257 q 537 180 516 208 q 594 151 559 151 q 694 208 660 153 q 731 359 729 263 q 690 632 734 483 l 889 632 q 922 495 908 563 q 935 359 936 428 q 890 161 933 245 q 769 31 847 77 q 594 -14 692 -14 q 390 51 460 -17 q 313 257 319 119 l 313 821 z '
    },
    ԏ: {
      ha: 885,
      x_min: 45,
      x_max: 843,
      o: 'm 245 575 l 45 575 l 45 734 l 660 734 l 660 575 l 441 575 l 441 254 q 467 175 441 205 q 533 145 492 145 q 615 184 586 146 q 646 288 644 221 q 605 484 648 383 l 796 484 q 834 365 825 406 q 842 288 843 323 q 754 68 840 150 q 533 -14 669 -14 q 325 50 397 -17 q 245 254 254 116 l 245 575 z '
    },
    Ԑ: {
      ha: 910,
      x_min: 72,
      x_max: 863,
      o: 'm 275 279 q 332 185 275 220 q 479 149 389 149 q 608 184 555 149 q 660 274 660 220 l 863 274 q 815 122 863 188 q 676 21 766 56 q 479 -14 586 -14 q 183 64 294 -14 q 72 277 72 143 q 118 421 72 363 q 252 507 164 479 q 131 596 174 540 q 87 720 87 652 q 192 928 87 854 q 479 1002 296 1002 q 667 966 583 1002 q 801 866 752 931 q 850 720 850 802 l 646 720 q 598 804 646 772 q 479 837 551 837 q 341 804 392 837 q 291 715 291 771 q 470 583 291 583 l 603 583 l 603 424 l 468 424 q 325 390 374 424 q 275 279 275 357 z '
    },
    Ԓ: {
      ha: 1129,
      x_min: 27,
      x_max: 1084,
      o: 'm 891 987 l 891 0 l 687 0 l 687 823 l 424 823 l 408 474 q 363 196 397 298 q 262 48 328 95 q 80 0 195 1 l 27 0 l 27 163 l 61 167 q 171 255 138 177 q 212 534 203 334 l 229 987 l 891 987 m 1084 175 l 1084 -27 q 1016 -226 1083 -156 q 827 -296 948 -296 q 730 -285 774 -296 l 740 -128 q 806 -136 769 -136 q 888 -20 888 -136 l 888 175 l 1084 175 z '
    },
    ԓ: {
      ha: 950,
      x_min: 15,
      x_max: 910,
      o: 'm 713 734 l 713 0 l 517 0 l 517 575 l 345 575 l 332 349 q 261 85 321 168 q 83 0 201 2 l 17 0 l 15 159 l 39 161 q 117 224 92 165 q 147 422 141 282 l 161 734 l 713 734 m 910 175 l 910 -27 q 841 -226 909 -156 q 652 -296 774 -296 q 556 -285 600 -296 l 566 -128 q 632 -136 595 -136 q 713 -20 713 -136 l 713 175 l 910 175 z '
    },
    ' ': { ha: 708, x_min: 0, x_max: 0, o: '' },
    ' ': { ha: 1417, x_min: 0, x_max: 0, o: '' },
    ' ': { ha: 708, x_min: 0, x_max: 0, o: '' },
    ' ': { ha: 1417, x_min: 0, x_max: 0, o: '' },
    ' ': { ha: 473, x_min: 0, x_max: 0, o: '' },
    ' ': { ha: 354, x_min: 0, x_max: 0, o: '' },
    ' ': { ha: 236, x_min: 0, x_max: 0, o: '' },
    ' ': { ha: 781, x_min: 0, x_max: 0, o: '' },
    ' ': { ha: 380, x_min: 0, x_max: 0, o: '' },
    ' ': { ha: 283, x_min: 0, x_max: 0, o: '' },
    ' ': { ha: 142, x_min: 0, x_max: 0, o: '' },
    '​': { ha: 0, x_min: 0, x_max: 0, o: '' },
    '‐': {
      ha: 539,
      x_min: 75,
      x_max: 456,
      o: 'm 456 344 l 75 344 l 75 502 l 456 502 l 456 344 z '
    },
    '‑': {
      ha: 539,
      x_min: 75,
      x_max: 456,
      o: 'm 456 344 l 75 344 l 75 502 l 456 502 l 456 344 z '
    },
    '–': {
      ha: 878,
      x_min: 103,
      x_max: 806,
      o: 'm 806 404 l 103 404 l 103 564 l 806 564 l 806 404 z '
    },
    '—': {
      ha: 1060,
      x_min: 74,
      x_max: 1010,
      o: 'm 1010 404 l 74 404 l 74 564 l 1010 564 l 1010 404 z '
    },
    '‗': {
      ha: 619,
      x_min: 1,
      x_max: 618,
      o: 'm 618 -282 l 1 -282 l 1 -178 l 618 -178 l 618 -282 m 618 -104 l 1 -104 l 1 0 l 618 0 l 618 -104 z '
    },
    '‘': {
      ha: 325,
      x_min: 71,
      x_max: 286,
      o: 'm 194 1065 l 286 1011 q 226 824 228 919 l 226 711 l 71 711 l 71 812 q 106 948 71 876 q 194 1065 142 1021 z '
    },
    '’': {
      ha: 319,
      x_min: 39,
      x_max: 256,
      o: 'm 132 684 l 39 738 q 100 927 98 829 l 100 1042 l 256 1042 l 256 937 q 222 804 256 876 q 132 684 188 733 z '
    },
    '‚': {
      ha: 345,
      x_min: 45,
      x_max: 261,
      o: 'm 137 -207 l 45 -153 q 100 33 98 -68 l 100 155 l 261 155 l 260 43 q 226 -87 260 -18 q 137 -207 193 -157 z '
    },
    '‛': {
      ha: 290,
      x_min: 48,
      x_max: 264,
      o: 'm 204 1042 l 204 931 q 217 839 205 883 q 264 738 230 795 l 172 684 q 82 804 117 732 q 48 937 48 875 l 48 1042 l 204 1042 z '
    },
    '“': {
      ha: 564,
      x_min: 76,
      x_max: 524,
      o: 'm 199 1065 l 292 1011 q 231 824 233 919 l 231 711 l 76 711 l 76 812 q 112 948 76 876 q 199 1065 147 1021 m 432 1065 l 524 1011 q 464 824 466 919 l 464 711 l 309 711 l 309 812 q 344 948 309 876 q 432 1065 380 1021 z '
    },
    '”': {
      ha: 568,
      x_min: 49,
      x_max: 500,
      o: 'm 141 684 l 49 738 q 109 927 107 829 l 109 1042 l 265 1042 l 265 937 q 231 804 265 876 q 141 684 197 733 m 376 684 l 284 738 q 345 927 342 829 l 345 1042 l 500 1042 l 500 937 q 467 804 500 876 q 376 684 433 733 z '
    },
    '„': {
      ha: 559,
      x_min: 45,
      x_max: 494,
      o: 'm 142 -220 l 45 -167 q 100 32 98 -76 l 100 178 l 261 178 l 260 43 q 228 -97 260 -22 q 142 -220 196 -171 m 370 -220 l 273 -167 q 333 33 331 -66 l 333 178 l 494 178 l 494 41 q 458 -98 492 -24 q 370 -220 424 -172 z '
    },
    '†': {
      ha: 747,
      x_min: 39,
      x_max: 710,
      o: 'm 710 570 l 471 570 l 471 0 l 275 0 l 275 570 l 39 570 l 39 734 l 275 734 l 275 987 l 471 987 l 471 734 l 710 734 l 710 570 z '
    },
    '‡': {
      ha: 804,
      x_min: 66,
      x_max: 737,
      o: 'm 737 0 l 498 0 l 498 -282 l 301 -282 l 301 0 l 66 0 l 66 158 l 301 158 l 301 575 l 66 575 l 66 734 l 301 734 l 301 987 l 498 987 l 498 734 l 737 734 l 737 575 l 498 575 l 498 158 l 737 158 l 737 0 z '
    },
    '•': {
      ha: 499,
      x_min: 92,
      x_max: 414,
      o: 'm 92 519 q 136 633 92 590 q 252 675 181 675 q 369 633 325 675 q 414 523 412 591 l 414 494 q 369 381 414 424 q 253 339 325 339 q 137 381 182 339 q 92 496 92 423 l 92 519 z '
    },
    '‥': {
      ha: 724,
      x_min: 90,
      x_max: 633,
      o: 'm 90 96 q 122 172 90 143 q 201 201 153 201 q 280 172 249 201 q 312 96 312 143 q 281 21 312 50 q 201 -7 250 -7 q 121 21 153 -7 q 90 96 90 50 m 411 96 q 443 172 411 143 q 522 201 474 201 q 601 172 570 201 q 633 96 633 143 q 602 21 633 50 q 522 -7 570 -7 q 442 21 473 -7 q 411 96 411 50 z '
    },
    '…': {
      ha: 1027,
      x_min: 90,
      x_max: 947,
      o: 'm 90 96 q 122 172 90 143 q 201 201 153 201 q 280 172 249 201 q 312 96 312 143 q 281 21 312 50 q 201 -7 250 -7 q 121 21 153 -7 q 90 96 90 50 m 411 96 q 443 172 411 143 q 522 201 474 201 q 601 172 570 201 q 633 96 633 143 q 602 21 633 50 q 522 -7 570 -7 q 442 21 473 -7 q 411 96 411 50 m 726 96 q 757 172 726 143 q 836 201 789 201 q 916 172 884 201 q 947 96 947 143 q 916 21 947 50 q 836 -7 885 -7 q 757 21 788 -7 q 726 96 726 50 z '
    },
    '‧': {
      ha: 357,
      x_min: 68,
      x_max: 288,
      o: 'm 68 424 q 98 497 68 469 q 178 525 127 525 q 259 497 229 525 q 288 424 288 469 q 259 351 288 379 q 178 323 229 323 q 98 351 127 323 q 68 424 68 379 z '
    },
    '‰': {
      ha: 1333,
      x_min: 59,
      x_max: 1289,
      o: 'm 551 242 q 610 388 551 330 q 765 446 670 446 q 920 374 865 446 q 1074 446 975 446 q 1228 389 1167 446 q 1289 237 1289 332 l 1289 189 q 1230 44 1289 102 q 1075 -14 1171 -14 q 920 58 975 -14 q 766 -14 865 -14 q 610 44 670 -14 q 551 192 551 102 l 551 242 m 59 797 q 116 943 59 886 q 263 1001 173 1001 q 418 944 359 1001 q 478 793 478 886 l 478 745 q 418 600 478 657 q 264 543 359 543 q 117 600 174 543 q 59 750 59 657 l 59 797 m 319 74 l 223 125 l 705 897 l 801 846 l 319 74 m 682 189 q 706 125 682 151 q 766 99 730 99 q 849 191 849 99 l 849 242 q 826 308 849 283 q 765 332 803 332 q 705 308 728 332 q 682 240 682 283 l 682 189 m 990 189 q 1014 126 990 153 q 1075 99 1038 99 q 1158 191 1158 99 l 1158 242 q 1135 308 1158 283 q 1074 332 1112 332 q 1013 308 1036 332 q 990 240 990 283 l 990 189 m 180 745 q 202 680 180 705 q 264 655 225 655 q 325 680 302 655 q 347 747 347 705 l 347 797 q 324 863 347 838 q 263 888 301 888 q 202 863 224 888 q 180 794 180 838 l 180 745 z '
    },
    '‹': {
      ha: 433,
      x_min: 73,
      x_max: 389,
      o: 'm 227 355 l 389 85 l 263 85 l 73 349 l 73 362 l 263 627 l 389 627 l 227 355 z '
    },
    '›': {
      ha: 419,
      x_min: 54,
      x_max: 371,
      o: 'm 181 626 l 371 361 l 371 349 l 181 84 l 54 84 l 217 355 l 54 626 l 181 626 z '
    },
    '⁄': {
      ha: 619,
      x_min: 20,
      x_max: 598,
      o: 'm 116 74 l 20 125 l 503 897 l 598 846 l 116 74 z '
    },
    '⁴': {
      ha: 517,
      x_min: 36,
      x_max: 477,
      o: 'm 418 673 l 477 673 l 477 560 l 418 560 l 418 452 l 279 452 l 279 560 l 44 560 l 36 652 l 278 987 l 418 987 l 418 673 m 169 673 l 279 673 l 279 817 l 269 802 l 169 673 z '
    },
    ⁿ: {
      ha: 581,
      x_min: 59,
      x_max: 524,
      o: 'm 173 986 l 195 903 q 345 994 245 994 q 524 793 521 994 l 524 443 l 380 443 l 380 752 q 294 870 378 870 q 203 817 229 870 l 203 443 l 59 443 l 59 986 l 173 986 z '
    },
    '₤': {
      ha: 825,
      x_min: 69,
      x_max: 787,
      o: 'm 570 317 l 386 317 l 387 296 q 345 163 387 213 l 787 163 l 787 0 l 69 0 l 69 163 l 132 163 q 180 285 180 176 l 179 317 l 69 317 l 69 425 l 176 425 l 173 500 l 69 500 l 69 608 l 170 608 l 167 705 q 251 921 167 842 q 475 1000 334 1000 q 701 924 618 1000 q 783 718 783 848 l 588 718 q 558 806 588 775 q 474 836 529 836 q 399 803 429 836 q 370 705 370 770 l 374 608 l 570 608 l 570 500 l 378 500 l 381 425 l 570 425 l 570 317 z '
    },
    '₦': {
      ha: 1131,
      x_min: 25,
      x_max: 1105,
      o: 'm 966 669 l 1105 669 l 1105 561 l 966 561 l 966 451 l 1105 451 l 1105 342 l 966 342 l 966 0 l 762 0 l 553 342 l 366 342 l 366 0 l 162 0 l 162 342 l 25 342 l 25 451 l 162 451 l 162 561 l 25 561 l 25 669 l 162 669 l 162 987 l 366 987 l 559 669 l 762 669 l 762 987 l 966 987 l 966 669 m 692 451 l 762 451 l 762 561 l 626 561 l 692 451 m 366 451 l 487 451 l 420 561 l 366 561 l 366 451 m 762 336 l 762 342 l 758 342 l 762 336 z '
    },
    '₧': {
      ha: 1194,
      x_min: 96,
      x_max: 1118,
      o: 'm 1111 590 l 986 590 l 986 224 q 1001 166 986 184 q 1061 148 1017 148 q 1118 153 1095 148 l 1118 4 q 1000 -14 1061 -14 q 790 195 794 -14 l 790 590 l 722 590 q 605 413 695 475 q 376 350 515 351 l 302 350 l 302 0 l 96 0 l 96 987 l 372 987 q 612 921 519 987 q 725 734 704 855 l 790 734 l 790 914 l 986 914 l 986 734 l 1111 734 l 1111 590 m 302 520 l 372 520 q 485 560 446 520 q 524 672 524 600 q 485 779 524 742 q 374 817 445 817 l 302 817 l 302 520 z '
    },
    '₨': {
      ha: 1507,
      x_min: 88,
      x_max: 1455,
      o: 'm 454 361 l 292 361 l 292 0 l 88 0 l 88 987 l 455 987 q 725 909 630 987 q 820 689 820 831 q 776 520 820 588 q 644 413 732 453 l 857 9 l 857 0 l 639 0 l 454 361 m 292 526 l 456 526 q 574 565 532 526 q 616 673 616 604 q 577 783 616 743 q 455 823 537 823 l 292 823 l 292 526 m 1265 203 q 1229 259 1265 239 q 1115 296 1194 280 q 853 519 853 351 q 934 682 853 616 q 1146 747 1015 747 q 1370 682 1286 747 q 1453 511 1453 616 l 1257 511 q 1230 580 1257 553 q 1145 608 1203 608 q 1069 585 1096 608 q 1042 528 1042 563 q 1073 476 1042 496 q 1177 441 1103 456 q 1300 408 1250 427 q 1455 211 1455 351 q 1369 48 1455 111 q 1147 -14 1283 -14 q 983 19 1055 -14 q 871 110 911 52 q 830 233 830 167 l 1016 233 q 1055 153 1019 181 q 1151 125 1090 125 q 1236 147 1207 125 q 1265 203 1265 168 z '
    },
    '₩': {
      ha: 1121,
      x_min: 25,
      x_max: 1096,
      o: 'm 675 785 l 808 785 l 836 987 l 1039 987 l 1000 785 l 1096 785 l 1096 677 l 978 677 l 961 587 l 1096 587 l 1096 479 l 940 479 l 847 0 l 641 0 l 566 479 l 549 479 l 475 0 l 269 0 l 175 479 l 25 479 l 25 587 l 154 587 l 137 677 l 25 677 l 25 785 l 116 785 l 77 987 l 279 987 l 308 785 l 441 785 l 471 987 l 646 987 l 675 785 m 336 587 l 413 587 l 426 677 l 323 677 l 336 587 m 705 587 l 781 587 l 793 677 l 692 677 l 705 587 m 374 315 l 397 479 l 351 479 l 374 315 m 743 321 l 766 479 l 720 479 l 743 321 z '
    },
    '₪': {
      ha: 1206,
      x_min: 75,
      x_max: 1131,
      o: 'm 582 734 q 777 672 716 734 q 839 467 837 610 l 839 247 l 642 247 l 642 457 q 617 546 642 518 q 524 575 593 574 l 271 575 l 271 0 l 75 0 l 75 734 l 582 734 m 366 0 l 366 488 l 562 488 l 562 158 l 809 158 q 907 184 881 158 q 934 270 932 211 l 934 734 l 1131 734 l 1131 276 q 1021 76 1130 152 q 735 0 913 0 l 366 0 z '
    },
    '€': {
      ha: 797,
      x_min: 60,
      x_max: 741,
      o: 'm 606 350 l 379 350 q 432 200 382 250 q 587 150 482 150 q 716 171 659 150 l 741 7 q 567 -13 656 -13 q 284 83 389 -13 q 175 350 180 179 l 60 350 l 60 453 l 175 453 l 175 537 l 60 537 l 60 640 l 176 640 q 295 906 188 811 q 581 1000 403 1000 q 741 979 652 1000 l 716 814 q 591 836 652 836 q 380 640 399 836 l 606 640 l 606 537 l 379 537 l 379 453 l 606 453 l 606 350 z '
    },
    '₱': {
      ha: 1040,
      x_min: 25,
      x_max: 1015,
      o: 'm 344 348 l 344 0 l 140 0 l 140 532 l 25 532 l 25 641 l 140 641 l 140 683 l 25 683 l 25 791 l 140 791 l 140 987 l 526 987 q 741 936 651 987 q 871 791 831 884 l 1015 791 l 1015 683 l 896 683 l 897 661 l 896 641 l 1015 641 l 1015 532 l 872 532 q 746 396 835 445 q 526 348 658 348 l 344 348 m 690 671 l 689 683 l 344 683 l 344 641 l 690 641 l 690 671 m 344 791 l 631 791 q 530 823 589 822 l 344 823 l 344 791 m 621 532 l 344 532 l 344 513 l 526 513 q 621 532 584 513 z '
    },
    '₹': {
      ha: 732,
      x_min: 27,
      x_max: 705,
      o: 'm 670 852 l 528 852 q 569 739 559 804 l 705 739 l 669 605 l 568 605 q 488 444 553 504 q 300 361 422 385 l 597 9 l 597 0 l 372 0 l 44 385 l 43 504 l 204 504 q 361 605 330 504 l 27 605 l 62 739 l 357 739 q 212 823 324 821 l 27 823 l 67 987 l 705 987 l 670 852 z '
    },
    '₺': {
      ha: 825,
      x_min: 25,
      x_max: 773,
      o: 'm 773 517 l 773 469 q 721 216 773 326 q 572 46 669 106 q 351 -14 475 -14 q 152 0 254 -14 l 152 424 l 25 382 l 25 527 l 152 568 l 152 650 l 25 608 l 25 753 l 152 794 l 152 987 l 355 987 l 355 861 l 488 905 l 488 760 l 355 716 l 355 635 l 488 679 l 488 535 l 355 491 l 355 153 q 513 233 458 155 q 568 467 568 312 l 568 517 l 773 517 z '
    },
    '₼': {
      ha: 947,
      x_min: 46,
      x_max: 901,
      o: 'm 572 587 q 811 428 723 553 q 901 119 900 303 l 901 0 l 705 0 l 705 119 q 669 308 705 233 q 572 414 634 382 l 572 0 l 376 0 l 376 415 q 278 307 313 382 q 242 115 242 232 l 242 0 l 46 0 l 46 114 q 86 336 46 237 q 200 500 125 435 q 376 587 275 565 l 376 734 l 572 734 l 572 587 z '
    },
    '₽': {
      ha: 979,
      x_min: 35,
      x_max: 928,
      o: 'm 591 132 l 376 132 l 376 0 l 172 0 l 172 132 l 35 132 l 35 296 l 172 296 l 172 348 l 35 348 l 35 513 l 172 513 l 172 987 l 556 987 q 751 947 667 987 q 882 833 836 907 q 928 664 928 759 q 829 433 928 517 q 553 348 730 348 l 376 348 l 376 296 l 591 296 l 591 132 m 376 513 l 551 513 q 722 663 722 513 q 679 778 722 734 q 559 822 635 821 l 376 822 l 376 513 z '
    },
    '℅': {
      ha: 1020,
      x_min: 68,
      x_max: 966,
      o: 'm 469 722 q 415 593 469 644 q 270 543 361 543 q 123 599 179 543 q 68 749 68 655 l 68 798 q 123 945 68 888 q 269 1002 178 1002 q 414 950 359 1002 q 469 820 469 899 l 339 820 q 319 869 339 850 q 269 888 299 888 q 218 864 237 888 q 199 796 199 839 l 199 745 q 217 681 199 707 q 270 655 236 655 q 319 674 300 655 q 339 722 339 693 l 469 722 m 536 242 q 596 390 536 334 q 751 446 656 446 q 906 390 847 446 q 966 238 966 335 l 966 189 q 907 42 966 98 q 752 -14 849 -14 q 595 43 654 -14 q 536 192 536 99 l 536 242 m 667 189 q 691 125 667 152 q 752 99 715 99 q 835 191 835 99 l 835 242 q 812 308 835 283 q 751 332 789 332 q 690 308 713 332 q 667 240 667 283 l 667 189 m 309 74 l 213 125 l 695 897 l 791 846 l 309 74 z '
    },
    ℓ: {
      ha: 686,
      x_min: 28,
      x_max: 638,
      o: 'm 505 -14 q 245 65 336 -14 q 155 292 155 144 l 155 303 q 28 293 94 293 l 28 420 q 155 431 94 420 l 155 718 q 224 937 157 857 q 408 1016 291 1016 q 575 951 511 1016 q 638 779 638 886 l 638 752 q 562 542 638 648 q 361 370 486 436 l 361 333 q 395 209 361 248 q 505 170 429 170 l 505 -14 m 361 532 q 462 760 462 625 l 462 781 q 448 832 462 813 q 413 851 433 851 q 361 732 361 851 l 361 532 z '
    },
    '№': {
      ha: 1409,
      x_min: 87,
      x_max: 1339,
      o: 'm 1304 283 l 899 283 l 899 382 l 1304 382 l 1304 283 m 869 754 q 934 930 869 863 q 1103 998 999 998 q 1273 931 1208 998 q 1339 750 1339 863 l 1339 708 q 1275 533 1339 601 q 1105 465 1211 465 q 933 533 998 465 q 869 712 869 602 l 869 754 m 987 708 q 1019 603 987 641 q 1105 564 1050 564 q 1189 603 1158 564 q 1220 711 1220 642 l 1220 754 q 1188 859 1220 821 q 1103 898 1156 898 q 1019 859 1051 898 q 987 751 987 821 l 987 708 m 786 0 l 570 0 l 284 642 l 284 0 l 87 0 l 87 987 l 302 987 l 589 344 l 589 987 l 786 987 l 786 0 z '
    },
    '™': {
      ha: 877,
      x_min: 79,
      x_max: 776,
      o: 'm 689 859 l 614 620 l 565 620 l 490 859 l 490 620 l 403 620 l 403 987 l 510 987 l 589 738 l 675 987 l 776 987 l 776 620 l 689 620 l 689 859 m 355 914 l 267 914 l 267 622 l 171 622 l 171 914 l 79 914 l 79 987 l 355 987 l 355 914 z '
    },
    '℮': {
      ha: 879,
      x_min: 100,
      x_max: 791,
      o: 'm 707 64 q 456 -14 583 -14 q 275 40 357 -14 q 146 180 192 93 q 100 367 100 267 q 149 552 100 464 q 282 693 198 640 q 456 747 366 747 q 623 700 546 747 q 745 571 700 653 q 791 391 789 488 l 791 349 l 271 349 l 271 126 q 456 52 351 52 q 705 134 589 52 l 707 64 m 456 684 q 271 601 353 684 l 271 413 l 637 413 l 637 607 q 456 684 559 684 z '
    },
    '⅛': {
      ha: 1088,
      x_min: 66,
      x_max: 1019,
      o: 'm 332 438 l 194 438 l 194 810 l 66 782 l 66 889 l 319 971 l 332 971 l 332 438 m 302 74 l 206 125 l 688 897 l 784 846 l 302 74 m 1007 391 q 932 275 1007 313 q 1019 148 1019 235 q 964 34 1019 75 q 810 -7 909 -7 q 656 34 713 -7 q 600 148 600 75 q 688 275 600 235 q 612 391 612 315 q 665 502 612 461 q 809 543 719 543 q 953 503 899 543 q 1007 391 1007 463 m 881 161 q 809 216 881 216 q 739 161 739 216 q 759 119 739 134 q 810 104 778 104 q 862 119 842 104 q 881 161 881 134 m 868 381 q 809 431 868 431 q 751 381 751 431 q 810 329 751 329 q 868 381 868 329 z '
    },
    '⅜': {
      ha: 1196,
      x_min: 49,
      x_max: 1125,
      o: 'm 201 766 l 257 766 q 338 826 338 766 q 318 864 338 850 q 266 878 299 878 q 217 868 237 878 q 197 838 197 857 l 58 838 q 116 948 58 907 q 262 990 173 990 q 418 950 360 990 q 476 837 476 909 q 385 722 476 756 q 486 597 486 694 q 424 483 486 526 q 262 440 362 440 q 107 485 165 440 q 49 608 49 530 l 189 608 q 212 568 189 585 q 270 551 235 551 q 329 569 311 551 q 347 611 347 587 q 264 674 347 673 l 201 674 l 201 766 m 406 74 l 310 125 l 792 897 l 888 846 l 406 74 m 1113 391 q 1038 275 1113 313 q 1125 148 1125 235 q 1070 34 1125 75 q 916 -7 1015 -7 q 762 34 819 -7 q 705 148 705 75 q 794 275 705 235 q 718 391 718 315 q 771 502 718 461 q 915 543 825 543 q 1059 503 1005 543 q 1113 391 1113 463 m 987 161 q 915 216 987 216 q 845 161 845 216 q 864 119 845 134 q 916 104 884 104 q 967 119 948 104 q 987 161 987 134 m 974 381 q 915 431 974 431 q 857 381 857 431 q 916 329 857 329 q 974 381 974 329 z '
    },
    '⅝': {
      ha: 1183,
      x_min: 59,
      x_max: 1112,
      o: 'm 71 708 l 108 985 l 449 985 l 449 875 l 221 875 l 207 783 q 296 802 250 802 q 433 757 386 802 q 479 629 479 712 q 422 494 479 546 q 270 442 364 442 q 121 487 182 442 q 59 601 60 532 l 199 601 q 270 553 201 553 q 340 630 340 553 q 320 685 340 665 q 259 706 300 706 q 208 697 225 706 q 182 681 191 688 l 71 708 m 392 74 l 296 125 l 779 897 l 874 846 l 392 74 m 1100 391 q 1025 275 1100 313 q 1112 148 1112 235 q 1057 34 1112 75 q 903 -7 1002 -7 q 749 34 806 -7 q 692 148 692 75 q 781 275 692 235 q 705 391 705 315 q 758 502 705 461 q 902 543 812 543 q 1046 503 992 543 q 1100 391 1100 463 m 974 161 q 902 216 974 216 q 832 161 832 216 q 851 119 832 134 q 903 104 871 104 q 955 119 935 104 q 974 161 974 134 m 961 381 q 902 431 961 431 q 844 381 844 431 q 903 329 844 329 q 961 381 961 329 z '
    },
    '⅞': {
      ha: 1194,
      x_min: 62,
      x_max: 1076,
      o: 'm 495 901 l 271 444 l 124 444 l 349 866 l 62 866 l 62 979 l 495 979 l 495 901 m 338 74 l 243 125 l 725 897 l 821 846 l 338 74 m 1063 391 q 988 275 1063 313 q 1076 148 1076 235 q 1020 34 1076 75 q 867 -7 965 -7 q 712 34 769 -7 q 656 148 656 75 q 745 275 656 235 q 668 391 668 315 q 722 502 668 461 q 865 543 775 543 q 1009 503 956 543 q 1063 391 1063 463 m 937 161 q 865 216 937 216 q 795 161 795 216 q 815 119 795 134 q 867 104 834 104 q 918 119 899 104 q 937 161 937 134 m 924 381 q 865 431 924 431 q 808 381 808 431 q 867 329 808 329 q 924 381 924 329 z '
    },
    '∂': {
      ha: 795,
      x_min: 60,
      x_max: 752,
      o: 'm 383 703 q 573 625 495 703 q 492 816 552 747 q 347 885 432 885 q 227 867 276 885 l 182 850 l 151 991 l 191 1008 q 363 1042 269 1042 q 648 898 547 1042 q 752 484 750 753 l 752 441 q 710 204 752 308 q 588 43 667 100 q 406 -14 509 -14 q 154 84 248 -14 q 60 351 60 182 l 60 360 q 148 609 60 515 q 383 703 235 703 m 407 545 q 296 494 334 545 q 257 336 257 444 q 295 193 257 243 q 406 144 333 144 q 516 203 477 144 q 556 379 556 262 l 556 454 q 496 521 535 497 q 407 545 458 545 z '
    },
    '∏': {
      ha: 962,
      x_min: 111,
      x_max: 857,
      o: 'm 857 -172 l 660 -172 l 660 833 l 308 833 l 308 -172 l 111 -172 l 111 987 l 857 987 l 857 -172 z '
    },
    '∑': {
      ha: 871,
      x_min: 39,
      x_max: 838,
      o: 'm 631 395 l 308 -24 l 838 -24 l 838 -182 l 39 -182 l 39 -80 l 425 406 l 39 885 l 39 987 l 814 987 l 814 829 l 310 829 l 631 417 l 631 395 z '
    },
    '−': {
      ha: 772,
      x_min: 100,
      x_max: 685,
      o: 'm 685 404 l 100 404 l 100 564 l 685 564 l 685 404 z '
    },
    '√': {
      ha: 785,
      x_min: 37,
      x_max: 770,
      o: 'm 395 199 l 613 987 l 770 987 l 484 0 l 317 0 l 191 355 l 37 355 l 37 515 l 300 515 l 395 199 z '
    },
    '∞': {
      ha: 1453,
      x_min: 64,
      x_max: 1387,
      o: 'm 1387 359 q 1342 167 1387 253 q 1218 34 1298 81 q 1038 -14 1139 -14 q 725 198 842 -14 q 412 -14 608 -14 q 160 92 257 -14 q 64 366 64 197 l 64 373 q 107 564 64 477 q 230 699 151 650 q 411 747 310 747 q 587 696 507 747 q 725 542 667 645 q 863 697 783 646 q 1039 747 943 747 q 1289 642 1192 747 q 1387 359 1387 537 m 1196 373 q 1149 526 1196 468 q 1029 584 1103 584 q 869 483 935 584 q 823 381 835 430 l 823 361 q 847 295 827 339 q 896 218 867 250 q 957 167 924 185 q 1027 149 989 149 q 1150 208 1105 149 q 1196 373 1196 266 m 254 359 q 299 207 254 265 q 422 149 345 149 q 590 271 522 149 q 626 361 621 326 l 626 381 q 582 483 614 433 q 508 558 549 533 q 421 584 467 584 q 300 526 347 584 q 254 359 254 469 z '
    },
    '∫': {
      ha: 401,
      x_min: -62,
      x_max: 475,
      o: 'm 294 -32 q 226 -229 294 -162 q 36 -296 158 -296 q -62 -284 -16 -296 l -51 -130 q 7 -138 -18 -138 q 97 -40 94 -138 l 97 798 q 168 989 97 922 q 368 1056 238 1056 q 475 1042 410 1056 l 459 891 q 393 898 431 898 q 294 794 294 898 l 294 -32 z '
    },
    '≈': {
      ha: 801,
      x_min: 68,
      x_max: 716,
      o: 'm 68 620 q 146 673 101 654 q 235 692 191 692 q 353 667 295 693 l 446 621 q 562 595 502 595 q 716 681 648 595 l 716 520 q 566 448 647 448 q 451 474 507 448 l 357 520 q 240 545 300 546 q 146 521 193 545 q 68 459 99 497 l 68 620 m 68 335 q 230 407 138 407 q 349 382 291 408 l 444 335 q 556 311 498 311 q 716 396 648 311 l 716 235 q 562 163 647 163 q 446 189 502 163 l 353 235 q 235 260 295 261 q 146 237 191 260 q 68 174 101 215 l 68 335 z '
    },
    '≠': {
      ha: 795,
      x_min: 92,
      x_max: 699,
      o: 'm 699 212 l 323 212 l 244 66 l 163 108 l 220 212 l 92 212 l 92 372 l 306 372 l 378 506 l 92 506 l 92 666 l 464 666 l 542 810 l 623 768 l 568 666 l 699 666 l 699 506 l 481 506 l 409 372 l 699 372 l 699 212 z '
    },
    '≤': {
      ha: 707,
      x_min: 37,
      x_max: 627,
      o: 'm 234 501 l 621 379 l 621 208 l 37 431 l 37 575 l 621 797 l 621 626 l 234 501 m 627 27 l 41 27 l 41 187 l 627 187 l 627 27 z '
    },
    '≥': {
      ha: 718,
      x_min: 81,
      x_max: 672,
      o: 'm 475 507 l 81 631 l 81 801 l 672 578 l 672 435 l 81 211 l 81 381 l 475 507 m 667 27 l 82 27 l 82 187 l 667 187 l 667 27 z '
    },
    '◊': {
      ha: 707,
      x_min: 21,
      x_max: 688,
      o: 'm 271 987 l 438 987 l 688 493 l 439 0 l 271 0 l 21 493 l 271 987 m 354 781 l 216 493 l 355 205 l 493 493 l 354 781 z '
    },
    '': {
      ha: 408,
      x_min: 94,
      x_max: 315,
      o: 'm 94 222 q 125 298 94 269 q 204 328 157 328 q 284 298 252 328 q 315 222 315 269 q 284 148 315 176 q 204 119 253 119 q 125 148 156 119 q 94 222 94 176 m 94 778 q 125 854 94 825 q 204 883 157 883 q 284 854 252 883 q 315 778 315 825 q 284 703 315 732 q 204 674 253 674 q 125 703 156 674 q 94 778 94 732 z '
    },
    '': {
      ha: 446,
      x_min: 61,
      x_max: 385,
      o: 'm 172 443 l 61 443 l 61 733 l 172 733 l 172 443 m 385 443 l 274 443 l 274 733 l 385 733 l 385 443 z '
    },
    '': {
      ha: 319,
      x_min: 35,
      x_max: 231,
      o: 'm 132 -101 l 35 -47 q 87 117 85 31 l 87 186 l 231 186 l 231 138 q 202 8 231 75 q 132 -101 174 -59 z '
    },
    ﬁ: {
      ha: 845,
      x_min: 14,
      x_max: 758,
      o: 'm 123 0 l 123 590 l 14 590 l 14 734 l 123 734 l 123 768 q 208 981 124 906 q 444 1056 292 1056 q 667 1016 536 1056 l 638 854 q 535 879 572 873 q 456 885 498 885 q 319 764 319 885 l 319 734 l 464 734 l 464 590 l 319 590 l 319 0 l 123 0 m 758 0 l 562 0 l 562 734 l 758 734 l 758 0 z '
    },
    ﬂ: {
      ha: 851,
      x_min: 20,
      x_max: 764,
      o: 'm 567 890 q 458 897 509 897 q 326 783 326 897 l 326 734 l 471 734 l 471 590 l 326 590 l 326 0 l 129 0 l 129 590 l 20 590 l 20 734 l 129 734 l 129 791 q 209 987 130 918 q 431 1056 288 1056 q 764 1034 534 1056 l 764 0 l 567 0 l 567 890 z '
    },
    ﬃ: {
      ha: 1289,
      x_min: 20,
      x_max: 1202,
      o: 'm 129 0 l 129 590 l 20 590 l 20 734 l 129 734 l 129 796 q 200 988 129 920 q 398 1056 271 1056 q 498 1042 439 1056 l 496 890 q 436 897 471 897 q 326 793 326 897 l 326 734 l 567 734 l 567 768 q 652 981 568 906 q 888 1056 736 1056 q 1112 1016 979 1056 l 1083 854 q 980 879 1017 873 q 901 885 943 885 q 764 764 764 885 l 764 734 l 908 734 l 908 590 l 764 590 l 764 0 l 567 0 l 567 590 l 326 590 l 326 0 l 129 0 m 1202 0 l 1006 0 l 1006 734 l 1202 734 l 1202 0 z '
    },
    ﬄ: {
      ha: 1289,
      x_min: 20,
      x_max: 1202,
      o: 'm 129 0 l 129 590 l 20 590 l 20 734 l 129 734 l 129 796 q 200 988 129 920 q 398 1056 271 1056 q 498 1042 439 1056 l 496 890 q 436 897 471 897 q 326 793 326 897 l 326 734 l 567 734 l 567 789 q 647 987 568 918 q 870 1056 727 1056 q 1202 1034 968 1056 l 1202 0 l 1006 0 l 1006 890 q 897 897 947 897 q 764 783 764 897 l 764 734 l 909 734 l 909 590 l 764 590 l 764 0 l 567 0 l 567 590 l 326 590 l 326 0 l 129 0 z '
    },
    '﻿': { ha: 0, x_min: 0, x_max: 0, o: '' },
    '￼': {
      ha: 1419,
      x_min: 59,
      x_max: 1374,
      o: 'm 557 317 q 513 210 557 251 q 401 169 469 169 q 289 210 332 169 q 244 314 245 250 l 244 393 q 287 500 244 458 q 400 542 330 542 q 512 501 469 542 q 557 397 555 460 l 557 317 m 602 171 l 602 543 l 730 543 q 835 518 796 543 q 873 441 873 494 q 817 363 873 385 q 868 330 850 354 q 886 276 886 307 q 745 171 886 171 l 602 171 m 494 393 q 469 467 494 440 q 400 493 444 493 q 332 467 357 493 q 307 393 307 440 l 307 317 q 332 244 307 271 q 401 218 357 218 q 470 244 445 218 q 494 317 494 271 l 494 393 m 1141 545 l 1204 545 l 1204 288 q 1168 204 1204 235 q 1077 172 1133 172 q 980 200 1017 172 q 943 283 943 227 l 1006 283 q 1077 222 1006 222 q 1123 240 1105 222 q 1141 288 1141 258 l 1141 545 m 59 -270 l 59 -56 l 136 -56 l 136 -193 l 269 -193 l 269 -270 l 59 -270 m 1164 -270 l 1164 -193 l 1299 -193 l 1299 -56 l 1374 -56 l 1374 -270 l 1164 -270 m 59 793 l 59 986 l 269 986 l 269 907 l 136 907 l 136 793 l 59 793 m 1164 907 l 1164 986 l 1374 986 l 1374 793 l 1299 793 l 1299 907 l 1164 907 m 667 336 l 667 222 l 752 222 q 822 278 822 222 q 755 336 822 334 l 667 336 m 893 907 l 893 986 l 1082 986 l 1082 907 l 893 907 m 623 907 l 623 986 l 810 986 l 810 907 l 623 907 m 352 907 l 352 986 l 539 986 l 539 907 l 352 907 m 893 -270 l 893 -193 l 1082 -193 l 1082 -270 l 893 -270 m 623 -270 l 623 -193 l 810 -193 l 810 -270 l 623 -270 m 352 -270 l 352 -193 l 539 -193 l 539 -270 l 352 -270 m 667 384 l 730 384 q 810 438 810 384 q 790 476 810 466 q 730 486 770 486 l 667 486 l 667 384 m 136 282 l 59 282 l 59 453 l 136 453 l 136 282 m 136 538 l 59 538 l 59 708 l 136 708 l 136 538 m 136 28 l 59 28 l 59 197 l 136 197 l 136 28 m 1374 282 l 1299 282 l 1299 453 l 1374 453 l 1374 282 m 1374 538 l 1299 538 l 1299 708 l 1374 708 l 1374 538 m 1374 28 l 1299 28 l 1299 197 l 1374 197 l 1374 28 z '
    },
    '�': {
      ha: 1425,
      x_min: 62,
      x_max: 1361,
      o: 'm 711 1097 l 1361 436 l 711 -225 l 62 436 l 711 1097 m 767 273 q 777 332 767 312 q 812 368 787 351 q 893 440 862 394 q 924 536 924 486 q 868 674 924 623 q 710 725 811 725 q 558 678 612 725 q 503 545 504 631 l 640 545 q 661 597 642 579 q 710 614 681 614 q 768 593 749 614 q 787 536 787 571 q 724 431 787 471 q 646 355 662 387 q 630 273 630 324 l 767 273 m 767 211 l 630 211 l 630 96 l 767 96 l 767 211 m 716 -374 l 719 -374 l 719 -376 l 716 -376 l 716 -374 m 715 1467 l 718 1467 l 718 1464 l 715 1464 l 715 1467 z '
    },
    ' ': { ha: 346, x_min: 0, x_max: 0, o: '' },
    '­': {
      ha: 538,
      x_min: 75,
      x_max: 456,
      o: 'm 456 344 l 75 344 l 75 502 l 456 502 l 456 344 z '
    },
    Đ: {
      ha: 923,
      x_min: -14,
      x_max: 863,
      o: 'm 109 0 l 109 435 l -14 435 l -14 559 l 109 559 l 109 987 l 412 987 q 645 929 543 987 q 806 762 748 870 q 863 516 863 654 l 863 471 q 807 226 863 333 q 647 60 750 119 q 414 0 544 1 l 109 0 m 460 435 l 312 435 l 312 163 l 410 163 q 594 243 531 163 q 657 471 657 323 l 657 517 q 595 745 657 667 q 412 823 532 823 l 312 823 l 312 559 l 460 559 l 460 435 z '
    },
    Ð: {
      ha: 923,
      x_min: -14,
      x_max: 863,
      o: 'm 109 0 l 109 435 l -14 435 l -14 559 l 109 559 l 109 987 l 412 987 q 645 929 543 987 q 806 762 748 870 q 863 516 863 654 l 863 471 q 807 226 863 333 q 647 60 750 119 q 414 0 544 1 l 109 0 m 460 435 l 312 435 l 312 163 l 410 163 q 594 243 531 163 q 657 471 657 323 l 657 517 q 595 745 657 667 q 412 823 532 823 l 312 823 l 312 559 l 460 559 l 460 435 z '
    },
    ħ: {
      ha: 798,
      x_min: -36,
      x_max: 725,
      o: 'm 438 825 l 287 825 l 287 654 q 483 747 365 747 q 725 470 722 747 l 725 0 l 529 0 l 529 465 q 502 558 529 528 q 412 588 475 588 q 287 522 326 588 l 287 0 l 91 0 l 91 825 l -36 825 l -36 949 l 91 949 l 91 1042 l 287 1042 l 287 949 l 438 949 l 438 825 z '
    },
    Ŧ: {
      ha: 859,
      x_min: 27,
      x_max: 831,
      o: 'm 654 508 l 529 508 l 529 0 l 326 0 l 326 508 l 180 508 l 180 632 l 326 632 l 326 823 l 27 823 l 27 987 l 831 987 l 831 823 l 529 823 l 529 632 l 654 632 l 654 508 z '
    },
    ŧ: {
      ha: 469,
      x_min: -20,
      x_max: 454,
      o: 'm 310 914 l 310 734 l 435 734 l 435 590 l 310 590 l 310 485 l 454 485 l 454 361 l 310 361 l 310 224 q 326 165 310 183 q 385 148 341 148 q 443 153 418 148 l 443 4 q 324 -14 385 -14 q 114 193 119 -14 l 114 361 l -20 361 l -20 485 l 114 485 l 114 590 l 7 590 l 7 734 l 114 734 l 114 914 l 310 914 z '
    },
    À: {
      ha: 935,
      x_min: 5,
      x_max: 930,
      o: 'm 646 203 l 289 203 l 221 0 l 5 0 l 372 987 l 561 987 l 930 0 l 714 0 l 646 203 m 344 368 l 591 368 l 467 738 l 344 368 m 567 1042 l 406 1042 l 219 1252 l 433 1252 l 567 1042 z '
    },
    Á: {
      ha: 935,
      x_min: 5,
      x_max: 930,
      o: 'm 646 203 l 289 203 l 221 0 l 5 0 l 372 987 l 561 987 l 930 0 l 714 0 l 646 203 m 344 368 l 591 368 l 467 738 l 344 368 m 509 1252 l 722 1252 l 534 1042 l 375 1042 l 509 1252 z '
    },
    Â: {
      ha: 935,
      x_min: 5,
      x_max: 930,
      o: 'm 646 203 l 289 203 l 221 0 l 5 0 l 372 987 l 561 987 l 930 0 l 714 0 l 646 203 m 344 368 l 591 368 l 467 738 l 344 368 m 730 1062 l 730 1054 l 574 1054 l 469 1152 l 365 1054 l 212 1054 l 212 1065 l 412 1252 l 526 1252 l 730 1062 z '
    },
    Ã: {
      ha: 935,
      x_min: 5,
      x_max: 930,
      o: 'm 646 203 l 289 203 l 221 0 l 5 0 l 372 987 l 561 987 l 930 0 l 714 0 l 646 203 m 344 368 l 591 368 l 467 738 l 344 368 m 724 1242 q 680 1114 724 1166 q 570 1062 635 1062 q 525 1068 545 1062 q 469 1093 505 1074 q 418 1116 434 1112 q 385 1120 403 1120 q 344 1103 361 1120 q 328 1055 328 1086 l 214 1062 q 258 1190 214 1137 q 367 1243 302 1243 q 405 1238 387 1243 q 464 1213 423 1233 q 520 1190 505 1194 q 553 1185 536 1185 q 594 1202 576 1185 q 611 1250 611 1219 l 724 1242 z '
    },
    Ä: {
      ha: 935,
      x_min: 5,
      x_max: 930,
      o: 'm 646 203 l 289 203 l 221 0 l 5 0 l 372 987 l 561 987 l 930 0 l 714 0 l 646 203 m 344 368 l 591 368 l 467 738 l 344 368 m 398 1136 q 372 1075 398 1100 q 304 1050 345 1050 q 236 1076 262 1050 q 210 1136 210 1101 q 236 1197 210 1171 q 304 1222 262 1222 q 372 1197 346 1222 q 398 1136 398 1171 m 541 1136 q 568 1197 541 1173 q 635 1222 595 1222 q 702 1197 675 1222 q 728 1136 728 1172 q 703 1075 728 1101 q 635 1050 677 1050 q 567 1075 593 1050 q 541 1136 541 1101 z '
    },
    Å: {
      ha: 935,
      x_min: 5,
      x_max: 930,
      o: 'm 646 203 l 289 203 l 221 0 l 5 0 l 372 987 l 561 987 l 930 0 l 714 0 l 646 203 m 344 368 l 591 368 l 467 738 l 344 368 m 319 1173 q 363 1272 319 1232 q 470 1312 407 1312 q 577 1273 532 1312 q 621 1173 621 1233 q 578 1076 621 1116 q 470 1037 534 1037 q 361 1077 404 1037 q 319 1173 319 1117 m 397 1173 q 416 1122 397 1143 q 470 1101 436 1101 q 524 1122 504 1101 q 543 1173 543 1143 q 523 1226 543 1204 q 470 1247 503 1247 q 417 1226 437 1247 q 397 1173 397 1204 z '
    },
    Ǻ: {
      ha: 935,
      x_min: 5,
      x_max: 930,
      o: 'm 646 203 l 289 203 l 221 0 l 5 0 l 372 987 l 561 987 l 930 0 l 714 0 l 646 203 m 344 368 l 591 368 l 467 738 l 344 368 m 547 1355 l 724 1355 l 543 1215 l 420 1215 l 547 1355 m 332 1061 q 372 1151 332 1114 q 469 1187 412 1187 q 565 1151 526 1187 q 604 1061 604 1114 q 566 972 604 1008 q 469 937 528 937 q 371 973 410 937 q 332 1061 332 1009 m 408 1061 q 426 1018 408 1035 q 469 1001 444 1001 q 511 1018 495 1001 q 528 1061 528 1035 q 511 1105 528 1088 q 469 1122 495 1122 q 426 1105 444 1122 q 408 1061 408 1088 z '
    },
    Ç: {
      ha: 909,
      x_min: 58,
      x_max: 865,
      o: 'm 863 329 q 746 78 852 170 q 466 -14 640 -14 q 167 114 276 -14 q 58 465 58 242 l 58 526 q 109 777 58 668 q 252 943 159 885 q 469 1001 345 1001 q 744 909 640 1001 q 865 652 848 818 l 661 652 q 608 791 654 748 q 469 834 562 834 q 316 761 367 834 q 264 535 266 688 l 264 460 q 313 227 264 300 q 466 153 361 153 q 607 196 560 153 q 660 329 653 239 l 863 329 m 541 4 l 533 -35 q 635 -153 635 -54 q 573 -271 635 -227 q 398 -314 511 -314 l 393 -201 q 469 -146 469 -201 q 447 -107 469 -117 q 373 -93 424 -96 l 394 4 l 541 4 z '
    },
    È: {
      ha: 781,
      x_min: 88,
      x_max: 750,
      o: 'm 682 428 l 292 428 l 292 163 l 750 163 l 750 0 l 88 0 l 88 987 l 749 987 l 749 823 l 292 823 l 292 587 l 682 587 l 682 428 m 528 1044 l 368 1044 l 180 1254 l 394 1254 l 528 1044 z '
    },
    É: {
      ha: 781,
      x_min: 88,
      x_max: 750,
      o: 'm 682 428 l 292 428 l 292 163 l 750 163 l 750 0 l 88 0 l 88 987 l 749 987 l 749 823 l 292 823 l 292 587 l 682 587 l 682 428 m 470 1254 l 684 1254 l 496 1044 l 336 1044 l 470 1254 z '
    },
    Ê: {
      ha: 781,
      x_min: 88,
      x_max: 750,
      o: 'm 682 428 l 292 428 l 292 163 l 750 163 l 750 0 l 88 0 l 88 987 l 749 987 l 749 823 l 292 823 l 292 587 l 682 587 l 682 428 m 691 1064 l 691 1056 l 535 1056 l 431 1154 l 326 1056 l 173 1056 l 173 1067 l 374 1254 l 488 1254 l 691 1064 z '
    },
    Ë: {
      ha: 781,
      x_min: 88,
      x_max: 750,
      o: 'm 682 428 l 292 428 l 292 163 l 750 163 l 750 0 l 88 0 l 88 987 l 749 987 l 749 823 l 292 823 l 292 587 l 682 587 l 682 428 m 359 1138 q 333 1077 359 1102 q 265 1053 307 1053 q 197 1078 223 1053 q 172 1138 172 1103 q 197 1199 172 1173 q 265 1224 223 1224 q 333 1199 307 1224 q 359 1138 359 1173 m 502 1138 q 529 1199 502 1175 q 596 1224 557 1224 q 663 1199 636 1224 q 690 1138 690 1174 q 664 1077 690 1103 q 596 1052 638 1052 q 528 1077 554 1052 q 502 1138 502 1103 z '
    },
    Ì: {
      ha: 405,
      x_min: -47,
      x_max: 304,
      o: 'm 304 0 l 101 0 l 101 987 l 304 987 l 304 0 m 300 1044 l 140 1044 l -47 1254 l 166 1254 l 300 1044 z '
    },
    Í: {
      ha: 405,
      x_min: 101,
      x_max: 455,
      o: 'm 304 0 l 101 0 l 101 987 l 304 987 l 304 0 m 241 1254 l 455 1254 l 267 1044 l 108 1044 l 241 1254 z '
    },
    Î: {
      ha: 405,
      x_min: -55,
      x_max: 463,
      o: 'm 304 0 l 101 0 l 101 987 l 304 987 l 304 0 m 463 1064 l 463 1056 l 307 1056 l 203 1154 l 98 1056 l -55 1056 l -55 1067 l 146 1254 l 260 1254 l 463 1064 z '
    },
    Ï: {
      ha: 405,
      x_min: -56,
      x_max: 462,
      o: 'm 304 0 l 101 0 l 101 987 l 304 987 l 304 0 m 132 1138 q 105 1077 132 1102 q 37 1053 79 1053 q -31 1078 -5 1053 q -56 1138 -56 1103 q -31 1199 -56 1173 q 37 1224 -5 1224 q 105 1199 79 1224 q 132 1138 132 1173 m 274 1138 q 301 1199 274 1175 q 368 1224 329 1224 q 435 1199 408 1224 q 462 1138 462 1174 q 436 1077 462 1103 q 368 1052 410 1052 q 300 1077 326 1052 q 274 1138 274 1103 z '
    },
    Ñ: {
      ha: 981,
      x_min: 88,
      x_max: 891,
      o: 'm 891 0 l 688 0 l 292 650 l 292 0 l 88 0 l 88 987 l 292 987 l 688 336 l 688 987 l 891 987 l 891 0 m 747 1242 q 703 1114 747 1166 q 593 1062 658 1062 q 548 1068 568 1062 q 492 1093 528 1074 q 441 1116 457 1112 q 408 1120 426 1120 q 367 1103 384 1120 q 351 1055 351 1086 l 237 1062 q 281 1190 237 1137 q 390 1243 326 1243 q 428 1238 410 1243 q 487 1213 446 1233 q 543 1190 528 1194 q 576 1185 559 1185 q 617 1202 600 1185 q 634 1250 634 1219 l 747 1242 z '
    },
    Ò: {
      ha: 959,
      x_min: 58,
      x_max: 899,
      o: 'm 899 471 q 848 216 899 326 q 700 46 796 106 q 480 -14 604 -14 q 261 45 357 -14 q 112 214 165 104 q 58 466 59 323 l 58 515 q 111 771 58 661 q 259 942 163 882 q 479 1001 355 1001 q 698 942 602 1001 q 847 771 794 882 q 899 515 899 661 l 899 471 m 693 516 q 637 752 693 671 q 479 833 582 833 q 321 753 376 833 q 264 519 265 673 l 264 471 q 320 237 264 320 q 480 153 376 153 q 637 234 583 153 q 693 468 692 314 l 693 516 m 576 1042 l 416 1042 l 229 1252 l 442 1252 l 576 1042 z '
    },
    Ó: {
      ha: 959,
      x_min: 58,
      x_max: 899,
      o: 'm 899 471 q 848 216 899 326 q 700 46 796 106 q 480 -14 604 -14 q 261 45 357 -14 q 112 214 165 104 q 58 466 59 323 l 58 515 q 111 771 58 661 q 259 942 163 882 q 479 1001 355 1001 q 698 942 602 1001 q 847 771 794 882 q 899 515 899 661 l 899 471 m 693 516 q 637 752 693 671 q 479 833 582 833 q 321 753 376 833 q 264 519 265 673 l 264 471 q 320 237 264 320 q 480 153 376 153 q 637 234 583 153 q 693 468 692 314 l 693 516 m 518 1252 l 732 1252 l 544 1042 l 385 1042 l 518 1252 z '
    },
    Ô: {
      ha: 959,
      x_min: 58,
      x_max: 899,
      o: 'm 899 471 q 848 216 899 326 q 700 46 796 106 q 480 -14 604 -14 q 261 45 357 -14 q 112 214 165 104 q 58 466 59 323 l 58 515 q 111 771 58 661 q 259 942 163 882 q 479 1001 355 1001 q 698 942 602 1001 q 847 771 794 882 q 899 515 899 661 l 899 471 m 693 516 q 637 752 693 671 q 479 833 582 833 q 321 753 376 833 q 264 519 265 673 l 264 471 q 320 237 264 320 q 480 153 376 153 q 637 234 583 153 q 693 468 692 314 l 693 516 m 739 1062 l 739 1054 l 583 1054 l 479 1152 l 374 1054 l 221 1054 l 221 1065 l 422 1252 l 536 1252 l 739 1062 z '
    },
    Õ: {
      ha: 959,
      x_min: 58,
      x_max: 899,
      o: 'm 899 471 q 848 216 899 326 q 700 46 796 106 q 480 -14 604 -14 q 261 45 357 -14 q 112 214 165 104 q 58 466 59 323 l 58 515 q 111 771 58 661 q 259 942 163 882 q 479 1001 355 1001 q 698 942 602 1001 q 847 771 794 882 q 899 515 899 661 l 899 471 m 693 516 q 637 752 693 671 q 479 833 582 833 q 321 753 376 833 q 264 519 265 673 l 264 471 q 320 237 264 320 q 480 153 376 153 q 637 234 583 153 q 693 468 692 314 l 693 516 m 734 1242 q 689 1114 734 1166 q 580 1062 644 1062 q 534 1068 554 1062 q 479 1093 514 1074 q 428 1116 444 1112 q 394 1120 412 1120 q 354 1103 370 1120 q 337 1055 337 1086 l 223 1062 q 268 1190 223 1137 q 376 1243 312 1243 q 415 1238 397 1243 q 473 1213 433 1233 q 530 1190 514 1194 q 562 1185 545 1185 q 603 1202 586 1185 q 621 1250 621 1219 l 734 1242 z '
    },
    Ö: {
      ha: 959,
      x_min: 58,
      x_max: 899,
      o: 'm 899 471 q 848 216 899 326 q 700 46 796 106 q 480 -14 604 -14 q 261 45 357 -14 q 112 214 165 104 q 58 466 59 323 l 58 515 q 111 771 58 661 q 259 942 163 882 q 479 1001 355 1001 q 698 942 602 1001 q 847 771 794 882 q 899 515 899 661 l 899 471 m 693 516 q 637 752 693 671 q 479 833 582 833 q 321 753 376 833 q 264 519 265 673 l 264 471 q 320 237 264 320 q 480 153 376 153 q 637 234 583 153 q 693 468 692 314 l 693 516 m 408 1136 q 381 1075 408 1100 q 313 1050 355 1050 q 245 1076 271 1050 q 220 1136 220 1101 q 245 1197 220 1171 q 313 1222 271 1222 q 381 1197 355 1222 q 408 1136 408 1171 m 550 1136 q 577 1197 550 1173 q 644 1222 605 1222 q 711 1197 684 1222 q 738 1136 738 1172 q 712 1075 738 1101 q 644 1050 686 1050 q 576 1075 602 1050 q 550 1136 550 1101 z '
    },
    Ù: {
      ha: 914,
      x_min: 79,
      x_max: 836,
      o: 'm 836 987 l 836 337 q 734 81 836 175 q 457 -14 633 -14 q 182 78 284 -14 q 79 330 81 170 l 79 987 l 282 987 l 282 336 q 329 194 282 239 q 457 150 375 150 q 631 330 629 150 l 631 987 l 836 987 m 552 1042 l 391 1042 l 204 1252 l 418 1252 l 552 1042 z '
    },
    Ú: {
      ha: 914,
      x_min: 79,
      x_max: 836,
      o: 'm 836 987 l 836 337 q 734 81 836 175 q 457 -14 633 -14 q 182 78 284 -14 q 79 330 81 170 l 79 987 l 282 987 l 282 336 q 329 194 282 239 q 457 150 375 150 q 631 330 629 150 l 631 987 l 836 987 m 494 1252 l 707 1252 l 519 1042 l 360 1042 l 494 1252 z '
    },
    Û: {
      ha: 914,
      x_min: 79,
      x_max: 836,
      o: 'm 836 987 l 836 337 q 734 81 836 175 q 457 -14 633 -14 q 182 78 284 -14 q 79 330 81 170 l 79 987 l 282 987 l 282 336 q 329 194 282 239 q 457 150 375 150 q 631 330 629 150 l 631 987 l 836 987 m 715 1062 l 715 1054 l 559 1054 l 454 1152 l 350 1054 l 197 1054 l 197 1065 l 397 1252 l 511 1252 l 715 1062 z '
    },
    Ü: {
      ha: 914,
      x_min: 79,
      x_max: 836,
      o: 'm 836 987 l 836 337 q 734 81 836 175 q 457 -14 633 -14 q 182 78 284 -14 q 79 330 81 170 l 79 987 l 282 987 l 282 336 q 329 194 282 239 q 457 150 375 150 q 631 330 629 150 l 631 987 l 836 987 m 383 1136 q 357 1075 383 1100 q 289 1050 330 1050 q 221 1076 247 1050 q 195 1136 195 1101 q 221 1197 195 1171 q 289 1222 247 1222 q 357 1197 331 1222 q 383 1136 383 1171 m 526 1136 q 553 1197 526 1173 q 620 1222 581 1222 q 687 1197 660 1222 q 713 1136 713 1172 q 688 1075 713 1101 q 620 1050 662 1050 q 552 1075 578 1050 q 526 1136 526 1101 z '
    },
    Ý: {
      ha: 859,
      x_min: 1,
      x_max: 857,
      o: 'm 429 543 l 634 987 l 857 987 l 532 358 l 532 0 l 326 0 l 326 358 l 1 987 l 224 987 l 429 543 m 470 1252 l 684 1252 l 496 1042 l 336 1042 l 470 1252 z '
    },
    à: {
      ha: 745,
      x_min: 46,
      x_max: 699,
      o: 'm 500 0 q 481 66 487 26 q 296 -14 410 -14 q 117 49 188 -14 q 46 206 46 111 q 133 385 46 323 q 382 448 219 448 l 473 448 l 473 490 q 447 572 473 541 q 364 602 420 602 q 287 578 315 602 q 258 513 258 555 l 62 513 q 102 631 62 577 q 213 716 141 686 q 374 747 285 747 q 590 679 510 747 q 669 488 669 611 l 669 170 q 699 12 670 65 l 699 0 l 500 0 m 338 136 q 418 156 382 136 q 473 208 455 175 l 473 334 l 399 334 q 243 232 252 334 l 242 220 q 268 160 242 184 q 338 136 294 136 m 471 831 l 311 831 l 123 1042 l 337 1042 l 471 831 z '
    },
    á: {
      ha: 745,
      x_min: 46,
      x_max: 699,
      o: 'm 500 0 q 481 66 487 26 q 296 -14 410 -14 q 117 49 188 -14 q 46 206 46 111 q 133 385 46 323 q 382 448 219 448 l 473 448 l 473 490 q 447 572 473 541 q 364 602 420 602 q 287 578 315 602 q 258 513 258 555 l 62 513 q 102 631 62 577 q 213 716 141 686 q 374 747 285 747 q 590 679 510 747 q 669 488 669 611 l 669 170 q 699 12 670 65 l 699 0 l 500 0 m 338 136 q 418 156 382 136 q 473 208 455 175 l 473 334 l 399 334 q 243 232 252 334 l 242 220 q 268 160 242 184 q 338 136 294 136 m 413 1042 l 627 1042 l 439 831 l 279 831 l 413 1042 z '
    },
    â: {
      ha: 745,
      x_min: 46,
      x_max: 699,
      o: 'm 500 0 q 481 66 487 26 q 296 -14 410 -14 q 117 49 188 -14 q 46 206 46 111 q 133 385 46 323 q 382 448 219 448 l 473 448 l 473 490 q 447 572 473 541 q 364 602 420 602 q 287 578 315 602 q 258 513 258 555 l 62 513 q 102 631 62 577 q 213 716 141 686 q 374 747 285 747 q 590 679 510 747 q 669 488 669 611 l 669 170 q 699 12 670 65 l 699 0 l 500 0 m 338 136 q 418 156 382 136 q 473 208 455 175 l 473 334 l 399 334 q 243 232 252 334 l 242 220 q 268 160 242 184 q 338 136 294 136 m 634 852 l 634 844 l 478 844 l 374 942 l 269 844 l 116 844 l 116 854 l 317 1042 l 431 1042 l 634 852 z '
    },
    ã: {
      ha: 745,
      x_min: 46,
      x_max: 699,
      o: 'm 500 0 q 481 66 487 26 q 296 -14 410 -14 q 117 49 188 -14 q 46 206 46 111 q 133 385 46 323 q 382 448 219 448 l 473 448 l 473 490 q 447 572 473 541 q 364 602 420 602 q 287 578 315 602 q 258 513 258 555 l 62 513 q 102 631 62 577 q 213 716 141 686 q 374 747 285 747 q 590 679 510 747 q 669 488 669 611 l 669 170 q 699 12 670 65 l 699 0 l 500 0 m 338 136 q 418 156 382 136 q 473 208 455 175 l 473 334 l 399 334 q 243 232 252 334 l 242 220 q 268 160 242 184 q 338 136 294 136 m 629 1033 q 584 904 629 956 q 475 852 539 852 q 429 858 449 852 q 374 883 409 864 q 323 906 338 902 q 289 911 307 911 q 249 894 265 911 q 232 846 232 877 l 118 852 q 162 981 118 928 q 271 1034 207 1034 q 310 1028 292 1034 q 368 1004 328 1023 q 425 980 409 984 q 457 976 440 976 q 498 992 481 976 q 515 1040 515 1009 l 629 1033 z '
    },
    ä: {
      ha: 745,
      x_min: 46,
      x_max: 699,
      o: 'm 500 0 q 481 66 487 26 q 296 -14 410 -14 q 117 49 188 -14 q 46 206 46 111 q 133 385 46 323 q 382 448 219 448 l 473 448 l 473 490 q 447 572 473 541 q 364 602 420 602 q 287 578 315 602 q 258 513 258 555 l 62 513 q 102 631 62 577 q 213 716 141 686 q 374 747 285 747 q 590 679 510 747 q 669 488 669 611 l 669 170 q 699 12 670 65 l 699 0 l 500 0 m 338 136 q 418 156 382 136 q 473 208 455 175 l 473 334 l 399 334 q 243 232 252 334 l 242 220 q 268 160 242 184 q 338 136 294 136 m 302 926 q 276 865 302 890 q 208 840 250 840 q 140 865 166 840 q 115 926 115 890 q 140 986 115 961 q 208 1012 166 1012 q 276 986 250 1012 q 302 926 302 961 m 445 926 q 472 987 445 962 q 539 1012 500 1012 q 606 987 579 1012 q 633 926 633 962 q 607 865 633 890 q 539 840 581 840 q 471 865 497 840 q 445 926 445 890 z '
    },
    å: {
      ha: 745,
      x_min: 46,
      x_max: 699,
      o: 'm 500 0 q 481 66 487 26 q 296 -14 410 -14 q 117 49 188 -14 q 46 206 46 111 q 133 385 46 323 q 382 448 219 448 l 473 448 l 473 490 q 447 572 473 541 q 364 602 420 602 q 287 578 315 602 q 258 513 258 555 l 62 513 q 102 631 62 577 q 213 716 141 686 q 374 747 285 747 q 590 679 510 747 q 669 488 669 611 l 669 170 q 699 12 670 65 l 699 0 l 500 0 m 338 136 q 418 156 382 136 q 473 208 455 175 l 473 334 l 399 334 q 243 232 252 334 l 242 220 q 268 160 242 184 q 338 136 294 136 m 223 963 q 267 1062 223 1021 q 374 1102 311 1102 q 481 1062 437 1102 q 526 963 526 1023 q 482 866 526 905 q 374 827 439 827 q 266 867 309 827 q 223 963 223 907 m 301 963 q 321 912 301 933 q 374 890 340 890 q 428 912 408 890 q 448 963 448 933 q 428 1016 448 994 q 374 1037 408 1037 q 321 1016 341 1037 q 301 963 301 994 z '
    },
    ǻ: {
      ha: 745,
      x_min: 46,
      x_max: 699,
      o: 'm 500 0 q 481 66 487 26 q 296 -14 410 -14 q 117 49 188 -14 q 46 206 46 111 q 133 385 46 323 q 382 448 219 448 l 473 448 l 473 490 q 447 572 473 541 q 364 602 420 602 q 287 578 315 602 q 258 513 258 555 l 62 513 q 102 631 62 577 q 213 716 141 686 q 374 747 285 747 q 590 679 510 747 q 669 488 669 611 l 669 170 q 699 12 670 65 l 699 0 l 500 0 m 338 136 q 418 156 382 136 q 473 208 455 175 l 473 334 l 399 334 q 243 232 252 334 l 242 220 q 268 160 242 184 q 338 136 294 136 m 452 1145 l 629 1145 l 447 1005 l 325 1005 l 452 1145 m 237 851 q 276 941 237 904 q 374 978 316 978 q 470 941 431 978 q 509 851 509 905 q 471 763 509 799 q 374 727 433 727 q 275 763 314 727 q 237 851 237 800 m 313 851 q 330 808 313 825 q 374 791 348 791 q 416 808 399 791 q 432 851 432 825 q 416 896 432 879 q 374 913 399 913 q 330 896 348 913 q 313 851 313 879 z '
    },
    ç: {
      ha: 724,
      x_min: 45,
      x_max: 688,
      o: 'm 380 144 q 469 174 435 144 q 504 254 503 204 l 688 254 q 647 117 687 179 q 537 21 607 55 q 384 -14 468 -14 q 136 86 227 -14 q 45 363 45 186 l 45 376 q 135 646 45 545 q 382 747 225 747 q 603 669 520 747 q 688 460 686 591 l 504 460 q 469 553 503 517 q 379 589 435 589 q 276 539 311 589 q 241 377 241 489 l 241 357 q 275 194 241 243 q 380 144 310 144 m 452 4 l 444 -35 q 546 -153 546 -54 q 484 -271 546 -227 q 309 -314 422 -314 l 304 -201 q 380 -146 380 -201 q 358 -107 380 -117 q 284 -93 335 -96 l 305 4 l 452 4 z '
    },
    è: {
      ha: 751,
      x_min: 49,
      x_max: 715,
      o: 'm 413 -14 q 150 85 252 -14 q 49 349 49 184 l 49 368 q 92 566 49 479 q 213 700 134 653 q 391 747 291 747 q 628 652 542 747 q 715 383 715 557 l 715 303 l 248 303 q 305 188 257 231 q 426 144 353 144 q 603 227 539 144 l 699 119 q 580 21 655 56 q 413 -14 505 -14 m 391 589 q 296 549 332 589 q 250 437 260 510 l 522 437 l 522 452 q 487 553 521 517 q 391 589 453 589 m 467 831 l 306 831 l 119 1042 l 332 1042 l 467 831 z '
    },
    é: {
      ha: 751,
      x_min: 49,
      x_max: 715,
      o: 'm 413 -14 q 150 85 252 -14 q 49 349 49 184 l 49 368 q 92 566 49 479 q 213 700 134 653 q 391 747 291 747 q 628 652 542 747 q 715 383 715 557 l 715 303 l 248 303 q 305 188 257 231 q 426 144 353 144 q 603 227 539 144 l 699 119 q 580 21 655 56 q 413 -14 505 -14 m 391 589 q 296 549 332 589 q 250 437 260 510 l 522 437 l 522 452 q 487 553 521 517 q 391 589 453 589 m 408 1042 l 622 1042 l 434 831 l 275 831 l 408 1042 z '
    },
    ê: {
      ha: 751,
      x_min: 49,
      x_max: 715,
      o: 'm 413 -14 q 150 85 252 -14 q 49 349 49 184 l 49 368 q 92 566 49 479 q 213 700 134 653 q 391 747 291 747 q 628 652 542 747 q 715 383 715 557 l 715 303 l 248 303 q 305 188 257 231 q 426 144 353 144 q 603 227 539 144 l 699 119 q 580 21 655 56 q 413 -14 505 -14 m 391 589 q 296 549 332 589 q 250 437 260 510 l 522 437 l 522 452 q 487 553 521 517 q 391 589 453 589 m 629 852 l 629 844 l 473 844 l 369 942 l 264 844 l 111 844 l 111 854 l 312 1042 l 426 1042 l 629 852 z '
    },
    ë: {
      ha: 751,
      x_min: 49,
      x_max: 715,
      o: 'm 413 -14 q 150 85 252 -14 q 49 349 49 184 l 49 368 q 92 566 49 479 q 213 700 134 653 q 391 747 291 747 q 628 652 542 747 q 715 383 715 557 l 715 303 l 248 303 q 305 188 257 231 q 426 144 353 144 q 603 227 539 144 l 699 119 q 580 21 655 56 q 413 -14 505 -14 m 391 589 q 296 549 332 589 q 250 437 260 510 l 522 437 l 522 452 q 487 553 521 517 q 391 589 453 589 m 298 926 q 271 865 298 890 q 203 840 245 840 q 136 865 161 840 q 110 926 110 890 q 136 986 110 961 q 203 1012 161 1012 q 272 986 245 1012 q 298 926 298 961 m 440 926 q 468 987 440 962 q 534 1012 495 1012 q 601 987 574 1012 q 628 926 628 962 q 602 865 628 890 q 534 840 576 840 q 466 865 492 840 q 440 926 440 890 z '
    },
    ì: {
      ha: 380,
      x_min: -60,
      x_max: 288,
      o: 'm 287 0 l 91 0 l 91 734 l 287 734 l 287 0 m 288 821 l 127 821 l -60 1031 l 154 1031 l 288 821 z '
    },
    í: {
      ha: 380,
      x_min: 91,
      x_max: 443,
      o: 'm 287 0 l 91 0 l 91 734 l 287 734 l 287 0 m 229 1031 l 443 1031 l 255 821 l 96 821 l 229 1031 z '
    },
    î: {
      ha: 380,
      x_min: -67,
      x_max: 451,
      o: 'm 287 0 l 91 0 l 91 734 l 287 734 l 287 0 m 451 842 l 451 833 l 295 833 l 191 932 l 86 833 l -67 833 l -67 844 l 134 1031 l 248 1031 l 451 842 z '
    },
    ï: {
      ha: 380,
      x_min: -68,
      x_max: 450,
      o: 'm 287 0 l 91 0 l 91 734 l 287 734 l 287 0 m 119 916 q 93 855 119 880 q 25 830 66 830 q -43 855 -17 830 q -68 916 -68 880 q -43 976 -68 951 q 25 1002 -17 1002 q 93 976 67 1002 q 119 916 119 951 m 262 916 q 289 977 262 952 q 356 1002 317 1002 q 423 977 396 1002 q 450 916 450 951 q 424 855 450 880 q 356 829 398 829 q 288 855 314 829 q 262 916 262 880 z '
    },
    ñ: {
      ha: 778,
      x_min: 71,
      x_max: 705,
      o: 'm 256 734 l 262 649 q 473 747 340 747 q 646 679 589 747 q 705 474 703 610 l 705 0 l 509 0 l 509 469 q 481 560 509 532 q 391 588 454 588 q 267 517 309 588 l 267 0 l 71 0 l 71 734 l 256 734 m 645 1033 q 600 904 645 956 q 491 852 555 852 q 445 858 465 852 q 390 883 425 864 q 339 906 355 902 q 305 911 323 911 q 265 894 281 911 q 248 846 248 877 l 134 852 q 179 981 134 928 q 288 1034 223 1034 q 326 1028 308 1034 q 385 1004 344 1023 q 441 980 425 984 q 473 976 456 976 q 514 992 497 976 q 532 1040 532 1009 l 645 1033 z '
    },
    ò: {
      ha: 785,
      x_min: 45,
      x_max: 740,
      o: 'm 45 374 q 87 568 45 483 q 208 701 129 654 q 391 747 287 747 q 634 656 540 747 q 739 410 728 566 l 740 359 q 646 89 740 191 q 393 -14 551 -14 q 139 88 234 -14 q 45 365 45 190 l 45 374 m 241 359 q 280 200 241 255 q 393 144 319 144 q 504 199 464 144 q 544 374 544 254 q 504 532 544 476 q 391 589 464 589 q 280 533 319 589 q 241 359 241 477 m 488 831 l 328 831 l 140 1042 l 354 1042 l 488 831 z '
    },
    ó: {
      ha: 785,
      x_min: 45,
      x_max: 740,
      o: 'm 45 374 q 87 568 45 483 q 208 701 129 654 q 391 747 287 747 q 634 656 540 747 q 739 410 728 566 l 740 359 q 646 89 740 191 q 393 -14 551 -14 q 139 88 234 -14 q 45 365 45 190 l 45 374 m 241 359 q 280 200 241 255 q 393 144 319 144 q 504 199 464 144 q 544 374 544 254 q 504 532 544 476 q 391 589 464 589 q 280 533 319 589 q 241 359 241 477 m 430 1042 l 644 1042 l 456 831 l 296 831 l 430 1042 z '
    },
    ô: {
      ha: 785,
      x_min: 45,
      x_max: 740,
      o: 'm 45 374 q 87 568 45 483 q 208 701 129 654 q 391 747 287 747 q 634 656 540 747 q 739 410 728 566 l 740 359 q 646 89 740 191 q 393 -14 551 -14 q 139 88 234 -14 q 45 365 45 190 l 45 374 m 241 359 q 280 200 241 255 q 393 144 319 144 q 504 199 464 144 q 544 374 544 254 q 504 532 544 476 q 391 589 464 589 q 280 533 319 589 q 241 359 241 477 m 651 852 l 651 844 l 495 844 l 391 942 l 286 844 l 133 844 l 133 854 l 334 1042 l 448 1042 l 651 852 z '
    },
    õ: {
      ha: 785,
      x_min: 45,
      x_max: 740,
      o: 'm 45 374 q 87 568 45 483 q 208 701 129 654 q 391 747 287 747 q 634 656 540 747 q 739 410 728 566 l 740 359 q 646 89 740 191 q 393 -14 551 -14 q 139 88 234 -14 q 45 365 45 190 l 45 374 m 241 359 q 280 200 241 255 q 393 144 319 144 q 504 199 464 144 q 544 374 544 254 q 504 532 544 476 q 391 589 464 589 q 280 533 319 589 q 241 359 241 477 m 646 1033 q 601 904 646 956 q 492 852 556 852 q 446 858 466 852 q 391 883 426 864 q 340 906 355 902 q 306 911 324 911 q 266 894 282 911 q 249 846 249 877 l 135 852 q 179 981 135 928 q 288 1034 224 1034 q 327 1028 309 1034 q 385 1004 345 1023 q 441 980 426 984 q 474 976 457 976 q 515 992 498 976 q 532 1040 532 1009 l 646 1033 z '
    },
    ö: {
      ha: 785,
      x_min: 45,
      x_max: 740,
      o: 'm 45 374 q 87 568 45 483 q 208 701 129 654 q 391 747 287 747 q 634 656 540 747 q 739 410 728 566 l 740 359 q 646 89 740 191 q 393 -14 551 -14 q 139 88 234 -14 q 45 365 45 190 l 45 374 m 241 359 q 280 200 241 255 q 393 144 319 144 q 504 199 464 144 q 544 374 544 254 q 504 532 544 476 q 391 589 464 589 q 280 533 319 589 q 241 359 241 477 m 319 926 q 293 865 319 890 q 225 840 267 840 q 157 865 183 840 q 132 926 132 890 q 157 986 132 961 q 225 1012 183 1012 q 293 986 267 1012 q 319 926 319 961 m 462 926 q 489 987 462 962 q 556 1012 517 1012 q 623 987 596 1012 q 650 926 650 962 q 624 865 650 890 q 556 840 598 840 q 488 865 514 840 q 462 926 462 890 z '
    },
    ù: {
      ha: 777,
      x_min: 71,
      x_max: 705,
      o: 'm 515 75 q 314 -14 442 -14 q 134 54 196 -14 q 71 253 72 122 l 71 734 l 267 734 l 267 260 q 371 145 267 145 q 508 214 471 145 l 508 734 l 705 734 l 705 0 l 520 0 l 515 75 m 486 831 l 325 831 l 138 1042 l 351 1042 l 486 831 z '
    },
    ú: {
      ha: 777,
      x_min: 71,
      x_max: 705,
      o: 'm 515 75 q 314 -14 442 -14 q 134 54 196 -14 q 71 253 72 122 l 71 734 l 267 734 l 267 260 q 371 145 267 145 q 508 214 471 145 l 508 734 l 705 734 l 705 0 l 520 0 l 515 75 m 427 1042 l 641 1042 l 453 831 l 294 831 l 427 1042 z '
    },
    û: {
      ha: 777,
      x_min: 71,
      x_max: 705,
      o: 'm 515 75 q 314 -14 442 -14 q 134 54 196 -14 q 71 253 72 122 l 71 734 l 267 734 l 267 260 q 371 145 267 145 q 508 214 471 145 l 508 734 l 705 734 l 705 0 l 520 0 l 515 75 m 648 852 l 648 844 l 492 844 l 388 942 l 283 844 l 130 844 l 130 854 l 331 1042 l 445 1042 l 648 852 z '
    },
    ü: {
      ha: 777,
      x_min: 71,
      x_max: 705,
      o: 'm 515 75 q 314 -14 442 -14 q 134 54 196 -14 q 71 253 72 122 l 71 734 l 267 734 l 267 260 q 371 145 267 145 q 508 214 471 145 l 508 734 l 705 734 l 705 0 l 520 0 l 515 75 m 317 926 q 290 865 317 890 q 222 840 264 840 q 155 865 180 840 q 129 926 129 890 q 155 986 129 961 q 222 1012 180 1012 q 291 986 264 1012 q 317 926 317 961 m 459 926 q 487 987 459 962 q 553 1012 514 1012 q 620 987 593 1012 q 647 926 647 962 q 621 865 647 890 q 553 840 595 840 q 485 865 511 840 q 459 926 459 890 z '
    },
    ý: {
      ha: 697,
      x_min: 2,
      x_max: 695,
      o: 'm 349 277 l 485 734 l 695 734 l 400 -114 l 384 -153 q 167 -296 318 -296 q 80 -283 124 -296 l 80 -135 l 110 -136 q 193 -119 165 -136 q 236 -62 220 -102 l 259 -2 l 2 734 l 213 734 l 349 277 m 392 1042 l 606 1042 l 418 831 l 258 831 l 392 1042 z '
    },
    ÿ: {
      ha: 697,
      x_min: 2,
      x_max: 695,
      o: 'm 349 277 l 485 734 l 695 734 l 400 -114 l 384 -153 q 167 -296 318 -296 q 80 -283 124 -296 l 80 -135 l 110 -136 q 193 -119 165 -136 q 236 -62 220 -102 l 259 -2 l 2 734 l 213 734 l 349 277 m 281 926 q 255 865 281 890 q 187 840 229 840 q 119 865 145 840 q 94 926 94 890 q 119 986 94 961 q 187 1012 145 1012 q 255 986 229 1012 q 281 926 281 961 m 424 926 q 451 987 424 962 q 518 1012 479 1012 q 585 987 558 1012 q 612 926 612 962 q 586 865 612 890 q 518 840 560 840 q 450 865 476 840 q 424 926 424 890 z '
    },
    Ā: {
      ha: 935,
      x_min: 5,
      x_max: 930,
      o: 'm 646 203 l 289 203 l 221 0 l 5 0 l 372 987 l 561 987 l 930 0 l 714 0 l 646 203 m 344 368 l 591 368 l 467 738 l 344 368 m 705 1082 l 237 1082 l 237 1195 l 705 1195 l 705 1082 z '
    },
    ā: {
      ha: 745,
      x_min: 46,
      x_max: 699,
      o: 'm 500 0 q 481 66 487 26 q 296 -14 410 -14 q 117 49 188 -14 q 46 206 46 111 q 133 385 46 323 q 382 448 219 448 l 473 448 l 473 490 q 447 572 473 541 q 364 602 420 602 q 287 578 315 602 q 258 513 258 555 l 62 513 q 102 631 62 577 q 213 716 141 686 q 374 747 285 747 q 590 679 510 747 q 669 488 669 611 l 669 170 q 699 12 670 65 l 699 0 l 500 0 m 338 136 q 418 156 382 136 q 473 208 455 175 l 473 334 l 399 334 q 243 232 252 334 l 242 220 q 268 160 242 184 q 338 136 294 136 m 609 872 l 141 872 l 141 985 l 609 985 l 609 872 z '
    },
    Ă: {
      ha: 935,
      x_min: 5,
      x_max: 930,
      o: 'm 646 203 l 289 203 l 221 0 l 5 0 l 372 987 l 561 987 l 930 0 l 714 0 l 646 203 m 344 368 l 591 368 l 467 738 l 344 368 m 705 1245 q 640 1099 705 1155 q 470 1044 575 1044 q 300 1099 365 1044 q 235 1245 235 1154 l 374 1245 q 400 1179 374 1202 q 470 1156 425 1156 q 539 1179 514 1156 q 564 1245 564 1202 l 705 1245 z '
    },
    ă: {
      ha: 745,
      x_min: 46,
      x_max: 699,
      o: 'm 500 0 q 481 66 487 26 q 296 -14 410 -14 q 117 49 188 -14 q 46 206 46 111 q 133 385 46 323 q 382 448 219 448 l 473 448 l 473 490 q 447 572 473 541 q 364 602 420 602 q 287 578 315 602 q 258 513 258 555 l 62 513 q 102 631 62 577 q 213 716 141 686 q 374 747 285 747 q 590 679 510 747 q 669 488 669 611 l 669 170 q 699 12 670 65 l 699 0 l 500 0 m 338 136 q 418 156 382 136 q 473 208 455 175 l 473 334 l 399 334 q 243 232 252 334 l 242 220 q 268 160 242 184 q 338 136 294 136 m 609 1035 q 544 889 609 945 q 374 833 479 833 q 204 888 269 833 q 140 1035 140 943 l 279 1035 q 304 969 279 992 q 374 945 330 945 q 444 969 418 945 q 469 1035 469 992 l 609 1035 z '
    },
    Ą: {
      ha: 935,
      x_min: 5,
      x_max: 930,
      o: 'm 561 987 l 930 0 l 873 0 q 796 -56 823 -28 q 769 -119 769 -83 q 814 -163 769 -163 q 868 -150 836 -163 l 888 -256 q 776 -286 838 -286 q 665 -249 708 -286 q 622 -144 622 -211 q 711 7 622 -53 l 646 203 l 289 203 l 221 0 l 5 0 l 372 987 l 561 987 m 344 368 l 591 368 l 467 738 l 344 368 z '
    },
    ą: {
      ha: 745,
      x_min: 46,
      x_max: 699,
      o: 'm 498 3 q 481 66 487 31 q 296 -14 410 -14 q 117 49 188 -14 q 46 206 46 111 q 133 385 46 323 q 382 448 219 448 l 473 448 l 473 490 q 447 572 473 541 q 364 602 420 602 q 287 578 315 602 q 258 513 258 555 l 62 513 q 102 631 62 577 q 213 716 141 686 q 374 747 285 747 q 590 679 510 747 q 669 488 669 611 l 669 170 q 699 12 670 65 l 699 0 l 666 0 q 589 -56 616 -28 q 562 -119 562 -83 q 606 -163 562 -163 q 661 -150 629 -163 l 680 -256 q 568 -286 631 -286 q 457 -249 500 -286 q 414 -144 414 -211 q 498 3 414 -56 m 338 136 q 418 156 382 136 q 473 208 455 175 l 473 334 l 399 334 q 243 232 252 334 l 242 220 q 268 160 242 184 q 338 136 294 136 z '
    },
    Ć: {
      ha: 909,
      x_min: 58,
      x_max: 865,
      o: 'm 863 329 q 746 78 852 170 q 466 -14 640 -14 q 167 114 276 -14 q 58 465 58 242 l 58 526 q 109 777 58 668 q 252 943 159 885 q 469 1001 345 1001 q 744 909 640 1001 q 865 652 848 818 l 661 652 q 608 791 654 748 q 469 834 562 834 q 316 761 367 834 q 264 535 266 688 l 264 460 q 313 227 264 300 q 466 153 361 153 q 607 196 560 153 q 660 329 653 239 l 863 329 m 506 1257 l 720 1257 l 532 1047 l 372 1047 l 506 1257 z '
    },
    ć: {
      ha: 724,
      x_min: 45,
      x_max: 688,
      o: 'm 380 144 q 469 174 435 144 q 504 254 503 204 l 688 254 q 647 117 687 179 q 537 21 607 55 q 384 -14 468 -14 q 136 86 227 -14 q 45 363 45 186 l 45 376 q 135 646 45 545 q 382 747 225 747 q 603 669 520 747 q 688 460 686 591 l 504 460 q 469 553 503 517 q 379 589 435 589 q 276 539 311 589 q 241 377 241 489 l 241 357 q 275 194 241 243 q 380 144 310 144 m 401 1042 l 615 1042 l 427 831 l 268 831 l 401 1042 z '
    },
    Ĉ: {
      ha: 909,
      x_min: 58,
      x_max: 865,
      o: 'm 863 329 q 746 78 852 170 q 466 -14 640 -14 q 167 114 276 -14 q 58 465 58 242 l 58 526 q 109 777 58 668 q 252 943 159 885 q 469 1001 345 1001 q 744 909 640 1001 q 865 652 848 818 l 661 652 q 608 791 654 748 q 469 834 562 834 q 316 761 367 834 q 264 535 266 688 l 264 460 q 313 227 264 300 q 466 153 361 153 q 607 196 560 153 q 660 329 653 239 l 863 329 m 727 1067 l 727 1059 l 571 1059 l 467 1158 l 362 1059 l 209 1059 l 209 1070 l 410 1257 l 524 1257 l 727 1067 z '
    },
    ĉ: {
      ha: 724,
      x_min: 45,
      x_max: 688,
      o: 'm 380 144 q 469 174 435 144 q 504 254 503 204 l 688 254 q 647 117 687 179 q 537 21 607 55 q 384 -14 468 -14 q 136 86 227 -14 q 45 363 45 186 l 45 376 q 135 646 45 545 q 382 747 225 747 q 603 669 520 747 q 688 460 686 591 l 504 460 q 469 553 503 517 q 379 589 435 589 q 276 539 311 589 q 241 377 241 489 l 241 357 q 275 194 241 243 q 380 144 310 144 m 623 852 l 623 844 l 467 844 l 362 942 l 258 844 l 104 844 l 104 854 l 305 1042 l 419 1042 l 623 852 z '
    },
    Ċ: {
      ha: 909,
      x_min: 58,
      x_max: 865,
      o: 'm 863 329 q 746 78 852 170 q 466 -14 640 -14 q 167 114 276 -14 q 58 465 58 242 l 58 526 q 109 777 58 668 q 252 943 159 885 q 469 1001 345 1001 q 744 909 640 1001 q 865 652 848 818 l 661 652 q 608 791 654 748 q 469 834 562 834 q 316 761 367 834 q 264 535 266 688 l 264 460 q 313 227 264 300 q 466 153 361 153 q 607 196 560 153 q 660 329 653 239 l 863 329 m 466 1252 q 539 1226 513 1252 q 566 1159 566 1200 q 539 1093 566 1118 q 466 1067 513 1067 q 393 1093 420 1067 q 366 1159 366 1118 q 393 1226 366 1200 q 466 1252 420 1252 z '
    },
    ċ: {
      ha: 724,
      x_min: 45,
      x_max: 688,
      o: 'm 380 144 q 469 174 435 144 q 504 254 503 204 l 688 254 q 647 117 687 179 q 537 21 607 55 q 384 -14 468 -14 q 136 86 227 -14 q 45 363 45 186 l 45 376 q 135 646 45 545 q 382 747 225 747 q 603 669 520 747 q 688 460 686 591 l 504 460 q 469 553 503 517 q 379 589 435 589 q 276 539 311 589 q 241 377 241 489 l 241 357 q 275 194 241 243 q 380 144 310 144 m 361 1036 q 435 1010 408 1036 q 462 943 462 984 q 435 877 462 903 q 361 851 408 851 q 288 877 315 851 q 261 943 261 903 q 289 1010 261 984 q 361 1036 316 1036 z '
    },
    Č: {
      ha: 909,
      x_min: 58,
      x_max: 865,
      o: 'm 863 329 q 746 78 852 170 q 466 -14 640 -14 q 167 114 276 -14 q 58 465 58 242 l 58 526 q 109 777 58 668 q 252 943 159 885 q 469 1001 345 1001 q 744 909 640 1001 q 865 652 848 818 l 661 652 q 608 791 654 748 q 469 834 562 834 q 316 761 367 834 q 264 535 266 688 l 264 460 q 313 227 264 300 q 466 153 361 153 q 607 196 560 153 q 660 329 653 239 l 863 329 m 467 1161 l 566 1258 l 733 1258 l 733 1251 l 528 1060 l 404 1060 l 199 1252 l 199 1258 l 367 1258 l 467 1161 z '
    },
    č: {
      ha: 724,
      x_min: 45,
      x_max: 688,
      o: 'm 380 144 q 469 174 435 144 q 504 254 503 204 l 688 254 q 647 117 687 179 q 537 21 607 55 q 384 -14 468 -14 q 136 86 227 -14 q 45 363 45 186 l 45 376 q 135 646 45 545 q 382 747 225 747 q 603 669 520 747 q 688 460 686 591 l 504 460 q 469 553 503 517 q 379 589 435 589 q 276 539 311 589 q 241 377 241 489 l 241 357 q 275 194 241 243 q 380 144 310 144 m 362 945 l 461 1042 l 629 1042 l 629 1035 l 424 844 l 300 844 l 95 1036 l 95 1042 l 262 1042 l 362 945 z '
    },
    Ď: {
      ha: 903,
      x_min: 88,
      x_max: 843,
      o: 'm 88 0 l 88 987 l 392 987 q 625 929 522 987 q 785 762 728 870 q 843 516 843 654 l 843 471 q 786 226 843 333 q 627 60 730 119 q 394 0 524 1 l 88 0 m 292 823 l 292 163 l 390 163 q 572 241 509 163 q 637 465 635 319 l 637 517 q 574 745 637 667 q 392 823 512 823 l 292 823 m 357 1158 l 456 1255 l 624 1255 l 624 1247 l 419 1057 l 295 1057 l 90 1249 l 90 1255 l 258 1255 l 357 1158 z '
    },
    ď: {
      ha: 884,
      x_min: 45,
      x_max: 954,
      o: 'm 45 372 q 122 646 45 544 q 332 747 199 747 q 509 667 439 747 l 509 1042 l 706 1042 l 706 0 l 529 0 l 519 78 q 331 -14 446 -14 q 123 89 201 -14 q 45 372 45 191 m 241 358 q 277 200 241 255 q 381 145 313 145 q 509 222 472 145 l 509 511 q 382 588 473 588 q 241 358 241 588 m 856 755 l 759 808 q 810 972 808 886 l 810 1042 l 954 1042 l 954 994 q 926 864 954 931 q 856 755 898 797 z '
    },
    Ē: {
      ha: 781,
      x_min: 88,
      x_max: 750,
      o: 'm 682 428 l 292 428 l 292 163 l 750 163 l 750 0 l 88 0 l 88 987 l 749 987 l 749 823 l 292 823 l 292 587 l 682 587 l 682 428 m 666 1084 l 198 1084 l 198 1197 l 666 1197 l 666 1084 z '
    },
    ē: {
      ha: 751,
      x_min: 49,
      x_max: 715,
      o: 'm 413 -14 q 150 85 252 -14 q 49 349 49 184 l 49 368 q 92 566 49 479 q 213 700 134 653 q 391 747 291 747 q 628 652 542 747 q 715 383 715 557 l 715 303 l 248 303 q 305 188 257 231 q 426 144 353 144 q 603 227 539 144 l 699 119 q 580 21 655 56 q 413 -14 505 -14 m 391 589 q 296 549 332 589 q 250 437 260 510 l 522 437 l 522 452 q 487 553 521 517 q 391 589 453 589 m 604 872 l 136 872 l 136 985 l 604 985 l 604 872 z '
    },
    Ĕ: {
      ha: 781,
      x_min: 88,
      x_max: 750,
      o: 'm 682 428 l 292 428 l 292 163 l 750 163 l 750 0 l 88 0 l 88 987 l 749 987 l 749 823 l 292 823 l 292 587 l 682 587 l 682 428 m 666 1247 q 601 1101 666 1157 q 431 1046 536 1046 q 261 1101 326 1046 q 197 1247 197 1156 l 336 1247 q 361 1181 336 1204 q 431 1158 387 1158 q 500 1181 475 1158 q 526 1247 526 1204 l 666 1247 z '
    },
    ĕ: {
      ha: 751,
      x_min: 49,
      x_max: 715,
      o: 'm 413 -14 q 150 85 252 -14 q 49 349 49 184 l 49 368 q 92 566 49 479 q 213 700 134 653 q 391 747 291 747 q 628 652 542 747 q 715 383 715 557 l 715 303 l 248 303 q 305 188 257 231 q 426 144 353 144 q 603 227 539 144 l 699 119 q 580 21 655 56 q 413 -14 505 -14 m 391 589 q 296 549 332 589 q 250 437 260 510 l 522 437 l 522 452 q 487 553 521 517 q 391 589 453 589 m 604 1035 q 539 889 604 945 q 370 833 475 833 q 200 888 264 833 q 135 1035 135 943 l 274 1035 q 299 969 274 992 q 370 945 325 945 q 439 969 414 945 q 464 1035 464 992 l 604 1035 z '
    },
    Ė: {
      ha: 781,
      x_min: 88,
      x_max: 750,
      o: 'm 682 428 l 292 428 l 292 163 l 750 163 l 750 0 l 88 0 l 88 987 l 749 987 l 749 823 l 292 823 l 292 587 l 682 587 l 682 428 m 430 1249 q 504 1222 477 1249 q 530 1156 530 1196 q 504 1089 530 1115 q 430 1063 477 1063 q 357 1089 384 1063 q 330 1156 330 1115 q 357 1222 330 1196 q 430 1249 385 1249 z '
    },
    ė: {
      ha: 751,
      x_min: 49,
      x_max: 715,
      o: 'm 413 -14 q 150 85 252 -14 q 49 349 49 184 l 49 368 q 92 566 49 479 q 213 700 134 653 q 391 747 291 747 q 628 652 542 747 q 715 383 715 557 l 715 303 l 248 303 q 305 188 257 231 q 426 144 353 144 q 603 227 539 144 l 699 119 q 580 21 655 56 q 413 -14 505 -14 m 391 589 q 296 549 332 589 q 250 437 260 510 l 522 437 l 522 452 q 487 553 521 517 q 391 589 453 589 m 368 1036 q 442 1010 415 1036 q 469 943 469 984 q 442 877 469 903 q 368 851 415 851 q 295 877 322 851 q 268 943 268 903 q 295 1010 268 984 q 368 1036 323 1036 z '
    },
    Ę: {
      ha: 781,
      x_min: 88,
      x_max: 750,
      o: 'm 682 428 l 292 428 l 292 163 l 750 163 l 750 0 l 647 0 q 570 -56 597 -28 q 543 -119 543 -83 q 587 -163 543 -163 q 642 -150 610 -163 l 661 -256 q 549 -286 612 -286 q 438 -249 481 -286 q 395 -144 395 -211 q 474 0 395 -58 l 88 0 l 88 987 l 749 987 l 749 823 l 292 823 l 292 587 l 682 587 l 682 428 z '
    },
    ę: {
      ha: 751,
      x_min: 49,
      x_max: 715,
      o: 'm 699 119 q 579 21 657 57 l 580 21 q 503 -35 530 -7 q 475 -98 475 -62 q 520 -142 475 -142 q 574 -129 543 -142 l 594 -235 q 482 -265 545 -265 q 371 -228 414 -265 q 328 -123 328 -190 q 371 -12 328 -58 q 137 99 226 1 q 49 347 49 196 l 49 368 q 92 566 49 479 q 213 700 134 653 q 391 747 291 747 q 628 652 542 747 q 715 383 715 557 l 715 303 l 248 303 q 305 188 257 231 q 426 144 353 144 q 603 227 539 144 l 699 119 m 391 589 q 296 549 332 589 q 250 437 260 510 l 522 437 l 522 452 q 487 553 521 517 q 391 589 453 589 z '
    },
    Ě: {
      ha: 781,
      x_min: 88,
      x_max: 750,
      o: 'm 682 428 l 292 428 l 292 163 l 750 163 l 750 0 l 88 0 l 88 987 l 749 987 l 749 823 l 292 823 l 292 587 l 682 587 l 682 428 m 431 1158 l 530 1255 l 697 1255 l 697 1247 l 492 1057 l 368 1057 l 163 1249 l 163 1255 l 331 1255 l 431 1158 z '
    },
    ě: {
      ha: 751,
      x_min: 49,
      x_max: 715,
      o: 'm 413 -14 q 150 85 252 -14 q 49 349 49 184 l 49 368 q 92 566 49 479 q 213 700 134 653 q 391 747 291 747 q 628 652 542 747 q 715 383 715 557 l 715 303 l 248 303 q 305 188 257 231 q 426 144 353 144 q 603 227 539 144 l 699 119 q 580 21 655 56 q 413 -14 505 -14 m 391 589 q 296 549 332 589 q 250 437 260 510 l 522 437 l 522 452 q 487 553 521 517 q 391 589 453 589 m 369 945 l 468 1042 l 635 1042 l 635 1035 l 431 844 l 307 844 l 102 1036 l 102 1042 l 269 1042 l 369 945 z '
    },
    Ĝ: {
      ha: 946,
      x_min: 64,
      x_max: 869,
      o: 'm 869 125 q 714 23 814 59 q 492 -14 614 -14 q 267 42 363 -14 q 118 205 170 98 q 64 455 65 311 l 64 522 q 114 778 64 670 q 257 944 163 886 q 477 1001 351 1001 q 752 917 653 1001 q 869 673 851 833 l 671 673 q 611 798 658 758 q 484 837 565 837 q 326 759 380 837 q 271 527 271 681 l 271 464 q 330 229 271 309 q 503 150 389 150 q 666 199 617 150 l 666 369 l 481 369 l 481 519 l 869 519 l 869 125 m 732 1067 l 732 1059 l 576 1059 l 471 1158 l 367 1059 l 214 1059 l 214 1070 l 414 1257 l 528 1257 l 732 1067 z '
    },
    ĝ: {
      ha: 793,
      x_min: 47,
      x_max: 718,
      o: 'm 47 372 q 127 644 47 541 q 344 747 208 747 q 532 665 465 747 l 540 734 l 718 734 l 718 24 q 674 -143 718 -72 q 551 -252 630 -214 q 365 -289 471 -289 q 208 -257 284 -289 q 92 -174 131 -224 l 178 -54 q 356 -136 252 -136 q 477 -95 434 -136 q 521 24 521 -53 l 521 63 q 342 -14 453 -14 q 129 90 210 -14 q 47 364 47 193 l 47 372 m 243 358 q 283 202 243 258 q 393 145 323 145 q 521 212 482 145 l 521 521 q 394 588 481 588 q 283 530 323 588 q 243 358 243 473 m 636 852 l 636 844 l 480 844 l 376 942 l 271 844 l 118 844 l 118 854 l 319 1042 l 433 1042 l 636 852 z '
    },
    Ğ: {
      ha: 946,
      x_min: 64,
      x_max: 869,
      o: 'm 869 125 q 714 23 814 59 q 492 -14 614 -14 q 267 42 363 -14 q 118 205 170 98 q 64 455 65 311 l 64 522 q 114 778 64 670 q 257 944 163 886 q 477 1001 351 1001 q 752 917 653 1001 q 869 673 851 833 l 671 673 q 611 798 658 758 q 484 837 565 837 q 326 759 380 837 q 271 527 271 681 l 271 464 q 330 229 271 309 q 503 150 389 150 q 666 199 617 150 l 666 369 l 481 369 l 481 519 l 869 519 l 869 125 m 707 1251 q 642 1105 707 1160 q 472 1049 577 1049 q 302 1104 367 1049 q 237 1251 237 1159 l 376 1251 q 402 1184 376 1208 q 472 1161 427 1161 q 541 1184 516 1161 q 566 1251 566 1208 l 707 1251 z '
    },
    ğ: {
      ha: 793,
      x_min: 47,
      x_max: 718,
      o: 'm 47 372 q 127 644 47 541 q 344 747 208 747 q 532 665 465 747 l 540 734 l 718 734 l 718 24 q 674 -143 718 -72 q 551 -252 630 -214 q 365 -289 471 -289 q 208 -257 284 -289 q 92 -174 131 -224 l 178 -54 q 356 -136 252 -136 q 477 -95 434 -136 q 521 24 521 -53 l 521 63 q 342 -14 453 -14 q 129 90 210 -14 q 47 364 47 193 l 47 372 m 243 358 q 283 202 243 258 q 393 145 323 145 q 521 212 482 145 l 521 521 q 394 588 481 588 q 283 530 323 588 q 243 358 243 473 m 611 1035 q 546 889 611 945 q 376 833 481 833 q 207 888 271 833 q 142 1035 142 943 l 281 1035 q 306 969 281 992 q 376 945 332 945 q 446 969 420 945 q 471 1035 471 992 l 611 1035 z '
    },
    Ġ: {
      ha: 946,
      x_min: 64,
      x_max: 869,
      o: 'm 869 125 q 714 23 814 59 q 492 -14 614 -14 q 267 42 363 -14 q 118 205 170 98 q 64 455 65 311 l 64 522 q 114 778 64 670 q 257 944 163 886 q 477 1001 351 1001 q 752 917 653 1001 q 869 673 851 833 l 671 673 q 611 798 658 758 q 484 837 565 837 q 326 759 380 837 q 271 527 271 681 l 271 464 q 330 229 271 309 q 503 150 389 150 q 666 199 617 150 l 666 369 l 481 369 l 481 519 l 869 519 l 869 125 m 471 1252 q 544 1226 517 1252 q 571 1159 571 1200 q 544 1093 571 1118 q 471 1067 517 1067 q 397 1093 425 1067 q 370 1159 370 1118 q 398 1226 370 1200 q 471 1252 425 1252 z '
    },
    ġ: {
      ha: 793,
      x_min: 47,
      x_max: 718,
      o: 'm 47 372 q 127 644 47 541 q 344 747 208 747 q 532 665 465 747 l 540 734 l 718 734 l 718 24 q 674 -143 718 -72 q 551 -252 630 -214 q 365 -289 471 -289 q 208 -257 284 -289 q 92 -174 131 -224 l 178 -54 q 356 -136 252 -136 q 477 -95 434 -136 q 521 24 521 -53 l 521 63 q 342 -14 453 -14 q 129 90 210 -14 q 47 364 47 193 l 47 372 m 243 358 q 283 202 243 258 q 393 145 323 145 q 521 212 482 145 l 521 521 q 394 588 481 588 q 283 530 323 588 q 243 358 243 473 m 375 1036 q 449 1010 422 1036 q 475 943 475 984 q 449 877 475 903 q 375 851 422 851 q 302 877 329 851 q 275 943 275 903 q 302 1010 275 984 q 375 1036 330 1036 z '
    },
    Ģ: {
      ha: 946,
      x_min: 64,
      x_max: 869,
      o: 'm 869 125 q 714 23 814 59 q 492 -14 614 -14 q 267 42 363 -14 q 118 205 170 98 q 64 455 65 311 l 64 522 q 114 778 64 670 q 257 944 163 886 q 477 1001 351 1001 q 752 917 653 1001 q 869 673 851 833 l 671 673 q 611 798 658 758 q 484 837 565 837 q 326 759 380 837 q 271 527 271 681 l 271 464 q 330 229 271 309 q 503 150 389 150 q 666 199 617 150 l 666 369 l 481 369 l 481 519 l 869 519 l 869 125 m 468 -351 l 371 -298 q 422 -134 420 -220 l 422 -64 l 566 -64 l 566 -112 q 538 -242 566 -175 q 468 -351 510 -309 z '
    },
    ģ: {
      ha: 793,
      x_min: 47,
      x_max: 718,
      o: 'm 47 372 q 127 644 47 541 q 344 747 208 747 q 532 665 465 747 l 540 734 l 718 734 l 718 24 q 674 -143 718 -72 q 551 -252 630 -214 q 365 -289 471 -289 q 208 -257 284 -289 q 92 -174 131 -224 l 178 -54 q 356 -136 252 -136 q 477 -95 434 -136 q 521 24 521 -53 l 521 63 q 342 -14 453 -14 q 129 90 210 -14 q 47 364 47 193 l 47 372 m 243 358 q 283 202 243 258 q 393 145 323 145 q 521 212 482 145 l 521 521 q 394 588 481 588 q 283 530 323 588 q 243 358 243 473 m 394 1166 l 495 1114 q 450 945 451 1034 l 449 854 l 296 854 l 296 949 q 324 1077 297 1017 q 394 1166 351 1137 z '
    },
    Ĥ: {
      ha: 981,
      x_min: 88,
      x_max: 892,
      o: 'm 892 0 l 688 0 l 688 423 l 292 423 l 292 0 l 88 0 l 88 987 l 292 987 l 292 587 l 688 587 l 688 987 l 892 987 l 892 0 m 750 1064 l 750 1056 l 594 1056 l 490 1154 l 385 1056 l 232 1056 l 232 1067 l 433 1254 l 547 1254 l 750 1064 z '
    },
    ĥ: {
      ha: 777,
      x_min: 71,
      x_max: 705,
      o: 'm 267 654 q 463 747 345 747 q 705 470 701 747 l 705 0 l 509 0 l 509 465 q 481 558 509 528 q 391 588 454 588 q 267 522 305 588 l 267 0 l 71 0 l 71 1042 l 267 1042 l 267 654 m 616 1109 l 616 1101 l 460 1101 l 355 1200 l 251 1101 l 98 1101 l 98 1112 l 298 1299 l 412 1299 l 616 1109 z '
    },
    Ĩ: {
      ha: 405,
      x_min: -53,
      x_max: 458,
      o: 'm 304 0 l 101 0 l 101 987 l 304 987 l 304 0 m 458 1244 q 413 1116 458 1168 q 304 1064 368 1064 q 258 1070 278 1064 q 203 1095 238 1076 q 152 1118 168 1114 q 118 1122 136 1122 q 78 1105 94 1122 q 61 1057 61 1088 l -53 1064 q -8 1192 -53 1139 q 100 1245 36 1245 q 139 1240 121 1245 q 197 1215 157 1235 q 254 1192 238 1196 q 286 1187 269 1187 q 327 1204 310 1187 q 345 1252 345 1221 l 458 1244 z '
    },
    ĩ: {
      ha: 380,
      x_min: -65,
      x_max: 446,
      o: 'm 287 0 l 91 0 l 91 734 l 287 734 l 287 0 m 446 1022 q 401 893 446 945 q 292 842 356 842 q 246 847 266 842 q 191 872 226 853 q 140 896 155 891 q 106 900 124 900 q 65 883 82 900 q 49 835 49 866 l -65 842 q -21 970 -65 917 q 88 1023 24 1023 q 126 1018 109 1023 q 185 993 144 1013 q 241 969 226 973 q 274 965 257 965 q 315 982 298 965 q 332 1029 332 998 l 446 1022 z '
    },
    Ī: {
      ha: 405,
      x_min: -30,
      x_max: 438,
      o: 'm 304 0 l 101 0 l 101 987 l 304 987 l 304 0 m 438 1084 l -30 1084 l -30 1197 l 438 1197 l 438 1084 z '
    },
    ī: {
      ha: 380,
      x_min: -42,
      x_max: 426,
      o: 'm 287 0 l 91 0 l 91 734 l 287 734 l 287 0 m 426 861 l -42 861 l -42 975 l 426 975 l 426 861 z '
    },
    Ĭ: {
      ha: 405,
      x_min: -31,
      x_max: 438,
      o: 'm 304 0 l 101 0 l 101 987 l 304 987 l 304 0 m 438 1247 q 373 1101 438 1157 q 203 1046 309 1046 q 34 1101 98 1046 q -31 1247 -31 1156 l 108 1247 q 133 1181 108 1204 q 203 1158 159 1158 q 273 1181 248 1158 q 298 1247 298 1204 l 438 1247 z '
    },
    ĭ: {
      ha: 380,
      x_min: -43,
      x_max: 426,
      o: 'm 287 0 l 91 0 l 91 734 l 287 734 l 287 0 m 426 1025 q 361 879 426 935 q 191 823 296 823 q 21 878 86 823 q -43 1025 -43 933 l 96 1025 q 121 959 96 982 q 191 935 146 935 q 260 959 235 935 q 286 1025 286 982 l 426 1025 z '
    },
    Į: {
      ha: 405,
      x_min: 16,
      x_max: 304,
      o: 'm 304 0 l 101 0 l 101 987 l 304 987 l 304 0 m 267 1 q 190 -55 217 -27 q 163 -118 163 -82 q 208 -162 163 -162 q 262 -149 230 -162 l 281 -255 q 170 -285 232 -285 q 59 -247 102 -285 q 16 -143 16 -210 q 167 42 16 -26 l 267 1 z '
    },
    į: {
      ha: 368,
      x_min: 2,
      x_max: 294,
      o: 'm 282 0 l 85 0 l 85 734 l 282 734 l 282 0 m 74 924 q 103 996 74 968 q 184 1025 133 1025 q 264 996 234 1025 q 294 924 294 968 q 263 850 294 879 q 184 822 233 822 q 104 850 134 822 q 74 924 74 879 m 254 0 q 176 -56 203 -28 q 149 -119 149 -83 q 194 -163 149 -163 q 248 -150 216 -163 l 268 -256 q 156 -286 218 -286 q 45 -249 88 -286 q 2 -144 2 -211 q 153 41 2 -28 l 254 0 z '
    },
    İ: {
      ha: 405,
      x_min: 101,
      x_max: 304,
      o: 'm 304 0 l 101 0 l 101 987 l 304 987 l 304 0 m 201 1249 q 275 1222 248 1249 q 302 1156 302 1196 q 275 1089 302 1115 q 201 1063 248 1063 q 128 1089 155 1063 q 101 1156 101 1115 q 129 1222 101 1196 q 201 1249 156 1249 z '
    },
    Ĳ: {
      ha: 1181,
      x_min: 101,
      x_max: 1095,
      o: 'm 304 0 l 101 0 l 101 987 l 304 987 l 304 0 m 891 987 l 1095 987 l 1095 304 q 1053 137 1095 210 q 935 26 1011 65 q 764 -14 859 -14 q 519 66 607 -14 q 432 292 432 146 l 637 292 q 667 184 637 219 q 764 150 698 150 q 857 190 822 150 q 891 304 891 230 l 891 987 z '
    },
    ĳ: {
      ha: 729,
      x_min: 74,
      x_max: 659,
      o: 'm 282 0 l 85 0 l 85 734 l 282 734 l 282 0 m 74 924 q 103 996 74 968 q 184 1025 133 1025 q 264 996 234 1025 q 294 924 294 968 q 263 850 294 879 q 184 822 233 822 q 104 850 134 822 q 74 924 74 879 m 651 734 l 651 -40 q 587 -229 651 -161 q 401 -296 522 -296 q 304 -285 350 -296 l 304 -130 q 366 -136 339 -136 q 454 -41 454 -136 l 454 734 l 651 734 m 439 924 q 468 996 439 968 q 549 1025 498 1025 q 629 996 600 1025 q 659 924 659 968 q 628 850 659 879 q 549 822 598 822 q 469 850 499 822 q 439 924 439 879 z '
    },
    Ĵ: {
      ha: 776,
      x_min: 27,
      x_max: 840,
      o: 'm 486 987 l 690 987 l 690 304 q 648 137 690 210 q 530 26 606 65 q 359 -14 454 -14 q 115 66 202 -14 q 27 292 27 146 l 232 292 q 262 184 232 219 q 359 150 293 150 q 452 190 417 150 q 486 304 486 230 l 486 987 m 840 1062 l 840 1054 l 684 1054 l 579 1152 l 475 1054 l 321 1054 l 321 1065 l 522 1252 l 636 1252 l 840 1062 z '
    },
    ĵ: {
      ha: 391,
      x_min: -71,
      x_max: 447,
      o: 'm 298 734 l 298 -24 q 230 -225 297 -155 q 40 -296 162 -296 q -56 -285 -12 -296 l -47 -130 q 20 -138 -17 -138 q 102 -18 102 -138 l 102 734 l 298 734 m 447 834 l 447 826 l 291 826 l 186 924 l 82 826 l -71 826 l -71 837 l 130 1024 l 243 1024 l 447 834 z '
    },
    Ķ: {
      ha: 882,
      x_min: 88,
      x_max: 893,
      o: 'm 397 396 l 292 282 l 292 0 l 88 0 l 88 987 l 292 987 l 292 540 l 381 663 l 633 987 l 883 987 l 532 549 l 893 0 l 651 0 l 397 396 m 417 -308 l 320 -254 q 372 -90 370 -176 l 372 -20 l 515 -20 l 515 -68 q 487 -199 515 -132 q 417 -308 459 -266 z '
    },
    ķ: {
      ha: 742,
      x_min: 75,
      x_max: 755,
      o: 'm 342 294 l 271 224 l 271 0 l 75 0 l 75 1042 l 271 1042 l 271 465 l 309 513 l 497 734 l 732 734 l 467 428 l 755 0 l 530 0 l 342 294 m 357 -323 l 260 -269 q 311 -105 309 -191 l 311 -35 l 455 -35 l 455 -83 q 427 -214 455 -146 q 357 -323 399 -281 z '
    },
    Ĺ: {
      ha: 752,
      x_min: 88,
      x_max: 724,
      o: 'm 292 163 l 724 163 l 724 0 l 88 0 l 88 987 l 292 987 l 292 163 m 233 1252 l 447 1252 l 259 1042 l 100 1042 l 233 1252 z '
    },
    ĺ: {
      ha: 368,
      x_min: 85,
      x_max: 437,
      o: 'm 282 0 l 85 0 l 85 1042 l 282 1042 l 282 0 m 223 1308 l 437 1308 l 249 1097 l 90 1097 l 223 1308 z '
    },
    Ļ: {
      ha: 752,
      x_min: 88,
      x_max: 724,
      o: 'm 292 163 l 724 163 l 724 0 l 88 0 l 88 987 l 292 987 l 292 163 m 382 -343 l 286 -290 q 337 -125 335 -212 l 337 -56 l 481 -56 l 481 -104 q 453 -234 481 -167 q 382 -343 425 -301 z '
    },
    ļ: {
      ha: 368,
      x_min: 62,
      x_max: 282,
      o: 'm 282 0 l 85 0 l 85 1042 l 282 1042 l 282 0 m 159 -343 l 62 -290 q 113 -125 111 -212 l 113 -56 l 257 -56 l 257 -104 q 229 -234 257 -167 q 159 -343 201 -301 z '
    },
    Ľ: {
      ha: 752,
      x_min: 88,
      x_max: 724,
      o: 'm 292 163 l 724 163 l 724 0 l 88 0 l 88 987 l 292 987 l 292 163 m 517 700 l 420 753 q 472 918 470 831 l 472 987 l 616 987 l 616 939 q 588 809 616 876 q 517 700 559 742 z '
    },
    ľ: {
      ha: 470,
      x_min: 85,
      x_max: 531,
      o: 'm 282 0 l 85 0 l 85 1042 l 282 1042 l 282 0 m 433 755 l 336 808 q 387 972 385 886 l 387 1042 l 531 1042 l 531 994 q 503 864 531 931 q 433 755 475 797 z '
    },
    Ŀ: {
      ha: 752,
      x_min: 88,
      x_max: 724,
      o: 'm 292 163 l 724 163 l 724 0 l 88 0 l 88 987 l 292 987 l 292 163 m 502 655 q 575 629 549 655 q 602 562 602 603 q 575 496 602 522 q 502 470 549 470 q 429 496 456 470 q 401 562 401 522 q 429 629 401 603 q 502 655 456 655 z '
    },
    ŀ: {
      ha: 517,
      x_min: 85,
      x_max: 549,
      o: 'm 282 0 l 85 0 l 85 1042 l 282 1042 l 282 0 m 448 617 q 522 591 495 617 q 549 524 549 565 q 522 458 549 484 q 448 432 495 432 q 375 458 402 432 q 348 524 348 484 q 375 591 348 565 q 448 617 403 617 z '
    },
    Ń: {
      ha: 981,
      x_min: 88,
      x_max: 891,
      o: 'm 891 0 l 688 0 l 292 650 l 292 0 l 88 0 l 88 987 l 292 987 l 688 336 l 688 987 l 891 987 l 891 0 m 532 1252 l 745 1252 l 557 1042 l 398 1042 l 532 1252 z '
    },
    ń: {
      ha: 778,
      x_min: 71,
      x_max: 705,
      o: 'm 256 734 l 262 649 q 473 747 340 747 q 646 679 589 747 q 705 474 703 610 l 705 0 l 509 0 l 509 469 q 481 560 509 532 q 391 588 454 588 q 267 517 309 588 l 267 0 l 71 0 l 71 734 l 256 734 m 429 1042 l 643 1042 l 455 831 l 296 831 l 429 1042 z '
    },
    Ņ: {
      ha: 981,
      x_min: 88,
      x_max: 891,
      o: 'm 891 0 l 688 0 l 292 650 l 292 0 l 88 0 l 88 987 l 292 987 l 688 336 l 688 987 l 891 987 l 891 0 m 466 -349 l 369 -295 q 420 -131 418 -217 l 420 -61 l 564 -61 l 564 -109 q 536 -239 564 -172 q 466 -349 508 -307 z '
    },
    ņ: {
      ha: 778,
      x_min: 71,
      x_max: 705,
      o: 'm 256 734 l 262 649 q 473 747 340 747 q 646 679 589 747 q 705 474 703 610 l 705 0 l 509 0 l 509 469 q 481 560 509 532 q 391 588 454 588 q 267 517 309 588 l 267 0 l 71 0 l 71 734 l 256 734 m 363 -343 l 266 -290 q 317 -125 315 -212 l 317 -56 l 461 -56 l 461 -104 q 433 -234 461 -167 q 363 -343 405 -301 z '
    },
    Ň: {
      ha: 981,
      x_min: 88,
      x_max: 891,
      o: 'm 891 0 l 688 0 l 292 650 l 292 0 l 88 0 l 88 987 l 292 987 l 688 336 l 688 987 l 891 987 l 891 0 m 492 1156 l 591 1253 l 759 1253 l 759 1245 l 554 1055 l 430 1055 l 225 1246 l 225 1253 l 393 1253 l 492 1156 z '
    },
    ň: {
      ha: 778,
      x_min: 71,
      x_max: 705,
      o: 'm 256 734 l 262 649 q 473 747 340 747 q 646 679 589 747 q 705 474 703 610 l 705 0 l 509 0 l 509 469 q 481 560 509 532 q 391 588 454 588 q 267 517 309 588 l 267 0 l 71 0 l 71 734 l 256 734 m 390 945 l 489 1042 l 656 1042 l 656 1035 l 452 844 l 328 844 l 123 1036 l 123 1042 l 290 1042 l 390 945 z '
    },
    ŉ: {
      ha: 778,
      x_min: -75,
      x_max: 705,
      o: 'm 256 734 l 262 649 q 473 747 340 747 q 646 679 589 747 q 705 474 703 610 l 705 0 l 509 0 l 509 469 q 481 560 509 532 q 391 588 454 588 q 267 517 309 588 l 267 0 l 71 0 l 71 734 l 256 734 m 22 754 l -75 808 q -23 972 -25 886 l -23 1042 l 121 1042 l 121 994 q 93 863 121 930 q 22 754 64 796 z '
    },
    Ō: {
      ha: 959,
      x_min: 58,
      x_max: 899,
      o: 'm 899 471 q 848 216 899 326 q 700 46 796 106 q 480 -14 604 -14 q 261 45 357 -14 q 112 214 165 104 q 58 466 59 323 l 58 515 q 111 771 58 661 q 259 942 163 882 q 479 1001 355 1001 q 698 942 602 1001 q 847 771 794 882 q 899 515 899 661 l 899 471 m 693 516 q 637 752 693 671 q 479 833 582 833 q 321 753 376 833 q 264 519 265 673 l 264 471 q 320 237 264 320 q 480 153 376 153 q 637 234 583 153 q 693 468 692 314 l 693 516 m 714 1082 l 246 1082 l 246 1195 l 714 1195 l 714 1082 z '
    },
    ō: {
      ha: 785,
      x_min: 45,
      x_max: 740,
      o: 'm 45 374 q 87 568 45 483 q 208 701 129 654 q 391 747 287 747 q 634 656 540 747 q 739 410 728 566 l 740 359 q 646 89 740 191 q 393 -14 551 -14 q 139 88 234 -14 q 45 365 45 190 l 45 374 m 241 359 q 280 200 241 255 q 393 144 319 144 q 504 199 464 144 q 544 374 544 254 q 504 532 544 476 q 391 589 464 589 q 280 533 319 589 q 241 359 241 477 m 626 872 l 158 872 l 158 985 l 626 985 l 626 872 z '
    },
    Ŏ: {
      ha: 959,
      x_min: 58,
      x_max: 899,
      o: 'm 899 471 q 848 216 899 326 q 700 46 796 106 q 480 -14 604 -14 q 261 45 357 -14 q 112 214 165 104 q 58 466 59 323 l 58 515 q 111 771 58 661 q 259 942 163 882 q 479 1001 355 1001 q 698 942 602 1001 q 847 771 794 882 q 899 515 899 661 l 899 471 m 693 516 q 637 752 693 671 q 479 833 582 833 q 321 753 376 833 q 264 519 265 673 l 264 471 q 320 237 264 320 q 480 153 376 153 q 637 234 583 153 q 693 468 692 314 l 693 516 m 714 1245 q 649 1099 714 1155 q 479 1044 585 1044 q 310 1099 374 1044 q 245 1245 245 1154 l 384 1245 q 409 1179 384 1202 q 479 1156 435 1156 q 549 1179 524 1156 q 574 1245 574 1202 l 714 1245 z '
    },
    ŏ: {
      ha: 785,
      x_min: 45,
      x_max: 740,
      o: 'm 45 374 q 87 568 45 483 q 208 701 129 654 q 391 747 287 747 q 634 656 540 747 q 739 410 728 566 l 740 359 q 646 89 740 191 q 393 -14 551 -14 q 139 88 234 -14 q 45 365 45 190 l 45 374 m 241 359 q 280 200 241 255 q 393 144 319 144 q 504 199 464 144 q 544 374 544 254 q 504 532 544 476 q 391 589 464 589 q 280 533 319 589 q 241 359 241 477 m 626 1035 q 561 889 626 945 q 391 833 496 833 q 221 888 286 833 q 157 1035 157 943 l 296 1035 q 321 969 296 992 q 391 945 347 945 q 460 969 435 945 q 486 1035 486 992 l 626 1035 z '
    },
    Ő: {
      ha: 959,
      x_min: 58,
      x_max: 899,
      o: 'm 899 471 q 848 216 899 326 q 700 46 796 106 q 480 -14 604 -14 q 261 45 357 -14 q 112 214 165 104 q 58 466 59 323 l 58 515 q 111 771 58 661 q 259 942 163 882 q 479 1001 355 1001 q 698 942 602 1001 q 847 771 794 882 q 899 515 899 661 l 899 471 m 693 516 q 637 752 693 671 q 479 833 582 833 q 321 753 376 833 q 264 519 265 673 l 264 471 q 320 237 264 320 q 480 153 376 153 q 637 234 583 153 q 693 468 692 314 l 693 516 m 663 1251 l 839 1251 l 659 1047 l 511 1047 l 663 1251 m 398 1251 l 571 1251 l 416 1047 l 272 1047 l 398 1251 z '
    },
    ő: {
      ha: 785,
      x_min: 45,
      x_max: 751,
      o: 'm 45 374 q 87 568 45 483 q 208 701 129 654 q 391 747 287 747 q 634 656 540 747 q 739 410 728 566 l 740 359 q 646 89 740 191 q 393 -14 551 -14 q 139 88 234 -14 q 45 365 45 190 l 45 374 m 241 359 q 280 200 241 255 q 393 144 319 144 q 504 199 464 144 q 544 374 544 254 q 504 532 544 476 q 391 589 464 589 q 280 533 319 589 q 241 359 241 477 m 575 1041 l 751 1041 l 570 837 l 422 837 l 575 1041 m 310 1041 l 483 1041 l 328 837 l 184 837 l 310 1041 z '
    },
    Ŕ: {
      ha: 886,
      x_min: 88,
      x_max: 857,
      o: 'm 454 361 l 292 361 l 292 0 l 88 0 l 88 987 l 455 987 q 725 909 630 987 q 820 689 820 831 q 776 520 820 588 q 644 413 732 453 l 857 9 l 857 0 l 639 0 l 454 361 m 292 526 l 456 526 q 574 565 532 526 q 616 673 616 604 q 577 783 616 743 q 455 823 537 823 l 292 823 l 292 526 m 445 1252 l 659 1252 l 471 1042 l 311 1042 l 445 1252 z '
    },
    ŕ: {
      ha: 507,
      x_min: 75,
      x_max: 531,
      o: 'm 488 550 q 417 555 448 555 q 271 480 306 555 l 271 0 l 75 0 l 75 734 l 260 734 l 266 646 q 429 747 325 747 q 490 739 462 747 l 488 550 m 317 1042 l 531 1042 l 343 831 l 184 831 l 317 1042 z '
    },
    Ŗ: {
      ha: 886,
      x_min: 88,
      x_max: 857,
      o: 'm 454 361 l 292 361 l 292 0 l 88 0 l 88 987 l 455 987 q 725 909 630 987 q 820 689 820 831 q 776 520 820 588 q 644 413 732 453 l 857 9 l 857 0 l 639 0 l 454 361 m 292 526 l 456 526 q 574 565 532 526 q 616 673 616 604 q 577 783 616 743 q 455 823 537 823 l 292 823 l 292 526 m 390 -343 l 293 -290 q 345 -125 342 -212 l 345 -56 l 488 -56 l 488 -104 q 460 -234 488 -167 q 390 -343 432 -301 z '
    },
    ŗ: {
      ha: 507,
      x_min: 54,
      x_max: 490,
      o: 'm 488 550 q 417 555 448 555 q 271 480 306 555 l 271 0 l 75 0 l 75 734 l 260 734 l 266 646 q 429 747 325 747 q 490 739 462 747 l 488 550 m 151 -343 l 54 -290 q 106 -125 104 -212 l 106 -56 l 250 -56 l 250 -104 q 221 -234 250 -167 q 151 -343 193 -301 z '
    },
    Ř: {
      ha: 886,
      x_min: 88,
      x_max: 857,
      o: 'm 454 361 l 292 361 l 292 0 l 88 0 l 88 987 l 455 987 q 725 909 630 987 q 820 689 820 831 q 776 520 820 588 q 644 413 732 453 l 857 9 l 857 0 l 639 0 l 454 361 m 292 526 l 456 526 q 574 565 532 526 q 616 673 616 604 q 577 783 616 743 q 455 823 537 823 l 292 823 l 292 526 m 406 1156 l 505 1253 l 672 1253 l 672 1245 l 467 1055 l 343 1055 l 138 1246 l 138 1253 l 306 1253 l 406 1156 z '
    },
    ř: {
      ha: 507,
      x_min: 12,
      x_max: 545,
      o: 'm 488 550 q 417 555 448 555 q 271 480 306 555 l 271 0 l 75 0 l 75 734 l 260 734 l 266 646 q 429 747 325 747 q 490 739 462 747 l 488 550 m 279 945 l 378 1042 l 545 1042 l 545 1035 l 340 844 l 216 844 l 12 1036 l 12 1042 l 179 1042 l 279 945 z '
    },
    Ś: {
      ha: 854,
      x_min: 47,
      x_max: 804,
      o: 'm 600 259 q 559 348 600 317 q 413 413 519 378 q 245 480 307 447 q 77 725 77 571 q 122 868 77 805 q 252 966 168 930 q 441 1001 336 1001 q 630 963 547 1001 q 759 854 713 924 q 804 696 804 785 l 601 696 q 558 801 601 764 q 438 839 515 839 q 322 807 363 839 q 281 724 281 776 q 329 644 281 676 q 472 583 378 611 q 725 453 646 530 q 804 260 804 376 q 707 59 804 132 q 446 -14 610 -14 q 239 28 332 -14 q 96 142 145 70 q 47 311 47 215 l 251 311 q 446 147 251 147 q 559 177 519 147 q 600 259 600 206 m 479 1252 l 692 1252 l 505 1042 l 345 1042 l 479 1252 z '
    },
    ś: {
      ha: 714,
      x_min: 38,
      x_max: 663,
      o: 'm 473 203 q 437 259 473 239 q 323 296 401 280 q 61 519 61 351 q 142 682 61 616 q 354 747 223 747 q 577 682 494 747 q 661 511 661 616 l 465 511 q 438 580 465 553 q 353 608 411 608 q 277 585 304 608 q 250 528 250 563 q 280 476 250 496 q 385 441 311 456 q 508 408 458 427 q 663 211 663 351 q 577 48 663 111 q 355 -14 491 -14 q 191 19 262 -14 q 79 110 119 52 q 38 233 38 167 l 224 233 q 262 153 227 181 q 359 125 298 125 q 444 147 415 125 q 473 203 473 168 m 398 1042 l 612 1042 l 424 831 l 264 831 l 398 1042 z '
    },
    Ŝ: {
      ha: 854,
      x_min: 47,
      x_max: 804,
      o: 'm 600 259 q 559 348 600 317 q 413 413 519 378 q 245 480 307 447 q 77 725 77 571 q 122 868 77 805 q 252 966 168 930 q 441 1001 336 1001 q 630 963 547 1001 q 759 854 713 924 q 804 696 804 785 l 601 696 q 558 801 601 764 q 438 839 515 839 q 322 807 363 839 q 281 724 281 776 q 329 644 281 676 q 472 583 378 611 q 725 453 646 530 q 804 260 804 376 q 707 59 804 132 q 446 -14 610 -14 q 239 28 332 -14 q 96 142 145 70 q 47 311 47 215 l 251 311 q 446 147 251 147 q 559 177 519 147 q 600 259 600 206 m 700 1062 l 700 1054 l 544 1054 l 439 1152 l 335 1054 l 182 1054 l 182 1065 l 382 1252 l 496 1252 l 700 1062 z '
    },
    ŝ: {
      ha: 714,
      x_min: 38,
      x_max: 663,
      o: 'm 473 203 q 437 259 473 239 q 323 296 401 280 q 61 519 61 351 q 142 682 61 616 q 354 747 223 747 q 577 682 494 747 q 661 511 661 616 l 465 511 q 438 580 465 553 q 353 608 411 608 q 277 585 304 608 q 250 528 250 563 q 280 476 250 496 q 385 441 311 456 q 508 408 458 427 q 663 211 663 351 q 577 48 663 111 q 355 -14 491 -14 q 191 19 262 -14 q 79 110 119 52 q 38 233 38 167 l 224 233 q 262 153 227 181 q 359 125 298 125 q 444 147 415 125 q 473 203 473 168 m 619 852 l 619 844 l 463 844 l 359 942 l 254 844 l 101 844 l 101 854 l 302 1042 l 416 1042 l 619 852 z '
    },
    Ş: {
      ha: 854,
      x_min: 47,
      x_max: 804,
      o: 'm 600 259 q 559 348 600 317 q 413 413 519 378 q 245 480 307 447 q 77 725 77 571 q 122 868 77 805 q 252 966 168 930 q 441 1001 336 1001 q 630 963 547 1001 q 759 854 713 924 q 804 696 804 785 l 601 696 q 558 801 601 764 q 438 839 515 839 q 322 807 363 839 q 281 724 281 776 q 329 644 281 676 q 472 583 378 611 q 725 453 646 530 q 804 260 804 376 q 707 59 804 132 q 446 -14 610 -14 q 239 28 332 -14 q 96 142 145 70 q 47 311 47 215 l 251 311 q 446 147 251 147 q 559 177 519 147 q 600 259 600 206 m 516 5 l 509 -35 q 610 -152 610 -53 q 548 -270 610 -227 q 374 -313 486 -313 l 369 -200 q 445 -145 445 -200 q 422 -106 445 -117 q 349 -92 399 -96 l 370 5 l 516 5 z '
    },
    ş: {
      ha: 714,
      x_min: 38,
      x_max: 663,
      o: 'm 473 203 q 437 259 473 239 q 323 296 401 280 q 61 519 61 351 q 142 682 61 616 q 354 747 223 747 q 577 682 494 747 q 661 511 661 616 l 465 511 q 438 580 465 553 q 353 608 411 608 q 277 585 304 608 q 250 528 250 563 q 280 476 250 496 q 385 441 311 456 q 508 408 458 427 q 663 211 663 351 q 577 48 663 111 q 355 -14 491 -14 q 191 19 262 -14 q 79 110 119 52 q 38 233 38 167 l 224 233 q 262 153 227 181 q 359 125 298 125 q 444 147 415 125 q 473 203 473 168 m 435 -1 l 427 -41 q 529 -158 529 -59 q 467 -276 529 -233 q 292 -319 405 -319 l 288 -206 q 363 -151 363 -206 q 341 -112 363 -123 q 267 -98 318 -102 l 288 -1 l 435 -1 z '
    },
    Ș: {
      ha: 854,
      x_min: 47,
      x_max: 804,
      o: 'm 600 259 q 559 348 600 317 q 413 413 519 378 q 245 480 307 447 q 77 725 77 571 q 122 868 77 805 q 252 966 168 930 q 441 1001 336 1001 q 630 963 547 1001 q 759 854 713 924 q 804 696 804 785 l 601 696 q 558 801 601 764 q 438 839 515 839 q 322 807 363 839 q 281 724 281 776 q 329 644 281 676 q 472 583 378 611 q 725 453 646 530 q 804 260 804 376 q 707 59 804 132 q 446 -14 610 -14 q 239 28 332 -14 q 96 142 145 70 q 47 311 47 215 l 251 311 q 446 147 251 147 q 559 177 519 147 q 600 259 600 206 m 415 -350 l 318 -296 q 370 -132 368 -218 l 370 -62 l 513 -62 l 513 -111 q 485 -241 513 -174 q 415 -350 457 -308 z '
    },
    ș: {
      ha: 714,
      x_min: 38,
      x_max: 663,
      o: 'm 473 203 q 437 259 473 239 q 323 296 401 280 q 61 519 61 351 q 142 682 61 616 q 354 747 223 747 q 577 682 494 747 q 661 511 661 616 l 465 511 q 438 580 465 553 q 353 608 411 608 q 277 585 304 608 q 250 528 250 563 q 280 476 250 496 q 385 441 311 456 q 508 408 458 427 q 663 211 663 351 q 577 48 663 111 q 355 -14 491 -14 q 191 19 262 -14 q 79 110 119 52 q 38 233 38 167 l 224 233 q 262 153 227 181 q 359 125 298 125 q 444 147 415 125 q 473 203 473 168 m 334 -357 l 237 -303 q 288 -139 286 -225 l 288 -69 l 432 -69 l 432 -117 q 404 -248 432 -180 q 334 -357 376 -315 z '
    },
    Š: {
      ha: 854,
      x_min: 47,
      x_max: 804,
      o: 'm 600 259 q 559 348 600 317 q 413 413 519 378 q 245 480 307 447 q 77 725 77 571 q 122 868 77 805 q 252 966 168 930 q 441 1001 336 1001 q 630 963 547 1001 q 759 854 713 924 q 804 696 804 785 l 601 696 q 558 801 601 764 q 438 839 515 839 q 322 807 363 839 q 281 724 281 776 q 329 644 281 676 q 472 583 378 611 q 725 453 646 530 q 804 260 804 376 q 707 59 804 132 q 446 -14 610 -14 q 239 28 332 -14 q 96 142 145 70 q 47 311 47 215 l 251 311 q 446 147 251 147 q 559 177 519 147 q 600 259 600 206 m 439 1156 l 538 1253 l 706 1253 l 706 1245 l 501 1055 l 377 1055 l 172 1246 l 172 1253 l 340 1253 l 439 1156 z '
    },
    š: {
      ha: 714,
      x_min: 38,
      x_max: 663,
      o: 'm 473 203 q 437 259 473 239 q 323 296 401 280 q 61 519 61 351 q 142 682 61 616 q 354 747 223 747 q 577 682 494 747 q 661 511 661 616 l 465 511 q 438 580 465 553 q 353 608 411 608 q 277 585 304 608 q 250 528 250 563 q 280 476 250 496 q 385 441 311 456 q 508 408 458 427 q 663 211 663 351 q 577 48 663 111 q 355 -14 491 -14 q 191 19 262 -14 q 79 110 119 52 q 38 233 38 167 l 224 233 q 262 153 227 181 q 359 125 298 125 q 444 147 415 125 q 473 203 473 168 m 359 945 l 458 1042 l 625 1042 l 625 1035 l 420 844 l 296 844 l 92 1036 l 92 1042 l 259 1042 l 359 945 z '
    },
    Ț: {
      ha: 859,
      x_min: 27,
      x_max: 831,
      o: 'm 831 823 l 529 823 l 529 0 l 326 0 l 326 823 l 27 823 l 27 987 l 831 987 l 831 823 m 401 -345 l 304 -292 q 355 -127 353 -214 l 355 -58 l 499 -58 l 499 -106 q 471 -236 499 -169 q 401 -345 443 -303 z '
    },
    ț: {
      ha: 469,
      x_min: 7,
      x_max: 443,
      o: 'm 310 914 l 310 734 l 435 734 l 435 590 l 310 590 l 310 224 q 326 165 310 183 q 385 148 341 148 q 443 153 418 148 l 443 4 q 324 -14 385 -14 q 114 195 118 -14 l 114 590 l 7 590 l 7 734 l 114 734 l 114 914 l 310 914 m 269 -350 l 172 -296 q 223 -132 221 -218 l 223 -62 l 367 -62 l 367 -111 q 339 -241 367 -174 q 269 -350 311 -308 z '
    },
    Ţ: {
      ha: 859,
      x_min: 27,
      x_max: 831,
      o: 'm 831 823 l 529 823 l 529 0 l 326 0 l 326 823 l 27 823 l 27 987 l 831 987 l 831 823 m 502 9 l 494 -30 q 596 -147 596 -48 q 534 -265 596 -222 q 359 -309 472 -309 l 355 -195 q 431 -140 431 -195 q 408 -101 431 -112 q 334 -87 385 -91 l 355 9 l 502 9 z '
    },
    ţ: {
      ha: 469,
      x_min: 7,
      x_max: 464,
      o: 'm 310 914 l 310 734 l 435 734 l 435 590 l 310 590 l 310 224 q 326 165 310 183 q 385 148 341 148 q 443 153 418 148 l 443 4 q 324 -14 385 -14 q 114 195 118 -14 l 114 590 l 7 590 l 7 734 l 114 734 l 114 914 l 310 914 m 370 5 l 362 -35 q 464 -152 464 -53 q 402 -270 464 -227 q 227 -313 340 -313 l 222 -200 q 298 -145 298 -200 q 276 -106 298 -117 q 202 -92 253 -96 l 223 5 l 370 5 z '
    },
    Ť: {
      ha: 859,
      x_min: 27,
      x_max: 831,
      o: 'm 831 823 l 529 823 l 529 0 l 326 0 l 326 823 l 27 823 l 27 987 l 831 987 l 831 823 m 426 1156 l 525 1253 l 692 1253 l 692 1245 l 488 1055 l 363 1055 l 159 1246 l 159 1253 l 326 1253 l 426 1156 z '
    },
    ť: {
      ha: 496,
      x_min: 7,
      x_max: 576,
      o: 'm 310 914 l 310 734 l 435 734 l 435 590 l 310 590 l 310 224 q 326 165 310 183 q 385 148 341 148 q 443 153 418 148 l 443 4 q 324 -14 385 -14 q 114 195 118 -14 l 114 590 l 7 590 l 7 734 l 114 734 l 114 914 l 310 914 m 477 843 l 380 897 q 432 1061 430 975 l 432 1131 l 576 1131 l 576 1082 q 548 952 576 1019 q 477 843 519 885 z '
    },
    Ũ: {
      ha: 914,
      x_min: 79,
      x_max: 836,
      o: 'm 836 987 l 836 337 q 734 81 836 175 q 457 -14 633 -14 q 182 78 284 -14 q 79 330 81 170 l 79 987 l 282 987 l 282 336 q 329 194 282 239 q 457 150 375 150 q 631 330 629 150 l 631 987 l 836 987 m 709 1242 q 665 1114 709 1166 q 555 1062 620 1062 q 510 1068 530 1062 q 454 1093 490 1074 q 404 1116 419 1112 q 370 1120 388 1120 q 329 1103 346 1120 q 313 1055 313 1086 l 199 1062 q 243 1190 199 1137 q 352 1243 288 1243 q 390 1238 372 1243 q 449 1213 408 1233 q 505 1190 490 1194 q 538 1185 521 1185 q 579 1202 562 1185 q 596 1250 596 1219 l 709 1242 z '
    },
    ũ: {
      ha: 777,
      x_min: 71,
      x_max: 705,
      o: 'm 515 75 q 314 -14 442 -14 q 134 54 196 -14 q 71 253 72 122 l 71 734 l 267 734 l 267 260 q 371 145 267 145 q 508 214 471 145 l 508 734 l 705 734 l 705 0 l 520 0 l 515 75 m 643 1033 q 598 904 643 956 q 489 852 553 852 q 443 858 463 852 q 388 883 423 864 q 337 906 353 902 q 303 911 321 911 q 263 894 279 911 q 246 846 246 877 l 132 852 q 177 981 132 928 q 286 1034 221 1034 q 324 1028 306 1034 q 382 1004 342 1023 q 439 980 423 984 q 471 976 454 976 q 512 992 495 976 q 530 1040 530 1009 l 643 1033 z '
    },
    Ū: {
      ha: 914,
      x_min: 79,
      x_max: 836,
      o: 'm 836 987 l 836 337 q 734 81 836 175 q 457 -14 633 -14 q 182 78 284 -14 q 79 330 81 170 l 79 987 l 282 987 l 282 336 q 329 194 282 239 q 457 150 375 150 q 631 330 629 150 l 631 987 l 836 987 m 690 1082 l 222 1082 l 222 1195 l 690 1195 l 690 1082 z '
    },
    ū: {
      ha: 777,
      x_min: 71,
      x_max: 705,
      o: 'm 515 75 q 314 -14 442 -14 q 134 54 196 -14 q 71 253 72 122 l 71 734 l 267 734 l 267 260 q 371 145 267 145 q 508 214 471 145 l 508 734 l 705 734 l 705 0 l 520 0 l 515 75 m 623 872 l 155 872 l 155 985 l 623 985 l 623 872 z '
    },
    Ŭ: {
      ha: 914,
      x_min: 79,
      x_max: 836,
      o: 'm 836 987 l 836 337 q 734 81 836 175 q 457 -14 633 -14 q 182 78 284 -14 q 79 330 81 170 l 79 987 l 282 987 l 282 336 q 329 194 282 239 q 457 150 375 150 q 631 330 629 150 l 631 987 l 836 987 m 690 1245 q 625 1099 690 1155 q 455 1044 560 1044 q 285 1099 350 1044 q 220 1245 220 1154 l 359 1245 q 385 1179 359 1202 q 455 1156 410 1156 q 524 1179 499 1156 q 549 1245 549 1202 l 690 1245 z '
    },
    ŭ: {
      ha: 777,
      x_min: 71,
      x_max: 705,
      o: 'm 515 75 q 314 -14 442 -14 q 134 54 196 -14 q 71 253 72 122 l 71 734 l 267 734 l 267 260 q 371 145 267 145 q 508 214 471 145 l 508 734 l 705 734 l 705 0 l 520 0 l 515 75 m 623 1035 q 558 889 623 945 q 389 833 494 833 q 219 888 283 833 q 154 1035 154 943 l 293 1035 q 318 969 293 992 q 389 945 344 945 q 458 969 433 945 q 483 1035 483 992 l 623 1035 z '
    },
    Ů: {
      ha: 914,
      x_min: 79,
      x_max: 836,
      o: 'm 836 987 l 836 337 q 734 81 836 175 q 457 -14 633 -14 q 182 78 284 -14 q 79 330 81 170 l 79 987 l 282 987 l 282 336 q 329 194 282 239 q 457 150 375 150 q 631 330 629 150 l 631 987 l 836 987 m 304 1173 q 348 1272 304 1232 q 455 1312 392 1312 q 562 1273 517 1312 q 606 1173 606 1233 q 563 1076 606 1116 q 455 1037 519 1037 q 347 1077 389 1037 q 304 1173 304 1117 m 382 1173 q 401 1122 382 1143 q 455 1101 421 1101 q 509 1122 489 1101 q 528 1173 528 1143 q 508 1226 528 1204 q 455 1247 488 1247 q 402 1226 422 1247 q 382 1173 382 1204 z '
    },
    ů: {
      ha: 777,
      x_min: 71,
      x_max: 705,
      o: 'm 515 75 q 314 -14 442 -14 q 134 54 196 -14 q 71 253 72 122 l 71 734 l 267 734 l 267 260 q 371 145 267 145 q 508 214 471 145 l 508 734 l 705 734 l 705 0 l 520 0 l 515 75 m 237 963 q 281 1062 237 1021 q 389 1102 326 1102 q 495 1062 451 1102 q 540 963 540 1023 q 496 866 540 905 q 389 827 453 827 q 280 867 323 827 q 237 963 237 907 m 315 963 q 335 912 315 933 q 389 890 355 890 q 442 912 422 890 q 462 963 462 933 q 442 1016 462 994 q 389 1037 422 1037 q 335 1016 355 1037 q 315 963 315 994 z '
    },
    Ű: {
      ha: 914,
      x_min: 79,
      x_max: 836,
      o: 'm 836 987 l 836 337 q 734 81 836 175 q 457 -14 633 -14 q 182 78 284 -14 q 79 330 81 170 l 79 987 l 282 987 l 282 336 q 329 194 282 239 q 457 150 375 150 q 631 330 629 150 l 631 987 l 836 987 m 639 1251 l 814 1251 l 634 1047 l 486 1047 l 639 1251 m 374 1251 l 547 1251 l 391 1047 l 248 1047 l 374 1251 z '
    },
    ű: {
      ha: 777,
      x_min: 71,
      x_max: 748,
      o: 'm 515 75 q 314 -14 442 -14 q 134 54 196 -14 q 71 253 72 122 l 71 734 l 267 734 l 267 260 q 371 145 267 145 q 508 214 471 145 l 508 734 l 705 734 l 705 0 l 520 0 l 515 75 m 572 1041 l 748 1041 l 568 837 l 420 837 l 572 1041 m 307 1041 l 480 1041 l 325 837 l 181 837 l 307 1041 z '
    },
    Ų: {
      ha: 914,
      x_min: 79,
      x_max: 836,
      o: 'm 836 987 l 836 336 q 788 146 836 224 q 659 29 741 69 q 602 -19 621 5 q 582 -74 582 -43 q 627 -118 582 -118 q 681 -104 649 -118 l 701 -211 q 589 -241 651 -241 q 478 -203 521 -241 q 435 -99 435 -165 q 458 -14 435 -50 q 180 80 282 -14 q 79 338 79 173 l 79 987 l 282 987 l 282 336 q 329 194 282 239 q 457 150 375 150 q 631 330 629 150 l 631 987 l 836 987 z '
    },
    ų: {
      ha: 777,
      x_min: 71,
      x_max: 705,
      o: 'm 684 0 q 606 -56 633 -28 q 579 -119 579 -83 q 624 -163 579 -163 q 678 -150 646 -163 l 698 -256 q 586 -286 648 -286 q 475 -249 518 -286 q 432 -144 432 -211 q 519 6 432 -54 l 515 75 q 314 -14 442 -14 q 134 54 196 -14 q 71 253 72 122 l 71 734 l 267 734 l 267 260 q 371 145 267 145 q 508 214 471 145 l 508 734 l 705 734 l 705 0 l 684 0 z '
    },
    Ŵ: {
      ha: 1215,
      x_min: 24,
      x_max: 1193,
      o: 'm 857 285 l 990 987 l 1193 987 l 974 0 l 769 0 l 608 661 l 448 0 l 243 0 l 24 987 l 227 987 l 360 286 l 523 987 l 695 987 l 857 285 m 873 1062 l 873 1054 l 717 1054 l 612 1152 l 508 1054 l 355 1054 l 355 1065 l 555 1252 l 669 1252 l 873 1062 z '
    },
    ŵ: {
      ha: 1021,
      x_min: 19,
      x_max: 999,
      o: 'm 713 267 l 810 734 l 999 734 l 812 0 l 648 0 l 509 462 l 370 0 l 206 0 l 19 734 l 208 734 l 304 267 l 438 734 l 580 734 l 713 267 m 768 852 l 768 844 l 612 844 l 508 942 l 404 844 l 250 844 l 250 854 l 451 1042 l 565 1042 l 768 852 z '
    },
    Ŷ: {
      ha: 859,
      x_min: 1,
      x_max: 857,
      o: 'm 429 543 l 634 987 l 857 987 l 532 358 l 532 0 l 326 0 l 326 358 l 1 987 l 224 987 l 429 543 m 691 1062 l 691 1054 l 535 1054 l 431 1152 l 326 1054 l 173 1054 l 173 1065 l 374 1252 l 488 1252 l 691 1062 z '
    },
    ŷ: {
      ha: 697,
      x_min: 2,
      x_max: 695,
      o: 'm 349 277 l 485 734 l 695 734 l 400 -114 l 384 -153 q 167 -296 318 -296 q 80 -283 124 -296 l 80 -135 l 110 -136 q 193 -119 165 -136 q 236 -62 220 -102 l 259 -2 l 2 734 l 213 734 l 349 277 m 613 852 l 613 844 l 457 844 l 353 942 l 248 844 l 95 844 l 95 854 l 296 1042 l 410 1042 l 613 852 z '
    },
    Ÿ: {
      ha: 859,
      x_min: 1,
      x_max: 857,
      o: 'm 429 543 l 634 987 l 857 987 l 532 358 l 532 0 l 326 0 l 326 358 l 1 987 l 224 987 l 429 543 m 359 1136 q 333 1075 359 1100 q 265 1050 307 1050 q 197 1076 223 1050 q 172 1136 172 1101 q 197 1197 172 1171 q 265 1222 223 1222 q 333 1197 307 1222 q 359 1136 359 1171 m 502 1136 q 529 1197 502 1173 q 596 1222 557 1222 q 663 1197 636 1222 q 690 1136 690 1172 q 664 1075 690 1101 q 596 1050 638 1050 q 528 1075 554 1050 q 502 1136 502 1101 z '
    },
    Ź: {
      ha: 842,
      x_min: 50,
      x_max: 802,
      o: 'm 304 163 l 802 163 l 802 0 l 50 0 l 50 119 l 538 823 l 50 823 l 50 987 l 791 987 l 791 871 l 304 163 m 466 1252 l 680 1252 l 492 1042 l 332 1042 l 466 1252 z '
    },
    ź: {
      ha: 707,
      x_min: 50,
      x_max: 659,
      o: 'm 300 158 l 659 158 l 659 0 l 50 0 l 50 119 l 395 575 l 60 575 l 60 734 l 648 734 l 648 618 l 300 158 m 393 1042 l 607 1042 l 419 831 l 260 831 l 393 1042 z '
    },
    Ż: {
      ha: 842,
      x_min: 50,
      x_max: 802,
      o: 'm 304 163 l 802 163 l 802 0 l 50 0 l 50 119 l 538 823 l 50 823 l 50 987 l 791 987 l 791 871 l 304 163 m 426 1246 q 499 1220 473 1246 q 526 1154 526 1194 q 499 1087 526 1113 q 426 1061 473 1061 q 353 1087 380 1061 q 326 1154 326 1113 q 353 1220 326 1194 q 426 1246 380 1246 z '
    },
    ż: {
      ha: 707,
      x_min: 50,
      x_max: 659,
      o: 'm 300 158 l 659 158 l 659 0 l 50 0 l 50 119 l 395 575 l 60 575 l 60 734 l 648 734 l 648 618 l 300 158 m 353 1036 q 427 1010 400 1036 q 454 943 454 984 q 427 877 454 903 q 353 851 400 851 q 280 877 307 851 q 253 943 253 903 q 280 1010 253 984 q 353 1036 308 1036 z '
    },
    Ž: {
      ha: 842,
      x_min: 50,
      x_max: 802,
      o: 'm 304 163 l 802 163 l 802 0 l 50 0 l 50 119 l 538 823 l 50 823 l 50 987 l 791 987 l 791 871 l 304 163 m 427 1156 l 526 1253 l 693 1253 l 693 1245 l 488 1055 l 364 1055 l 159 1246 l 159 1253 l 327 1253 l 427 1156 z '
    },
    ž: {
      ha: 707,
      x_min: 50,
      x_max: 659,
      o: 'm 300 158 l 659 158 l 659 0 l 50 0 l 50 119 l 395 575 l 60 575 l 60 734 l 648 734 l 648 618 l 300 158 m 354 945 l 453 1042 l 621 1042 l 621 1035 l 416 844 l 292 844 l 87 1036 l 87 1042 l 254 1042 l 354 945 z '
    },
    Ǽ: {
      ha: 1305,
      x_min: 1,
      x_max: 1265,
      o: 'm 1265 0 l 656 0 l 647 226 l 345 226 l 231 0 l 1 0 l 534 987 l 1223 987 l 1223 827 l 818 827 l 828 587 l 1168 587 l 1168 427 l 835 427 l 846 159 l 1265 159 l 1265 0 m 429 393 l 640 393 l 624 780 l 429 393 m 673 1260 l 886 1260 l 699 1050 l 539 1050 l 673 1260 z '
    },
    ǽ: {
      ha: 1173,
      x_min: 45,
      x_max: 1137,
      o: 'm 845 -14 q 583 86 677 -14 q 470 13 540 39 q 316 -14 401 -14 q 117 47 190 -14 q 45 216 45 107 q 129 381 45 323 q 378 440 213 439 l 492 440 l 492 479 q 464 559 492 530 q 385 589 437 589 q 297 565 329 589 q 264 505 264 541 l 68 518 q 157 683 68 619 q 387 747 245 747 q 608 673 530 747 q 829 747 694 749 q 1055 658 973 747 q 1137 412 1137 569 l 1137 305 l 684 305 q 739 185 692 227 q 865 144 786 144 q 962 155 918 144 q 1065 196 1006 165 l 1118 68 q 995 8 1068 30 q 845 -14 922 -14 m 353 130 q 426 145 387 130 q 492 184 465 161 l 492 313 l 380 313 q 278 283 316 312 q 241 214 241 255 q 268 153 241 176 q 353 130 296 130 m 829 589 q 731 550 768 589 q 686 437 694 511 l 945 437 l 945 456 q 915 554 945 519 q 829 589 886 589 m 623 1042 l 837 1042 l 649 832 l 490 832 l 623 1042 z '
    },
    Ǿ: {
      ha: 957,
      x_min: 63,
      x_max: 904,
      o: 'm 904 471 q 852 216 904 326 q 705 46 801 106 q 485 -14 609 -14 q 285 34 374 -14 l 227 -64 l 100 -64 l 197 100 q 63 476 63 232 l 63 515 q 116 771 63 661 q 264 942 168 882 q 484 1001 360 1001 q 696 945 602 1001 l 747 1029 l 873 1029 l 783 876 q 904 511 904 741 l 904 471 m 269 471 q 302 278 269 355 l 606 791 q 484 833 556 833 q 326 753 381 833 q 269 519 270 673 l 269 471 m 699 516 q 673 690 699 618 l 374 185 q 485 153 422 153 q 643 234 587 153 q 699 468 698 314 l 699 516 m 524 1302 l 738 1302 l 550 1092 l 391 1092 l 524 1302 z '
    },
    ǿ: {
      ha: 784,
      x_min: 45,
      x_max: 740,
      o: 'm 45 374 q 87 568 45 483 q 208 701 129 654 q 391 747 287 747 q 517 728 460 747 l 565 825 l 674 825 l 604 682 q 740 359 740 581 q 646 89 740 191 q 393 -14 551 -14 q 273 4 328 -14 l 224 -96 l 115 -96 l 185 47 q 45 374 45 146 m 241 359 q 269 218 241 271 l 445 579 q 391 589 420 589 q 280 533 319 589 q 241 359 241 477 m 544 374 q 519 507 544 451 l 345 151 q 393 144 366 144 q 504 199 464 144 q 544 374 544 254 m 405 1039 l 618 1039 l 431 829 l 271 829 l 405 1039 z '
    },
    Ά: {
      ha: 935,
      x_min: 5,
      x_max: 930,
      o: 'm 646 203 l 289 203 l 221 0 l 5 0 l 372 987 l 561 987 l 930 0 l 714 0 l 646 203 m 344 368 l 591 368 l 467 738 l 344 368 m 99 1086 l 277 1086 l 166 852 l 50 852 l 99 1086 z '
    },
    Έ: {
      ha: 781,
      x_min: -235,
      x_max: 750,
      o: 'm 682 428 l 292 428 l 292 163 l 750 163 l 750 0 l 88 0 l 88 987 l 749 987 l 749 823 l 292 823 l 292 587 l 682 587 l 682 428 m -186 1086 l -8 1086 l -119 852 l -235 852 l -186 1086 z '
    },
    Ή: {
      ha: 981,
      x_min: -233,
      x_max: 892,
      o: 'm 892 0 l 688 0 l 688 423 l 292 423 l 292 0 l 88 0 l 88 987 l 292 987 l 292 587 l 688 587 l 688 987 l 892 987 l 892 0 m -183 1084 l -5 1084 l -116 850 l -233 850 l -183 1084 z '
    },
    Ί: {
      ha: 405,
      x_min: -232,
      x_max: 304,
      o: 'm 304 0 l 101 0 l 101 987 l 304 987 l 304 0 m -182 1087 l -5 1087 l -115 853 l -232 853 l -182 1087 z '
    },
    Ό: {
      ha: 972,
      x_min: -102,
      x_max: 913,
      o: 'm 913 471 q 861 216 913 326 q 714 46 810 106 q 494 -14 618 -14 q 275 45 371 -14 q 125 214 178 104 q 72 466 73 323 l 72 515 q 124 771 72 661 q 273 942 177 882 q 492 1001 369 1001 q 712 942 616 1001 q 860 771 808 882 q 913 515 913 661 l 913 471 m 707 516 q 651 752 707 671 q 492 833 595 833 q 334 753 390 833 q 278 519 279 673 l 278 471 q 334 237 278 320 q 494 153 389 153 q 651 234 596 153 q 707 468 706 314 l 707 516 m -53 1086 l 125 1086 l 14 852 l -102 852 l -53 1086 z '
    },
    Ύ: {
      ha: 926,
      x_min: -226,
      x_max: 924,
      o: 'm 496 543 l 702 987 l 924 987 l 600 358 l 600 0 l 393 0 l 393 358 l 69 987 l 292 987 l 496 543 m -176 1086 l 1 1086 l -109 852 l -226 852 l -176 1086 z '
    },
    Ώ: {
      ha: 947,
      x_min: -87,
      x_max: 866,
      o: 'm 512 168 q 638 486 630 219 l 639 585 q 595 771 639 709 q 474 834 552 834 q 354 771 397 834 q 310 585 310 709 l 310 526 q 343 283 310 373 q 441 168 376 193 l 441 0 l 94 0 l 94 165 l 241 165 q 125 327 168 232 q 83 523 83 421 l 83 583 q 132 799 83 703 q 271 947 182 895 q 474 1000 361 1000 q 675 948 586 1000 q 814 803 764 897 q 866 593 864 710 l 866 526 q 823 326 866 420 q 707 165 781 231 l 854 165 l 854 0 l 512 0 l 512 168 m -38 1086 l 140 1086 l 29 852 l -87 852 l -38 1086 z '
    },
    ΐ: {
      ha: 468,
      x_min: -96,
      x_max: 510,
      o: 'm 290 734 l 290 229 q 306 171 290 189 q 366 153 321 153 q 422 159 395 153 l 422 10 q 304 -7 370 -7 q 94 202 97 -7 l 94 734 l 290 734 m 178 1173 l 354 1173 l 250 948 l 149 948 l 178 1173 m -96 911 q -70 972 -96 947 q -2 998 -44 998 q 66 972 40 998 q 92 911 92 947 q 66 851 92 876 q -2 826 40 826 q -70 851 -43 826 q -96 911 -96 876 m 322 911 q 349 972 322 947 q 416 998 376 998 q 483 973 455 998 q 510 911 510 948 q 484 851 510 876 q 416 825 458 825 q 348 851 374 825 q 322 911 322 876 z '
    },
    Α: {
      ha: 935,
      x_min: 5,
      x_max: 930,
      o: 'm 646 203 l 289 203 l 221 0 l 5 0 l 372 987 l 561 987 l 930 0 l 714 0 l 646 203 m 344 368 l 591 368 l 467 738 l 344 368 z '
    },
    Β: {
      ha: 886,
      x_min: 88,
      x_max: 822,
      o: 'm 88 0 l 88 987 l 434 987 q 707 919 614 987 q 800 717 800 850 q 762 589 800 644 q 659 508 725 534 q 778 431 734 489 q 822 290 822 374 q 731 75 822 148 q 472 0 640 1 l 88 0 m 292 430 l 292 163 l 466 163 q 578 198 538 163 q 618 292 618 232 q 478 430 618 428 l 292 430 m 292 574 l 442 574 q 596 696 596 576 q 557 793 596 764 q 434 823 518 823 l 292 823 l 292 574 z '
    },
    Ε: {
      ha: 781,
      x_min: 88,
      x_max: 750,
      o: 'm 682 428 l 292 428 l 292 163 l 750 163 l 750 0 l 88 0 l 88 987 l 749 987 l 749 823 l 292 823 l 292 587 l 682 587 l 682 428 z '
    },
    Ζ: {
      ha: 842,
      x_min: 50,
      x_max: 802,
      o: 'm 304 163 l 802 163 l 802 0 l 50 0 l 50 119 l 538 823 l 50 823 l 50 987 l 791 987 l 791 871 l 304 163 z '
    },
    Η: {
      ha: 981,
      x_min: 88,
      x_max: 892,
      o: 'm 892 0 l 688 0 l 688 423 l 292 423 l 292 0 l 88 0 l 88 987 l 292 987 l 292 587 l 688 587 l 688 987 l 892 987 l 892 0 z '
    },
    Ι: {
      ha: 405,
      x_min: 101,
      x_max: 304,
      o: 'm 304 0 l 101 0 l 101 987 l 304 987 l 304 0 z '
    },
    Κ: {
      ha: 882,
      x_min: 88,
      x_max: 893,
      o: 'm 397 396 l 292 282 l 292 0 l 88 0 l 88 987 l 292 987 l 292 540 l 381 663 l 633 987 l 883 987 l 532 549 l 893 0 l 651 0 l 397 396 z '
    },
    Μ: {
      ha: 1217,
      x_min: 88,
      x_max: 1127,
      o: 'm 354 987 l 608 271 l 860 987 l 1127 987 l 1127 0 l 923 0 l 923 270 l 943 736 l 677 0 l 537 0 l 271 735 l 292 270 l 292 0 l 88 0 l 88 987 l 354 987 z '
    },
    Ν: {
      ha: 981,
      x_min: 88,
      x_max: 891,
      o: 'm 891 0 l 688 0 l 292 650 l 292 0 l 88 0 l 88 987 l 292 987 l 688 336 l 688 987 l 891 987 l 891 0 z '
    },
    Ο: {
      ha: 959,
      x_min: 58,
      x_max: 899,
      o: 'm 899 471 q 848 216 899 326 q 700 46 796 106 q 480 -14 604 -14 q 261 45 357 -14 q 112 214 165 104 q 58 466 59 323 l 58 515 q 111 771 58 661 q 259 942 163 882 q 479 1001 355 1001 q 698 942 602 1001 q 847 771 794 882 q 899 515 899 661 l 899 471 m 693 516 q 637 752 693 671 q 479 833 582 833 q 321 753 376 833 q 264 519 265 673 l 264 471 q 320 237 264 320 q 480 153 376 153 q 637 234 583 153 q 693 468 692 314 l 693 516 z '
    },
    Ρ: {
      ha: 896,
      x_min: 88,
      x_max: 844,
      o: 'm 292 348 l 292 0 l 88 0 l 88 987 l 473 987 q 669 947 585 987 q 799 831 753 906 q 844 661 844 756 q 745 432 844 515 q 470 348 646 348 l 292 348 m 292 513 l 473 513 q 596 551 554 513 q 639 659 639 589 q 596 777 639 732 q 478 823 553 821 l 292 823 l 292 513 z '
    },
    Τ: {
      ha: 859,
      x_min: 27,
      x_max: 831,
      o: 'm 831 823 l 529 823 l 529 0 l 326 0 l 326 823 l 27 823 l 27 987 l 831 987 l 831 823 z '
    },
    Υ: {
      ha: 859,
      x_min: 1,
      x_max: 857,
      o: 'm 429 543 l 634 987 l 857 987 l 532 358 l 532 0 l 326 0 l 326 358 l 1 987 l 224 987 l 429 543 z '
    },
    Χ: {
      ha: 882,
      x_min: 15,
      x_max: 868,
      o: 'm 441 647 l 627 987 l 861 987 l 573 498 l 868 0 l 631 0 l 441 346 l 252 0 l 15 0 l 310 498 l 22 987 l 256 987 l 441 647 z '
    },
    Ϊ: {
      ha: 405,
      x_min: -56,
      x_max: 462,
      o: 'm 304 0 l 101 0 l 101 987 l 304 987 l 304 0 m 132 1138 q 105 1077 132 1102 q 37 1053 79 1053 q -31 1078 -5 1053 q -56 1138 -56 1103 q -31 1199 -56 1173 q 37 1224 -5 1224 q 105 1199 79 1224 q 132 1138 132 1173 m 274 1138 q 301 1199 274 1175 q 368 1224 329 1224 q 435 1199 408 1224 q 462 1138 462 1174 q 436 1077 462 1103 q 368 1052 410 1052 q 300 1077 326 1052 q 274 1138 274 1103 z '
    },
    Ϋ: {
      ha: 859,
      x_min: 1,
      x_max: 857,
      o: 'm 429 543 l 634 987 l 857 987 l 532 358 l 532 0 l 326 0 l 326 358 l 1 987 l 224 987 l 429 543 m 359 1136 q 333 1075 359 1100 q 265 1050 307 1050 q 197 1076 223 1050 q 172 1136 172 1101 q 197 1197 172 1171 q 265 1222 223 1222 q 333 1197 307 1222 q 359 1136 359 1171 m 502 1136 q 529 1197 502 1173 q 596 1222 557 1222 q 663 1197 636 1222 q 690 1136 690 1172 q 664 1075 690 1101 q 596 1050 638 1050 q 528 1075 554 1050 q 502 1136 502 1101 z '
    },
    ά: {
      ha: 783,
      x_min: 50,
      x_max: 779,
      o: 'm 699 734 l 699 227 q 747 147 701 147 q 762 150 757 147 l 779 3 q 694 -14 745 -14 q 525 99 571 -14 q 336 -14 458 -14 q 134 76 210 -14 q 50 320 57 165 l 50 361 q 127 644 50 540 q 337 747 204 747 q 515 646 449 747 l 529 734 l 699 734 m 246 347 q 385 144 246 144 q 503 209 466 144 l 503 517 q 387 589 466 589 q 283 530 319 589 q 246 347 246 472 m 397 1086 l 575 1086 l 465 852 l 348 852 l 397 1086 z '
    },
    έ: {
      ha: 772,
      x_min: 64,
      x_max: 726,
      o: 'm 64 208 q 203 378 64 332 q 111 443 144 402 q 77 533 77 484 q 165 690 77 633 q 405 747 253 747 q 628 684 541 747 q 715 522 715 621 l 519 522 q 485 578 519 557 q 395 599 450 599 q 307 576 340 599 q 273 517 273 554 q 304 461 273 482 q 395 440 334 440 l 522 440 l 522 309 l 393 309 q 260 222 260 309 q 297 159 260 184 q 394 134 334 134 q 493 157 456 134 q 530 217 530 181 l 726 217 q 636 50 726 113 q 405 -14 546 -14 q 159 47 254 -14 q 64 208 64 108 m 374 1086 l 551 1086 l 441 852 l 324 852 l 374 1086 z '
    },
    ή: {
      ha: 784,
      x_min: 73,
      x_max: 710,
      o: 'm 256 734 l 263 644 q 474 747 344 747 q 710 484 705 747 l 710 -281 l 513 -281 l 513 475 q 402 589 511 589 q 269 526 316 589 l 269 0 l 73 0 l 73 734 l 256 734 m 369 1086 l 547 1086 l 436 852 l 319 852 l 369 1086 z '
    },
    ί: {
      ha: 468,
      x_min: 94,
      x_max: 422,
      o: 'm 290 734 l 290 229 q 306 171 290 189 q 366 153 321 153 q 422 159 395 153 l 422 10 q 304 -7 370 -7 q 94 202 97 -7 l 94 734 l 290 734 m 180 1072 l 357 1072 l 247 838 l 130 838 l 180 1072 z '
    },
    ΰ: {
      ha: 758,
      x_min: 77,
      x_max: 705,
      o: 'm 273 734 l 273 285 q 359 144 273 144 q 467 213 424 144 q 510 384 510 283 q 441 734 507 544 l 628 734 q 705 384 705 579 q 617 92 705 198 q 366 -14 529 -14 q 151 61 224 -14 q 77 277 78 137 l 77 734 l 273 734 m 359 1184 l 534 1184 l 430 959 l 330 959 l 359 1184 m 84 922 q 110 983 84 958 q 178 1008 136 1008 q 246 983 220 1008 q 272 922 272 958 q 246 862 272 887 q 178 837 220 837 q 111 862 137 837 q 84 922 84 886 m 503 922 q 529 983 503 958 q 596 1008 556 1008 q 663 984 635 1008 q 690 922 690 959 q 664 862 690 887 q 596 836 638 836 q 528 862 554 836 q 503 922 503 887 z '
    },
    κ: {
      ha: 819,
      x_min: 88,
      x_max: 793,
      o: 'm 364 271 l 284 271 l 284 0 l 88 0 l 88 734 l 284 734 l 284 458 l 343 458 l 534 734 l 782 734 l 524 380 l 793 0 l 542 0 l 364 271 z '
    },
    ο: {
      ha: 785,
      x_min: 45,
      x_max: 740,
      o: 'm 45 374 q 87 568 45 483 q 208 701 129 654 q 391 747 287 747 q 634 656 540 747 q 739 410 728 566 l 740 359 q 646 89 740 191 q 393 -14 551 -14 q 139 88 234 -14 q 45 365 45 190 l 45 374 m 241 359 q 280 200 241 255 q 393 144 319 144 q 504 199 464 144 q 544 374 544 254 q 504 532 544 476 q 391 589 464 589 q 280 533 319 589 q 241 359 241 477 z '
    },
    μ: {
      ha: 855,
      x_min: 94,
      x_max: 747,
      o: 'm 290 734 l 290 311 q 318 185 290 226 q 412 145 345 145 q 551 216 513 145 l 551 734 l 747 734 l 747 0 l 565 0 l 561 46 q 408 -14 500 -14 q 290 16 339 -14 l 290 -282 l 94 -282 l 94 734 l 290 734 z '
    },
    ν: {
      ha: 702,
      x_min: 9,
      x_max: 691,
      o: 'm 350 239 l 486 734 l 691 734 l 444 0 l 256 0 l 9 734 l 214 734 l 350 239 z '
    },
    χ: {
      ha: 707,
      x_min: 17,
      x_max: 745,
      o: 'm 123 745 q 248 709 197 745 q 333 595 299 674 l 399 446 l 538 734 l 737 734 l 493 236 l 621 -51 q 701 -130 652 -119 l 722 -132 l 745 -132 l 728 -287 q 684 -293 708 -292 q 586 -279 624 -296 q 514 -218 549 -262 q 435 -68 479 -174 l 392 31 l 239 -282 l 45 -282 l 299 241 l 182 507 q 65 585 151 585 l 21 581 l 17 729 q 123 745 71 745 z '
    },
    ϊ: {
      ha: 468,
      x_min: -57,
      x_max: 461,
      o: 'm 290 734 l 290 229 q 306 171 290 189 q 366 153 321 153 q 422 159 395 153 l 422 10 q 304 -7 370 -7 q 94 202 97 -7 l 94 734 l 290 734 m 131 911 q 104 851 131 876 q 37 826 78 826 q -31 851 -5 826 q -57 911 -57 876 q -31 972 -57 947 q 37 998 -5 998 q 105 972 79 998 q 131 911 131 947 m 273 911 q 301 973 273 948 q 368 998 328 998 q 434 972 408 998 q 461 911 461 947 q 435 851 461 876 q 368 825 410 825 q 299 851 326 825 q 273 911 273 876 z '
    },
    ϋ: {
      ha: 758,
      x_min: 77,
      x_max: 705,
      o: 'm 273 734 l 273 285 q 359 144 273 144 q 467 213 424 144 q 510 384 510 283 q 441 734 507 544 l 628 734 q 705 384 705 579 q 617 92 705 198 q 366 -14 529 -14 q 151 61 224 -14 q 77 277 78 137 l 77 734 l 273 734 m 311 922 q 285 862 311 886 q 217 837 258 837 q 149 862 175 837 q 123 922 123 887 q 149 983 123 958 q 217 1008 175 1008 q 285 983 259 1008 q 311 922 311 958 m 454 922 q 481 984 454 959 q 548 1008 509 1008 q 615 983 588 1008 q 642 922 642 958 q 616 862 642 887 q 548 836 590 836 q 480 862 506 836 q 454 922 454 887 z '
    },
    ό: {
      ha: 785,
      x_min: 45,
      x_max: 740,
      o: 'm 45 374 q 87 568 45 483 q 208 701 129 654 q 391 747 287 747 q 634 656 540 747 q 739 410 728 566 l 740 359 q 646 89 740 191 q 393 -14 551 -14 q 139 88 234 -14 q 45 365 45 190 l 45 374 m 241 359 q 280 200 241 255 q 393 144 319 144 q 504 199 464 144 q 544 374 544 254 q 504 532 544 476 q 391 589 464 589 q 280 533 319 589 q 241 359 241 477 m 368 1086 l 546 1086 l 435 852 l 319 852 l 368 1086 z '
    },
    ύ: {
      ha: 758,
      x_min: 77,
      x_max: 705,
      o: 'm 273 734 l 273 285 q 359 144 273 144 q 467 213 424 144 q 510 384 510 283 q 441 734 507 544 l 628 734 q 705 384 705 579 q 617 92 705 198 q 366 -14 529 -14 q 151 61 224 -14 q 77 277 78 137 l 77 734 l 273 734 m 360 1082 l 538 1082 l 427 848 l 311 848 l 360 1082 z '
    },
    ώ: {
      ha: 1140,
      x_min: 56,
      x_max: 1086,
      o: 'm 345 734 q 253 384 258 551 q 281 205 253 267 q 359 144 309 144 q 468 340 468 144 l 468 572 l 675 572 l 675 340 q 783 144 675 144 q 862 207 835 144 q 890 384 890 271 q 798 734 885 552 l 985 734 q 1086 384 1086 579 q 1010 86 1086 186 q 790 -14 935 -14 q 660 23 715 -14 q 571 130 604 60 q 482 23 538 60 q 353 -14 427 -14 q 132 86 207 -14 q 56 384 56 186 q 157 734 56 579 l 345 734 m 547 1082 l 724 1082 l 614 848 l 497 848 l 547 1082 z '
    },
    Ё: {
      ha: 781,
      x_min: 88,
      x_max: 750,
      o: 'm 682 428 l 292 428 l 292 163 l 750 163 l 750 0 l 88 0 l 88 987 l 749 987 l 749 823 l 292 823 l 292 587 l 682 587 l 682 428 m 359 1138 q 333 1077 359 1102 q 265 1053 307 1053 q 197 1078 223 1053 q 172 1138 172 1103 q 197 1199 172 1173 q 265 1224 223 1224 q 333 1199 307 1224 q 359 1138 359 1173 m 502 1138 q 529 1199 502 1175 q 596 1224 557 1224 q 663 1199 636 1224 q 690 1138 690 1174 q 664 1077 690 1103 q 596 1052 638 1052 q 528 1077 554 1052 q 502 1138 502 1103 z '
    },
    Ѓ: {
      ha: 774,
      x_min: 90,
      x_max: 736,
      o: 'm 736 823 l 293 823 l 293 0 l 90 0 l 90 987 l 736 987 l 736 823 m 457 1254 l 671 1254 l 483 1044 l 323 1044 l 457 1254 z '
    },
    Ѕ: {
      ha: 854,
      x_min: 47,
      x_max: 804,
      o: 'm 600 259 q 559 348 600 317 q 413 413 519 378 q 245 480 307 447 q 77 725 77 571 q 122 868 77 805 q 252 966 168 930 q 441 1001 336 1001 q 630 963 547 1001 q 759 854 713 924 q 804 696 804 785 l 601 696 q 558 801 601 764 q 438 839 515 839 q 322 807 363 839 q 281 724 281 776 q 329 644 281 676 q 472 583 378 611 q 725 453 646 530 q 804 260 804 376 q 707 59 804 132 q 446 -14 610 -14 q 239 28 332 -14 q 96 142 145 70 q 47 311 47 215 l 251 311 q 446 147 251 147 q 559 177 519 147 q 600 259 600 206 z '
    },
    І: {
      ha: 405,
      x_min: 101,
      x_max: 304,
      o: 'm 304 0 l 101 0 l 101 987 l 304 987 l 304 0 z '
    },
    Ї: {
      ha: 405,
      x_min: -56,
      x_max: 462,
      o: 'm 304 0 l 101 0 l 101 987 l 304 987 l 304 0 m 132 1138 q 105 1077 132 1102 q 37 1053 79 1053 q -31 1078 -5 1053 q -56 1138 -56 1103 q -31 1199 -56 1173 q 37 1224 -5 1224 q 105 1199 79 1224 q 132 1138 132 1173 m 274 1138 q 301 1199 274 1175 q 368 1224 329 1224 q 435 1199 408 1224 q 462 1138 462 1174 q 436 1077 462 1103 q 368 1052 410 1052 q 300 1077 326 1052 q 274 1138 274 1103 z '
    },
    Ј: {
      ha: 776,
      x_min: 27,
      x_max: 690,
      o: 'm 486 987 l 690 987 l 690 304 q 648 137 690 210 q 530 26 606 65 q 359 -14 454 -14 q 115 66 202 -14 q 27 292 27 146 l 232 292 q 262 184 232 219 q 359 150 293 150 q 452 190 417 150 q 486 304 486 230 l 486 987 z '
    },
    К: {
      ha: 897,
      x_min: 90,
      x_max: 907,
      o: 'm 410 404 l 293 404 l 293 0 l 90 0 l 90 987 l 293 987 l 293 592 l 386 592 l 627 987 l 876 987 l 571 520 l 907 0 l 665 0 l 410 404 z '
    },
    Ќ: {
      ha: 882,
      x_min: 88,
      x_max: 893,
      o: 'm 397 396 l 292 282 l 292 0 l 88 0 l 88 987 l 292 987 l 292 540 l 381 663 l 633 987 l 883 987 l 532 549 l 893 0 l 651 0 l 397 396 m 444 1252 l 657 1252 l 469 1042 l 310 1042 l 444 1252 z '
    },
    Ў: {
      ha: 877,
      x_min: 21,
      x_max: 858,
      o: 'm 458 521 l 638 987 l 858 987 l 513 173 l 485 119 q 250 -14 408 -14 l 179 -12 l 177 152 q 230 149 193 149 q 299 164 273 149 q 342 219 325 179 l 368 283 l 21 987 l 240 987 l 458 521 m 688 1247 q 624 1101 688 1157 q 454 1046 559 1046 q 284 1101 349 1046 q 219 1247 219 1156 l 358 1247 q 384 1181 358 1204 q 454 1158 409 1158 q 523 1181 498 1158 q 548 1247 548 1204 l 688 1247 z '
    },
    А: {
      ha: 935,
      x_min: 5,
      x_max: 930,
      o: 'm 646 203 l 289 203 l 221 0 l 5 0 l 372 987 l 561 987 l 930 0 l 714 0 l 646 203 m 344 368 l 591 368 l 467 738 l 344 368 z '
    },
    В: {
      ha: 886,
      x_min: 88,
      x_max: 822,
      o: 'm 88 0 l 88 987 l 434 987 q 707 919 614 987 q 800 717 800 850 q 762 589 800 644 q 659 508 725 534 q 778 431 734 489 q 822 290 822 374 q 731 75 822 148 q 472 0 640 1 l 88 0 m 292 430 l 292 163 l 466 163 q 578 198 538 163 q 618 292 618 232 q 478 430 618 428 l 292 430 m 292 574 l 442 574 q 596 696 596 576 q 557 793 596 764 q 434 823 518 823 l 292 823 l 292 574 z '
    },
    Г: {
      ha: 774,
      x_min: 90,
      x_max: 736,
      o: 'm 736 823 l 293 823 l 293 0 l 90 0 l 90 987 l 736 987 l 736 823 z '
    },
    Е: {
      ha: 781,
      x_min: 88,
      x_max: 750,
      o: 'm 682 428 l 292 428 l 292 163 l 750 163 l 750 0 l 88 0 l 88 987 l 749 987 l 749 823 l 292 823 l 292 587 l 682 587 l 682 428 z '
    },
    Й: {
      ha: 972,
      x_min: 81,
      x_max: 884,
      o: 'm 680 987 l 884 987 l 884 0 l 680 0 l 680 656 l 285 0 l 81 0 l 81 987 l 285 987 l 285 330 l 680 987 m 720 1247 q 655 1101 720 1157 q 485 1046 590 1046 q 315 1101 380 1046 q 250 1247 250 1156 l 389 1247 q 415 1181 389 1204 q 485 1158 440 1158 q 554 1181 529 1158 q 579 1247 579 1204 l 720 1247 z '
    },
    М: {
      ha: 1217,
      x_min: 88,
      x_max: 1127,
      o: 'm 354 987 l 608 271 l 860 987 l 1127 987 l 1127 0 l 923 0 l 923 270 l 943 736 l 677 0 l 537 0 l 271 735 l 292 270 l 292 0 l 88 0 l 88 987 l 354 987 z '
    },
    Н: {
      ha: 981,
      x_min: 88,
      x_max: 892,
      o: 'm 892 0 l 688 0 l 688 423 l 292 423 l 292 0 l 88 0 l 88 987 l 292 987 l 292 587 l 688 587 l 688 987 l 892 987 l 892 0 z '
    },
    О: {
      ha: 959,
      x_min: 58,
      x_max: 899,
      o: 'm 899 471 q 848 216 899 326 q 700 46 796 106 q 480 -14 604 -14 q 261 45 357 -14 q 112 214 165 104 q 58 466 59 323 l 58 515 q 111 771 58 661 q 259 942 163 882 q 479 1001 355 1001 q 698 942 602 1001 q 847 771 794 882 q 899 515 899 661 l 899 471 m 693 516 q 637 752 693 671 q 479 833 582 833 q 321 753 376 833 q 264 519 265 673 l 264 471 q 320 237 264 320 q 480 153 376 153 q 637 234 583 153 q 693 468 692 314 l 693 516 z '
    },
    П: {
      ha: 983,
      x_min: 90,
      x_max: 892,
      o: 'm 892 0 l 688 0 l 688 823 l 293 823 l 293 0 l 90 0 l 90 987 l 892 987 l 892 0 z '
    },
    Р: {
      ha: 896,
      x_min: 88,
      x_max: 844,
      o: 'm 292 348 l 292 0 l 88 0 l 88 987 l 473 987 q 669 947 585 987 q 799 831 753 906 q 844 661 844 756 q 745 432 844 515 q 470 348 646 348 l 292 348 m 292 513 l 473 513 q 596 551 554 513 q 639 659 639 589 q 596 777 639 732 q 478 823 553 821 l 292 823 l 292 513 z '
    },
    С: {
      ha: 909,
      x_min: 58,
      x_max: 865,
      o: 'm 863 329 q 746 78 852 170 q 466 -14 640 -14 q 167 114 276 -14 q 58 465 58 242 l 58 526 q 109 777 58 668 q 252 943 159 885 q 469 1001 345 1001 q 744 909 640 1001 q 865 652 848 818 l 661 652 q 608 791 654 748 q 469 834 562 834 q 316 761 367 834 q 264 535 266 688 l 264 460 q 313 227 264 300 q 466 153 361 153 q 607 196 560 153 q 660 329 653 239 l 863 329 z '
    },
    Т: {
      ha: 859,
      x_min: 27,
      x_max: 831,
      o: 'm 831 823 l 529 823 l 529 0 l 326 0 l 326 823 l 27 823 l 27 987 l 831 987 l 831 823 z '
    },
    Х: {
      ha: 882,
      x_min: 15,
      x_max: 868,
      o: 'm 441 647 l 627 987 l 861 987 l 573 498 l 868 0 l 631 0 l 441 346 l 252 0 l 15 0 l 310 498 l 22 987 l 256 987 l 441 647 z '
    },
    а: {
      ha: 745,
      x_min: 46,
      x_max: 699,
      o: 'm 500 0 q 481 66 487 26 q 296 -14 410 -14 q 117 49 188 -14 q 46 206 46 111 q 133 385 46 323 q 382 448 219 448 l 473 448 l 473 490 q 447 572 473 541 q 364 602 420 602 q 287 578 315 602 q 258 513 258 555 l 62 513 q 102 631 62 577 q 213 716 141 686 q 374 747 285 747 q 590 679 510 747 q 669 488 669 611 l 669 170 q 699 12 670 65 l 699 0 l 500 0 m 338 136 q 418 156 382 136 q 473 208 455 175 l 473 334 l 399 334 q 243 232 252 334 l 242 220 q 268 160 242 184 q 338 136 294 136 z '
    },
    е: {
      ha: 751,
      x_min: 49,
      x_max: 715,
      o: 'm 413 -14 q 150 85 252 -14 q 49 349 49 184 l 49 368 q 92 566 49 479 q 213 700 134 653 q 391 747 291 747 q 628 652 542 747 q 715 383 715 557 l 715 303 l 248 303 q 305 188 257 231 q 426 144 353 144 q 603 227 539 144 l 699 119 q 580 21 655 56 q 413 -14 505 -14 m 391 589 q 296 549 332 589 q 250 437 260 510 l 522 437 l 522 452 q 487 553 521 517 q 391 589 453 589 z '
    },
    й: {
      ha: 788,
      x_min: 75,
      x_max: 713,
      o: 'm 517 734 l 713 734 l 713 0 l 517 0 l 517 453 l 272 0 l 75 0 l 75 734 l 272 734 l 272 281 l 517 734 m 633 1031 q 568 886 633 941 q 398 830 503 830 q 228 885 293 830 q 163 1031 163 940 l 302 1031 q 328 965 302 989 q 398 942 353 942 q 467 965 442 942 q 492 1031 492 989 l 633 1031 z '
    },
    о: {
      ha: 785,
      x_min: 45,
      x_max: 740,
      o: 'm 45 374 q 87 568 45 483 q 208 701 129 654 q 391 747 287 747 q 634 656 540 747 q 739 410 728 566 l 740 359 q 646 89 740 191 q 393 -14 551 -14 q 139 88 234 -14 q 45 365 45 190 l 45 374 m 241 359 q 280 200 241 255 q 393 144 319 144 q 504 199 464 144 q 544 374 544 254 q 504 532 544 476 q 391 589 464 589 q 280 533 319 589 q 241 359 241 477 z '
    },
    р: {
      ha: 782,
      x_min: 75,
      x_max: 736,
      o: 'm 736 360 q 659 89 736 191 q 451 -14 582 -14 q 271 64 340 -14 l 271 -282 l 75 -282 l 75 734 l 257 734 l 264 662 q 450 747 335 747 q 661 647 585 747 q 736 370 736 547 l 736 360 m 540 374 q 504 532 540 477 q 398 588 467 588 q 271 517 306 588 l 271 217 q 399 144 307 144 q 540 374 540 144 z '
    },
    с: {
      ha: 724,
      x_min: 45,
      x_max: 688,
      o: 'm 380 144 q 469 174 435 144 q 504 254 503 204 l 688 254 q 647 117 687 179 q 537 21 607 55 q 384 -14 468 -14 q 136 86 227 -14 q 45 363 45 186 l 45 376 q 135 646 45 545 q 382 747 225 747 q 603 669 520 747 q 688 460 686 591 l 504 460 q 469 553 503 517 q 379 589 435 589 q 276 539 311 589 q 241 377 241 489 l 241 357 q 275 194 241 243 q 380 144 310 144 z '
    },
    у: {
      ha: 697,
      x_min: 2,
      x_max: 695,
      o: 'm 349 277 l 485 734 l 695 734 l 400 -114 l 384 -153 q 167 -296 318 -296 q 80 -283 124 -296 l 80 -135 l 110 -136 q 193 -119 165 -136 q 236 -62 220 -102 l 259 -2 l 2 734 l 213 734 l 349 277 z '
    },
    х: {
      ha: 707,
      x_min: 14,
      x_max: 696,
      o: 'm 355 515 l 478 734 l 688 734 l 479 374 l 696 0 l 486 0 l 355 231 l 225 0 l 14 0 l 232 374 l 24 734 l 234 734 l 355 515 z '
    },
    ё: {
      ha: 751,
      x_min: 49,
      x_max: 715,
      o: 'm 413 -14 q 150 85 252 -14 q 49 349 49 184 l 49 368 q 92 566 49 479 q 213 700 134 653 q 391 747 291 747 q 628 652 542 747 q 715 383 715 557 l 715 303 l 248 303 q 305 188 257 231 q 426 144 353 144 q 603 227 539 144 l 699 119 q 580 21 655 56 q 413 -14 505 -14 m 391 589 q 296 549 332 589 q 250 437 260 510 l 522 437 l 522 452 q 487 553 521 517 q 391 589 453 589 m 298 926 q 271 865 298 890 q 203 840 245 840 q 136 865 161 840 q 110 926 110 890 q 136 986 110 961 q 203 1012 161 1012 q 272 986 245 1012 q 298 926 298 961 m 440 926 q 468 987 440 962 q 534 1012 495 1012 q 601 987 574 1012 q 628 926 628 962 q 602 865 628 890 q 534 840 576 840 q 466 865 492 840 q 440 926 440 890 z '
    },
    ѓ: {
      ha: 582,
      x_min: 75,
      x_max: 575,
      o: 'm 575 575 l 271 575 l 271 0 l 75 0 l 75 734 l 575 734 l 575 575 m 328 1038 l 542 1038 l 354 828 l 195 828 l 328 1038 z '
    },
    ѕ: {
      ha: 714,
      x_min: 38,
      x_max: 663,
      o: 'm 473 203 q 437 259 473 239 q 323 296 401 280 q 61 519 61 351 q 142 682 61 616 q 354 747 223 747 q 577 682 494 747 q 661 511 661 616 l 465 511 q 438 580 465 553 q 353 608 411 608 q 277 585 304 608 q 250 528 250 563 q 280 476 250 496 q 385 441 311 456 q 508 408 458 427 q 663 211 663 351 q 577 48 663 111 q 355 -14 491 -14 q 191 19 262 -14 q 79 110 119 52 q 38 233 38 167 l 224 233 q 262 153 227 181 q 359 125 298 125 q 444 147 415 125 q 473 203 473 168 z '
    },
    і: {
      ha: 368,
      x_min: 74,
      x_max: 294,
      o: 'm 282 0 l 85 0 l 85 734 l 282 734 l 282 0 m 74 924 q 103 996 74 968 q 184 1025 133 1025 q 264 996 234 1025 q 294 924 294 968 q 263 850 294 879 q 184 822 233 822 q 104 850 134 822 q 74 924 74 879 z '
    },
    ї: {
      ha: 380,
      x_min: -68,
      x_max: 450,
      o: 'm 287 0 l 91 0 l 91 734 l 287 734 l 287 0 m 119 916 q 93 855 119 880 q 25 830 66 830 q -43 855 -17 830 q -68 916 -68 880 q -43 976 -68 951 q 25 1002 -17 1002 q 93 976 67 1002 q 119 916 119 951 m 262 916 q 289 977 262 952 q 356 1002 317 1002 q 423 977 396 1002 q 450 916 450 951 q 424 855 450 880 q 356 829 398 829 q 288 855 314 829 q 262 916 262 880 z '
    },
    ј: {
      ha: 361,
      x_min: -64,
      x_max: 290,
      o: 'm 283 734 l 283 -40 q 218 -229 283 -161 q 33 -296 154 -296 q -64 -285 -18 -296 l -64 -130 q -3 -136 -29 -136 q 86 -41 86 -136 l 86 734 l 283 734 m 71 924 q 100 996 71 968 q 180 1025 130 1025 q 261 996 231 1025 q 290 924 290 968 q 260 850 290 879 q 180 822 230 822 q 101 850 131 822 q 71 924 71 879 z '
    },
    ќ: {
      ha: 783,
      x_min: 88,
      x_max: 784,
      o: 'm 363 271 l 284 271 l 284 0 l 88 0 l 88 734 l 284 734 l 284 458 l 354 458 l 514 734 l 762 734 l 522 385 l 784 0 l 523 0 l 363 271 m 432 1038 l 646 1038 l 458 828 l 298 828 l 432 1038 z '
    },
    ў: {
      ha: 697,
      x_min: 2,
      x_max: 695,
      o: 'm 349 277 l 485 734 l 695 734 l 400 -114 l 384 -153 q 167 -296 318 -296 q 80 -283 124 -296 l 80 -135 l 110 -136 q 193 -119 165 -136 q 236 -62 220 -102 l 259 -2 l 2 734 l 213 734 l 349 277 m 588 1035 q 523 889 588 945 q 353 833 458 833 q 183 888 248 833 q 119 1035 119 943 l 258 1035 q 283 969 258 992 q 353 945 309 945 q 422 969 397 945 q 448 1035 448 992 l 588 1035 z '
    },
    Ẁ: {
      ha: 1215,
      x_min: 24,
      x_max: 1193,
      o: 'm 857 285 l 990 987 l 1193 987 l 974 0 l 769 0 l 608 661 l 448 0 l 243 0 l 24 987 l 227 987 l 360 286 l 523 987 l 695 987 l 857 285 m 710 1042 l 549 1042 l 362 1252 l 576 1252 l 710 1042 z '
    },
    ẁ: {
      ha: 1021,
      x_min: 19,
      x_max: 999,
      o: 'm 713 267 l 810 734 l 999 734 l 812 0 l 648 0 l 509 462 l 370 0 l 206 0 l 19 734 l 208 734 l 304 267 l 438 734 l 580 734 l 713 267 m 606 831 l 445 831 l 258 1042 l 471 1042 l 606 831 z '
    },
    Ẃ: {
      ha: 1215,
      x_min: 24,
      x_max: 1193,
      o: 'm 857 285 l 990 987 l 1193 987 l 974 0 l 769 0 l 608 661 l 448 0 l 243 0 l 24 987 l 227 987 l 360 286 l 523 987 l 695 987 l 857 285 m 652 1252 l 865 1252 l 677 1042 l 518 1042 l 652 1252 z '
    },
    ẃ: {
      ha: 1021,
      x_min: 19,
      x_max: 999,
      o: 'm 713 267 l 810 734 l 999 734 l 812 0 l 648 0 l 509 462 l 370 0 l 206 0 l 19 734 l 208 734 l 304 267 l 438 734 l 580 734 l 713 267 m 547 1042 l 761 1042 l 573 831 l 414 831 l 547 1042 z '
    },
    Ẅ: {
      ha: 1215,
      x_min: 24,
      x_max: 1193,
      o: 'm 857 285 l 990 987 l 1193 987 l 974 0 l 769 0 l 608 661 l 448 0 l 243 0 l 24 987 l 227 987 l 360 286 l 523 987 l 695 987 l 857 285 m 541 1136 q 515 1075 541 1100 q 447 1050 488 1050 q 379 1076 405 1050 q 353 1136 353 1101 q 379 1197 353 1171 q 447 1222 405 1222 q 515 1197 489 1222 q 541 1136 541 1171 m 684 1136 q 711 1197 684 1173 q 778 1222 739 1222 q 845 1197 818 1222 q 871 1136 871 1172 q 846 1075 871 1101 q 778 1050 820 1050 q 710 1075 736 1050 q 684 1136 684 1101 z '
    },
    ẅ: {
      ha: 1021,
      x_min: 19,
      x_max: 999,
      o: 'm 713 267 l 810 734 l 999 734 l 812 0 l 648 0 l 509 462 l 370 0 l 206 0 l 19 734 l 208 734 l 304 267 l 438 734 l 580 734 l 713 267 m 437 926 q 410 865 437 890 q 342 840 384 840 q 275 865 300 840 q 249 926 249 890 q 275 986 249 961 q 342 1012 300 1012 q 411 986 385 1012 q 437 926 437 961 m 579 926 q 607 987 579 962 q 673 1012 634 1012 q 740 987 713 1012 q 767 926 767 962 q 741 865 767 890 q 673 840 715 840 q 605 865 631 840 q 579 926 579 890 z '
    },
    Ỳ: {
      ha: 859,
      x_min: 1,
      x_max: 857,
      o: 'm 429 543 l 634 987 l 857 987 l 532 358 l 532 0 l 326 0 l 326 358 l 1 987 l 224 987 l 429 543 m 528 1042 l 368 1042 l 180 1252 l 394 1252 l 528 1042 z '
    },
    ỳ: {
      ha: 697,
      x_min: 2,
      x_max: 695,
      o: 'm 349 277 l 485 734 l 695 734 l 400 -114 l 384 -153 q 167 -296 318 -296 q 80 -283 124 -296 l 80 -135 l 110 -136 q 193 -119 165 -136 q 236 -62 220 -102 l 259 -2 l 2 734 l 213 734 l 349 277 m 450 831 l 290 831 l 102 1042 l 316 1042 l 450 831 z '
    },
    '′': {
      ha: 224,
      x_min: 43,
      x_max: 186,
      o: 'm 186 942 l 167 668 l 43 668 l 43 1042 l 186 1042 l 186 942 z '
    },
    '″': {
      ha: 446,
      x_min: 43,
      x_max: 401,
      o: 'm 180 948 l 153 669 l 43 669 l 43 1042 l 180 1042 l 180 948 m 401 948 l 374 669 l 264 669 l 264 1042 l 401 1042 l 401 948 z '
    },
    '‼': {
      ha: 755,
      x_min: 84,
      x_max: 681,
      o: 'm 275 303 l 112 303 l 89 987 l 298 987 l 275 303 m 193 196 q 273 167 243 196 q 303 92 303 138 q 273 18 303 47 q 193 -11 243 -11 q 114 18 144 -11 q 84 92 84 47 q 114 166 84 137 q 193 196 144 196 m 652 303 l 490 303 l 467 987 l 675 987 l 652 303 m 571 196 q 651 167 621 196 q 681 92 681 138 q 651 18 681 47 q 571 -11 621 -11 q 492 18 522 -11 q 462 92 462 47 q 492 166 462 137 q 571 196 522 196 z '
    },
    ǰ: {
      ha: 391,
      x_min: -81,
      x_max: 453,
      o: 'm 298 734 l 298 -24 q 230 -225 297 -155 q 40 -296 162 -296 q -56 -285 -12 -296 l -47 -130 q 20 -138 -17 -138 q 102 -18 102 -138 l 102 734 l 298 734 m 186 928 l 286 1025 l 453 1025 l 453 1017 l 248 827 l 124 827 l -81 1019 l -81 1025 l 87 1025 l 186 928 z '
    },
    ʼ: {
      ha: 319,
      x_min: 39,
      x_max: 256,
      o: 'm 132 684 l 39 738 q 100 927 98 829 l 100 1042 l 256 1042 l 256 937 q 222 804 256 876 q 132 684 188 733 z '
    },
    Ḿ: {
      ha: 1217,
      x_min: 88,
      x_max: 1127,
      o: 'm 354 987 l 608 271 l 860 987 l 1127 987 l 1127 0 l 923 0 l 923 270 l 943 736 l 677 0 l 537 0 l 271 735 l 292 270 l 292 0 l 88 0 l 88 987 l 354 987 m 644 1252 l 858 1252 l 670 1042 l 511 1042 l 644 1252 z '
    },
    ḿ: {
      ha: 1202,
      x_min: 75,
      x_max: 1127,
      o: 'm 259 734 l 265 652 q 476 747 343 747 q 671 635 618 747 q 891 747 748 747 q 1069 678 1010 747 q 1127 469 1127 608 l 1127 0 l 930 0 l 930 468 q 906 559 930 530 q 820 588 882 588 q 698 504 732 588 l 699 0 l 503 0 l 503 467 q 477 559 503 531 q 392 588 452 588 q 271 519 309 588 l 271 0 l 75 0 l 75 734 l 259 734 m 653 1042 l 867 1042 l 679 831 l 519 831 l 653 1042 z '
    },
    Ḁ: {
      ha: 935,
      x_min: 5,
      x_max: 930,
      o: 'm 646 203 l 289 203 l 221 0 l 5 0 l 372 987 l 561 987 l 930 0 l 714 0 l 646 203 m 344 368 l 591 368 l 467 738 l 344 368 m 471 -35 q 562 -69 526 -35 q 597 -152 597 -104 q 562 -233 597 -200 q 471 -267 526 -267 q 380 -234 417 -267 q 344 -152 344 -201 q 380 -68 344 -102 q 471 -35 417 -35 m 420 -152 q 435 -188 420 -174 q 471 -202 450 -202 q 507 -188 493 -202 q 520 -152 520 -174 q 507 -114 520 -129 q 471 -100 493 -100 q 435 -114 450 -100 q 420 -152 420 -129 z '
    },
    ḁ: {
      ha: 745,
      x_min: 46,
      x_max: 699,
      o: 'm 500 0 q 481 66 487 26 q 296 -14 410 -14 q 117 49 188 -14 q 46 206 46 111 q 133 385 46 323 q 382 448 219 448 l 473 448 l 473 490 q 447 572 473 541 q 364 602 420 602 q 287 578 315 602 q 258 513 258 555 l 62 513 q 102 631 62 577 q 213 716 141 686 q 374 747 285 747 q 590 679 510 747 q 669 488 669 611 l 669 170 q 699 12 670 65 l 699 0 l 500 0 m 338 136 q 418 156 382 136 q 473 208 455 175 l 473 334 l 399 334 q 243 232 252 334 l 242 220 q 268 160 242 184 q 338 136 294 136 m 321 -28 q 411 -62 376 -28 q 446 -145 446 -97 q 411 -227 446 -193 q 321 -260 376 -260 q 230 -227 267 -260 q 193 -145 193 -195 q 230 -62 193 -96 q 321 -28 267 -28 m 270 -145 q 284 -181 270 -167 q 321 -195 299 -195 q 356 -181 342 -195 q 370 -145 370 -167 q 356 -107 370 -122 q 321 -93 342 -93 q 284 -107 299 -93 q 270 -145 270 -122 z '
    },
    Ѐ: {
      ha: 781,
      x_min: 88,
      x_max: 750,
      o: 'm 682 428 l 292 428 l 292 163 l 750 163 l 750 0 l 88 0 l 88 987 l 749 987 l 749 823 l 292 823 l 292 587 l 682 587 l 682 428 m 528 1044 l 368 1044 l 180 1254 l 394 1254 l 528 1044 z '
    },
    Ѝ: {
      ha: 972,
      x_min: 81,
      x_max: 884,
      o: 'm 680 987 l 884 987 l 884 0 l 680 0 l 680 656 l 285 0 l 81 0 l 81 987 l 285 987 l 285 330 l 680 987 m 582 1044 l 421 1044 l 234 1254 l 448 1254 l 582 1044 z '
    },
    ѐ: {
      ha: 751,
      x_min: 49,
      x_max: 715,
      o: 'm 413 -14 q 150 85 252 -14 q 49 349 49 184 l 49 368 q 92 566 49 479 q 213 700 134 653 q 391 747 291 747 q 628 652 542 747 q 715 383 715 557 l 715 303 l 248 303 q 305 188 257 231 q 426 144 353 144 q 603 227 539 144 l 699 119 q 580 21 655 56 q 413 -14 505 -14 m 391 589 q 296 549 332 589 q 250 437 260 510 l 522 437 l 522 452 q 487 553 521 517 q 391 589 453 589 m 467 831 l 306 831 l 119 1042 l 332 1042 l 467 831 z '
    },
    ѝ: {
      ha: 788,
      x_min: 75,
      x_max: 713,
      o: 'm 517 734 l 713 734 l 713 0 l 517 0 l 517 453 l 272 0 l 75 0 l 75 734 l 272 734 l 272 281 l 517 734 m 495 828 l 334 828 l 147 1038 l 361 1038 l 495 828 z '
    },
    Ѱ: {
      ha: 1009,
      x_min: 35,
      x_max: 971,
      o: 'm 608 430 q 727 505 688 445 q 766 673 766 564 l 766 987 l 971 987 l 971 667 q 864 378 969 486 q 608 264 769 282 l 608 0 l 405 0 l 405 264 q 135 385 235 277 q 35 671 36 492 l 35 987 l 239 987 l 239 673 q 282 507 239 567 q 405 431 326 447 l 405 987 l 608 987 l 608 430 z '
    },
    ѱ: {
      ha: 1034,
      x_min: 46,
      x_max: 988,
      o: 'm 608 734 l 608 153 q 792 404 792 192 q 719 734 790 548 l 901 734 q 988 404 988 586 q 889 117 988 223 q 608 -9 791 11 l 608 -324 l 412 -324 l 412 -8 q 141 114 235 14 q 46 391 48 215 l 46 734 l 243 734 l 243 399 q 412 155 243 195 l 412 734 l 608 734 z '
    },
    Ѷ: {
      ha: 892,
      x_min: 7,
      x_max: 873,
      o: 'm 429 268 l 442 206 l 455 265 l 595 761 q 694 943 634 886 q 847 1000 755 1000 l 873 999 l 872 828 l 854 828 q 772 748 795 828 l 548 0 l 337 0 l 7 987 l 223 987 l 429 268 m 412 1048 l 250 1048 l 52 1228 l 245 1228 l 412 1048 m 642 1048 l 484 1048 l 317 1228 l 507 1228 l 642 1048 z '
    },
    ѷ: {
      ha: 709,
      x_min: -15,
      x_max: 719,
      o: 'm 327 280 l 340 208 l 353 280 l 416 521 q 505 689 449 630 q 649 747 562 747 q 719 735 693 747 l 703 580 l 669 583 q 623 562 643 583 q 593 512 602 542 l 435 0 l 248 0 l 12 734 l 216 734 l 327 280 m 345 841 l 183 841 l -15 1021 l 179 1021 l 345 841 m 575 841 l 417 841 l 251 1021 l 441 1021 l 575 841 z '
    },
    ѹ: {
      ha: 1482,
      x_min: 45,
      x_max: 1480,
      o: 'm 45 374 q 87 568 45 483 q 208 701 129 654 q 391 747 287 747 q 634 656 540 747 q 739 410 728 566 l 740 359 q 646 89 740 191 q 393 -14 551 -14 q 139 88 234 -14 q 45 365 45 190 l 45 374 m 241 359 q 280 200 241 255 q 393 144 319 144 q 504 199 464 144 q 544 374 544 254 q 504 532 544 476 q 391 589 464 589 q 280 533 319 589 q 241 359 241 477 m 1135 277 l 1270 734 l 1480 734 l 1185 -114 l 1169 -153 q 952 -296 1103 -296 q 865 -283 909 -296 l 865 -135 l 895 -136 q 978 -119 951 -136 q 1021 -62 1006 -102 l 1044 -2 l 787 734 l 998 734 l 1135 277 z '
    },
    Ѹ: {
      ha: 1656,
      x_min: 58,
      x_max: 1654,
      o: 'm 899 471 q 848 216 899 326 q 700 46 796 106 q 480 -14 604 -14 q 261 45 357 -14 q 112 214 165 104 q 58 466 59 323 l 58 515 q 111 771 58 661 q 259 942 163 882 q 479 1001 355 1001 q 698 942 602 1001 q 847 771 794 882 q 899 515 899 661 l 899 471 m 693 516 q 637 752 693 671 q 479 833 582 833 q 321 753 376 833 q 264 519 265 673 l 264 471 q 320 237 264 320 q 480 153 376 153 q 637 234 583 153 q 693 468 692 314 l 693 516 m 1308 277 l 1444 734 l 1654 734 l 1359 -114 l 1343 -153 q 1126 -296 1277 -296 q 1039 -283 1083 -296 l 1039 -135 l 1069 -136 q 1152 -119 1124 -136 q 1195 -62 1179 -102 l 1218 -2 l 961 734 l 1172 734 l 1308 277 z '
    },
    Ҙ: {
      ha: 857,
      x_min: 45,
      x_max: 795,
      o: 'm 575 715 q 531 804 575 772 q 414 836 487 836 q 306 804 349 836 q 263 720 263 772 l 60 720 q 105 864 60 800 q 233 964 150 928 q 414 1000 316 1000 q 682 927 585 1000 q 779 720 779 854 q 740 597 779 654 q 627 507 700 541 q 751 421 708 479 q 795 277 795 363 q 691 65 795 144 q 414 -13 587 -13 q 220 24 307 -13 q 90 125 134 61 q 45 274 45 189 l 250 274 q 296 185 250 221 q 414 150 342 150 q 543 186 496 150 q 590 279 590 223 q 548 390 590 357 q 425 424 506 424 l 304 424 l 304 583 l 429 583 q 575 715 575 585 m 522 -326 l 326 -326 l 326 56 l 522 56 l 522 -326 z '
    },
    ҙ: {
      ha: 713,
      x_min: 47,
      x_max: 669,
      o: 'm 460 517 q 435 577 460 556 q 363 599 410 599 q 284 579 315 599 q 254 522 254 559 l 58 522 q 141 684 58 622 q 353 747 224 747 q 575 691 494 747 q 656 533 656 635 q 627 443 656 484 q 544 378 597 402 q 669 208 669 334 q 583 46 669 106 q 353 -14 496 -14 q 133 49 219 -14 q 47 217 47 111 l 243 217 q 276 157 243 180 q 363 134 309 134 q 444 158 415 134 q 473 222 473 182 q 446 291 473 270 q 362 311 418 311 l 256 311 l 256 439 l 369 439 q 460 517 460 441 m 459 -325 l 263 -325 l 263 56 l 459 56 l 459 -325 z '
    },
    Ҫ: {
      ha: 909,
      x_min: 58,
      x_max: 865,
      o: 'm 863 329 q 746 78 852 170 q 466 -14 640 -14 q 167 114 276 -14 q 58 465 58 242 l 58 526 q 109 777 58 668 q 252 943 159 885 q 469 1001 345 1001 q 744 909 640 1001 q 865 652 848 818 l 661 652 q 608 791 654 748 q 469 834 562 834 q 316 761 367 834 q 264 535 266 688 l 264 460 q 313 227 264 300 q 466 153 361 153 q 607 196 560 153 q 660 329 653 239 l 863 329 m 563 -320 l 367 -320 l 367 61 l 563 61 l 563 -320 z '
    },
    ҫ: {
      ha: 724,
      x_min: 45,
      x_max: 688,
      o: 'm 380 144 q 469 174 435 144 q 504 254 503 204 l 688 254 q 647 117 687 179 q 537 21 607 55 q 384 -14 468 -14 q 136 86 227 -14 q 45 363 45 186 l 45 376 q 135 646 45 545 q 382 747 225 747 q 603 669 520 747 q 688 460 686 591 l 504 460 q 469 553 503 517 q 379 589 435 589 q 276 539 311 589 q 241 377 241 489 l 241 357 q 275 194 241 243 q 380 144 310 144 m 474 -320 l 278 -320 l 278 61 l 474 61 l 474 -320 z '
    },
    Ү: {
      ha: 859,
      x_min: 1,
      x_max: 857,
      o: 'm 429 543 l 634 987 l 857 987 l 532 358 l 532 0 l 326 0 l 326 358 l 1 987 l 224 987 l 429 543 z '
    },
    ү: {
      ha: 709,
      x_min: 12,
      x_max: 699,
      o: 'm 357 231 l 494 734 l 699 734 l 452 9 l 452 -283 l 256 -283 l 256 16 l 12 734 l 216 734 l 357 231 z '
    },
    Ӏ: {
      ha: 405,
      x_min: 101,
      x_max: 304,
      o: 'm 304 0 l 101 0 l 101 987 l 304 987 l 304 0 z '
    },
    Ӂ: {
      ha: 1385,
      x_min: 12,
      x_max: 1385,
      o: 'm 921 402 l 804 402 l 804 0 l 600 0 l 600 402 l 480 402 l 265 0 l 12 0 l 319 530 l 26 987 l 279 987 l 499 589 l 600 589 l 600 987 l 804 987 l 804 589 l 903 589 l 1117 987 l 1369 987 l 1082 530 l 1385 0 l 1131 0 l 921 402 m 930 1247 q 865 1101 930 1157 q 695 1046 800 1046 q 525 1101 590 1046 q 460 1247 460 1156 l 600 1247 q 625 1181 600 1204 q 695 1158 650 1158 q 764 1181 739 1158 q 789 1247 789 1204 l 930 1247 z '
    },
    ӂ: {
      ha: 1186,
      x_min: 26,
      x_max: 1168,
      o: 'm 781 272 l 692 272 l 692 0 l 496 0 l 496 272 l 409 272 l 263 0 l 26 0 l 258 384 l 29 734 l 272 734 l 425 460 l 496 460 l 496 734 l 692 734 l 692 460 l 766 460 l 919 734 l 1162 734 l 935 389 l 1168 0 l 927 0 l 781 272 m 836 1031 q 771 886 836 941 q 601 830 706 830 q 431 885 496 830 q 366 1031 366 940 l 505 1031 q 531 965 505 989 q 601 942 556 942 q 670 965 645 942 q 695 1031 695 989 l 836 1031 z '
    },
    ӏ: {
      ha: 405,
      x_min: 101,
      x_max: 304,
      o: 'm 304 0 l 101 0 l 101 987 l 304 987 l 304 0 z '
    },
    Ӑ: {
      ha: 935,
      x_min: 5,
      x_max: 930,
      o: 'm 646 203 l 289 203 l 221 0 l 5 0 l 372 987 l 561 987 l 930 0 l 714 0 l 646 203 m 344 368 l 591 368 l 467 738 l 344 368 m 705 1245 q 640 1099 705 1155 q 470 1044 575 1044 q 300 1099 365 1044 q 235 1245 235 1154 l 374 1245 q 400 1179 374 1202 q 470 1156 425 1156 q 539 1179 514 1156 q 564 1245 564 1202 l 705 1245 z '
    },
    ӑ: {
      ha: 745,
      x_min: 46,
      x_max: 699,
      o: 'm 500 0 q 481 66 487 26 q 296 -14 410 -14 q 117 49 188 -14 q 46 206 46 111 q 133 385 46 323 q 382 448 219 448 l 473 448 l 473 490 q 447 572 473 541 q 364 602 420 602 q 287 578 315 602 q 258 513 258 555 l 62 513 q 102 631 62 577 q 213 716 141 686 q 374 747 285 747 q 590 679 510 747 q 669 488 669 611 l 669 170 q 699 12 670 65 l 699 0 l 500 0 m 338 136 q 418 156 382 136 q 473 208 455 175 l 473 334 l 399 334 q 243 232 252 334 l 242 220 q 268 160 242 184 q 338 136 294 136 m 609 1035 q 544 889 609 945 q 374 833 479 833 q 204 888 269 833 q 140 1035 140 943 l 279 1035 q 304 969 279 992 q 374 945 330 945 q 444 969 418 945 q 469 1035 469 992 l 609 1035 z '
    },
    Ӓ: {
      ha: 935,
      x_min: 5,
      x_max: 930,
      o: 'm 646 203 l 289 203 l 221 0 l 5 0 l 372 987 l 561 987 l 930 0 l 714 0 l 646 203 m 344 368 l 591 368 l 467 738 l 344 368 m 398 1136 q 372 1075 398 1100 q 304 1050 345 1050 q 236 1076 262 1050 q 210 1136 210 1101 q 236 1197 210 1171 q 304 1222 262 1222 q 372 1197 346 1222 q 398 1136 398 1171 m 541 1136 q 568 1197 541 1173 q 635 1222 595 1222 q 702 1197 675 1222 q 728 1136 728 1172 q 703 1075 728 1101 q 635 1050 677 1050 q 567 1075 593 1050 q 541 1136 541 1101 z '
    },
    ӓ: {
      ha: 745,
      x_min: 46,
      x_max: 699,
      o: 'm 500 0 q 481 66 487 26 q 296 -14 410 -14 q 117 49 188 -14 q 46 206 46 111 q 133 385 46 323 q 382 448 219 448 l 473 448 l 473 490 q 447 572 473 541 q 364 602 420 602 q 287 578 315 602 q 258 513 258 555 l 62 513 q 102 631 62 577 q 213 716 141 686 q 374 747 285 747 q 590 679 510 747 q 669 488 669 611 l 669 170 q 699 12 670 65 l 699 0 l 500 0 m 338 136 q 418 156 382 136 q 473 208 455 175 l 473 334 l 399 334 q 243 232 252 334 l 242 220 q 268 160 242 184 q 338 136 294 136 m 302 926 q 276 865 302 890 q 208 840 250 840 q 140 865 166 840 q 115 926 115 890 q 140 986 115 961 q 208 1012 166 1012 q 276 986 250 1012 q 302 926 302 961 m 445 926 q 472 987 445 962 q 539 1012 500 1012 q 606 987 579 1012 q 633 926 633 962 q 607 865 633 890 q 539 840 581 840 q 471 865 497 840 q 445 926 445 890 z '
    },
    Ӕ: {
      ha: 1305,
      x_min: 1,
      x_max: 1265,
      o: 'm 1265 0 l 656 0 l 647 226 l 345 226 l 231 0 l 1 0 l 534 987 l 1223 987 l 1223 827 l 818 827 l 828 587 l 1168 587 l 1168 427 l 835 427 l 846 159 l 1265 159 l 1265 0 m 429 393 l 640 393 l 624 780 l 429 393 z '
    },
    ӕ: {
      ha: 1173,
      x_min: 45,
      x_max: 1137,
      o: 'm 845 -14 q 583 86 677 -14 q 470 13 540 39 q 316 -14 401 -14 q 117 47 190 -14 q 45 216 45 107 q 129 381 45 323 q 378 440 213 439 l 492 440 l 492 479 q 464 559 492 530 q 385 589 437 589 q 297 565 329 589 q 264 505 264 541 l 68 518 q 157 683 68 619 q 387 747 245 747 q 608 673 530 747 q 829 747 694 749 q 1055 658 973 747 q 1137 412 1137 569 l 1137 305 l 684 305 q 739 185 692 227 q 865 144 786 144 q 962 155 918 144 q 1065 196 1006 165 l 1118 68 q 995 8 1068 30 q 845 -14 922 -14 m 353 130 q 426 145 387 130 q 492 184 465 161 l 492 313 l 380 313 q 278 283 316 312 q 241 214 241 255 q 268 153 241 176 q 353 130 296 130 m 829 589 q 731 550 768 589 q 686 437 694 511 l 945 437 l 945 456 q 915 554 945 519 q 829 589 886 589 z '
    },
    Ӗ: {
      ha: 781,
      x_min: 88,
      x_max: 750,
      o: 'm 682 428 l 292 428 l 292 163 l 750 163 l 750 0 l 88 0 l 88 987 l 749 987 l 749 823 l 292 823 l 292 587 l 682 587 l 682 428 m 666 1247 q 601 1101 666 1157 q 431 1046 536 1046 q 261 1101 326 1046 q 197 1247 197 1156 l 336 1247 q 361 1181 336 1204 q 431 1158 387 1158 q 500 1181 475 1158 q 526 1247 526 1204 l 666 1247 z '
    },
    ӗ: {
      ha: 751,
      x_min: 49,
      x_max: 715,
      o: 'm 413 -14 q 150 85 252 -14 q 49 349 49 184 l 49 368 q 92 566 49 479 q 213 700 134 653 q 391 747 291 747 q 628 652 542 747 q 715 383 715 557 l 715 303 l 248 303 q 305 188 257 231 q 426 144 353 144 q 603 227 539 144 l 699 119 q 580 21 655 56 q 413 -14 505 -14 m 391 589 q 296 549 332 589 q 250 437 260 510 l 522 437 l 522 452 q 487 553 521 517 q 391 589 453 589 m 604 1035 q 539 889 604 945 q 370 833 475 833 q 200 888 264 833 q 135 1035 135 943 l 274 1035 q 299 969 274 992 q 370 945 325 945 q 439 969 414 945 q 464 1035 464 992 l 604 1035 z '
    },
    Ӛ: {
      ha: 965,
      x_min: 51,
      x_max: 899,
      o: 'm 420 1001 q 772 878 646 1001 q 899 536 899 754 l 899 441 q 844 207 899 312 q 691 44 789 102 q 475 -14 593 -14 q 162 108 274 -14 q 51 455 51 229 l 51 560 l 695 560 q 621 755 690 688 q 420 823 551 823 q 158 780 282 823 l 125 947 q 258 987 178 972 q 420 1001 338 1001 m 475 163 q 623 224 566 163 q 693 395 681 286 l 254 395 l 254 374 q 311 217 254 271 q 475 163 368 163 m 373 1106 q 347 1045 373 1070 q 279 1021 320 1021 q 211 1046 237 1021 q 185 1106 185 1071 q 211 1167 185 1141 q 279 1192 237 1192 q 347 1167 321 1192 q 373 1106 373 1141 m 515 1106 q 543 1167 515 1143 q 610 1192 570 1192 q 676 1167 650 1192 q 703 1106 703 1142 q 677 1045 703 1071 q 610 1020 652 1020 q 542 1045 568 1020 q 515 1106 515 1071 z '
    },
    ә: {
      ha: 735,
      x_min: 53,
      x_max: 695,
      o: 'm 347 748 q 598 648 501 748 q 695 382 695 548 l 695 362 q 654 168 695 254 q 537 34 613 81 q 365 -13 462 -14 q 136 75 218 -13 q 53 321 53 163 l 53 429 l 496 429 q 441 547 486 505 q 327 590 397 590 q 163 557 232 590 l 123 537 l 69 664 q 192 726 119 703 q 347 748 265 748 m 365 145 q 450 184 417 145 q 494 295 484 222 l 245 295 l 245 277 q 277 179 245 212 q 365 145 308 145 z '
    },
    ӛ: {
      ha: 735,
      x_min: 53,
      x_max: 695,
      o: 'm 347 748 q 598 648 501 748 q 695 382 695 548 l 695 362 q 654 168 695 254 q 537 34 613 81 q 365 -13 462 -14 q 136 75 218 -13 q 53 321 53 163 l 53 429 l 496 429 q 441 547 486 505 q 327 590 397 590 q 163 557 232 590 l 123 537 l 69 664 q 192 726 119 703 q 347 748 265 748 m 365 145 q 450 184 417 145 q 494 295 484 222 l 245 295 l 245 277 q 277 179 245 212 q 365 145 308 145 m 299 926 q 273 866 299 890 q 205 841 246 841 q 137 866 163 841 q 111 926 111 891 q 137 987 111 962 q 205 1013 163 1013 q 273 987 247 1013 q 299 926 299 962 m 441 926 q 469 988 441 963 q 536 1013 496 1013 q 603 987 576 1013 q 629 926 629 962 q 604 866 629 891 q 536 840 578 840 q 468 866 494 840 q 441 926 441 891 z '
    },
    Ӝ: {
      ha: 1385,
      x_min: 12,
      x_max: 1385,
      o: 'm 921 402 l 804 402 l 804 0 l 600 0 l 600 402 l 480 402 l 265 0 l 12 0 l 319 530 l 26 987 l 279 987 l 499 589 l 600 589 l 600 987 l 804 987 l 804 589 l 903 589 l 1117 987 l 1369 987 l 1082 530 l 1385 0 l 1131 0 l 921 402 m 623 1138 q 597 1077 623 1102 q 529 1053 570 1053 q 461 1078 487 1053 q 435 1138 435 1103 q 461 1199 435 1173 q 529 1224 487 1224 q 597 1199 571 1224 q 623 1138 623 1173 m 766 1138 q 793 1199 766 1175 q 860 1224 821 1224 q 927 1199 900 1224 q 954 1138 954 1174 q 928 1077 954 1103 q 860 1052 902 1052 q 792 1077 818 1052 q 766 1138 766 1103 z '
    },
    ӝ: {
      ha: 1186,
      x_min: 26,
      x_max: 1168,
      o: 'm 781 272 l 692 272 l 692 0 l 496 0 l 496 272 l 409 272 l 263 0 l 26 0 l 258 384 l 29 734 l 272 734 l 425 460 l 496 460 l 496 734 l 692 734 l 692 460 l 766 460 l 919 734 l 1162 734 l 935 389 l 1168 0 l 927 0 l 781 272 m 529 922 q 503 862 529 886 q 435 837 476 837 q 367 862 393 837 q 341 922 341 887 q 367 983 341 958 q 435 1008 393 1008 q 503 983 477 1008 q 529 922 529 958 m 671 922 q 699 984 671 959 q 766 1008 726 1008 q 832 983 806 1008 q 859 922 859 958 q 833 862 859 887 q 766 836 808 836 q 697 862 724 836 q 671 922 671 887 z '
    },
    Ӟ: {
      ha: 857,
      x_min: 45,
      x_max: 795,
      o: 'm 575 715 q 531 804 575 772 q 414 836 487 836 q 306 804 349 836 q 263 720 263 772 l 60 720 q 105 864 60 800 q 233 964 150 928 q 414 1000 316 1000 q 682 927 585 1000 q 779 720 779 854 q 740 597 779 654 q 627 507 700 541 q 751 421 708 479 q 795 277 795 363 q 691 65 795 144 q 414 -13 587 -13 q 220 24 307 -13 q 90 125 134 61 q 45 274 45 189 l 250 274 q 296 185 250 221 q 414 150 342 150 q 543 186 496 150 q 590 279 590 223 q 548 390 590 357 q 425 424 506 424 l 304 424 l 304 583 l 429 583 q 575 715 575 585 m 348 1141 q 321 1081 348 1105 q 254 1056 295 1056 q 186 1081 212 1056 q 160 1141 160 1106 q 186 1202 160 1177 q 254 1227 212 1227 q 322 1202 296 1227 q 348 1141 348 1177 m 490 1141 q 518 1203 490 1178 q 585 1227 545 1227 q 651 1202 625 1227 q 678 1141 678 1177 q 652 1081 678 1106 q 585 1055 627 1055 q 516 1081 543 1055 q 490 1141 490 1106 z '
    },
    ӟ: {
      ha: 713,
      x_min: 47,
      x_max: 669,
      o: 'm 460 517 q 435 577 460 556 q 363 599 410 599 q 284 579 315 599 q 254 522 254 559 l 58 522 q 141 684 58 622 q 353 747 224 747 q 575 691 494 747 q 656 533 656 635 q 627 443 656 484 q 544 378 597 402 q 669 208 669 334 q 583 46 669 106 q 353 -14 496 -14 q 133 49 219 -14 q 47 217 47 111 l 243 217 q 276 157 243 180 q 363 134 309 134 q 444 158 415 134 q 473 222 473 182 q 446 291 473 270 q 362 311 418 311 l 256 311 l 256 439 l 369 439 q 460 517 460 441 m 290 926 q 263 865 290 890 q 195 840 237 840 q 127 865 153 840 q 102 926 102 890 q 127 986 102 961 q 195 1012 153 1012 q 263 986 237 1012 q 290 926 290 961 m 432 926 q 459 987 432 962 q 526 1012 487 1012 q 593 987 566 1012 q 620 926 620 962 q 594 865 620 890 q 526 840 568 840 q 458 865 484 840 q 432 926 432 890 z '
    },
    Ӣ: {
      ha: 972,
      x_min: 81,
      x_max: 884,
      o: 'm 680 987 l 884 987 l 884 0 l 680 0 l 680 656 l 285 0 l 81 0 l 81 987 l 285 987 l 285 330 l 680 987 m 720 1084 l 252 1084 l 252 1197 l 720 1197 l 720 1084 z '
    },
    ӣ: {
      ha: 788,
      x_min: 75,
      x_max: 713,
      o: 'm 517 734 l 713 734 l 713 0 l 517 0 l 517 453 l 272 0 l 75 0 l 75 734 l 272 734 l 272 281 l 517 734 m 633 868 l 165 868 l 165 981 l 633 981 l 633 868 z '
    },
    Ӥ: {
      ha: 972,
      x_min: 81,
      x_max: 884,
      o: 'm 680 987 l 884 987 l 884 0 l 680 0 l 680 656 l 285 0 l 81 0 l 81 987 l 285 987 l 285 330 l 680 987 m 413 1138 q 387 1077 413 1102 q 319 1053 360 1053 q 251 1078 277 1053 q 225 1138 225 1103 q 251 1199 225 1173 q 319 1224 277 1224 q 387 1199 361 1224 q 413 1138 413 1173 m 555 1138 q 583 1199 555 1175 q 650 1224 610 1224 q 716 1199 690 1224 q 743 1138 743 1174 q 718 1077 743 1103 q 650 1052 692 1052 q 582 1077 608 1052 q 555 1138 555 1103 z '
    },
    ӥ: {
      ha: 788,
      x_min: 75,
      x_max: 713,
      o: 'm 517 734 l 713 734 l 713 0 l 517 0 l 517 453 l 272 0 l 75 0 l 75 734 l 272 734 l 272 281 l 517 734 m 326 922 q 300 862 326 886 q 232 837 273 837 q 164 862 190 837 q 138 922 138 887 q 164 983 138 958 q 232 1008 190 1008 q 300 983 274 1008 q 326 922 326 958 m 469 922 q 496 984 469 959 q 563 1008 524 1008 q 630 983 603 1008 q 656 922 656 958 q 631 862 656 887 q 563 836 605 836 q 495 862 521 836 q 469 922 469 887 z '
    },
    Ӧ: {
      ha: 959,
      x_min: 58,
      x_max: 899,
      o: 'm 899 471 q 848 216 899 326 q 700 46 796 106 q 480 -14 604 -14 q 261 45 357 -14 q 112 214 165 104 q 58 466 59 323 l 58 515 q 111 771 58 661 q 259 942 163 882 q 479 1001 355 1001 q 698 942 602 1001 q 847 771 794 882 q 899 515 899 661 l 899 471 m 693 516 q 637 752 693 671 q 479 833 582 833 q 321 753 376 833 q 264 519 265 673 l 264 471 q 320 237 264 320 q 480 153 376 153 q 637 234 583 153 q 693 468 692 314 l 693 516 m 408 1136 q 381 1075 408 1100 q 313 1050 355 1050 q 245 1076 271 1050 q 220 1136 220 1101 q 245 1197 220 1171 q 313 1222 271 1222 q 381 1197 355 1222 q 408 1136 408 1171 m 550 1136 q 577 1197 550 1173 q 644 1222 605 1222 q 711 1197 684 1222 q 738 1136 738 1172 q 712 1075 738 1101 q 644 1050 686 1050 q 576 1075 602 1050 q 550 1136 550 1101 z '
    },
    ӧ: {
      ha: 785,
      x_min: 45,
      x_max: 740,
      o: 'm 45 374 q 87 568 45 483 q 208 701 129 654 q 391 747 287 747 q 634 656 540 747 q 739 410 728 566 l 740 359 q 646 89 740 191 q 393 -14 551 -14 q 139 88 234 -14 q 45 365 45 190 l 45 374 m 241 359 q 280 200 241 255 q 393 144 319 144 q 504 199 464 144 q 544 374 544 254 q 504 532 544 476 q 391 589 464 589 q 280 533 319 589 q 241 359 241 477 m 319 926 q 293 865 319 890 q 225 840 267 840 q 157 865 183 840 q 132 926 132 890 q 157 986 132 961 q 225 1012 183 1012 q 293 986 267 1012 q 319 926 319 961 m 462 926 q 489 987 462 962 q 556 1012 517 1012 q 623 987 596 1012 q 650 926 650 962 q 624 865 650 890 q 556 840 598 840 q 488 865 514 840 q 462 926 462 890 z '
    },
    Ө: {
      ha: 956,
      x_min: 61,
      x_max: 902,
      o: 'm 902 471 q 850 216 902 326 q 703 46 799 106 q 483 -14 607 -14 q 264 45 360 -14 q 115 214 168 104 q 61 466 62 323 l 61 515 q 114 771 61 661 q 262 942 166 882 q 481 1001 358 1001 q 701 942 605 1001 q 849 771 797 882 q 902 515 902 661 l 902 471 m 483 153 q 634 225 579 153 q 695 434 688 297 l 268 434 q 331 225 275 297 q 483 153 386 153 m 481 833 q 331 763 385 833 q 269 557 276 692 l 695 557 q 632 763 688 692 q 481 833 577 833 z '
    },
    ө: {
      ha: 784,
      x_min: 43,
      x_max: 739,
      o: 'm 43 374 q 86 569 43 484 q 208 701 128 654 q 391 747 287 747 q 644 645 549 747 q 739 367 739 543 l 739 359 q 696 164 739 250 q 575 33 654 79 q 392 -14 497 -14 q 146 81 240 -14 q 44 335 52 175 l 43 374 m 391 589 q 290 546 329 589 q 243 427 252 503 l 539 427 q 491 547 530 506 q 391 589 453 589 m 392 144 q 491 185 454 144 q 539 302 528 225 l 243 302 q 290 186 252 227 q 392 144 328 144 z '
    },
    Ӫ: {
      ha: 956,
      x_min: 61,
      x_max: 902,
      o: 'm 902 471 q 850 216 902 326 q 703 46 799 106 q 483 -14 607 -14 q 264 45 360 -14 q 115 214 168 104 q 61 466 62 323 l 61 515 q 114 771 61 661 q 262 942 166 882 q 481 1001 358 1001 q 701 942 605 1001 q 849 771 797 882 q 902 515 902 661 l 902 471 m 483 153 q 634 225 579 153 q 695 434 688 297 l 268 434 q 331 225 275 297 q 483 153 386 153 m 481 833 q 331 763 385 833 q 269 557 276 692 l 695 557 q 632 763 688 692 q 481 833 577 833 m 420 1137 q 393 1076 420 1101 q 326 1051 367 1051 q 258 1076 283 1051 q 232 1137 232 1101 q 258 1197 232 1172 q 326 1223 283 1223 q 394 1197 368 1223 q 420 1137 420 1172 m 562 1137 q 590 1198 562 1173 q 656 1223 617 1223 q 723 1198 696 1223 q 750 1137 750 1173 q 724 1076 750 1101 q 656 1050 699 1050 q 588 1076 614 1050 q 562 1137 562 1101 z '
    },
    ӫ: {
      ha: 784,
      x_min: 43,
      x_max: 739,
      o: 'm 43 374 q 86 569 43 484 q 208 701 128 654 q 391 747 287 747 q 644 645 549 747 q 739 367 739 543 l 739 359 q 696 164 739 250 q 575 33 654 79 q 392 -14 497 -14 q 146 81 240 -14 q 44 335 52 175 l 43 374 m 391 589 q 290 546 329 589 q 243 427 252 503 l 539 427 q 491 547 530 506 q 391 589 453 589 m 392 144 q 491 185 454 144 q 539 302 528 225 l 243 302 q 290 186 252 227 q 392 144 328 144 m 313 926 q 287 865 313 890 q 219 840 260 840 q 151 865 177 840 q 125 926 125 890 q 151 986 125 961 q 219 1012 177 1012 q 287 986 261 1012 q 313 926 313 961 m 456 926 q 483 987 456 962 q 550 1012 511 1012 q 617 987 590 1012 q 644 926 644 962 q 618 865 644 890 q 550 840 592 840 q 482 865 508 840 q 456 926 456 890 z '
    },
    Ӭ: {
      ha: 903,
      x_min: 42,
      x_max: 848,
      o: 'm 246 328 q 302 191 255 233 q 440 149 350 149 q 588 215 540 149 q 644 411 636 281 l 332 411 l 332 576 l 643 576 q 584 772 635 708 q 437 836 532 836 q 299 792 345 836 q 245 652 253 749 l 42 652 q 160 907 57 814 q 437 1001 264 1001 q 654 943 561 1001 q 798 777 747 885 q 848 525 848 669 l 848 460 q 739 114 848 242 q 440 -14 630 -14 q 160 79 265 -14 q 43 328 54 172 l 246 328 m 373 1142 q 347 1081 373 1106 q 279 1057 320 1057 q 211 1082 237 1057 q 185 1142 185 1107 q 211 1203 185 1177 q 279 1228 237 1228 q 347 1203 321 1228 q 373 1142 373 1177 m 515 1142 q 543 1203 515 1179 q 610 1228 570 1228 q 676 1203 650 1228 q 703 1142 703 1178 q 677 1081 703 1107 q 610 1056 652 1056 q 542 1081 568 1056 q 515 1142 515 1107 z '
    },
    ӭ: {
      ha: 722,
      x_min: 43,
      x_max: 682,
      o: 'm 342 589 q 258 559 290 589 q 227 480 227 530 l 43 480 q 82 616 43 555 q 191 713 122 678 q 342 747 260 747 q 590 646 498 747 q 682 370 682 545 l 682 357 q 642 164 682 248 q 524 33 601 79 q 344 -14 447 -14 q 125 64 208 -14 q 43 273 43 142 l 227 273 q 259 180 227 216 q 344 144 290 144 q 439 185 403 144 q 483 309 475 227 l 286 309 l 286 429 l 483 429 q 342 589 463 589 m 284 926 q 258 865 284 890 q 190 840 231 840 q 122 865 148 840 q 96 926 96 890 q 122 986 96 961 q 190 1012 148 1012 q 258 986 232 1012 q 284 926 284 961 m 427 926 q 454 987 427 962 q 521 1012 481 1012 q 588 987 561 1012 q 614 926 614 962 q 589 865 614 890 q 521 840 563 840 q 453 865 479 840 q 427 926 427 890 z '
    },
    Ӯ: {
      ha: 877,
      x_min: 21,
      x_max: 858,
      o: 'm 458 521 l 638 987 l 858 987 l 513 173 l 485 119 q 250 -14 408 -14 l 179 -12 l 177 152 q 230 149 193 149 q 299 164 273 149 q 342 219 325 179 l 368 283 l 21 987 l 240 987 l 458 521 m 688 1084 l 220 1084 l 220 1197 l 688 1197 l 688 1084 z '
    },
    ӯ: {
      ha: 697,
      x_min: 2,
      x_max: 695,
      o: 'm 349 277 l 485 734 l 695 734 l 400 -114 l 384 -153 q 167 -296 318 -296 q 80 -283 124 -296 l 80 -135 l 110 -136 q 193 -119 165 -136 q 236 -62 220 -102 l 259 -2 l 2 734 l 213 734 l 349 277 m 588 872 l 120 872 l 120 985 l 588 985 l 588 872 z '
    },
    Ӱ: {
      ha: 877,
      x_min: 21,
      x_max: 858,
      o: 'm 458 521 l 638 987 l 858 987 l 513 173 l 485 119 q 250 -14 408 -14 l 179 -12 l 177 152 q 230 149 193 149 q 299 164 273 149 q 342 219 325 179 l 368 283 l 21 987 l 240 987 l 458 521 m 382 1138 q 355 1077 382 1102 q 288 1053 329 1053 q 220 1078 245 1053 q 194 1138 194 1103 q 220 1199 194 1173 q 288 1224 245 1224 q 356 1199 330 1224 q 382 1138 382 1173 m 524 1138 q 552 1199 524 1175 q 618 1224 579 1224 q 685 1199 659 1224 q 712 1138 712 1174 q 686 1077 712 1103 q 618 1052 661 1052 q 550 1077 576 1052 q 524 1138 524 1103 z '
    },
    ӱ: {
      ha: 697,
      x_min: 2,
      x_max: 695,
      o: 'm 349 277 l 485 734 l 695 734 l 400 -114 l 384 -153 q 167 -296 318 -296 q 80 -283 124 -296 l 80 -135 l 110 -136 q 193 -119 165 -136 q 236 -62 220 -102 l 259 -2 l 2 734 l 213 734 l 349 277 m 281 926 q 255 865 281 890 q 187 840 229 840 q 119 865 145 840 q 94 926 94 890 q 119 986 94 961 q 187 1012 145 1012 q 255 986 229 1012 q 281 926 281 961 m 424 926 q 451 987 424 962 q 518 1012 479 1012 q 585 987 558 1012 q 612 926 612 962 q 586 865 612 890 q 518 840 560 840 q 450 865 476 840 q 424 926 424 890 z '
    },
    Ӳ: {
      ha: 877,
      x_min: 21,
      x_max: 858,
      o: 'm 458 521 l 638 987 l 858 987 l 513 173 l 485 119 q 250 -14 408 -14 l 179 -12 l 177 152 q 230 149 193 149 q 299 164 273 149 q 342 219 325 179 l 368 283 l 21 987 l 240 987 l 458 521 m 637 1253 l 813 1253 l 633 1049 l 485 1049 l 637 1253 m 372 1253 l 545 1253 l 390 1049 l 246 1049 l 372 1253 z '
    },
    ӳ: {
      ha: 697,
      x_min: 2,
      x_max: 713,
      o: 'm 349 277 l 485 734 l 695 734 l 400 -114 l 384 -153 q 167 -296 318 -296 q 80 -283 124 -296 l 80 -135 l 110 -136 q 193 -119 165 -136 q 236 -62 220 -102 l 259 -2 l 2 734 l 213 734 l 349 277 m 537 1041 l 713 1041 l 532 837 l 385 837 l 537 1041 m 272 1041 l 445 1041 l 290 837 l 146 837 l 272 1041 z '
    },
    Ӵ: {
      ha: 966,
      x_min: 93,
      x_max: 876,
      o: 'm 876 987 l 876 0 l 672 0 l 672 374 q 478 355 579 355 q 193 437 290 355 q 93 674 96 519 l 93 987 l 297 987 l 297 678 q 338 556 298 593 q 478 519 378 519 q 672 538 579 519 l 672 987 l 876 987 m 439 1138 q 412 1077 439 1102 q 345 1053 386 1053 q 277 1078 302 1053 q 251 1138 251 1103 q 277 1199 251 1173 q 345 1224 302 1224 q 413 1199 387 1224 q 439 1138 439 1173 m 581 1138 q 609 1199 581 1175 q 675 1224 636 1224 q 742 1199 715 1224 q 769 1138 769 1174 q 743 1077 769 1103 q 675 1052 718 1052 q 607 1077 633 1052 q 581 1138 581 1103 z '
    },
    ӵ: {
      ha: 769,
      x_min: 60,
      x_max: 694,
      o: 'm 694 0 l 498 0 l 498 231 q 395 220 443 220 q 145 291 229 220 q 60 497 61 361 l 60 734 l 256 734 l 256 497 q 287 406 256 433 q 395 378 317 378 q 498 390 444 378 l 498 734 l 694 734 l 694 0 m 319 922 q 292 862 319 886 q 224 837 266 837 q 157 862 182 837 q 131 922 131 887 q 157 983 131 958 q 224 1008 182 1008 q 293 983 267 1008 q 319 922 319 958 m 461 922 q 489 984 461 959 q 555 1008 516 1008 q 622 983 595 1008 q 649 922 649 958 q 623 862 649 887 q 555 836 597 836 q 487 862 513 836 q 461 922 461 887 z '
    },
    Ӹ: {
      ha: 1211,
      x_min: 90,
      x_max: 1120,
      o: 'm 295 631 l 454 631 q 730 547 628 631 q 832 319 832 463 q 731 89 832 176 q 461 0 629 1 l 90 0 l 90 987 l 295 987 l 295 631 m 295 467 l 295 163 l 457 163 q 582 206 535 163 q 628 321 628 249 q 584 427 628 388 q 462 467 539 466 l 295 467 m 1120 0 l 917 0 l 917 987 l 1120 987 l 1120 0 m 540 1138 q 513 1077 540 1102 q 446 1053 487 1053 q 378 1078 404 1053 q 352 1138 352 1103 q 378 1199 352 1173 q 446 1224 404 1224 q 514 1199 488 1224 q 540 1138 540 1173 m 682 1138 q 710 1199 682 1175 q 777 1224 737 1224 q 843 1199 817 1224 q 870 1138 870 1174 q 844 1077 870 1103 q 777 1052 819 1052 q 708 1077 734 1052 q 682 1138 682 1103 z '
    },
    ӹ: {
      ha: 1149,
      x_min: 88,
      x_max: 1053,
      o: 'm 285 519 l 425 519 q 592 487 520 519 q 702 396 664 455 q 741 258 741 336 q 655 71 741 142 q 421 0 569 0 l 88 0 l 88 734 l 285 734 l 285 519 m 285 361 l 285 157 l 424 157 q 513 184 482 157 q 545 258 545 211 q 514 333 545 305 q 424 361 484 361 l 285 361 m 1053 0 l 857 0 l 857 734 l 1053 734 l 1053 0 m 508 922 q 481 862 508 886 q 414 837 455 837 q 346 862 372 837 q 320 922 320 887 q 346 983 320 958 q 414 1008 372 1008 q 482 983 456 1008 q 508 922 508 958 m 650 922 q 678 984 650 959 q 745 1008 705 1008 q 811 983 785 1008 q 838 922 838 958 q 812 862 838 887 q 745 836 787 836 q 676 862 703 836 q 650 922 650 887 z '
    },
    ԁ: {
      ha: 783,
      x_min: 45,
      x_max: 706,
      o: 'm 45 372 q 122 646 45 544 q 332 747 199 747 q 509 667 439 747 l 509 1042 l 706 1042 l 706 0 l 529 0 l 519 78 q 331 -14 446 -14 q 123 89 201 -14 q 45 372 45 191 m 241 358 q 277 200 241 255 q 381 145 313 145 q 509 222 472 145 l 509 511 q 382 588 473 588 q 241 358 241 588 z '
    },
    Ạ: {
      ha: 935,
      x_min: 5,
      x_max: 930,
      o: 'm 646 203 l 289 203 l 221 0 l 5 0 l 372 987 l 561 987 l 930 0 l 714 0 l 646 203 m 344 368 l 591 368 l 467 738 l 344 368 m 363 -155 q 394 -87 363 -114 q 473 -61 425 -61 q 552 -87 522 -61 q 583 -155 583 -114 q 552 -222 583 -195 q 473 -249 522 -249 q 393 -222 423 -249 q 363 -155 363 -195 z '
    },
    ạ: {
      ha: 745,
      x_min: 46,
      x_max: 699,
      o: 'm 500 0 q 481 66 487 26 q 296 -14 410 -14 q 117 49 188 -14 q 46 206 46 111 q 133 385 46 323 q 382 448 219 448 l 473 448 l 473 490 q 447 572 473 541 q 364 602 420 602 q 287 578 315 602 q 258 513 258 555 l 62 513 q 102 631 62 577 q 213 716 141 686 q 374 747 285 747 q 590 679 510 747 q 669 488 669 611 l 669 170 q 699 12 670 65 l 699 0 l 500 0 m 338 136 q 418 156 382 136 q 473 208 455 175 l 473 334 l 399 334 q 243 232 252 334 l 242 220 q 268 160 242 184 q 338 136 294 136 m 213 -148 q 243 -81 213 -107 q 322 -54 274 -54 q 401 -81 371 -54 q 432 -148 432 -107 q 402 -215 432 -188 q 322 -242 372 -242 q 243 -215 273 -242 q 213 -148 213 -188 z '
    },
    Ả: {
      ha: 935,
      x_min: 5,
      x_max: 930,
      o: 'm 646 203 l 289 203 l 221 0 l 5 0 l 372 987 l 561 987 l 930 0 l 714 0 l 646 203 m 344 368 l 591 368 l 467 738 l 344 368 m 395 1068 l 385 1159 q 457 1172 435 1162 q 479 1203 479 1181 q 382 1250 479 1250 l 387 1341 q 579 1306 515 1341 q 644 1209 644 1271 q 616 1144 644 1169 q 543 1112 589 1118 l 543 1068 l 395 1068 z '
    },
    ả: {
      ha: 745,
      x_min: 46,
      x_max: 699,
      o: 'm 500 0 q 481 66 487 26 q 296 -14 410 -14 q 117 49 188 -14 q 46 206 46 111 q 133 385 46 323 q 382 448 219 448 l 473 448 l 473 490 q 447 572 473 541 q 364 602 420 602 q 287 578 315 602 q 258 513 258 555 l 62 513 q 102 631 62 577 q 213 716 141 686 q 374 747 285 747 q 590 679 510 747 q 669 488 669 611 l 669 170 q 699 12 670 65 l 699 0 l 500 0 m 338 136 q 418 156 382 136 q 473 208 455 175 l 473 334 l 399 334 q 243 232 252 334 l 242 220 q 268 160 242 184 q 338 136 294 136 m 300 859 l 290 949 q 361 962 339 952 q 383 994 383 972 q 287 1040 383 1040 l 292 1132 q 484 1097 419 1132 q 549 1000 549 1061 q 521 934 549 960 q 447 902 493 909 l 447 859 l 300 859 z '
    },
    Ấ: {
      ha: 935,
      x_min: 5,
      x_max: 934,
      o: 'm 646 203 l 289 203 l 221 0 l 5 0 l 372 987 l 561 987 l 930 0 l 714 0 l 646 203 m 344 368 l 591 368 l 467 738 l 344 368 m 413 1197 l 524 1197 l 717 1041 l 570 1041 l 468 1126 l 366 1041 l 220 1041 l 413 1197 m 777 1316 l 934 1316 l 780 1132 l 667 1132 l 777 1316 z '
    },
    ấ: {
      ha: 745,
      x_min: 46,
      x_max: 838,
      o: 'm 500 0 q 481 66 487 26 q 296 -14 410 -14 q 117 49 188 -14 q 46 206 46 111 q 133 385 46 323 q 382 448 219 448 l 473 448 l 473 490 q 447 572 473 541 q 364 602 420 602 q 287 578 315 602 q 258 513 258 555 l 62 513 q 102 631 62 577 q 213 716 141 686 q 374 747 285 747 q 590 679 510 747 q 669 488 669 611 l 669 170 q 699 12 670 65 l 699 0 l 500 0 m 338 136 q 418 156 382 136 q 473 208 455 175 l 473 334 l 399 334 q 243 232 252 334 l 242 220 q 268 160 242 184 q 338 136 294 136 m 317 987 l 428 987 l 621 831 l 475 831 l 372 917 l 270 831 l 124 831 l 317 987 m 682 1107 l 838 1107 l 684 922 l 571 922 l 682 1107 z '
    },
    Ầ: {
      ha: 935,
      x_min: 4,
      x_max: 930,
      o: 'm 646 203 l 289 203 l 221 0 l 5 0 l 372 987 l 561 987 l 930 0 l 714 0 l 646 203 m 344 368 l 591 368 l 467 738 l 344 368 m 718 1040 l 572 1040 l 469 1126 l 367 1040 l 220 1040 l 414 1197 l 524 1197 l 718 1040 m 271 1132 l 157 1132 l 4 1316 l 160 1316 l 271 1132 z '
    },
    ầ: {
      ha: 745,
      x_min: -92,
      x_max: 699,
      o: 'm 500 0 q 481 66 487 26 q 296 -14 410 -14 q 117 49 188 -14 q 46 206 46 111 q 133 385 46 323 q 382 448 219 448 l 473 448 l 473 490 q 447 572 473 541 q 364 602 420 602 q 287 578 315 602 q 258 513 258 555 l 62 513 q 102 631 62 577 q 213 716 141 686 q 374 747 285 747 q 590 679 510 747 q 669 488 669 611 l 669 170 q 699 12 670 65 l 699 0 l 500 0 m 338 136 q 418 156 382 136 q 473 208 455 175 l 473 334 l 399 334 q 243 232 252 334 l 242 220 q 268 160 242 184 q 338 136 294 136 m 622 831 l 476 831 l 374 917 l 271 831 l 125 831 l 318 987 l 429 987 l 622 831 m 175 922 l 62 922 l -92 1106 l 64 1106 l 175 922 z '
    },
    Ẩ: {
      ha: 935,
      x_min: 5,
      x_max: 930,
      o: 'm 646 203 l 289 203 l 221 0 l 5 0 l 372 987 l 561 987 l 930 0 l 714 0 l 646 203 m 344 368 l 591 368 l 467 738 l 344 368 m 716 1037 l 576 1037 l 468 1128 l 359 1037 l 219 1037 l 409 1193 l 527 1193 l 716 1037 m 653 1123 l 644 1200 q 705 1211 686 1202 q 724 1237 724 1219 q 642 1278 724 1278 l 646 1354 q 793 1325 744 1354 q 843 1243 843 1295 q 820 1188 843 1211 q 758 1160 798 1165 l 757 1123 l 653 1123 z '
    },
    ẩ: {
      ha: 745,
      x_min: 46,
      x_max: 747,
      o: 'm 500 0 q 481 66 487 26 q 296 -14 410 -14 q 117 49 188 -14 q 46 206 46 111 q 133 385 46 323 q 382 448 219 448 l 473 448 l 473 490 q 447 572 473 541 q 364 602 420 602 q 287 578 315 602 q 258 513 258 555 l 62 513 q 102 631 62 577 q 213 716 141 686 q 374 747 285 747 q 590 679 510 747 q 669 488 669 611 l 669 170 q 699 12 670 65 l 699 0 l 500 0 m 338 136 q 418 156 382 136 q 473 208 455 175 l 473 334 l 399 334 q 243 232 252 334 l 242 220 q 268 160 242 184 q 338 136 294 136 m 621 827 l 480 827 l 372 918 l 264 827 l 123 827 l 313 983 l 431 983 l 621 827 m 557 913 l 549 991 q 609 1001 591 993 q 628 1027 628 1010 q 546 1068 628 1068 l 550 1145 q 698 1115 648 1145 q 747 1034 747 1086 q 725 978 747 1001 q 662 951 702 956 l 661 913 l 557 913 z '
    },
    Ẫ: {
      ha: 935,
      x_min: 5,
      x_max: 930,
      o: 'm 646 203 l 289 203 l 221 0 l 5 0 l 372 987 l 561 987 l 930 0 l 714 0 l 646 203 m 344 368 l 591 368 l 467 738 l 344 368 m 718 1034 l 577 1034 l 469 1119 l 361 1034 l 220 1034 l 416 1186 l 523 1186 l 718 1034 m 645 1331 q 618 1256 645 1286 q 552 1225 591 1225 q 477 1246 521 1225 q 409 1268 433 1268 q 383 1254 393 1268 q 373 1220 373 1240 l 304 1240 q 331 1315 304 1284 q 395 1346 357 1346 q 469 1325 423 1346 q 539 1304 514 1304 q 566 1320 555 1304 q 576 1356 576 1336 l 645 1331 z '
    },
    ẫ: {
      ha: 745,
      x_min: 46,
      x_max: 699,
      o: 'm 500 0 q 481 66 487 26 q 296 -14 410 -14 q 117 49 188 -14 q 46 206 46 111 q 133 385 46 323 q 382 448 219 448 l 473 448 l 473 490 q 447 572 473 541 q 364 602 420 602 q 287 578 315 602 q 258 513 258 555 l 62 513 q 102 631 62 577 q 213 716 141 686 q 374 747 285 747 q 590 679 510 747 q 669 488 669 611 l 669 170 q 699 12 670 65 l 699 0 l 500 0 m 338 136 q 418 156 382 136 q 473 208 455 175 l 473 334 l 399 334 q 243 232 252 334 l 242 220 q 268 160 242 184 q 338 136 294 136 m 622 824 l 481 824 l 374 909 l 265 824 l 125 824 l 320 977 l 427 977 l 622 824 m 549 1121 q 522 1046 549 1077 q 456 1015 495 1015 q 381 1037 425 1015 q 313 1059 337 1059 q 287 1044 297 1059 q 277 1010 277 1030 l 209 1030 q 235 1105 209 1074 q 300 1137 262 1137 q 373 1116 328 1137 q 444 1095 418 1095 q 470 1111 460 1095 q 480 1146 480 1126 l 549 1121 z '
    },
    Ậ: {
      ha: 935,
      x_min: 5,
      x_max: 930,
      o: 'm 646 203 l 289 203 l 221 0 l 5 0 l 372 987 l 561 987 l 930 0 l 714 0 l 646 203 m 344 368 l 591 368 l 467 738 l 344 368 m 730 1062 l 730 1054 l 574 1054 l 469 1152 l 365 1054 l 212 1054 l 212 1065 l 412 1252 l 526 1252 l 730 1062 m 363 -155 q 394 -87 363 -114 q 473 -61 425 -61 q 552 -87 522 -61 q 583 -155 583 -114 q 552 -222 583 -195 q 473 -249 522 -249 q 393 -222 423 -249 q 363 -155 363 -195 z '
    },
    ậ: {
      ha: 745,
      x_min: 46,
      x_max: 699,
      o: 'm 500 0 q 481 66 487 26 q 296 -14 410 -14 q 117 49 188 -14 q 46 206 46 111 q 133 385 46 323 q 382 448 219 448 l 473 448 l 473 490 q 447 572 473 541 q 364 602 420 602 q 287 578 315 602 q 258 513 258 555 l 62 513 q 102 631 62 577 q 213 716 141 686 q 374 747 285 747 q 590 679 510 747 q 669 488 669 611 l 669 170 q 699 12 670 65 l 699 0 l 500 0 m 338 136 q 418 156 382 136 q 473 208 455 175 l 473 334 l 399 334 q 243 232 252 334 l 242 220 q 268 160 242 184 q 338 136 294 136 m 634 852 l 634 844 l 478 844 l 374 942 l 269 844 l 116 844 l 116 854 l 317 1042 l 431 1042 l 634 852 m 213 -148 q 243 -81 213 -107 q 322 -54 274 -54 q 401 -81 371 -54 q 432 -148 432 -107 q 402 -215 432 -188 q 322 -242 372 -242 q 243 -215 273 -242 q 213 -148 213 -188 z '
    },
    Ắ: {
      ha: 935,
      x_min: 5,
      x_max: 930,
      o: 'm 646 203 l 289 203 l 221 0 l 5 0 l 372 987 l 561 987 l 930 0 l 714 0 l 646 203 m 344 368 l 591 368 l 467 738 l 344 368 m 703 1198 q 638 1084 703 1128 q 467 1040 574 1040 q 296 1083 360 1040 q 233 1198 233 1127 l 362 1198 q 390 1142 362 1162 q 467 1122 417 1122 q 545 1143 518 1122 q 572 1198 572 1163 l 703 1198 m 497 1327 l 635 1327 l 516 1200 l 414 1200 l 497 1327 z '
    },
    ắ: {
      ha: 745,
      x_min: 46,
      x_max: 699,
      o: 'm 500 0 q 481 66 487 26 q 296 -14 410 -14 q 117 49 188 -14 q 46 206 46 111 q 133 385 46 323 q 382 448 219 448 l 473 448 l 473 490 q 447 572 473 541 q 364 602 420 602 q 287 578 315 602 q 258 513 258 555 l 62 513 q 102 631 62 577 q 213 716 141 686 q 374 747 285 747 q 590 679 510 747 q 669 488 669 611 l 669 170 q 699 12 670 65 l 699 0 l 500 0 m 338 136 q 418 156 382 136 q 473 208 455 175 l 473 334 l 399 334 q 243 232 252 334 l 242 220 q 268 160 242 184 q 338 136 294 136 m 607 988 q 543 873 607 918 q 372 829 479 829 q 201 873 264 829 q 137 988 137 917 l 267 988 q 294 932 267 951 q 372 912 321 912 q 450 932 422 912 q 477 988 477 953 l 607 988 m 401 1117 l 539 1117 l 420 990 l 318 990 l 401 1117 z '
    },
    Ằ: {
      ha: 935,
      x_min: 5,
      x_max: 930,
      o: 'm 646 203 l 289 203 l 221 0 l 5 0 l 372 987 l 561 987 l 930 0 l 714 0 l 646 203 m 344 368 l 591 368 l 467 738 l 344 368 m 703 1200 q 638 1085 703 1128 q 467 1042 574 1042 q 297 1085 361 1042 q 233 1200 233 1128 l 362 1200 q 390 1143 362 1163 q 467 1124 417 1124 q 545 1144 518 1124 q 572 1200 572 1164 l 703 1200 m 308 1327 l 446 1327 l 528 1200 l 426 1200 l 308 1327 z '
    },
    ằ: {
      ha: 745,
      x_min: 46,
      x_max: 699,
      o: 'm 500 0 q 481 66 487 26 q 296 -14 410 -14 q 117 49 188 -14 q 46 206 46 111 q 133 385 46 323 q 382 448 219 448 l 473 448 l 473 490 q 447 572 473 541 q 364 602 420 602 q 287 578 315 602 q 258 513 258 555 l 62 513 q 102 631 62 577 q 213 716 141 686 q 374 747 285 747 q 590 679 510 747 q 669 488 669 611 l 669 170 q 699 12 670 65 l 699 0 l 500 0 m 338 136 q 418 156 382 136 q 473 208 455 175 l 473 334 l 399 334 q 243 232 252 334 l 242 220 q 268 160 242 184 q 338 136 294 136 m 607 989 q 543 875 607 918 q 372 831 478 831 q 201 874 266 831 q 137 989 137 918 l 267 989 q 294 933 267 953 q 372 913 321 913 q 450 934 422 913 q 477 989 477 954 l 607 989 m 212 1117 l 350 1117 l 433 990 l 330 990 l 212 1117 z '
    },
    Ẳ: {
      ha: 935,
      x_min: 5,
      x_max: 930,
      o: 'm 646 203 l 289 203 l 221 0 l 5 0 l 372 987 l 561 987 l 930 0 l 714 0 l 646 203 m 344 368 l 591 368 l 467 738 l 344 368 m 701 1192 q 638 1079 701 1122 q 465 1036 574 1036 q 292 1079 355 1036 q 229 1192 229 1122 l 359 1192 q 386 1139 359 1159 q 465 1120 412 1120 q 543 1139 515 1120 q 570 1192 570 1158 l 701 1192 m 401 1213 l 391 1285 q 460 1295 439 1287 q 482 1319 482 1303 q 387 1355 482 1355 l 392 1427 q 565 1400 507 1427 q 623 1324 623 1373 q 598 1274 623 1294 q 524 1249 572 1254 l 524 1213 l 401 1213 z '
    },
    ẳ: {
      ha: 745,
      x_min: 46,
      x_max: 699,
      o: 'm 500 0 q 481 66 487 26 q 296 -14 410 -14 q 117 49 188 -14 q 46 206 46 111 q 133 385 46 323 q 382 448 219 448 l 473 448 l 473 490 q 447 572 473 541 q 364 602 420 602 q 287 578 315 602 q 258 513 258 555 l 62 513 q 102 631 62 577 q 213 716 141 686 q 374 747 285 747 q 590 679 510 747 q 669 488 669 611 l 669 170 q 699 12 670 65 l 699 0 l 500 0 m 338 136 q 418 156 382 136 q 473 208 455 175 l 473 334 l 399 334 q 243 232 252 334 l 242 220 q 268 160 242 184 q 338 136 294 136 m 606 983 q 542 869 606 913 q 370 826 479 826 q 196 869 260 826 q 133 983 133 913 l 263 983 q 290 930 263 949 q 370 910 317 910 q 447 929 420 910 q 475 983 475 949 l 606 983 m 305 1003 l 295 1076 q 365 1085 343 1078 q 387 1109 387 1093 q 292 1145 387 1145 l 296 1217 q 470 1190 412 1217 q 528 1115 528 1163 q 502 1064 528 1084 q 428 1039 477 1044 l 428 1003 l 305 1003 z '
    },
    Ẵ: {
      ha: 935,
      x_min: 5,
      x_max: 930,
      o: 'm 646 203 l 289 203 l 221 0 l 5 0 l 372 987 l 561 987 l 930 0 l 714 0 l 646 203 m 344 368 l 591 368 l 467 738 l 344 368 m 701 1196 q 636 1079 701 1123 q 467 1036 571 1036 q 297 1079 362 1036 q 233 1196 233 1123 l 361 1196 q 389 1141 361 1160 q 467 1122 416 1122 q 543 1141 516 1122 q 570 1196 570 1160 l 701 1196 m 664 1381 q 632 1294 664 1329 q 553 1258 600 1258 q 468 1281 514 1258 q 394 1303 422 1303 q 362 1287 375 1303 q 349 1245 349 1270 l 267 1268 q 299 1355 267 1318 q 378 1392 331 1392 q 458 1369 406 1392 q 536 1347 511 1347 q 569 1363 555 1347 q 582 1404 582 1380 l 664 1381 z '
    },
    ẵ: {
      ha: 745,
      x_min: 46,
      x_max: 699,
      o: 'm 500 0 q 481 66 487 26 q 296 -14 410 -14 q 117 49 188 -14 q 46 206 46 111 q 133 385 46 323 q 382 448 219 448 l 473 448 l 473 490 q 447 572 473 541 q 364 602 420 602 q 287 578 315 602 q 258 513 258 555 l 62 513 q 102 631 62 577 q 213 716 141 686 q 374 747 285 747 q 590 679 510 747 q 669 488 669 611 l 669 170 q 699 12 670 65 l 699 0 l 500 0 m 338 136 q 418 156 382 136 q 473 208 455 175 l 473 334 l 399 334 q 243 232 252 334 l 242 220 q 268 160 242 184 q 338 136 294 136 m 605 986 q 540 870 605 913 q 371 826 475 826 q 202 870 267 826 q 137 986 137 913 l 266 986 q 293 932 266 951 q 371 913 320 913 q 448 932 420 913 q 475 986 475 951 l 605 986 m 568 1171 q 536 1084 568 1120 q 457 1048 504 1048 q 372 1071 418 1048 q 298 1094 326 1094 q 266 1077 279 1094 q 253 1036 253 1061 l 172 1059 q 203 1145 172 1109 q 283 1182 235 1182 q 363 1160 311 1182 q 441 1137 415 1137 q 473 1154 460 1137 q 486 1195 486 1171 l 568 1171 z '
    },
    Ặ: {
      ha: 935,
      x_min: 5,
      x_max: 930,
      o: 'm 646 203 l 289 203 l 221 0 l 5 0 l 372 987 l 561 987 l 930 0 l 714 0 l 646 203 m 344 368 l 591 368 l 467 738 l 344 368 m 705 1245 q 640 1099 705 1155 q 470 1044 575 1044 q 300 1099 365 1044 q 235 1245 235 1154 l 374 1245 q 400 1179 374 1202 q 470 1156 425 1156 q 539 1179 514 1156 q 564 1245 564 1202 l 705 1245 m 363 -155 q 394 -87 363 -114 q 473 -61 425 -61 q 552 -87 522 -61 q 583 -155 583 -114 q 552 -222 583 -195 q 473 -249 522 -249 q 393 -222 423 -249 q 363 -155 363 -195 z '
    },
    ặ: {
      ha: 745,
      x_min: 46,
      x_max: 699,
      o: 'm 500 0 q 481 66 487 26 q 296 -14 410 -14 q 117 49 188 -14 q 46 206 46 111 q 133 385 46 323 q 382 448 219 448 l 473 448 l 473 490 q 447 572 473 541 q 364 602 420 602 q 287 578 315 602 q 258 513 258 555 l 62 513 q 102 631 62 577 q 213 716 141 686 q 374 747 285 747 q 590 679 510 747 q 669 488 669 611 l 669 170 q 699 12 670 65 l 699 0 l 500 0 m 338 136 q 418 156 382 136 q 473 208 455 175 l 473 334 l 399 334 q 243 232 252 334 l 242 220 q 268 160 242 184 q 338 136 294 136 m 609 1035 q 544 889 609 945 q 374 833 479 833 q 204 888 269 833 q 140 1035 140 943 l 279 1035 q 304 969 279 992 q 374 945 330 945 q 444 969 418 945 q 469 1035 469 992 l 609 1035 m 213 -148 q 243 -81 213 -107 q 322 -54 274 -54 q 401 -81 371 -54 q 432 -148 432 -107 q 402 -215 432 -188 q 322 -242 372 -242 q 243 -215 273 -242 q 213 -148 213 -188 z '
    },
    Ẹ: {
      ha: 781,
      x_min: 88,
      x_max: 750,
      o: 'm 682 428 l 292 428 l 292 163 l 750 163 l 750 0 l 88 0 l 88 987 l 749 987 l 749 823 l 292 823 l 292 587 l 682 587 l 682 428 m 322 -152 q 353 -85 322 -111 q 431 -58 383 -58 q 511 -85 480 -58 q 541 -152 541 -111 q 511 -219 541 -192 q 431 -246 481 -246 q 352 -219 382 -246 q 322 -152 322 -192 z '
    },
    ẹ: {
      ha: 751,
      x_min: 49,
      x_max: 715,
      o: 'm 413 -14 q 150 85 252 -14 q 49 349 49 184 l 49 368 q 92 566 49 479 q 213 700 134 653 q 391 747 291 747 q 628 652 542 747 q 715 383 715 557 l 715 303 l 248 303 q 305 188 257 231 q 426 144 353 144 q 603 227 539 144 l 699 119 q 580 21 655 56 q 413 -14 505 -14 m 391 589 q 296 549 332 589 q 250 437 260 510 l 522 437 l 522 452 q 487 553 521 517 q 391 589 453 589 m 276 -159 q 307 -92 276 -118 q 385 -65 337 -65 q 465 -92 434 -65 q 495 -159 495 -118 q 465 -226 495 -199 q 385 -253 435 -253 q 306 -226 336 -253 q 276 -159 276 -199 z '
    },
    Ẻ: {
      ha: 781,
      x_min: 88,
      x_max: 750,
      o: 'm 682 428 l 292 428 l 292 163 l 750 163 l 750 0 l 88 0 l 88 987 l 749 987 l 749 823 l 292 823 l 292 587 l 682 587 l 682 428 m 357 1070 l 347 1161 q 418 1174 396 1164 q 440 1205 440 1183 q 344 1252 440 1252 l 349 1343 q 541 1308 476 1343 q 606 1211 606 1273 q 578 1146 606 1171 q 504 1114 550 1120 l 504 1070 l 357 1070 z '
    },
    ẻ: {
      ha: 751,
      x_min: 49,
      x_max: 715,
      o: 'm 413 -14 q 150 85 252 -14 q 49 349 49 184 l 49 368 q 92 566 49 479 q 213 700 134 653 q 391 747 291 747 q 628 652 542 747 q 715 383 715 557 l 715 303 l 248 303 q 305 188 257 231 q 426 144 353 144 q 603 227 539 144 l 699 119 q 580 21 655 56 q 413 -14 505 -14 m 391 589 q 296 549 332 589 q 250 437 260 510 l 522 437 l 522 452 q 487 553 521 517 q 391 589 453 589 m 295 859 l 285 949 q 356 962 334 952 q 378 994 378 972 q 282 1040 378 1040 l 287 1132 q 479 1097 414 1132 q 544 1000 544 1061 q 516 934 544 960 q 442 902 488 909 l 442 859 l 295 859 z '
    },
    Ẽ: {
      ha: 781,
      x_min: 88,
      x_max: 750,
      o: 'm 682 428 l 292 428 l 292 163 l 750 163 l 750 0 l 88 0 l 88 987 l 749 987 l 749 823 l 292 823 l 292 587 l 682 587 l 682 428 m 686 1244 q 641 1116 686 1168 q 532 1064 596 1064 q 486 1070 506 1064 q 431 1095 466 1076 q 380 1118 395 1114 q 346 1122 364 1122 q 306 1105 322 1122 q 289 1057 289 1088 l 175 1064 q 219 1192 175 1139 q 328 1245 264 1245 q 367 1240 349 1245 q 425 1215 385 1235 q 481 1192 466 1196 q 514 1187 497 1187 q 555 1204 538 1187 q 572 1252 572 1221 l 686 1244 z '
    },
    ẽ: {
      ha: 751,
      x_min: 49,
      x_max: 715,
      o: 'm 413 -14 q 150 85 252 -14 q 49 349 49 184 l 49 368 q 92 566 49 479 q 213 700 134 653 q 391 747 291 747 q 628 652 542 747 q 715 383 715 557 l 715 303 l 248 303 q 305 188 257 231 q 426 144 353 144 q 603 227 539 144 l 699 119 q 580 21 655 56 q 413 -14 505 -14 m 391 589 q 296 549 332 589 q 250 437 260 510 l 522 437 l 522 452 q 487 553 521 517 q 391 589 453 589 m 624 1033 q 579 904 624 956 q 470 852 534 852 q 424 858 444 852 q 369 883 404 864 q 318 906 334 902 q 284 911 302 911 q 244 894 260 911 q 227 846 227 877 l 113 852 q 158 981 113 928 q 267 1034 202 1034 q 305 1028 287 1034 q 363 1004 323 1023 q 420 980 404 984 q 452 976 435 976 q 493 992 476 976 q 511 1040 511 1009 l 624 1033 z '
    },
    Ế: {
      ha: 781,
      x_min: 88,
      x_max: 895,
      o: 'm 682 428 l 292 428 l 292 163 l 750 163 l 750 0 l 88 0 l 88 987 l 749 987 l 749 823 l 292 823 l 292 587 l 682 587 l 682 428 m 374 1199 l 485 1199 l 678 1043 l 532 1043 l 429 1128 l 327 1043 l 181 1043 l 374 1199 m 739 1318 l 895 1318 l 741 1134 l 628 1134 l 739 1318 z '
    },
    ế: {
      ha: 751,
      x_min: 49,
      x_max: 833,
      o: 'm 413 -14 q 150 85 252 -14 q 49 349 49 184 l 49 368 q 92 566 49 479 q 213 700 134 653 q 391 747 291 747 q 628 652 542 747 q 715 383 715 557 l 715 303 l 248 303 q 305 188 257 231 q 426 144 353 144 q 603 227 539 144 l 699 119 q 580 21 655 56 q 413 -14 505 -14 m 391 589 q 296 549 332 589 q 250 437 260 510 l 522 437 l 522 452 q 487 553 521 517 q 391 589 453 589 m 313 987 l 423 987 l 616 831 l 470 831 l 368 917 l 265 831 l 119 831 l 313 987 m 677 1107 l 833 1107 l 680 922 l 566 922 l 677 1107 z '
    },
    Ề: {
      ha: 781,
      x_min: -35,
      x_max: 750,
      o: 'm 682 428 l 292 428 l 292 163 l 750 163 l 750 0 l 88 0 l 88 987 l 749 987 l 749 823 l 292 823 l 292 587 l 682 587 l 682 428 m 679 1042 l 533 1042 l 431 1128 l 328 1042 l 182 1042 l 375 1199 l 486 1199 l 679 1042 m 232 1134 l 119 1134 l -35 1318 l 121 1318 l 232 1134 z '
    },
    ề: {
      ha: 751,
      x_min: -96,
      x_max: 715,
      o: 'm 413 -14 q 150 85 252 -14 q 49 349 49 184 l 49 368 q 92 566 49 479 q 213 700 134 653 q 391 747 291 747 q 628 652 542 747 q 715 383 715 557 l 715 303 l 248 303 q 305 188 257 231 q 426 144 353 144 q 603 227 539 144 l 699 119 q 580 21 655 56 q 413 -14 505 -14 m 391 589 q 296 549 332 589 q 250 437 260 510 l 522 437 l 522 452 q 487 553 521 517 q 391 589 453 589 m 617 831 l 471 831 l 369 917 l 267 831 l 120 831 l 313 987 l 424 987 l 617 831 m 170 922 l 57 922 l -96 1106 l 60 1106 l 170 922 z '
    },
    Ể: {
      ha: 781,
      x_min: 88,
      x_max: 804,
      o: 'm 682 428 l 292 428 l 292 163 l 750 163 l 750 0 l 88 0 l 88 987 l 749 987 l 749 823 l 292 823 l 292 587 l 682 587 l 682 428 m 677 1039 l 537 1039 l 429 1130 l 321 1039 l 180 1039 l 370 1195 l 488 1195 l 677 1039 m 614 1125 l 606 1202 q 666 1213 648 1204 q 685 1239 685 1221 q 603 1280 685 1280 l 607 1356 q 755 1327 705 1356 q 804 1245 804 1297 q 782 1190 804 1213 q 719 1162 759 1167 l 718 1125 l 614 1125 z '
    },
    ể: {
      ha: 751,
      x_min: 49,
      x_max: 743,
      o: 'm 413 -14 q 150 85 252 -14 q 49 349 49 184 l 49 368 q 92 566 49 479 q 213 700 134 653 q 391 747 291 747 q 628 652 542 747 q 715 383 715 557 l 715 303 l 248 303 q 305 188 257 231 q 426 144 353 144 q 603 227 539 144 l 699 119 q 580 21 655 56 q 413 -14 505 -14 m 391 589 q 296 549 332 589 q 250 437 260 510 l 522 437 l 522 452 q 487 553 521 517 q 391 589 453 589 m 616 827 l 475 827 l 368 918 l 259 827 l 119 827 l 309 983 l 427 983 l 616 827 m 553 913 l 544 991 q 605 1001 586 993 q 623 1027 623 1010 q 541 1068 623 1068 l 545 1145 q 693 1115 644 1145 q 743 1034 743 1086 q 720 978 743 1001 q 657 951 697 956 l 656 913 l 553 913 z '
    },
    Ễ: {
      ha: 781,
      x_min: 88,
      x_max: 750,
      o: 'm 682 428 l 292 428 l 292 163 l 750 163 l 750 0 l 88 0 l 88 987 l 749 987 l 749 823 l 292 823 l 292 587 l 682 587 l 682 428 m 679 1036 l 538 1036 l 431 1121 l 322 1036 l 182 1036 l 377 1188 l 484 1188 l 679 1036 m 606 1333 q 579 1258 606 1289 q 513 1227 552 1227 q 438 1249 482 1227 q 370 1270 394 1270 q 344 1256 354 1270 q 334 1222 334 1242 l 266 1242 q 292 1317 266 1286 q 357 1348 319 1348 q 430 1327 385 1348 q 500 1306 475 1306 q 527 1322 517 1306 q 537 1358 537 1338 l 606 1333 z '
    },
    ễ: {
      ha: 751,
      x_min: 49,
      x_max: 715,
      o: 'm 413 -14 q 150 85 252 -14 q 49 349 49 184 l 49 368 q 92 566 49 479 q 213 700 134 653 q 391 747 291 747 q 628 652 542 747 q 715 383 715 557 l 715 303 l 248 303 q 305 188 257 231 q 426 144 353 144 q 603 227 539 144 l 699 119 q 580 21 655 56 q 413 -14 505 -14 m 391 589 q 296 549 332 589 q 250 437 260 510 l 522 437 l 522 452 q 487 553 521 517 q 391 589 453 589 m 617 824 l 477 824 l 369 909 l 260 824 l 120 824 l 315 977 l 422 977 l 617 824 m 545 1121 q 517 1046 545 1077 q 452 1015 490 1015 q 376 1037 420 1015 q 309 1059 332 1059 q 282 1044 292 1059 q 273 1010 273 1030 l 204 1030 q 231 1105 204 1074 q 295 1137 257 1137 q 368 1116 323 1137 q 439 1095 414 1095 q 465 1111 455 1095 q 475 1146 475 1126 l 545 1121 z '
    },
    Ệ: {
      ha: 781,
      x_min: 88,
      x_max: 750,
      o: 'm 682 428 l 292 428 l 292 163 l 750 163 l 750 0 l 88 0 l 88 987 l 749 987 l 749 823 l 292 823 l 292 587 l 682 587 l 682 428 m 691 1064 l 691 1056 l 535 1056 l 431 1154 l 326 1056 l 173 1056 l 173 1067 l 374 1254 l 488 1254 l 691 1064 m 322 -152 q 353 -85 322 -111 q 431 -58 383 -58 q 511 -85 480 -58 q 541 -152 541 -111 q 511 -219 541 -192 q 431 -246 481 -246 q 352 -219 382 -246 q 322 -152 322 -192 z '
    },
    ệ: {
      ha: 751,
      x_min: 49,
      x_max: 715,
      o: 'm 413 -14 q 150 85 252 -14 q 49 349 49 184 l 49 368 q 92 566 49 479 q 213 700 134 653 q 391 747 291 747 q 628 652 542 747 q 715 383 715 557 l 715 303 l 248 303 q 305 188 257 231 q 426 144 353 144 q 603 227 539 144 l 699 119 q 580 21 655 56 q 413 -14 505 -14 m 391 589 q 296 549 332 589 q 250 437 260 510 l 522 437 l 522 452 q 487 553 521 517 q 391 589 453 589 m 629 852 l 629 844 l 473 844 l 369 942 l 264 844 l 111 844 l 111 854 l 312 1042 l 426 1042 l 629 852 m 276 -159 q 307 -92 276 -118 q 385 -65 337 -65 q 465 -92 434 -65 q 495 -159 495 -118 q 465 -226 495 -199 q 385 -253 435 -253 q 306 -226 336 -253 q 276 -159 276 -199 z '
    },
    Ỉ: {
      ha: 405,
      x_min: 101,
      x_max: 377,
      o: 'm 304 0 l 101 0 l 101 987 l 304 987 l 304 0 m 128 1070 l 118 1161 q 190 1174 168 1164 q 212 1205 212 1183 q 115 1252 212 1252 l 120 1343 q 312 1308 248 1343 q 377 1211 377 1273 q 349 1146 377 1171 q 275 1114 321 1120 l 275 1070 l 128 1070 z '
    },
    ỉ: {
      ha: 380,
      x_min: 91,
      x_max: 365,
      o: 'm 287 0 l 91 0 l 91 734 l 287 734 l 287 0 m 116 848 l 106 939 q 177 951 155 941 q 199 983 199 961 q 103 1029 199 1029 l 108 1121 q 300 1086 235 1121 q 365 989 365 1050 q 337 923 365 949 q 263 891 309 898 l 263 848 l 116 848 z '
    },
    Ị: {
      ha: 405,
      x_min: 92,
      x_max: 311,
      o: 'm 304 0 l 101 0 l 101 987 l 304 987 l 304 0 m 92 -157 q 123 -90 92 -117 q 201 -64 153 -64 q 281 -90 250 -64 q 311 -157 311 -117 q 281 -224 311 -197 q 201 -252 251 -252 q 122 -224 152 -252 q 92 -157 92 -197 z '
    },
    ị: {
      ha: 368,
      x_min: 74,
      x_max: 294,
      o: 'm 282 0 l 85 0 l 85 734 l 282 734 l 282 0 m 74 924 q 103 996 74 968 q 184 1025 133 1025 q 264 996 234 1025 q 294 924 294 968 q 263 850 294 879 q 184 822 233 822 q 104 850 134 822 q 74 924 74 879 m 74 -152 q 104 -85 74 -111 q 183 -58 135 -58 q 262 -85 232 -58 q 293 -152 293 -111 q 263 -219 293 -192 q 183 -246 233 -246 q 104 -219 134 -246 q 74 -152 74 -192 z '
    },
    Ọ: {
      ha: 959,
      x_min: 58,
      x_max: 899,
      o: 'm 899 471 q 848 216 899 326 q 700 46 796 106 q 480 -14 604 -14 q 261 45 357 -14 q 112 214 165 104 q 58 466 59 323 l 58 515 q 111 771 58 661 q 259 942 163 882 q 479 1001 355 1001 q 698 942 602 1001 q 847 771 794 882 q 899 515 899 661 l 899 471 m 693 516 q 637 752 693 671 q 479 833 582 833 q 321 753 376 833 q 264 519 265 673 l 264 471 q 320 237 264 320 q 480 153 376 153 q 637 234 583 153 q 693 468 692 314 l 693 516 m 372 -159 q 403 -92 372 -118 q 481 -65 433 -65 q 561 -92 530 -65 q 591 -159 591 -118 q 561 -226 591 -199 q 481 -253 531 -253 q 402 -226 432 -253 q 372 -159 372 -199 z '
    },
    ọ: {
      ha: 785,
      x_min: 45,
      x_max: 740,
      o: 'm 45 374 q 87 568 45 483 q 208 701 129 654 q 391 747 287 747 q 634 656 540 747 q 739 410 728 566 l 740 359 q 646 89 740 191 q 393 -14 551 -14 q 139 88 234 -14 q 45 365 45 190 l 45 374 m 241 359 q 280 200 241 255 q 393 144 319 144 q 504 199 464 144 q 544 374 544 254 q 504 532 544 476 q 391 589 464 589 q 280 533 319 589 q 241 359 241 477 m 282 -163 q 313 -96 282 -122 q 391 -69 343 -69 q 471 -96 440 -69 q 501 -163 501 -122 q 471 -230 501 -203 q 391 -257 441 -257 q 312 -230 342 -257 q 282 -163 282 -203 z '
    },
    Ỏ: {
      ha: 959,
      x_min: 58,
      x_max: 899,
      o: 'm 899 471 q 848 216 899 326 q 700 46 796 106 q 480 -14 604 -14 q 261 45 357 -14 q 112 214 165 104 q 58 466 59 323 l 58 515 q 111 771 58 661 q 259 942 163 882 q 479 1001 355 1001 q 698 942 602 1001 q 847 771 794 882 q 899 515 899 661 l 899 471 m 693 516 q 637 752 693 671 q 479 833 582 833 q 321 753 376 833 q 264 519 265 673 l 264 471 q 320 237 264 320 q 480 153 376 153 q 637 234 583 153 q 693 468 692 314 l 693 516 m 405 1068 l 395 1159 q 466 1172 444 1162 q 488 1203 488 1181 q 392 1250 488 1250 l 397 1341 q 589 1306 524 1341 q 654 1209 654 1271 q 626 1144 654 1169 q 552 1112 598 1118 l 552 1068 l 405 1068 z '
    },
    ỏ: {
      ha: 785,
      x_min: 45,
      x_max: 740,
      o: 'm 45 374 q 87 568 45 483 q 208 701 129 654 q 391 747 287 747 q 634 656 540 747 q 739 410 728 566 l 740 359 q 646 89 740 191 q 393 -14 551 -14 q 139 88 234 -14 q 45 365 45 190 l 45 374 m 241 359 q 280 200 241 255 q 393 144 319 144 q 504 199 464 144 q 544 374 544 254 q 504 532 544 476 q 391 589 464 589 q 280 533 319 589 q 241 359 241 477 m 317 859 l 307 949 q 378 962 356 952 q 400 994 400 972 q 304 1040 400 1040 l 309 1132 q 501 1097 436 1132 q 566 1000 566 1061 q 538 934 566 960 q 464 902 510 909 l 464 859 l 317 859 z '
    },
    Ố: {
      ha: 959,
      x_min: 58,
      x_max: 943,
      o: 'm 899 471 q 848 216 899 326 q 700 46 796 106 q 480 -14 604 -14 q 261 45 357 -14 q 112 214 165 104 q 58 466 59 323 l 58 515 q 111 771 58 661 q 259 942 163 882 q 479 1001 355 1001 q 698 942 602 1001 q 847 771 794 882 q 899 515 899 661 l 899 471 m 693 516 q 637 752 693 671 q 479 833 582 833 q 321 753 376 833 q 264 519 265 673 l 264 471 q 320 237 264 320 q 480 153 376 153 q 637 234 583 153 q 693 468 692 314 l 693 516 m 422 1197 l 533 1197 l 726 1041 l 580 1041 l 477 1126 l 375 1041 l 229 1041 l 422 1197 m 787 1316 l 943 1316 l 789 1132 l 676 1132 l 787 1316 z '
    },
    ố: {
      ha: 785,
      x_min: 45,
      x_max: 855,
      o: 'm 45 374 q 87 568 45 483 q 208 701 129 654 q 391 747 287 747 q 634 656 540 747 q 739 410 728 566 l 740 359 q 646 89 740 191 q 393 -14 551 -14 q 139 88 234 -14 q 45 365 45 190 l 45 374 m 241 359 q 280 200 241 255 q 393 144 319 144 q 504 199 464 144 q 544 374 544 254 q 504 532 544 476 q 391 589 464 589 q 280 533 319 589 q 241 359 241 477 m 334 987 l 445 987 l 638 831 l 492 831 l 389 917 l 287 831 l 141 831 l 334 987 m 699 1107 l 855 1107 l 701 922 l 588 922 l 699 1107 z '
    },
    Ồ: {
      ha: 959,
      x_min: 14,
      x_max: 899,
      o: 'm 899 471 q 848 216 899 326 q 700 46 796 106 q 480 -14 604 -14 q 261 45 357 -14 q 112 214 165 104 q 58 466 59 323 l 58 515 q 111 771 58 661 q 259 942 163 882 q 479 1001 355 1001 q 698 942 602 1001 q 847 771 794 882 q 899 515 899 661 l 899 471 m 693 516 q 637 752 693 671 q 479 833 582 833 q 321 753 376 833 q 264 519 265 673 l 264 471 q 320 237 264 320 q 480 153 376 153 q 637 234 583 153 q 693 468 692 314 l 693 516 m 727 1040 l 581 1040 l 479 1126 l 376 1040 l 230 1040 l 423 1197 l 534 1197 l 727 1040 m 280 1132 l 167 1132 l 14 1316 l 170 1316 l 280 1132 z '
    },
    ồ: {
      ha: 785,
      x_min: -75,
      x_max: 740,
      o: 'm 45 374 q 87 568 45 483 q 208 701 129 654 q 391 747 287 747 q 634 656 540 747 q 739 410 728 566 l 740 359 q 646 89 740 191 q 393 -14 551 -14 q 139 88 234 -14 q 45 365 45 190 l 45 374 m 241 359 q 280 200 241 255 q 393 144 319 144 q 504 199 464 144 q 544 374 544 254 q 504 532 544 476 q 391 589 464 589 q 280 533 319 589 q 241 359 241 477 m 639 831 l 493 831 l 391 917 l 288 831 l 142 831 l 335 987 l 446 987 l 639 831 m 192 922 l 79 922 l -75 1106 l 81 1106 l 192 922 z '
    },
    Ổ: {
      ha: 959,
      x_min: 58,
      x_max: 899,
      o: 'm 899 471 q 848 216 899 326 q 700 46 796 106 q 480 -14 604 -14 q 261 45 357 -14 q 112 214 165 104 q 58 466 59 323 l 58 515 q 111 771 58 661 q 259 942 163 882 q 479 1001 355 1001 q 698 942 602 1001 q 847 771 794 882 q 899 515 899 661 l 899 471 m 693 516 q 637 752 693 671 q 479 833 582 833 q 321 753 376 833 q 264 519 265 673 l 264 471 q 320 237 264 320 q 480 153 376 153 q 637 234 583 153 q 693 468 692 314 l 693 516 m 726 1037 l 585 1037 l 477 1128 l 369 1037 l 229 1037 l 418 1193 l 536 1193 l 726 1037 m 663 1123 l 654 1200 q 714 1211 696 1202 q 733 1237 733 1219 q 651 1278 733 1278 l 655 1354 q 803 1325 753 1354 q 852 1243 852 1295 q 830 1188 852 1211 q 767 1160 807 1165 l 766 1123 l 663 1123 z '
    },
    ổ: {
      ha: 785,
      x_min: 45,
      x_max: 764,
      o: 'm 45 374 q 87 568 45 483 q 208 701 129 654 q 391 747 287 747 q 634 656 540 747 q 739 410 728 566 l 740 359 q 646 89 740 191 q 393 -14 551 -14 q 139 88 234 -14 q 45 365 45 190 l 45 374 m 241 359 q 280 200 241 255 q 393 144 319 144 q 504 199 464 144 q 544 374 544 254 q 504 532 544 476 q 391 589 464 589 q 280 533 319 589 q 241 359 241 477 m 637 827 l 497 827 l 389 918 l 281 827 l 140 827 l 330 983 l 448 983 l 637 827 m 574 913 l 566 991 q 626 1001 608 993 q 645 1027 645 1010 q 563 1068 645 1068 l 567 1145 q 715 1115 665 1145 q 764 1034 764 1086 q 742 978 764 1001 q 679 951 719 956 l 678 913 l 574 913 z '
    },
    Ỗ: {
      ha: 959,
      x_min: 58,
      x_max: 899,
      o: 'm 899 471 q 848 216 899 326 q 700 46 796 106 q 480 -14 604 -14 q 261 45 357 -14 q 112 214 165 104 q 58 466 59 323 l 58 515 q 111 771 58 661 q 259 942 163 882 q 479 1001 355 1001 q 698 942 602 1001 q 847 771 794 882 q 899 515 899 661 l 899 471 m 693 516 q 637 752 693 671 q 479 833 582 833 q 321 753 376 833 q 264 519 265 673 l 264 471 q 320 237 264 320 q 480 153 376 153 q 637 234 583 153 q 693 468 692 314 l 693 516 m 727 1034 l 587 1034 l 479 1119 l 370 1034 l 230 1034 l 425 1186 l 532 1186 l 727 1034 m 654 1331 q 627 1256 654 1286 q 562 1225 600 1225 q 486 1246 530 1225 q 418 1268 442 1268 q 392 1254 402 1268 q 382 1220 382 1240 l 314 1240 q 340 1315 314 1284 q 405 1346 367 1346 q 478 1325 433 1346 q 549 1304 524 1304 q 575 1320 565 1304 q 585 1356 585 1336 l 654 1331 z '
    },
    ỗ: {
      ha: 785,
      x_min: 45,
      x_max: 740,
      o: 'm 45 374 q 87 568 45 483 q 208 701 129 654 q 391 747 287 747 q 634 656 540 747 q 739 410 728 566 l 740 359 q 646 89 740 191 q 393 -14 551 -14 q 139 88 234 -14 q 45 365 45 190 l 45 374 m 241 359 q 280 200 241 255 q 393 144 319 144 q 504 199 464 144 q 544 374 544 254 q 504 532 544 476 q 391 589 464 589 q 280 533 319 589 q 241 359 241 477 m 639 824 l 498 824 l 391 909 l 282 824 l 142 824 l 337 977 l 444 977 l 639 824 m 566 1121 q 539 1046 566 1077 q 473 1015 512 1015 q 398 1037 442 1015 q 330 1059 354 1059 q 304 1044 314 1059 q 294 1010 294 1030 l 226 1030 q 252 1105 226 1074 q 317 1137 279 1137 q 390 1116 345 1137 q 460 1095 435 1095 q 487 1111 477 1095 q 497 1146 497 1126 l 566 1121 z '
    },
    Ộ: {
      ha: 959,
      x_min: 58,
      x_max: 899,
      o: 'm 899 471 q 848 216 899 326 q 700 46 796 106 q 480 -14 604 -14 q 261 45 357 -14 q 112 214 165 104 q 58 466 59 323 l 58 515 q 111 771 58 661 q 259 942 163 882 q 479 1001 355 1001 q 698 942 602 1001 q 847 771 794 882 q 899 515 899 661 l 899 471 m 693 516 q 637 752 693 671 q 479 833 582 833 q 321 753 376 833 q 264 519 265 673 l 264 471 q 320 237 264 320 q 480 153 376 153 q 637 234 583 153 q 693 468 692 314 l 693 516 m 739 1062 l 739 1054 l 583 1054 l 479 1152 l 374 1054 l 221 1054 l 221 1065 l 422 1252 l 536 1252 l 739 1062 m 372 -159 q 403 -92 372 -118 q 481 -65 433 -65 q 561 -92 530 -65 q 591 -159 591 -118 q 561 -226 591 -199 q 481 -253 531 -253 q 402 -226 432 -253 q 372 -159 372 -199 z '
    },
    ộ: {
      ha: 785,
      x_min: 45,
      x_max: 740,
      o: 'm 45 374 q 87 568 45 483 q 208 701 129 654 q 391 747 287 747 q 634 656 540 747 q 739 410 728 566 l 740 359 q 646 89 740 191 q 393 -14 551 -14 q 139 88 234 -14 q 45 365 45 190 l 45 374 m 241 359 q 280 200 241 255 q 393 144 319 144 q 504 199 464 144 q 544 374 544 254 q 504 532 544 476 q 391 589 464 589 q 280 533 319 589 q 241 359 241 477 m 651 852 l 651 844 l 495 844 l 391 942 l 286 844 l 133 844 l 133 854 l 334 1042 l 448 1042 l 651 852 m 282 -163 q 313 -96 282 -122 q 391 -69 343 -69 q 471 -96 440 -69 q 501 -163 501 -122 q 471 -230 501 -203 q 391 -257 441 -257 q 312 -230 342 -257 q 282 -163 282 -203 z '
    },
    Ớ: {
      ha: 974,
      x_min: 54,
      x_max: 995,
      o: 'm 895 471 q 844 216 895 326 q 696 46 792 106 q 476 -14 600 -14 q 257 45 353 -14 q 108 214 161 104 q 54 466 55 323 l 54 515 q 107 771 54 661 q 255 942 159 882 q 475 1001 351 1001 q 644 968 568 1001 q 776 873 720 935 q 844 935 825 886 q 862 1062 862 983 l 995 1062 q 840 777 995 829 q 895 522 894 665 l 895 471 m 689 516 q 633 752 689 671 q 475 833 578 833 q 317 753 372 833 q 260 519 261 673 l 260 471 q 316 237 260 320 q 476 153 372 153 q 633 234 578 153 q 689 468 688 314 l 689 516 m 517 1254 l 731 1254 l 543 1044 l 384 1044 l 517 1254 z '
    },
    ớ: {
      ha: 807,
      x_min: 43,
      x_max: 819,
      o: 'm 43 374 q 86 569 43 484 q 208 701 128 654 q 391 747 287 747 q 646 642 551 747 q 688 703 677 662 q 699 802 699 744 l 819 802 q 699 564 819 618 q 739 374 739 480 l 739 359 q 696 164 739 250 q 575 33 654 79 q 392 -14 497 -14 q 146 81 240 -14 q 44 335 52 175 l 43 374 m 240 359 q 279 200 240 255 q 392 144 319 144 q 503 199 464 144 q 543 374 543 254 q 503 532 543 475 q 391 589 464 589 q 279 533 319 589 q 240 359 240 477 m 431 1042 l 644 1042 l 456 831 l 297 831 l 431 1042 z '
    },
    Ờ: {
      ha: 974,
      x_min: 54,
      x_max: 995,
      o: 'm 895 471 q 844 216 895 326 q 696 46 792 106 q 476 -14 600 -14 q 257 45 353 -14 q 108 214 161 104 q 54 466 55 323 l 54 515 q 107 771 54 661 q 255 942 159 882 q 475 1001 351 1001 q 644 968 568 1001 q 776 873 720 935 q 844 935 825 886 q 862 1062 862 983 l 995 1062 q 840 777 995 829 q 895 522 894 665 l 895 471 m 689 516 q 633 752 689 671 q 475 833 578 833 q 317 753 372 833 q 260 519 261 673 l 260 471 q 316 237 260 320 q 476 153 372 153 q 633 234 578 153 q 689 468 688 314 l 689 516 m 576 1044 l 415 1044 l 228 1254 l 441 1254 l 576 1044 z '
    },
    ờ: {
      ha: 807,
      x_min: 43,
      x_max: 819,
      o: 'm 43 374 q 86 569 43 484 q 208 701 128 654 q 391 747 287 747 q 646 642 551 747 q 688 703 677 662 q 699 802 699 744 l 819 802 q 699 564 819 618 q 739 374 739 480 l 739 359 q 696 164 739 250 q 575 33 654 79 q 392 -14 497 -14 q 146 81 240 -14 q 44 335 52 175 l 43 374 m 240 359 q 279 200 240 255 q 392 144 319 144 q 503 199 464 144 q 543 374 543 254 q 503 532 543 475 q 391 589 464 589 q 279 533 319 589 q 240 359 240 477 m 489 831 l 328 831 l 141 1042 l 355 1042 l 489 831 z '
    },
    Ở: {
      ha: 974,
      x_min: 54,
      x_max: 995,
      o: 'm 895 471 q 844 216 895 326 q 696 46 792 106 q 476 -14 600 -14 q 257 45 353 -14 q 108 214 161 104 q 54 466 55 323 l 54 515 q 107 771 54 661 q 255 942 159 882 q 475 1001 351 1001 q 644 968 568 1001 q 776 873 720 935 q 844 935 825 886 q 862 1062 862 983 l 995 1062 q 840 777 995 829 q 895 522 894 665 l 895 471 m 689 516 q 633 752 689 671 q 475 833 578 833 q 317 753 372 833 q 260 519 261 673 l 260 471 q 316 237 260 320 q 476 153 372 153 q 633 234 578 153 q 689 468 688 314 l 689 516 m 404 1070 l 394 1161 q 466 1174 444 1164 q 488 1205 488 1183 q 391 1252 488 1252 l 396 1343 q 588 1308 524 1343 q 653 1211 653 1273 q 625 1146 653 1171 q 551 1114 597 1120 l 551 1070 l 404 1070 z '
    },
    ở: {
      ha: 807,
      x_min: 43,
      x_max: 819,
      o: 'm 43 374 q 86 569 43 484 q 208 701 128 654 q 391 747 287 747 q 646 642 551 747 q 688 703 677 662 q 699 802 699 744 l 819 802 q 699 564 819 618 q 739 374 739 480 l 739 359 q 696 164 739 250 q 575 33 654 79 q 392 -14 497 -14 q 146 81 240 -14 q 44 335 52 175 l 43 374 m 240 359 q 279 200 240 255 q 392 144 319 144 q 503 199 464 144 q 543 374 543 254 q 503 532 543 475 q 391 589 464 589 q 279 533 319 589 q 240 359 240 477 m 317 859 l 307 949 q 379 962 357 952 q 401 994 401 972 q 304 1040 401 1040 l 309 1132 q 502 1097 437 1132 q 566 1000 566 1061 q 538 934 566 960 q 465 902 511 909 l 465 859 l 317 859 z '
    },
    Ỡ: {
      ha: 974,
      x_min: 54,
      x_max: 995,
      o: 'm 895 471 q 844 216 895 326 q 696 46 792 106 q 476 -14 600 -14 q 257 45 353 -14 q 108 214 161 104 q 54 466 55 323 l 54 515 q 107 771 54 661 q 255 942 159 882 q 475 1001 351 1001 q 644 968 568 1001 q 776 873 720 935 q 844 935 825 886 q 862 1062 862 983 l 995 1062 q 840 777 995 829 q 895 522 894 665 l 895 471 m 689 516 q 633 752 689 671 q 475 833 578 833 q 317 753 372 833 q 260 519 261 673 l 260 471 q 316 237 260 320 q 476 153 372 153 q 633 234 578 153 q 689 468 688 314 l 689 516 m 733 1244 q 688 1116 733 1168 q 579 1064 644 1064 q 533 1070 553 1064 q 478 1095 513 1076 q 427 1118 443 1114 q 393 1122 412 1122 q 353 1105 370 1122 q 336 1057 336 1088 l 222 1064 q 267 1192 222 1139 q 376 1245 311 1245 q 414 1240 396 1245 q 473 1215 432 1235 q 529 1192 513 1196 q 562 1187 545 1187 q 603 1204 585 1187 q 620 1252 620 1221 l 733 1244 z '
    },
    ỡ: {
      ha: 807,
      x_min: 43,
      x_max: 819,
      o: 'm 43 374 q 86 569 43 484 q 208 701 128 654 q 391 747 287 747 q 646 642 551 747 q 688 703 677 662 q 699 802 699 744 l 819 802 q 699 564 819 618 q 739 374 739 480 l 739 359 q 696 164 739 250 q 575 33 654 79 q 392 -14 497 -14 q 146 81 240 -14 q 44 335 52 175 l 43 374 m 240 359 q 279 200 240 255 q 392 144 319 144 q 503 199 464 144 q 543 374 543 254 q 503 532 543 475 q 391 589 464 589 q 279 533 319 589 q 240 359 240 477 m 646 1033 q 602 904 646 956 q 492 852 557 852 q 447 858 467 852 q 391 883 427 864 q 340 906 356 902 q 307 911 325 911 q 266 894 283 911 q 250 846 250 877 l 136 852 q 180 981 136 928 q 289 1034 224 1034 q 327 1028 309 1034 q 386 1004 345 1023 q 442 980 427 984 q 475 976 458 976 q 516 992 498 976 q 533 1040 533 1009 l 646 1033 z '
    },
    Ợ: {
      ha: 974,
      x_min: 54,
      x_max: 995,
      o: 'm 895 471 q 844 216 895 326 q 696 46 792 106 q 476 -14 600 -14 q 257 45 353 -14 q 108 214 161 104 q 54 466 55 323 l 54 515 q 107 771 54 661 q 255 942 159 882 q 475 1001 351 1001 q 644 968 568 1001 q 776 873 720 935 q 844 935 825 886 q 862 1062 862 983 l 995 1062 q 840 777 995 829 q 895 522 894 665 l 895 471 m 689 516 q 633 752 689 671 q 475 833 578 833 q 317 753 372 833 q 260 519 261 673 l 260 471 q 316 237 260 320 q 476 153 372 153 q 633 234 578 153 q 689 468 688 314 l 689 516 m 353 -159 q 384 -92 353 -118 q 463 -65 414 -65 q 542 -92 511 -65 q 572 -159 572 -118 q 542 -226 572 -199 q 463 -253 512 -253 q 383 -226 413 -253 q 353 -159 353 -199 z '
    },
    ợ: {
      ha: 807,
      x_min: 43,
      x_max: 819,
      o: 'm 43 374 q 86 569 43 484 q 208 701 128 654 q 391 747 287 747 q 646 642 551 747 q 688 703 677 662 q 699 802 699 744 l 819 802 q 699 564 819 618 q 739 374 739 480 l 739 359 q 696 164 739 250 q 575 33 654 79 q 392 -14 497 -14 q 146 81 240 -14 q 44 335 52 175 l 43 374 m 240 359 q 279 200 240 255 q 392 144 319 144 q 503 199 464 144 q 543 374 543 254 q 503 532 543 475 q 391 589 464 589 q 279 533 319 589 q 240 359 240 477 m 281 -165 q 312 -98 281 -124 q 391 -71 342 -71 q 470 -98 439 -71 q 500 -165 500 -124 q 470 -232 500 -205 q 391 -259 440 -259 q 311 -232 341 -259 q 281 -165 281 -205 z '
    },
    Ụ: {
      ha: 914,
      x_min: 79,
      x_max: 836,
      o: 'm 836 987 l 836 337 q 734 81 836 175 q 457 -14 633 -14 q 182 78 284 -14 q 79 330 81 170 l 79 987 l 282 987 l 282 336 q 329 194 282 239 q 457 150 375 150 q 631 330 629 150 l 631 987 l 836 987 m 345 -159 q 375 -92 345 -118 q 454 -65 406 -65 q 533 -92 503 -65 q 564 -159 564 -118 q 533 -226 564 -199 q 454 -253 503 -253 q 374 -226 404 -253 q 345 -159 345 -199 z '
    },
    ụ: {
      ha: 777,
      x_min: 71,
      x_max: 705,
      o: 'm 515 75 q 314 -14 442 -14 q 134 54 196 -14 q 71 253 72 122 l 71 734 l 267 734 l 267 260 q 371 145 267 145 q 508 214 471 145 l 508 734 l 705 734 l 705 0 l 520 0 l 515 75 m 210 -159 q 241 -92 210 -118 q 319 -65 271 -65 q 399 -92 368 -65 q 429 -159 429 -118 q 399 -226 429 -199 q 319 -253 369 -253 q 240 -226 270 -253 q 210 -159 210 -199 z '
    },
    Ủ: {
      ha: 914,
      x_min: 79,
      x_max: 836,
      o: 'm 836 987 l 836 337 q 734 81 836 175 q 457 -14 633 -14 q 182 78 284 -14 q 79 330 81 170 l 79 987 l 282 987 l 282 336 q 329 194 282 239 q 457 150 375 150 q 631 330 629 150 l 631 987 l 836 987 m 380 1068 l 370 1159 q 442 1172 420 1162 q 464 1203 464 1181 q 368 1250 464 1250 l 372 1341 q 565 1306 500 1341 q 629 1209 629 1271 q 602 1144 629 1169 q 528 1112 574 1118 l 528 1068 l 380 1068 z '
    },
    ủ: {
      ha: 777,
      x_min: 71,
      x_max: 705,
      o: 'm 515 75 q 314 -14 442 -14 q 134 54 196 -14 q 71 253 72 122 l 71 734 l 267 734 l 267 260 q 371 145 267 145 q 508 214 471 145 l 508 734 l 705 734 l 705 0 l 520 0 l 515 75 m 314 859 l 304 949 q 375 962 353 952 q 397 994 397 972 q 301 1040 397 1040 l 306 1132 q 498 1097 433 1132 q 563 1000 563 1061 q 535 934 563 960 q 461 902 507 909 l 461 859 l 314 859 z '
    },
    Ứ: {
      ha: 989,
      x_min: 79,
      x_max: 1099,
      o: 'm 836 987 l 836 833 q 915 858 886 837 q 955 916 943 878 q 968 1042 968 954 l 1099 1042 q 1035 806 1099 880 q 836 726 972 732 l 836 337 q 734 81 836 175 q 457 -14 633 -14 q 182 78 284 -14 q 79 330 81 170 l 79 987 l 282 987 l 282 336 q 329 194 282 239 q 457 150 375 150 q 631 330 629 150 l 631 987 l 836 987 m 524 1260 l 738 1260 l 550 1050 l 391 1050 l 524 1260 z '
    },
    ứ: {
      ha: 847,
      x_min: 71,
      x_max: 905,
      o: 'm 905 798 q 857 615 905 675 q 705 545 808 556 l 705 0 l 520 0 l 515 75 q 314 -14 442 -14 q 134 54 196 -14 q 71 253 72 122 l 71 734 l 267 734 l 267 260 q 371 145 267 145 q 508 214 471 145 l 508 734 l 705 734 l 705 640 q 769 682 751 650 q 788 798 788 713 l 905 798 m 430 1028 l 644 1028 l 456 818 l 296 818 l 430 1028 z '
    },
    Ừ: {
      ha: 989,
      x_min: 79,
      x_max: 1099,
      o: 'm 836 987 l 836 833 q 915 858 886 837 q 955 916 943 878 q 968 1042 968 954 l 1099 1042 q 1035 806 1099 880 q 836 726 972 732 l 836 337 q 734 81 836 175 q 457 -14 633 -14 q 182 78 284 -14 q 79 330 81 170 l 79 987 l 282 987 l 282 336 q 329 194 282 239 q 457 150 375 150 q 631 330 629 150 l 631 987 l 836 987 m 583 1050 l 422 1050 l 235 1260 l 448 1260 l 583 1050 z '
    },
    ừ: {
      ha: 847,
      x_min: 71,
      x_max: 905,
      o: 'm 905 798 q 857 615 905 675 q 705 545 808 556 l 705 0 l 520 0 l 515 75 q 314 -14 442 -14 q 134 54 196 -14 q 71 253 72 122 l 71 734 l 267 734 l 267 260 q 371 145 267 145 q 508 214 471 145 l 508 734 l 705 734 l 705 640 q 769 682 751 650 q 788 798 788 713 l 905 798 m 488 818 l 328 818 l 140 1028 l 354 1028 l 488 818 z '
    },
    Ử: {
      ha: 989,
      x_min: 79,
      x_max: 1099,
      o: 'm 836 987 l 836 833 q 915 858 886 837 q 955 916 943 878 q 968 1042 968 954 l 1099 1042 q 1035 806 1099 880 q 836 726 972 732 l 836 337 q 734 81 836 175 q 457 -14 633 -14 q 182 78 284 -14 q 79 330 81 170 l 79 987 l 282 987 l 282 336 q 329 194 282 239 q 457 150 375 150 q 631 330 629 150 l 631 987 l 836 987 m 411 1076 l 401 1167 q 472 1180 450 1170 q 494 1211 494 1190 q 398 1258 494 1258 l 403 1350 q 595 1314 530 1350 q 660 1217 660 1279 q 632 1152 660 1177 q 558 1120 604 1126 l 558 1076 l 411 1076 z '
    },
    ử: {
      ha: 847,
      x_min: 71,
      x_max: 905,
      o: 'm 905 798 q 857 615 905 675 q 705 545 808 556 l 705 0 l 520 0 l 515 75 q 314 -14 442 -14 q 134 54 196 -14 q 71 253 72 122 l 71 734 l 267 734 l 267 260 q 371 145 267 145 q 508 214 471 145 l 508 734 l 705 734 l 705 640 q 769 682 751 650 q 788 798 788 713 l 905 798 m 317 844 l 307 935 q 378 948 356 938 q 400 979 400 958 q 304 1026 400 1026 l 309 1118 q 501 1082 436 1118 q 566 985 566 1047 q 538 920 566 945 q 464 888 510 895 l 464 844 l 317 844 z '
    },
    Ữ: {
      ha: 989,
      x_min: 79,
      x_max: 1099,
      o: 'm 836 987 l 836 833 q 915 858 886 837 q 955 916 943 878 q 968 1042 968 954 l 1099 1042 q 1035 806 1099 880 q 836 726 972 732 l 836 337 q 734 81 836 175 q 457 -14 633 -14 q 182 78 284 -14 q 79 330 81 170 l 79 987 l 282 987 l 282 336 q 329 194 282 239 q 457 150 375 150 q 631 330 629 150 l 631 987 l 836 987 m 740 1251 q 695 1122 740 1174 q 586 1070 650 1070 q 540 1076 560 1070 q 485 1101 520 1082 q 434 1124 450 1120 q 400 1128 418 1128 q 360 1112 376 1128 q 343 1063 343 1095 l 229 1070 q 274 1198 229 1145 q 382 1251 318 1251 q 421 1246 403 1251 q 479 1221 439 1241 q 536 1198 520 1202 q 568 1194 551 1194 q 609 1210 592 1194 q 627 1258 627 1227 l 740 1251 z '
    },
    ữ: {
      ha: 847,
      x_min: 71,
      x_max: 905,
      o: 'm 905 798 q 857 615 905 675 q 705 545 808 556 l 705 0 l 520 0 l 515 75 q 314 -14 442 -14 q 134 54 196 -14 q 71 253 72 122 l 71 734 l 267 734 l 267 260 q 371 145 267 145 q 508 214 471 145 l 508 734 l 705 734 l 705 640 q 769 682 751 650 q 788 798 788 713 l 905 798 m 646 1019 q 601 890 646 942 q 492 838 556 838 q 446 844 466 838 q 391 869 426 850 q 340 892 355 888 q 306 897 324 897 q 266 880 282 897 q 249 831 249 863 l 135 838 q 179 966 135 913 q 288 1019 224 1019 q 327 1014 309 1019 q 385 989 345 1009 q 441 966 426 970 q 474 962 457 962 q 515 978 498 962 q 532 1026 532 995 l 646 1019 z '
    },
    Ự: {
      ha: 989,
      x_min: 79,
      x_max: 1099,
      o: 'm 836 987 l 836 833 q 915 858 886 837 q 955 916 943 878 q 968 1042 968 954 l 1099 1042 q 1035 806 1099 880 q 836 726 972 732 l 836 337 q 734 81 836 175 q 457 -14 633 -14 q 182 78 284 -14 q 79 330 81 170 l 79 987 l 282 987 l 282 336 q 329 194 282 239 q 457 150 375 150 q 631 330 629 150 l 631 987 l 836 987 m 375 -165 q 406 -98 375 -124 q 484 -71 436 -71 q 564 -98 533 -71 q 594 -165 594 -124 q 564 -232 594 -205 q 484 -259 534 -259 q 405 -232 435 -259 q 375 -165 375 -205 z '
    },
    ự: {
      ha: 847,
      x_min: 71,
      x_max: 905,
      o: 'm 905 798 q 857 615 905 675 q 705 545 808 556 l 705 0 l 520 0 l 515 75 q 314 -14 442 -14 q 134 54 196 -14 q 71 253 72 122 l 71 734 l 267 734 l 267 260 q 371 145 267 145 q 508 214 471 145 l 508 734 l 705 734 l 705 640 q 769 682 751 650 q 788 798 788 713 l 905 798 m 277 -159 q 308 -92 277 -118 q 387 -65 338 -65 q 466 -92 435 -65 q 496 -159 496 -118 q 466 -226 496 -199 q 387 -253 436 -253 q 307 -226 337 -253 q 277 -159 277 -199 z '
    },
    Ỵ: {
      ha: 859,
      x_min: 1,
      x_max: 857,
      o: 'm 429 543 l 634 987 l 857 987 l 532 358 l 532 0 l 326 0 l 326 358 l 1 987 l 224 987 l 429 543 m 318 -136 q 349 -68 318 -95 q 427 -42 379 -42 q 507 -68 476 -42 q 537 -136 537 -95 q 507 -203 537 -176 q 427 -230 477 -230 q 348 -203 378 -230 q 318 -136 318 -176 z '
    },
    ỵ: {
      ha: 697,
      x_min: 2,
      x_max: 695,
      o: 'm 349 277 l 485 734 l 695 734 l 400 -114 l 384 -153 q 167 -296 318 -296 q 80 -283 124 -296 l 80 -135 l 110 -136 q 193 -119 165 -136 q 236 -62 220 -102 l 259 -2 l 2 734 l 213 734 l 349 277 m 429 -232 q 460 -165 429 -191 q 538 -138 490 -138 q 618 -165 587 -138 q 648 -232 648 -191 q 618 -299 648 -272 q 538 -326 588 -326 q 459 -299 489 -326 q 429 -232 429 -272 z '
    },
    Ỷ: {
      ha: 859,
      x_min: 1,
      x_max: 857,
      o: 'm 429 543 l 634 987 l 857 987 l 532 358 l 532 0 l 326 0 l 326 358 l 1 987 l 224 987 l 429 543 m 357 1068 l 347 1159 q 418 1172 396 1162 q 440 1203 440 1181 q 344 1250 440 1250 l 349 1341 q 541 1306 476 1341 q 606 1209 606 1271 q 578 1144 606 1169 q 504 1112 550 1118 l 504 1068 l 357 1068 z '
    },
    ỷ: {
      ha: 697,
      x_min: 2,
      x_max: 695,
      o: 'm 349 277 l 485 734 l 695 734 l 400 -114 l 384 -153 q 167 -296 318 -296 q 80 -283 124 -296 l 80 -135 l 110 -136 q 193 -119 165 -136 q 236 -62 220 -102 l 259 -2 l 2 734 l 213 734 l 349 277 m 279 859 l 269 949 q 340 962 318 952 q 362 994 362 972 q 266 1040 362 1040 l 271 1132 q 463 1097 398 1132 q 528 1000 528 1061 q 500 934 528 960 q 426 902 472 909 l 426 859 l 279 859 z '
    },
    Ỹ: {
      ha: 859,
      x_min: 1,
      x_max: 857,
      o: 'm 429 543 l 634 987 l 857 987 l 532 358 l 532 0 l 326 0 l 326 358 l 1 987 l 224 987 l 429 543 m 686 1242 q 641 1114 686 1166 q 532 1062 596 1062 q 486 1068 506 1062 q 431 1093 466 1074 q 380 1116 395 1112 q 346 1120 364 1120 q 306 1103 322 1120 q 289 1055 289 1086 l 175 1062 q 219 1190 175 1137 q 328 1243 264 1243 q 367 1238 349 1243 q 425 1213 385 1233 q 481 1190 466 1194 q 514 1185 497 1185 q 555 1202 538 1185 q 572 1250 572 1219 l 686 1242 z '
    },
    ỹ: {
      ha: 697,
      x_min: 2,
      x_max: 695,
      o: 'm 349 277 l 485 734 l 695 734 l 400 -114 l 384 -153 q 167 -296 318 -296 q 80 -283 124 -296 l 80 -135 l 110 -136 q 193 -119 165 -136 q 236 -62 220 -102 l 259 -2 l 2 734 l 213 734 l 349 277 m 608 1033 q 563 904 608 956 q 454 852 518 852 q 408 858 428 852 q 353 883 388 864 q 302 906 317 902 q 268 911 286 911 q 228 894 244 911 q 211 846 211 877 l 97 852 q 141 981 97 928 q 250 1034 186 1034 q 289 1028 271 1034 q 347 1004 307 1023 q 404 980 388 984 q 436 976 419 976 q 477 992 460 976 q 494 1040 494 1009 l 608 1033 z '
    },
    '₫': {
      ha: 803,
      x_min: 45,
      x_max: 812,
      o: 'm 45 372 q 122 646 45 544 q 332 747 199 747 q 509 667 439 747 l 509 1042 l 706 1042 l 706 0 l 529 0 l 519 78 q 331 -14 446 -14 q 123 89 201 -14 q 45 372 45 191 m 241 358 q 277 200 241 255 q 381 145 313 145 q 509 222 472 145 l 509 511 q 382 588 473 588 q 241 358 241 588 m 812 827 l 338 827 l 338 951 l 812 951 l 812 827 m 718 -246 l 100 -246 l 100 -93 l 718 -93 l 718 -246 z '
    },
    Ҭ: {
      ha: 859,
      x_min: 27,
      x_max: 831,
      o: 'm 831 823 l 529 823 l 529 0 l 326 0 l 326 823 l 27 823 l 27 987 l 831 987 l 831 823 m 658 -242 l 462 -242 l 462 139 l 658 139 l 658 -242 z '
    },
    ҭ: {
      ha: 707,
      x_min: 21,
      x_max: 684,
      o: 'm 684 576 l 449 576 l 449 0 l 252 0 l 252 576 l 21 576 l 21 734 l 684 734 l 684 576 m 599 -242 l 403 -242 l 403 139 l 599 139 l 599 -242 z '
    },
    Ӌ: {
      ha: 966,
      x_min: 93,
      x_max: 876,
      o: 'm 876 987 l 876 0 l 672 0 l 672 374 q 478 355 579 355 q 193 437 290 355 q 93 674 96 519 l 93 987 l 297 987 l 297 678 q 338 556 298 593 q 478 519 378 519 q 672 538 579 519 l 672 987 l 876 987 m 717 -242 l 521 -242 l 521 139 l 717 139 l 717 -242 z '
    },
    ӌ: {
      ha: 769,
      x_min: 60,
      x_max: 694,
      o: 'm 694 0 l 498 0 l 498 231 q 395 220 443 220 q 145 291 229 220 q 60 497 61 361 l 60 734 l 256 734 l 256 497 q 287 406 256 433 q 395 378 317 378 q 498 390 444 378 l 498 734 l 694 734 l 694 0 m 538 -242 l 342 -242 l 342 139 l 538 139 l 538 -242 z '
    },
    Ӷ: {
      ha: 774,
      x_min: 90,
      x_max: 736,
      o: 'm 736 823 l 293 823 l 293 0 l 90 0 l 90 987 l 736 987 l 736 823 m 439 -242 l 243 -242 l 243 139 l 439 139 l 439 -242 z '
    },
    ӷ: {
      ha: 582,
      x_min: 75,
      x_max: 575,
      o: 'm 575 575 l 271 575 l 271 0 l 75 0 l 75 734 l 575 734 l 575 575 m 421 -242 l 225 -242 l 225 139 l 421 139 l 421 -242 z '
    },
    Ҿ: {
      ha: 1051,
      x_min: -18,
      x_max: 987,
      o: 'm 650 -16 q 318 99 437 -16 q 199 416 199 214 l 199 442 q 38 536 95 460 q -18 734 -18 612 l 117 734 q 199 590 117 621 q 252 800 199 705 q 398 947 304 894 q 604 1000 492 1001 q 886 878 785 1000 q 987 530 987 756 l 987 426 l 402 426 l 402 412 q 466 225 402 289 q 650 162 530 162 q 899 204 785 162 l 932 37 q 809 -1 886 14 q 650 -16 732 -16 m 604 821 q 458 758 512 821 q 402 590 404 694 l 784 590 l 784 611 q 738 767 784 713 q 604 821 692 821 m 737 -319 l 541 -319 l 541 62 l 737 62 l 737 -319 z '
    },
    ҿ: {
      ha: 830,
      x_min: -46,
      x_max: 815,
      o: 'm 514 -14 q 258 78 357 -14 q 151 315 159 170 q 4 406 54 336 q -46 585 -46 477 l 77 585 q 156 447 77 478 q 267 666 177 585 q 492 747 357 747 q 729 652 644 747 q 815 383 815 557 l 815 303 l 349 303 q 406 188 358 231 q 526 144 453 144 q 703 227 640 144 l 800 119 q 681 21 755 56 q 514 -14 606 -14 m 491 589 q 397 549 433 589 q 351 437 361 510 l 623 437 l 623 452 q 587 553 621 517 q 491 589 553 589 m 585 -313 l 389 -313 l 389 68 l 585 68 l 585 -313 z '
    },
    һ: {
      ha: 777,
      x_min: 71,
      x_max: 705,
      o: 'm 267 654 q 463 747 345 747 q 705 470 701 747 l 705 0 l 509 0 l 509 465 q 481 558 509 528 q 391 588 454 588 q 267 522 305 588 l 267 0 l 71 0 l 71 1042 l 267 1042 l 267 654 z '
    },
    Ҍ: {
      ha: 869,
      x_min: -29,
      x_max: 829,
      o: 'm 445 739 l 292 739 l 292 631 l 450 631 q 727 547 625 631 q 829 319 829 463 q 727 89 829 176 q 458 0 626 1 l 87 0 l 87 739 l -29 739 l -29 863 l 87 863 l 87 987 l 292 987 l 292 863 l 445 863 l 445 739 m 292 467 l 292 163 l 454 163 q 578 206 532 163 q 625 321 625 249 q 580 427 625 388 q 458 467 536 466 l 292 467 z '
    },
    Ѣ: {
      ha: 869,
      x_min: -29,
      x_max: 829,
      o: 'm 445 739 l 292 739 l 292 631 l 450 631 q 727 547 625 631 q 829 319 829 463 q 727 89 829 176 q 458 0 626 1 l 87 0 l 87 739 l -29 739 l -29 863 l 87 863 l 87 987 l 292 987 l 292 863 l 445 863 l 445 739 m 292 467 l 292 163 l 454 163 q 578 206 532 163 q 625 321 625 249 q 580 427 625 388 q 458 467 536 466 l 292 467 z '
    },
    Ғ: {
      ha: 774,
      x_min: -18,
      x_max: 736,
      o: 'm 456 449 l 293 449 l 293 0 l 90 0 l 90 449 l -18 449 l -18 573 l 90 573 l 90 987 l 736 987 l 736 823 l 293 823 l 293 573 l 456 573 l 456 449 z '
    },
    ғ: {
      ha: 582,
      x_min: -39,
      x_max: 575,
      o: 'm 435 307 l 271 307 l 271 0 l 75 0 l 75 307 l -39 307 l -39 431 l 75 431 l 75 734 l 575 734 l 575 575 l 271 575 l 271 431 l 435 431 l 435 307 z '
    },
    Ҟ: {
      ha: 911,
      x_min: -35,
      x_max: 921,
      o: 'm 424 404 l 307 404 l 307 0 l 103 0 l 103 745 l -35 745 l -35 869 l 103 869 l 103 987 l 307 987 l 307 869 l 439 869 l 439 745 l 307 745 l 307 592 l 399 592 l 641 987 l 889 987 l 585 520 l 921 0 l 678 0 l 424 404 z '
    },
    ҟ: {
      ha: 756,
      x_min: -60,
      x_max: 761,
      o: 'm 348 304 l 286 304 l 286 0 l 90 0 l 90 819 l -60 819 l -60 943 l 90 943 l 90 1042 l 286 1042 l 286 943 l 414 943 l 414 819 l 286 819 l 286 459 l 341 459 l 508 734 l 734 734 l 505 398 l 761 0 l 535 0 l 348 304 z '
    },
    Ұ: {
      ha: 859,
      x_min: 1,
      x_max: 857,
      o: 'm 671 349 l 532 349 l 532 0 l 326 0 l 326 349 l 197 349 l 197 473 l 267 473 l 1 987 l 224 987 l 429 543 l 634 987 l 857 987 l 591 473 l 671 473 l 671 349 z '
    },
    ұ: {
      ha: 709,
      x_min: 12,
      x_max: 699,
      o: 'm 597 7 l 452 7 l 452 -283 l 256 -283 l 256 7 l 123 7 l 123 132 l 216 132 l 12 734 l 216 734 l 357 231 l 494 734 l 699 734 l 494 132 l 597 132 l 597 7 z '
    },
    Ӿ: {
      ha: 882,
      x_min: 15,
      x_max: 868,
      o: 'm 681 444 l 605 444 l 868 0 l 631 0 l 441 346 l 252 0 l 15 0 l 278 444 l 207 444 l 207 568 l 269 568 l 22 987 l 256 987 l 441 647 l 627 987 l 861 987 l 614 568 l 681 568 l 681 444 z '
    },
    ӿ: {
      ha: 707,
      x_min: 14,
      x_max: 696,
      o: 'm 596 315 l 513 315 l 696 0 l 486 0 l 355 231 l 225 0 l 14 0 l 197 315 l 122 315 l 122 439 l 195 439 l 24 734 l 234 734 l 355 515 l 478 734 l 688 734 l 516 439 l 596 439 l 596 315 z '
    },
    ԑ: {
      ha: 772,
      x_min: 64,
      x_max: 726,
      o: 'm 64 208 q 203 378 64 332 q 111 443 144 402 q 77 533 77 484 q 165 690 77 633 q 405 747 253 747 q 628 684 541 747 q 715 522 715 621 l 519 522 q 485 578 519 557 q 395 599 450 599 q 307 576 340 599 q 273 517 273 554 q 304 461 273 482 q 395 440 334 440 l 522 440 l 522 309 l 393 309 q 260 222 260 309 q 297 159 260 184 q 394 134 334 134 q 493 157 456 134 q 530 217 530 181 l 726 217 q 636 50 726 113 q 405 -14 546 -14 q 159 47 254 -14 q 64 208 64 108 z '
    },
    '₣': {
      ha: 761,
      x_min: -9,
      x_max: 731,
      o: 'm 682 404 l 292 404 l 292 0 l 88 0 l 88 987 l 731 987 l 731 823 l 292 823 l 292 568 l 682 568 l 682 404 m 465 147 l -9 147 l -9 271 l 465 271 l 465 147 z '
    },
    '―': {
      ha: 1060,
      x_min: 74,
      x_max: 1010,
      o: 'm 1010 404 l 74 404 l 74 564 l 1010 564 l 1010 404 z '
    },
    Ὅ: {
      ha: 1006,
      x_min: -332,
      x_max: 947,
      o: 'm 947 471 q 895 216 947 326 q 748 46 844 106 q 528 -14 652 -14 q 309 45 405 -14 q 159 214 212 104 q 106 466 106 323 l 106 515 q 158 771 106 661 q 307 942 211 882 q 526 1001 403 1001 q 746 942 650 1001 q 894 771 842 882 q 947 515 947 661 l 947 471 m 741 516 q 685 752 741 671 q 526 833 629 833 q 368 753 424 833 q 312 519 313 673 l 312 471 q 368 237 312 320 q 528 153 423 153 q 685 234 630 153 q 741 468 740 314 l 741 516 m -127 800 l -52 1014 l 92 1014 l 92 1000 l -64 783 l -127 783 l -127 800 m -332 1014 l -214 1014 l -214 950 q -162 828 -214 866 l -218 770 q -300 840 -269 793 q -332 949 -332 886 l -332 1014 z '
    }
  },
  familyName: 'Roboto',
  ascender: 1289,
  descender: -339,
  underlinePosition: -102,
  underlineThickness: 68,
  boundingBox: { yMin: -376, xMin: -1009, yMax: 1467, xMax: 1654 },
  resolution: 1000,
  original_font_information: {
    format: 0,
    copyright: 'Copyright 2011 Google Inc. All Rights Reserved.',
    fontFamily: 'Roboto',
    fontSubfamily: 'Bold',
    uniqueID: 'Roboto Bold',
    fullName: 'Roboto Bold',
    version: 'Version 2.137; 2017',
    postScriptName: 'Roboto-Bold',
    trademark: 'Roboto is a trademark of Google.',
    designer: 'Google',
    manufacturerURL: 'Google.com',
    designerURL: 'Christian Robertson',
    licence: 'Licensed under the Apache License, Version 2.0',
    licenceURL: 'http://www.apache.org/licenses/LICENSE-2.0'
  },
  cssFontWeight: 'bold',
  cssFontStyle: 'normal'
};
